(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[855],{

/***/ 13692:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/creatoki.b59c150c.png","height":148,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAYFBMVEVMaXG6zOdIcLkAAC1Fj9/4/v7s9/9BXaTT3vDY6vtqh8NFabBMbLBKpfVKnewvTptQr/1YsftZs/09VZ6KoM5Uc7WIrNyUq9RKaK2ht9xvmNOn0vluuPhQpfJVmOCrwOKFZ4K4AAAAF3RSTlMA/v0IVP79/f7+iTq91GL8L7L7Yt/81iXvWY0AAAAJcEhZcwAACxMAAAsTAQCanBgAAAA+SURBVAiZBcEHAoAgDACxQ0YL7oGA6//PNAHcOAHL+tzX0LO96rVWvk6DipClmDILuQUTm+DO6OOxg00lWX5YDAKpNsOtWQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 72341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useAccountBasePage; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useAccountBasePage = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("my-account");


/***/ }),

/***/ 28955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useCategories; }
/* harmony export */ });
/* harmony import */ var _useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64215);

var useCategories = (0,_useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageIndependentData */ .p)("categories");


/***/ }),

/***/ 63794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useContextSsr; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_data_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4118);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var useContextSsr = (0,next_data_hooks__WEBPACK_IMPORTED_MODULE_1__/* .createDataHook */ .Qo)("host-ssr", function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
        var ref, ref1, ref2, ref3, ref4, localeRes, ref5, ref6;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    localeRes = !(context === null || context === void 0 ? void 0 : context.locale) || (context === null || context === void 0 ? void 0 : context.locale) === "catchAll" ? "en" : context === null || context === void 0 ? void 0 : context.locale;
                    ;
                    return _ctx.abrupt("return", {
                        host: (ref5 = (ref = context) === null || ref === void 0 ? void 0 : (ref1 = ref.req) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.headers) === null || ref2 === void 0 ? void 0 : ref2.host) !== null && ref5 !== void 0 ? ref5 : "",
                        url: (ref6 = (ref3 = context) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.req) === null || ref4 === void 0 ? void 0 : ref4.url) !== null && ref6 !== void 0 ? ref6 : "",
                        locale: localeRes
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
}());


/***/ }),

/***/ 91785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ useCurrentLanguage; }
});

// EXTERNAL MODULE: ./src/config/supportedLang.json
var supportedLang = __webpack_require__(9682);
// EXTERNAL MODULE: ./src/utils/_helper/isServer.ts
var isServer = __webpack_require__(63755);
;// CONCATENATED MODULE: ./src/api/hooks/useIsStorybook.hook.ts

var useIsStorybook = function() {
    var ref;
    if ((0,isServer/* isServer */.s)()) return false;
    return ((ref = window) === null || ref === void 0 ? void 0 : ref.STORYBOOK_ENV) === "react";
};

;// CONCATENATED MODULE: ./src/api/hooks/useCurrentLanguage.hook.ts



var useCurrentLanguage = function() {
    var ref;
    var isStorybook = useIsStorybook();
    if ((0,isServer/* isServer */.s)() || isStorybook) return "en";
    var currentLang = (ref = location.pathname.split("/")) === null || ref === void 0 ? void 0 : ref[1];
    if (supportedLang.includes(currentLang)) return currentLang;
    else return "en";
};


/***/ }),

/***/ 47536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useFooter; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useFooter = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("footer");


/***/ }),

/***/ 26323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useGenres; }
/* harmony export */ });
/* harmony import */ var _useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64215);

var useGenres = (0,_useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageIndependentData */ .p)("genres");


/***/ }),

/***/ 81548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useHeader; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useHeader = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("header");


/***/ }),

/***/ 64215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useLanguageIndependentData; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var _utils_config_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79098);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useLanguageIndependentData = function(basepath) {
    return function() {
        return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            basepath
        ], function() {
            var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                var _queryKey, _;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _queryKey = _slicedToArray(param.queryKey, 1), _ = _queryKey[0];
                            _ctx.next = 3;
                            return (0,_utils_config_axios__WEBPACK_IMPORTED_MODULE_2__/* .backend */ .y)().get("api/strapi/".concat(basepath));
                        case 3:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }());
    };
};


/***/ }),

/***/ 92534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useLoginPage; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_data_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4118);
/* harmony import */ var _utils_config_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79098);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useLoginPage = (0,next_data_hooks__WEBPACK_IMPORTED_MODULE_1__/* .createDataHook */ .Qo)("login-page", function() {
    var _ref1 = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1(param) {
        var locale, localeRes, result;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    locale = param.locale;
                    localeRes = !locale || locale === "catchAll" ? "en" : locale;
                    _ctx1.next = 4;
                    return (0,_utils_config_axios__WEBPACK_IMPORTED_MODULE_2__/* .backend */ .y)().get("api/strapi/login-page?_locale=".concat(localeRes));
                case 4:
                    result = _ctx1.sent.data;
                    _ctx1.next = 7;
                    return Promise.all(result.faqbox.map(function() {
                        var _ref2 = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(box) {
                            var ref;
                            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx2) {
                                while(1)switch(_ctx2.prev = _ctx2.next){
                                    case 0:
                                        ;
                                        _ctx2.next = 3;
                                        return Promise.all((ref = box.fa_qs) === null || ref === void 0 ? void 0 : ref.map(function() {
                                            var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(faqIdItem) {
                                                var id;
                                                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            id = faqIdItem.id;
                                                            _ctx.next = 3;
                                                            return (0,_utils_config_axios__WEBPACK_IMPORTED_MODULE_2__/* .backend */ .y)().get("api/strapi/fa-qs/".concat(id));
                                                        case 3:
                                                            return _ctx.abrupt("return", _ctx.sent.data);
                                                        case 4:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            }));
                                            return function(faqIdItem) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }()));
                                    case 3:
                                        box.fa_qs = _ctx2.sent;
                                        return _ctx2.abrupt("return", box);
                                    case 5:
                                    case "end":
                                        return _ctx2.stop();
                                }
                            }, _callee2);
                        }));
                        return function(box) {
                            return _ref2.apply(this, arguments);
                        };
                    }()));
                case 7:
                    result.faqbox = _ctx1.sent;
                    return _ctx1.abrupt("return", result);
                case 9:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return function(_) {
        return _ref1.apply(this, arguments);
    };
}());


/***/ }),

/***/ 12310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ mapLookupToLanguageHook; }
/* harmony export */ });
/* harmony import */ var _useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91785);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var mapLookupToLanguageHook = function(data) {
    if (data) {
        var ref;
        var ref1;
        var language = (ref1 = _useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentLanguage */ .U === null || _useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentLanguage */ .U === void 0 ? void 0 : (ref = (0,_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentLanguage */ .U)()) === null || ref === void 0 ? void 0 : ref.slice(0, 2)) !== null && ref1 !== void 0 ? ref1 : "en";
        return data.map(function(item) {
            return _objectSpread({}, item, {
                text: language === "de" ? item.trans_de : item.trans_en
            });
        }).filter(function(item) {
            return !!item.text;
        });
    }
    return [];
};


/***/ }),

/***/ 12207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useMyOan; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useMyOan = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("my-oan");


/***/ }),

/***/ 71887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useSubCategories; }
/* harmony export */ });
/* harmony import */ var _useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64215);

var useSubCategories = (0,_useLanguageIndependentData_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageIndependentData */ .p)("sub-categories");


/***/ }),

/***/ 80612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useTypoContent; },
/* harmony export */   "n": function() { return /* binding */ getTypoData; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_data_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4118);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37287);
/* harmony import */ var _utils_config_axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79098);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var getTypoData = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(locale, params) {
        var token, localeRes, pageName, authorizationToken, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "";
                    localeRes = !locale || locale === "catchAll" || locale === "en" ? "en/" : locale + "/";
                    pageName = params && params.typoPage && Array.isArray(params.typoPage) ? params.typoPage.join("/") : "";
                    authorizationToken = token !== null && token !== void 0 ? token : _redux__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .T8.getState().authentification.jwt;
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return _utils_config_axios__WEBPACK_IMPORTED_MODULE_3__/* .typo.get */ .f.get(localeRes + "page/" + pageName, {
                        headers: {
                            Authorization: "Bearer ".concat(authorizationToken)
                        }
                    });
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    return _ctx.abrupt("return", handleError(_ctx.t0));
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    }));
    return function getTypoData(locale, params) {
        return _ref.apply(this, arguments);
    };
}();
var useTypoContent = (0,next_data_hooks__WEBPACK_IMPORTED_MODULE_1__/* .createDataHook */ .Qo)("TypoContent", function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
        var useContext, jwt;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    useContext = context;
                    jwt = useContext.req.cookies["jwt-cookie"];
                    return _ctx.abrupt("return", getTypoData(useContext.locale, useContext.params, jwt !== null && jwt !== void 0 ? jwt : ""));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
}());
var handleError = function(error) {
    try {
        var responseError = error;
        if (responseError && responseError.response && responseError.response.status) {
            if (responseError.response.status !== 404 && responseError.response.status !== 403) {
                console.error("axios error in typo data hook", responseError.response.status);
            }
            return responseError.response.status;
        }
    } catch (err) {
        console.error(err);
    }
};


/***/ }),

/***/ 55584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ TypoService; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97762);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/utils/_helper/equal-object-helper.tsx
var equal_object_helper = __webpack_require__(91946);
;// CONCATENATED MODULE: ./src/components/typo/_shared/link/link.tsx


var Link = function(props) {
    var content = props.linkText === undefined || props.linkText === null || props.linkText == "" ? props.children : props.linkText;
    props.class === null ? props.class = undefined : 0;
    props.title === null ? props.title = undefined : 0;
    props.target === null ? props.target = undefined : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: props.href,
        className: props.class,
        title: props.title,
        target: props.target,
        children: content
    });
};
Link.defaultProps = {};


// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/accordion/accordion.tsx
var accordion = __webpack_require__(85256);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-text/teaser-card-text.tsx
var teaser_card_text = __webpack_require__(33997);
// EXTERNAL MODULE: ./src/components/typo/_shared/headline/headline.module.scss
var headline_module = __webpack_require__(41374);
var headline_module_default = /*#__PURE__*/__webpack_require__.n(headline_module);
;// CONCATENATED MODULE: ./src/components/typo/_shared/headline/headline.tsx








var Headline = function(props) {
    var inverted = props.inverted, headerPosition = props.headerPosition, headerClass = props.headerClass, headerLink = props.headerLink, headerLayout = props.headerLayout, header = props.header, noHeadlineSpacing = props.noHeadlineSpacing, noContentSpacing = props.noContentSpacing, noTextAlignment = props.noTextAlignment, subheader = props.subheader, variant = props.variant, bodytext = props.bodytext, contentTextPosition = props.contentTextPosition, subHeaderClass = props.subHeaderClass;
    if (!header) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    if (headerLayout == 100 && variant !== "teaser") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var variantHeader = function() {
        switch(headerLayout){
            case 11:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING1 */.H.HEADING1;
                }
            case 12:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING2_BOLD */.H.HEADING2_BOLD;
                }
            case 13:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD;
                }
            case 14:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD;
                }
            case 15:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5;
                }
            case 16:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6;
                }
            default:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD;
                }
        }
    };
    var variantSubHeader = function() {
        switch(headerLayout){
            case 11:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING2_BOLD */.H.HEADING2_BOLD;
                }
            case 12:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD;
                }
            case 13:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD;
                }
            case 14:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5;
                }
            case 15:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6;
                }
            case 16:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6;
                }
            default:
                {
                    return typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD;
                }
        }
    };
    var headerAlignment = headerPosition ? "text-" + headerPosition : "";
    var hasHeaderLink = headerLink !== undefined && headerLink !== null;
    var contentAlignment = contentTextPosition ? {
        textAlign: contentTextPosition,
        display: "block",
        width: "100%",
        paddingBottom: "0"
    } : {
        paddingBottom: "0"
    };
    var headlineStyle = noHeadlineSpacing ? {
        paddingBottom: "0"
    } : undefined;
    var getContent = function() {
        if (!header || headerLayout == 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        if (hasHeaderLink && headerLink !== null && headerLink !== "") {
            if (typeof headerLink !== "string") {
                var _target, _title, _class;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    target: (_target = headerLink.target) !== null && _target !== void 0 ? _target : "",
                    href: headerLink.href,
                    title: (_title = headerLink.title) !== null && _title !== void 0 ? _title : "",
                    class: (_class = headerLink.class) !== null && _class !== void 0 ? _class : "",
                    children: getTypography()
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    href: headerLink,
                    children: getTypography()
                });
            }
        } else {
            return getTypography();
        }
    };
    var getTypography = function() {
        if (!header || headerLayout == 100) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        if (variant === "teaser") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_text/* default */.Z, {
                headline: header,
                topline: subheader,
                headlineStyle: contentAlignment,
                toplineStyle: contentAlignment,
                headlineVariant: variantHeader(),
                subHeadlineVariant: variantSubHeader(),
                variant: basic_card_variants_enum/* BasicCardVariants.TEXT_IMAGE_TEASER */.I.TEXT_IMAGE_TEASER,
                inverted: inverted
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: variantHeader(),
                        style: headlineStyle,
                        className: headerClass,
                        inverted: inverted,
                        children: header
                    }),
                    subheader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: variantSubHeader(),
                        className: "".concat((headline_module_default()).subheader, " ").concat(subHeaderClass),
                        inverted: inverted,
                        children: subheader
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "\n            ".concat((headline_module_default())["headline-section"], "\n            ").concat(inverted ? (headline_module_default()).inverted : "", "\n            ").concat(noTextAlignment ? "" : (headline_module_default())[headerAlignment], "\n        "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((headline_module_default()).headline, " ").concat(variant && variant === "teaser" || noContentSpacing ? (headline_module_default()).nospace : ""),
                children: getContent()
            }),
            variant === "teaser" && /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_text/* default */.Z, {
                description: bodytext,
                variant: basic_card_variants_enum/* BasicCardVariants.TEXT_IMAGE_TEASER */.I.TEXT_IMAGE_TEASER,
                inverted: inverted
            })
        ]
    });
};
Headline.defaultProps = {
    variantHeader: typeography_variants_enum/* TypographyVariantsEnum.HEADING2_BOLD */.H.HEADING2_BOLD,
    variantSubHeader: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
    headerPosition: "left",
    inverted: false
};


// EXTERNAL MODULE: ./src/components/typo/accord/accord.module.scss
var accord_module = __webpack_require__(34823);
var accord_module_default = /*#__PURE__*/__webpack_require__.n(accord_module);
;// CONCATENATED MODULE: ./src/components/typo/accord/accord.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var Accord = function(props) {
    var id = props.id, inverted = props.inverted, faqs = props.faqs, fullwidth = props.fullwidth, wrapper = props.wrapper, childrenHeadline = props.childrenHeadline, children = props.children;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var faQs = [];
    if (faqs) {
        faqs.map(function(obj) {
            faQs.push({
                HeadlineDirect: "",
                faqs: {
                    headline: obj.question,
                    description: obj.answer,
                    initialOpen: obj.initial_open,
                    image: {}
                }
            });
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((accord_module_default())["accord-box"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (accord_module_default()).inverted : "", "\n                ").concat(fullwidth ? (accord_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (accord_module_default())[wrapper] : "", "\n            "),
        "data-testid": "accord-box",
        children: [
            !childrenHeadline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, _objectSpread({}, props)),
            faQs && faQs.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: faQs === null || faQs === void 0 ? void 0 : faQs.map(function(param) {
                    var _faqs = param.faqs, description = _faqs.description, headline = _faqs.headline, initialOpen = _faqs.initialOpen;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* default */.Z, {
                        initialOpen: initialOpen !== null && initialOpen !== void 0 ? initialOpen : false,
                        label: headline,
                        inverted: inverted,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (accord_module_default())["accord-item-content"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                                    inverted: inverted,
                                    className: (accord_module_default())["accord-item-description"],
                                    children: description
                                })
                            })
                        })
                    }, "accord-item" + headline);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* default */.Z, {
                initialOpen: false,
                label: childrenHeadline !== null && childrenHeadline !== void 0 ? childrenHeadline : "",
                inverted: inverted,
                children: children
            }, "accord-item" + childrenHeadline)
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(41548);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(73873);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/assets/icons/creatoken.svg.tsx
var creatoken_svg = __webpack_require__(43301);
// EXTERNAL MODULE: ./src/utils/_enums/alignment.enum.ts
var alignment_enum = __webpack_require__(76221);
// EXTERNAL MODULE: ./src/components/typo/_shared/typo_buttons/typo_buttons.module.scss
var typo_buttons_module = __webpack_require__(2562);
var typo_buttons_module_default = /*#__PURE__*/__webpack_require__.n(typo_buttons_module);
;// CONCATENATED MODULE: ./src/components/typo/_shared/typo_buttons/typo_buttons.tsx
function typo_buttons_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function typo_buttons_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            typo_buttons_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var TypoButtons = function(props1) {
    var inverted = props1.inverted, buttons = props1.buttons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: buttons && buttons.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (typo_buttons_module_default()).buttons,
            children: buttons.map(function(props) {
                props.children = !props.children ? props.title : props.children;
                if (props.uri && props.uri.href && !props.disabled) return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                    href: props.uri.href,
                    locale: false,
                    external: props.uri.target !== "" && props.uri.target !== null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, typo_buttons_objectSpread({
                        inverted: inverted
                    }, props))
                }, props.children);
                else return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, typo_buttons_objectSpread({
                    inverted: inverted
                }, props));
            })
        })
    });
};


// EXTERNAL MODULE: ./src/components/typo/stage/stage.module.scss
var stage_module = __webpack_require__(82242);
var stage_module_default = /*#__PURE__*/__webpack_require__.n(stage_module);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/components/typo/stage/stage-image-button-token/stage-image-button-token.module.scss
var stage_image_button_token_module = __webpack_require__(80910);
var stage_image_button_token_module_default = /*#__PURE__*/__webpack_require__.n(stage_image_button_token_module);
;// CONCATENATED MODULE: ./src/components/typo/stage/stage-image-button-token/stage-image-button-token.tsx
function stage_image_button_token_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function stage_image_button_token_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            stage_image_button_token_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var StageImageButtonToken = function(_param) {
    var image = _param.image, editButtonProps = _param.editButtonProps, shadow = _param.shadow, props = _objectWithoutProperties(_param, [
        "image",
        "editButtonProps",
        "shadow"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (stage_image_button_token_module_default())["stage-image-button-token"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, stage_image_button_token_objectSpread({}, props, {
                variant: shadow ? button_variants_enum/* ButtonVariantsEnum.STAGE */.l.STAGE : button_variants_enum/* ButtonVariantsEnum.SECONDARY_FILLED */.l.SECONDARY_FILLED,
                className: (stage_image_button_token_module_default())["token-button"],
                icon: {
                    element: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: image ? image + "?resolution=thumbnail" : "",
                        alt: "Icon"
                    }),
                    align: "left"
                }
            })),
            editButtonProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, stage_image_button_token_objectSpread({}, editButtonProps, {
                className: (stage_image_button_token_module_default()).editButton
            }))
        ]
    });
};


// EXTERNAL MODULE: ./src/components/typo/animated_stage/animated_stage.module.scss
var animated_stage_module = __webpack_require__(23708);
var animated_stage_module_default = /*#__PURE__*/__webpack_require__.n(animated_stage_module);
;// CONCATENATED MODULE: ./src/components/typo/animated_stage/animated_stage.tsx
function animated_stage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function animated_stage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            animated_stage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




// @ts-ignore








var AnimatedStage = function(props) {
    var animationSpeedClass = props.animationSpeedClass, animationClass = props.animationClass, contentVertical = props.contentVertical, contentHorizontal = props.contentHorizontal, contentSize = props.contentSize, inverted = props.inverted, id = props.id, stages = props.stages, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var ref3 = (0,react.useState)(), sliderInverted = ref3[0], setSliderInverted = ref3[1];
    var getAutoplaySpeed = function() {
        if (animationSpeedClass === "slow") {
            return 10000;
        } else if (animationSpeedClass === "slower") {
            return 8000;
        } else if (animationSpeedClass === "fast") {
            return 6000;
        } else if (animationSpeedClass === "faster") {
            return 4000;
        } else {
            return 5000;
        }
    };
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        afterChange: function afterChange(i) {
            if (stages && stages[i].contentStyle == "inverted") {
                setSliderInverted(true);
            } else {
                setSliderInverted(false);
            }
        },
        autoplaySpeed: getAutoplaySpeed()
    };
    var decButton = {
        icon: {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(creatoken_svg/* default */.Z, {}),
            align: "right"
        }
    };
    if (stages && stages.length > 0) {
        var ref1, ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "c".concat(id),
            className: "\n                    ".concat((animated_stage_module_default())["animated-stages-section"], "\n                    ").concat("spaceBefore" + appearance.spaceBefore, " \n                    ").concat("spaceAfter" + appearance.spaceAfter, " \n                    ").concat(inverted ? (animated_stage_module_default()).inverted : "", "\n                    ").concat(sliderInverted ? (animated_stage_module_default())["slider-inverted"] : "", "\n                    ").concat(fullwidth ? (animated_stage_module_default()).fullwidth : "", "\n                    ").concat(wrapper !== undefined ? (animated_stage_module_default())[wrapper] : "", "\n                "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (stage_module_default()).headline,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, animated_stage_objectSpread({}, props))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, animated_stage_objectSpread({}, settings, {
                    children: stages.map(function(element, i) {
                        var verticalOrientation = contentVertical.toUpperCase();
                        var size = contentSize.charAt(0).toUpperCase() + contentSize.slice(1);
                        var orientation = contentHorizontal.toUpperCase();
                        var textDirection = "horizontal";
                        var buttons = element.buttons;
                        var ref;
                        var img = (ref = element.media[0]) !== null && ref !== void 0 ? ref : [];
                        var _properties;
                        var imgProps = (_properties = img.properties) !== null && _properties !== void 0 ? _properties : [];
                        var backgrounds = imgProps && imgProps.dimensions ? {
                            large: {
                                ext: "." + imgProps.extension,
                                hash: "large_typo_" + id,
                                height: imgProps.dimensions.height,
                                mime: imgProps.mimeType,
                                name: imgProps.filename,
                                path: null,
                                size: parseFloat(imgProps.size),
                                url: img.publicUrl,
                                width: imgProps.dimensions.width
                            }
                        } : {};
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((stage_module_default()).stage, "  ").concat((stage_module_default())[size], " ").concat((animated_stage_module_default()).stage),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((stage_module_default())["stage-background"], " ").concat(backgrounds || img.publicUrl ? "" : (stage_module_default())["default-background"], "}"),
                                style: backgrounds ? {
                                    backgroundImage: "url(".concat(img.publicUrl ? img.publicUrl : "", ")")
                                } : undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((stage_module_default())[orientation], " ").concat(element.contentStyle == "inverted" ? (stage_module_default()).inverted : "", " ").concat(element.contentStyle == "inverted" ? (animated_stage_module_default()).inverted : "", " ").concat((stage_module_default())["vert-".concat(verticalOrientation === null || verticalOrientation === void 0 ? void 0 : verticalOrientation.toLowerCase())]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: textDirection === alignment_enum/* Alignment.HORIZONTAL */.v.HORIZONTAL ? (stage_module_default())["horizontal-text-alignment"] : "",
                                            children: [
                                                element.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((stage_module_default()).title),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, animated_stage_objectSpread({}, props, element, {
                                                        header: element.headline,
                                                        subheader: element.subline,
                                                        headerPosition: element.headlineAlign,
                                                        headerLayout: 0,
                                                        inverted: element.contentStyle == "inverted",
                                                        headerClass: "\n                                    ".concat(animationClass !== "" ? "animate__animated animate__".concat(animationClass) : "", "\n                                     ").concat(animationSpeedClass !== "" ? "animate__".concat(animationSpeedClass) : "", "\n                                    "),
                                                        subHeaderClass: "\n                                    ".concat(animationClass !== "" ? "animate__animated animate__".concat(animationClass) : "", "\n                                     ").concat(animationSpeedClass !== "" ? "animate__".concat(animationSpeedClass) : "", "\n                                    "),
                                                        variantHeader: "heading1",
                                                        variantSubHeader: "introtext"
                                                    }))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: textDirection === alignment_enum/* Alignment.HORIZONTAL */.v.HORIZONTAL ? (stage_module_default())["flex-container"] : ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoButtons, {
                                            inverted: element.contentStyle == "inverted",
                                            buttons: buttons
                                        })
                                    ]
                                })
                            })
                        }, "animated-stage-".concat(i));
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (animated_stage_module_default()).decButtonContainer,
                    children: ((ref1 = decButton) === null || ref1 === void 0 ? void 0 : ref1.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (stage_module_default()).decButtonCustomContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StageImageButtonToken, animated_stage_objectSpread({}, decButton, {
                            shadow: true
                        }))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (stage_module_default()).decButtonContainer,
                        children: decButton === null || decButton === void 0 ? void 0 : (ref2 = decButton.icon) === null || ref2 === void 0 ? void 0 : ref2.element
                    })
                })
            ]
        });
    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};


// EXTERNAL MODULE: ./src/components/typo/text/text.module.scss
var text_module = __webpack_require__(51163);
var text_module_default = /*#__PURE__*/__webpack_require__.n(text_module);
// EXTERNAL MODULE: ./src/components/typo/bullets/bullets.module.scss
var bullets_module = __webpack_require__(68823);
var bullets_module_default = /*#__PURE__*/__webpack_require__.n(bullets_module);
;// CONCATENATED MODULE: ./src/components/typo/bullets/ordered-list/ordered-list.tsx



var TypoOrderedList = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: (bullets_module_default()).orderedList,
            children: (ref = props.bodytext) === null || ref === void 0 ? void 0 : ref.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (bullets_module_default()).listItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (bullets_module_default()).text,
                        children: item
                    })
                }, "item-".concat(i));
            })
        })
    });
};
TypoOrderedList.defaultProps = {};


;// CONCATENATED MODULE: ./src/components/typo/bullets/unordered-list/unordered-list.tsx



var TypoUnorderedList = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (bullets_module_default()).list,
            children: (ref = props.bodytext) === null || ref === void 0 ? void 0 : ref.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (bullets_module_default()).listItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (bullets_module_default()).text,
                        children: item
                    })
                }, "item-".concat(i));
            })
        })
    });
};
TypoUnorderedList.defaultProps = {};


;// CONCATENATED MODULE: ./src/components/typo/bullets/bullets.tsx
function bullets_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bullets_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bullets_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// @ts-nocheck





var TypoBullets = function(props) {
    var id = props.id, inverted = props.inverted, bodytext = props.bodytext, bulletsType = props.bulletsType, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var list;
    switch(bulletsType){
        case 0:
            list = /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoUnorderedList, {
                id: id,
                bulletsType: bulletsType,
                bodytext: bodytext
            });
            break;
        case 1:
            list = /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoOrderedList, {
                id: id,
                bulletsType: bulletsType,
                bodytext: bodytext
            });
            break;
        default:
            list = /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoUnorderedList, {
                id: id,
                bulletsType: bulletsType,
                bodytext: bodytext
            });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n        ".concat("spaceBefore" + appearance.spaceBefore, " \n        ").concat("spaceAfter" + appearance.spaceAfter, " \n        ").concat(inverted ? (text_module_default()).inverted : "", "\n        ").concat(fullwidth ? (text_module_default()).fullwidth : "", "\n        ").concat(wrapper !== undefined ? (text_module_default())[wrapper] : "", "\n      "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, bullets_objectSpread({}, props))
            }),
            list
        ]
    });
};
TypoBullets.defaultProps = {};


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/api/hooks/useTypoContent.hook.ts
var useTypoContent_hook = __webpack_require__(80612);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 3 modules
var redux_toolkit_esm = __webpack_require__(62963);
// EXTERNAL MODULE: ./src/utils/_config/axios.ts
var axios = __webpack_require__(79098);
;// CONCATENATED MODULE: ./src/api/services/comment.service.tsx
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CommentService = /*#__PURE__*/ function() {
    "use strict";
    function CommentService() {
        _classCallCheck(this, CommentService);
    }
    var _proto = CommentService.prototype;
    _proto.sendCommentForm = function sendCommentForm(data) {
        return axios/* typo.post */.f.post("/en/typo3/api/comment/add", data);
    };
    _proto.sendRemoveComment = function sendRemoveComment(data) {
        return axios/* typo.post */.f.post("/en/typo3/api/comment/remove", data);
    };
    return CommentService;
}();


// EXTERNAL MODULE: ./src/redux/_helper/redux-thunk-wrapper.ts
var redux_thunk_wrapper = __webpack_require__(18956);
;// CONCATENATED MODULE: ./src/redux/slices/comment.slice.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function comment_slice_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var initialState = {
    commentModel: {
        pending: false
    }
};
var sendCommentForm = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("api/comment/add", function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee1(data, param) {
        var rejectWithValue;
        return runtime_default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    rejectWithValue = param.rejectWithValue;
                    _ctx1.next = 3;
                    return (0,redux_thunk_wrapper/* reduxThunkWrapper */.k)(_asyncToGenerator(runtime_default().mark(function _callee() {
                        var commentService, response;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    commentService = new CommentService();
                                    _ctx.next = 3;
                                    return commentService.sendCommentForm(data);
                                case 3:
                                    response = _ctx.sent;
                                    return _ctx.abrupt("return", response.data);
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })), rejectWithValue);
                case 3:
                    return _ctx1.abrupt("return", _ctx1.sent);
                case 4:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return function(data, _) {
        return _ref.apply(this, arguments);
    };
}());
var removeComment = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("api/comment/remove", function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee2(data, param) {
        var rejectWithValue;
        return runtime_default().wrap(function _callee$(_ctx2) {
            while(1)switch(_ctx2.prev = _ctx2.next){
                case 0:
                    rejectWithValue = param.rejectWithValue;
                    _ctx2.next = 3;
                    return (0,redux_thunk_wrapper/* reduxThunkWrapper */.k)(_asyncToGenerator(runtime_default().mark(function _callee() {
                        var commentService, response;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    commentService = new CommentService();
                                    _ctx.next = 3;
                                    return commentService.sendRemoveComment(data);
                                case 3:
                                    response = _ctx.sent;
                                    return _ctx.abrupt("return", response.data);
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })), rejectWithValue);
                case 3:
                    return _ctx2.abrupt("return", _ctx2.sent);
                case 4:
                case "end":
                    return _ctx2.stop();
            }
        }, _callee2);
    }));
    return function(data, _) {
        return _ref.apply(this, arguments);
    };
}());
var _obj;
var commentSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "comment",
    initialState: initialState,
    reducers: {
        removeCommentStatus: function(state) {
            state.commentModel.status = undefined;
        }
    },
    extraReducers: (_obj = {}, comment_slice_defineProperty(_obj, sendCommentForm.pending.type, function(state) {
        state.commentModel.pending = true;
        state.commentModel.status = undefined;
    }), comment_slice_defineProperty(_obj, sendCommentForm.fulfilled.type, function(state) {
        state.commentModel.pending = false;
        state.commentModel.status = 200;
    }), comment_slice_defineProperty(_obj, sendCommentForm.rejected.type, function(state, action) {
        state.commentModel.status = action.payload.status;
        state.commentModel.pending = false;
    }), _obj)
});
var removeCommentStatus = commentSlice.actions.removeCommentStatus;
/* harmony default export */ var comment_slice = (commentSlice.reducer);

// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/text-area/text-area.tsx
var text_area = __webpack_require__(47085);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var index_es = __webpack_require__(92565);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/api/hooks/useMyOan.hook.tsx
var useMyOan_hook = __webpack_require__(12207);
// EXTERNAL MODULE: ./src/assets/creatoki.png
var creatoki = __webpack_require__(13692);
// EXTERNAL MODULE: ./src/redux/slices/my-oan.slice.tsx
var my_oan_slice = __webpack_require__(85841);
// EXTERNAL MODULE: ./src/components/typo/comments/comment/comment.module.scss
var comment_module = __webpack_require__(84807);
var comment_module_default = /*#__PURE__*/__webpack_require__.n(comment_module);
;// CONCATENATED MODULE: ./src/components/typo/comments/comment/comment.tsx
function comment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function comment_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                comment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                comment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}















var Comment = function(props) {
    var uid = props.uid, username = props.username, replyid = props.replyid, parent = props.parent, pid = props.pid, comment = props.comment, crdate1 = props.crdate, inverted = props.inverted;
    var dispatch = (0,es/* useDispatch */.I0)();
    var typoService = new TypoService((0,useTypoContent_hook/* useTypoContent */.f)());
    var ref2 = (0,react.useState)(false), isRemoved = ref2[0], setIsRemoved = ref2[1];
    var user = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            user: state.userSlice.user
        };
    }).user;
    var ref1 = (0,react.useState)(), commentOwner = ref1[0], setCommentOwner = ref1[1];
    (0,react.useEffect)(function() {
        comment_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, resp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return dispatch((0,my_oan_slice/* fetchMyOanUser */.OQ)(username));
                    case 3:
                        resp = _ctx.sent;
                        if (((ref = resp.meta) === null || ref === void 0 ? void 0 : ref.requestStatus) === "fulfilled" && resp.payload) {
                            setCommentOwner(resp.payload);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    var deleteComment = function() {
        if (confirm(typoService.getLabel("comments", "comment-confirm-delete"))) {
            comment_asyncToGenerator(runtime_default().mark(function _callee() {
                var resp;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return dispatch(removeComment({
                                uid: uid,
                                parent: parent,
                                username: username,
                                pid: pid
                            }));
                        case 2:
                            resp = _ctx.sent;
                            if (resp.payload.success && resp.payload.data) {
                                setIsRemoved(true);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    };
    var creationDate = function(crdate) {
        var newDate = new Date(crdate * 1000);
        return new Intl.DateTimeFormat("de-DE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
        }).format(newDate).replace(", ", " - ");
    };
    var isMyComment = user && (commentOwner === null || commentOwner === void 0 ? void 0 : commentOwner.username) === user.username;
    console.log(comment);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "u".concat(uid),
        "data-replyid": replyid,
        className: "".concat((comment_module_default())["comment-section"], " ").concat(inverted ? (comment_module_default()).inverted : ""),
        children: !isRemoved ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (comment_module_default()).avatar,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (commentOwner === null || commentOwner === void 0 ? void 0 : commentOwner.profileImageUrl) ? commentOwner.profileImageUrl : creatoki/* default.src */.Z.src,
                        alt: "Avatar"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (comment_module_default()).comment,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (comment_module_default()).text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                inverted: inverted,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        whiteSpace: "pre-line"
                                    },
                                    children: comment
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (comment_module_default()).controls,
                            children: [
                                isMyComment && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (comment_module_default())["control-delete"],
                                    onClick: deleteComment,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                                        inverted: inverted,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                                                icon: index_es/* faTrash */.$aW
                                            }),
                                            " ",
                                            typoService.getLabel("comments", "comment-delete")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (comment_module_default())["control-crdate"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                                        inverted: inverted,
                                        children: [
                                            commentOwner === null || commentOwner === void 0 ? void 0 : commentOwner.username,
                                            " ",
                                            typoService.getLabel("comments", "comment-crdate"),
                                            " ",
                                            creationDate(crdate1)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (comment_module_default()).removed,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                inverted: inverted,
                children: typoService.getLabel("comments", "comment-message-removed")
            })
        })
    });
};
Comment.defaultProps = {};
Comment.dataHooks = [
    useMyOan_hook/* useMyOan */.o
];


// EXTERNAL MODULE: ./src/components/typo/comments/comments.module.scss
var comments_module = __webpack_require__(92772);
var comments_module_default = /*#__PURE__*/__webpack_require__.n(comments_module);
;// CONCATENATED MODULE: ./src/components/typo/comments/comments.tsx
function comments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function comments_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                comments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                comments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function comments_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function comments_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            comments_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















var Comments = function(props) {
    var ref;
    var id = props.id, pid = props.pid, header = props.header, comments = props.comments, allowedCommentGroups = props.allowedCommentGroups, commentLimit = props.commentLimit, inverted = props.inverted, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var typoService = new TypoService((0,useTypoContent_hook/* useTypoContent */.f)());
    var ref1 = (0,react.useState)(comments), commentList = ref1[0], setCommentList = ref1[1];
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var ref2 = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            user: state.userSlice.user,
            supportModel: state.supportSlice.supportModel
        };
    }), user = ref2.user, supportModel = ref2.supportModel;
    var userid = user === null || user === void 0 ? void 0 : user.id;
    var schema = yup_es/* object */.Ry({
        comment: yup_es/* string */.Z_().trim().test("len", typoService.getLabel("comments", "form-comment-length"), function(val) {
            if (val === undefined) {
                return true;
            }
            return val.length === 0 || val.length >= 2 && val.length <= 800;
        }).required(typoService.getLabel("comments", "form-comment-required"))
    });
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onTouched",
        // @ts-ignore
        resolver: (0,yup_module/* yupResolver */.X)(schema)
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, reset = ref3.reset, errors = ref3.formState.errors;
    (0,react.useEffect)(function() {
        reset({
            comment: ""
        });
    }, [
        commentList
    ]);
    var saveComment = function(form) {
        if (executeRecaptcha && userid) {
            var token = executeRecaptcha("comment");
            token.then(function() {
                var _ref = comments_asyncToGenerator(runtime_default().mark(function _callee(res) {
                    var resp, newList;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return dispatch(sendCommentForm(comments_objectSpread({}, form, {
                                    username: user.username,
                                    parent: id,
                                    replyid: 0,
                                    pid: pid,
                                    token: res
                                })));
                            case 2:
                                resp = _ctx.sent;
                                if (resp.payload.success && resp.payload.data) {
                                    newList = [
                                        resp.payload.data
                                    ].concat(commentList);
                                    setCommentList(newList);
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(res) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    };
    var allowCommentaring = function() {
        // Todo: Feature request pushed back in priority. Only allow user that owns tokens in allowedCommentGroups to comment
        // Also make the template below work
        if (allowedCommentGroups && allowedCommentGroups.length > 0 && userid) {
            return true;
        } else if (userid) {
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((comments_module_default())["comments-section"], "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (comments_module_default()).inverted : "", "\n                ").concat(fullwidth ? (comments_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (comments_module_default())[wrapper] : "", "\n            "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accord, {
            id: 99999,
            childrenHeadline: header,
            inverted: inverted,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (comments_module_default()).comments,
                    children: commentList && commentList.length > 0 ? Object.keys(commentList).map(function(key) {
                        if (commentLimit !== undefined && commentLimit > 0 && key >= commentLimit) {
                            return;
                        }
                        var element = commentList[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment, comments_objectSpread({
                            inverted: props.inverted
                        }, element), key);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (comments_module_default()).noComments,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            inverted: inverted,
                            children: typoService.getLabel("comments", "no-comments")
                        })
                    })
                }),
                allowCommentaring() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (comments_module_default()).controls,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_area/* default */.Z, {
                            name: "comment",
                            className: (comments_module_default())["text-area"],
                            register: register,
                            inverted: props.inverted,
                            errorMessage: (ref = errors.comment) === null || ref === void 0 ? void 0 : ref.message,
                            placeholder: typoService.getLabel("comments", "form-comment-placeholder")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (comments_module_default())["button-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                inverted: props.inverted,
                                onClick: handleSubmit(saveComment),
                                pending: supportModel.pending,
                                children: typoService.getLabel("comments", "form-comment-button")
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (comments_module_default())["login-message"],
                    children:  false ? /*#__PURE__*/ 0 : /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        inverted: inverted,
                        children: typoService.getLabel("comments", "login-message")
                    })
                })
            ]
        })
    });
};
Comments.defaultProps = {};


// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(80880);
// EXTERNAL MODULE: ./src/components/typo/countdown/countdown.module.scss
var countdown_module = __webpack_require__(88546);
var countdown_module_default = /*#__PURE__*/__webpack_require__.n(countdown_module);
;// CONCATENATED MODULE: ./src/components/typo/countdown/countdown.tsx
function countdown_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function countdown_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            countdown_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var Countdown = function(props) {
    var id = props.id, inverted = props.inverted, contentTextTag = props.contentTextTag, contentTextLink = props.contentTextLink, contentTextPosition = props.contentTextPosition, label1 = props.label, datetimer = props.datetimer;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var headerAlignment = contentTextPosition ? "text-" + contentTextPosition : "";
    var typoService = new TypoService((0,useTypoContent_hook/* useTypoContent */.f)());
    var date = new Date(datetimer * 1000);
    var timezoneOffset = date.getTimezoneOffset() * 60000;
    var dateWithOffset = new Date(date.getTime() + timezoneOffset);
    var countDownDate = dateWithOffset.getTime();
    var ref = (0,react.useState)(), stopCounter = ref[0], setStopCounter = ref[1];
    var ref1 = (0,react.useState)(countDownDate - new Date().getTime()), countDown1 = ref1[0], setCountDown = ref1[1];
    var headerLink = undefined;
    if (stopCounter) {
        var router = (0,client_router.useRouter)();
        var lang = router.locale ? router.locale.toLowerCase() : "en";
        headerLink = contentTextLink && typeof contentTextLink.href !== "undefined" ? contentTextLink : {
            "href": "/".concat(lang, "/digital-originals"),
            "target": null,
            "class": null,
            "title": null,
            "linkText": "",
            "additionalAttributes": []
        };
    }
    (0,react.useEffect)(function() {
        if (!stopCounter) {
            var interval = setInterval(function() {
                setCountDown(countDownDate - new Date().getTime());
            }, 1000);
            return function() {
                return clearInterval(interval);
            };
        }
    }, [
        countDownDate
    ]);
    var getReturnValues = function(countDown) {
        var days = Math.floor(countDown / (1000 * 60 * 60 * 24));
        var hours = Math.floor(countDown % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(countDown % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(countDown % (1000 * 60) / 1000);
        var generateLabel = function(label) {
            if (label <= 0) {
                return "00";
            } else if (label <= 9 && label > 0) {
                return "0".concat(label);
            }
            return label.toString();
        };
        if (!stopCounter && days < 0 && hours < 0 && minutes < 0 && seconds < 0) {
            setStopCounter(true);
        }
        var text = label1 && label1 !== "" ? label1 : typoService.getLabel("content-elements", "buy-now-countdown");
        return stopCounter ? text : "".concat(generateLabel(days), ":").concat(generateLabel(hours), ":").concat(generateLabel(minutes), ":").concat(generateLabel(seconds));
    };
    var getButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
            variant: button_variants_enum/* ButtonVariantsEnum.PRIMARY */.l.PRIMARY,
            disabled: !stopCounter,
            inverted: inverted,
            className: "height-auto",
            children: stopCounter ? getReturnValues(countDown1) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, countdown_objectSpread({}, props, {
                header: getReturnValues(countDown1),
                bodytext: "",
                subheader: "",
                headerPosition: "center",
                headerLink: "",
                headerLayout: contentTextTag,
                noContentSpacing: true,
                inverted: true,
                noHeadlineSpacing: true
            }))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((countdown_module_default()).countdown, "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (countdown_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, countdown_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bodytext-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((countdown_module_default())[headerAlignment], " ").concat(stopCounter ? "" : (countdown_module_default()).monospace),
                    children: stopCounter && headerLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                        href: headerLink.href,
                        external: headerLink.target !== "" && headerLink.target !== null,
                        title: typeof headerLink.title === "string" ? headerLink.title : "",
                        className: typeof headerLink.class === "string" ? headerLink.class : "",
                        locale: false,
                        children: getButton()
                    }) : getButton()
                })
            })
        ]
    });
};
Countdown.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/div/div.module.scss
var div_module = __webpack_require__(55707);
var div_module_default = /*#__PURE__*/__webpack_require__.n(div_module);
;// CONCATENATED MODULE: ./src/components/typo/div/div.tsx



var DivTypo = function(props) {
    var id = props.id, inverted = props.inverted, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((div_module_default()).div, "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (div_module_default()).inverted : "", "\n                ").concat(fullwidth ? (div_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (div_module_default())[wrapper] : "", "\n            "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
    });
};
DivTypo.defaultProps = {};


// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media_media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/typo/multi/multi.module.scss
var multi_module = __webpack_require__(63246);
var multi_module_default = /*#__PURE__*/__webpack_require__.n(multi_module);
;// CONCATENATED MODULE: ./src/components/typo/file-links/file-links.tsx
function file_links_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function file_links_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            file_links_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// @ts-nocheck




var TypoFileLinks = function(props) {
    var ref2 = (0,react.useState)([]), mediaDataArray = ref2[0], setMediaDataArray = ref2[1];
    var id = props.id, inverted = props.inverted, media = props.media, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    (0,react.useEffect)(function() {
        if (media !== undefined && media.length !== 0) {
            setMediaDataArray(media);
        }
    }, [
        props.media
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n            ".concat("spaceBefore" + appearance.spaceBefore, " \n            ").concat("spaceAfter" + appearance.spaceAfter, " \n            ").concat(inverted ? (multi_module_default()).inverted : "", "\n            ").concat(fullwidth ? (multi_module_default()).fullwidth : "", "\n            ").concat(wrapper !== undefined ? (multi_module_default())[wrapper] : "", "\n          "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (multi_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, file_links_objectSpread({}, props))
            }),
            mediaDataArray.map(function(mediaData, i) {
                var ref, ref1;
                var properties = mediaData.properties;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* Media */.pU, {
                    inverted: inverted,
                    mediaId: properties.fileReferenceUid,
                    src: mediaData.publicUrl,
                    contentType: properties.mimeType,
                    alt: properties.alternative,
                    caption: properties.imageCaption,
                    title: properties.imageTitle,
                    redirectUrl: (ref = properties.linkData) === null || ref === void 0 ? void 0 : ref.href,
                    linkClassName: (ref1 = properties.linkData) === null || ref1 === void 0 ? void 0 : ref1.class
                }, "uploads-".concat(i));
            })
        ]
    });
};
TypoFileLinks.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/header/header.module.scss
var header_module = __webpack_require__(39409);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ./src/components/typo/header/header.tsx
function header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var Header = function(props) {
    var id = props.id, inverted = props.inverted, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((header_module_default())["text-section"], "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (header_module_default()).inverted : "", "\n                ").concat(fullwidth ? (header_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (header_module_default())[wrapper] : "", "\n            "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (header_module_default()).headline,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, header_objectSpread({}, props, {
                noContentSpacing: true
            }))
        })
    });
};
Header.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/html/html.module.scss
var html_module = __webpack_require__(10261);
var html_module_default = /*#__PURE__*/__webpack_require__.n(html_module);
;// CONCATENATED MODULE: ./src/components/typo/html/html.tsx





var HtmlTypo = function(props) {
    var id = props.id, inverted = props.inverted, header = props.header, bodytext = props.bodytext, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var htmlContent = function(text) {
        if (header === "[MISSINGTOKENS]" && text.match("[CODE]")) {
            var typoService = new TypoService((0,useTypoContent_hook/* useTypoContent */.f)());
            var response = typoService.getPageResponse();
            return text.replace("[CODE]", response !== null && response !== void 0 ? response : "");
        } else {
            return text;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((html_module_default()).html, "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (html_module_default()).inverted : "", "\n                ").concat(fullwidth ? (html_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (html_module_default())[wrapper] : "", "\n            "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (html_module_default()).container,
            dangerouslySetInnerHTML: {
                __html: htmlContent(bodytext !== null && bodytext !== void 0 ? bodytext : "")
            }
        })
    });
};
HtmlTypo.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/iframe/iframe.module.scss
var iframe_module = __webpack_require__(4242);
var iframe_module_default = /*#__PURE__*/__webpack_require__.n(iframe_module);
;// CONCATENATED MODULE: ./src/components/typo/iframe/iframe.tsx
function iframe_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function iframe_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            iframe_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var Iframe = function(props) {
    var id = props.id, url = props.url, width = props.width, height = props.height, inverted = props.inverted, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    if (!url) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n        ".concat((iframe_module_default())["iframe-box"], " \n        ").concat("spaceBefore" + appearance.spaceBefore, " \n        ").concat("spaceAfter" + appearance.spaceAfter, "\n        ").concat(inverted ? (iframe_module_default()).inverted : "", " \n        ").concat(fullwidth ? (iframe_module_default()).fullwidth : "", " \n        ").concat(wrapper !== undefined ? (iframe_module_default())[wrapper] : "", "\n      "),
        "data-testid": "iframe-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, iframe_objectSpread({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (iframe_module_default())["iframe-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: url,
                    loading: "lazy",
                    style: {
                        height: height ? height + "px" : "",
                        width: width ? width + "px" : ""
                    }
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ./src/components/typo/_shared/multirow/multirow.module.scss
var multirow_module = __webpack_require__(63384);
var multirow_module_default = /*#__PURE__*/__webpack_require__.n(multirow_module);
;// CONCATENATED MODULE: ./src/components/typo/_shared/multirow/multirow.tsx




var Multirow = function(props) {
    var images = props.images, rowsDesktop = props.rowsDesktop, rowsTablet = props.rowsTablet, rowsMobile = props.rowsMobile, galleryOptions = props.galleryOptions, inverted = props.inverted;
    var elementsPerRow = function(cols) {
        if (cols < 1) {
            cols = 1;
        }
        return cols;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (multirow_module_default())["typoimage-container"],
        children: images && images.map(function(image, i) {
            {
                if (image.publicUrl) {
                    var ref, ref1;
                    var _alternative, _description, _title;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "\n                                ".concat((multirow_module_default())["multi-item-container"], " \n                                ").concat((multirow_module_default())["multi-item-row-" + elementsPerRow(rowsDesktop)], "\n                                ").concat((multirow_module_default())["mobile-multi-item-row-" + elementsPerRow(rowsMobile)], "\n                                ").concat((multirow_module_default())["tablet-multi-item-row-" + elementsPerRow(rowsTablet)], "\n                            "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* Media */.pU, {
                            mediaId: i,
                            contentType: (0,media_media/* getMediaType */.V4)(image.properties.mimeType),
                            src: image.publicUrl,
                            alt: (_alternative = image.properties.alternative) !== null && _alternative !== void 0 ? _alternative : "",
                            caption: (_description = image.properties.description) !== null && _description !== void 0 ? _description : "",
                            title: (_title = image.properties.title) !== null && _title !== void 0 ? _title : "",
                            redirectUrl: (ref = image.properties.linkData) === null || ref === void 0 ? void 0 : ref.href,
                            linkClassName: (ref1 = image.properties.linkData) === null || ref1 === void 0 ? void 0 : ref1.class,
                            imageEffect: galleryOptions === null || galleryOptions === void 0 ? void 0 : galleryOptions.imageEffect,
                            enlargeOnClick: galleryOptions === null || galleryOptions === void 0 ? void 0 : galleryOptions.enlargeOnClick,
                            inverted: inverted
                        })
                    }, i);
                }
            }
        })
    });
};
Multirow.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/image/image.module.scss
var image_module = __webpack_require__(99959);
var image_module_default = /*#__PURE__*/__webpack_require__.n(image_module);
;// CONCATENATED MODULE: ./src/components/typo/image/image.tsx
function image_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Image = function(props) {
    var id = props.id, inverted = props.inverted, images = props.images, gallery = props.gallery, fullwidth = props.fullwidth, wrapper = props.wrapper, columnsMobile = props.columnsMobile, columnsTablet = props.columnsTablet, imageEffect = props.imageEffect, withSubline = props.withSubline, enlargeImageOnClick = props.enlargeImageOnClick;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((image_module_default()).typoimage, " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (image_module_default()).inverted : "", "\n                ").concat(fullwidth ? (image_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (image_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (image_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, image_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (image_module_default())["typoimage-container"],
                children: images && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (image_module_default()).images,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Multirow, {
                        images: images,
                        rowsDesktop: gallery.count.columns,
                        rowsTablet: columnsTablet,
                        rowsMobile: columnsMobile,
                        galleryOptions: {
                            imageEffect: {
                                effect: imageEffect !== null && imageEffect !== void 0 ? imageEffect : "",
                                withSubline: withSubline !== null && withSubline !== void 0 ? withSubline : false
                            },
                            enlargeOnClick: enlargeImageOnClick
                        },
                        inverted: inverted
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/typo/menu_abstract/menu_abstract.module.scss
var menu_abstract_module = __webpack_require__(5021);
var menu_abstract_module_default = /*#__PURE__*/__webpack_require__.n(menu_abstract_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_abstract/menu_abstract.tsx
function menu_abstract_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_abstract_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_abstract_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_abstract = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_abstract_module_default())["menu_abstract-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_abstract_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_abstract_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_abstract_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_abstract_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_abstract_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_abstract_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                target: menuObj.target,
                                href: menuObj.link,
                                title: menuObj.title,
                                linkText: menuObj.title,
                                class: menuObj.active ? "active" : ""
                            })
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_abstract.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/menu_categorized_content/menu_categorized_content.module.scss
var menu_categorized_content_module = __webpack_require__(14779);
var menu_categorized_content_module_default = /*#__PURE__*/__webpack_require__.n(menu_categorized_content_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_categorized_content/menu_categorized_content.tsx
function menu_categorized_content_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_categorized_content_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_categorized_content_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_categorized_content = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_categorized_content_module_default())["menu_categorized_content-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_categorized_content_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_categorized_content_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_categorized_content_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_categorized_content_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_categorized_content_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_categorized_content_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                target: menuObj.target,
                                href: menuObj.link,
                                title: menuObj.title,
                                linkText: menuObj.title,
                                class: menuObj.active ? "active" : ""
                            })
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_categorized_content.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/menu_categorized_pages/menu_categorized_pages.module.scss
var menu_categorized_pages_module = __webpack_require__(96055);
var menu_categorized_pages_module_default = /*#__PURE__*/__webpack_require__.n(menu_categorized_pages_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_categorized_pages/menu_categorized_pages.tsx
function menu_categorized_pages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_categorized_pages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_categorized_pages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_categorized_pages = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_categorized_pages_module_default())["menu_categorized_pages-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_categorized_pages_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_categorized_pages_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_categorized_pages_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_categorized_pages_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_categorized_pages_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_categorized_pages_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                target: menuObj.target,
                                href: menuObj.link,
                                title: menuObj.title,
                                linkText: menuObj.title,
                                class: menuObj.active ? "active" : ""
                            })
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_categorized_pages.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/menu_pages/menu_pages.module.scss
var menu_pages_module = __webpack_require__(44792);
var menu_pages_module_default = /*#__PURE__*/__webpack_require__.n(menu_pages_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_pages/menu_pages.tsx
function menu_pages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_pages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_pages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_pages = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_pages_module_default())["menu_pages-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_pages_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_pages_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_pages_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_pages_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_pages_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_pages_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                target: menuObj.target,
                                href: menuObj.link,
                                title: menuObj.title,
                                linkText: menuObj.title,
                                class: menuObj.active ? "active" : ""
                            })
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_pages.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/menu_related_pages/menu_related_pages.module.scss
var menu_related_pages_module = __webpack_require__(81613);
var menu_related_pages_module_default = /*#__PURE__*/__webpack_require__.n(menu_related_pages_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_related_pages/menu_related_pages.tsx
function menu_related_pages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_related_pages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_related_pages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_related_pages = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_related_pages_module_default())["menu_related_pages-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_related_pages_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_related_pages_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_related_pages_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_related_pages_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_related_pages_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_related_pages_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                target: menuObj.target,
                                href: menuObj.link,
                                title: menuObj.title,
                                linkText: menuObj.title,
                                class: menuObj.active ? "active" : ""
                            })
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_related_pages.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/menu_sitemap/menu_sitemap.module.scss
var menu_sitemap_module = __webpack_require__(67341);
var menu_sitemap_module_default = /*#__PURE__*/__webpack_require__.n(menu_sitemap_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_sitemap/menu_sitemap.tsx
function menu_sitemap_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_sitemap_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_sitemap_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_sitemap = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_sitemap_module_default())["menu_sitemap-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_sitemap_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_sitemap_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_sitemap_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_sitemap_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_sitemap_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_sitemap_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    target: menuObj.target,
                                    href: menuObj.link,
                                    title: menuObj.title,
                                    linkText: menuObj.title,
                                    class: menuObj.active ? "active" : ""
                                }),
                                menuObj.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: Object.keys(menuObj.children).map(function(k) {
                                        var subMenuObj = menuObj.children[k];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                target: subMenuObj.target,
                                                href: subMenuObj.link,
                                                title: subMenuObj.title,
                                                linkText: subMenuObj.title,
                                                class: subMenuObj.active ? "active" : ""
                                            })
                                        }, id + subMenuObj.link + subMenuObj.title);
                                    })
                                })
                            ]
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_sitemap.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/menu_sitemap_pages/menu_sitemap_pages.module.scss
var menu_sitemap_pages_module = __webpack_require__(29229);
var menu_sitemap_pages_module_default = /*#__PURE__*/__webpack_require__.n(menu_sitemap_pages_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_sitemap_pages/menu_sitemap_pages.tsx
function menu_sitemap_pages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_sitemap_pages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_sitemap_pages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_sitemap_pages = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_sitemap_pages_module_default())["menu_sitemap_pages-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_sitemap_pages_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_sitemap_pages_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_sitemap_pages_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_sitemap_pages_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_sitemap_pages_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_sitemap_pages_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                target: menuObj.target,
                                href: menuObj.link,
                                title: menuObj.title,
                                linkText: menuObj.title,
                                class: menuObj.active ? "active" : ""
                            })
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_sitemap_pages.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/menu_subpages/menu_subpages.module.scss
var menu_subpages_module = __webpack_require__(48682);
var menu_subpages_module_default = /*#__PURE__*/__webpack_require__.n(menu_subpages_module);
;// CONCATENATED MODULE: ./src/components/typo/menu_subpages/menu_subpages.tsx
function menu_subpages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_subpages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_subpages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Menu_subpages = function(props) {
    var id = props.id, inverted = props.inverted, menu = props.menu, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((menu_subpages_module_default())["menu_subpages-section"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (menu_subpages_module_default()).inverted : "", "\n                ").concat(fullwidth ? (menu_subpages_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (menu_subpages_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_subpages_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, menu_subpages_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_subpages_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: Object.keys(menu).map(function(key) {
                        var menuObj = menu[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                target: menuObj.target,
                                href: menuObj.link,
                                title: menuObj.title,
                                linkText: menuObj.title,
                                class: menuObj.active ? "active" : ""
                            })
                        }, id + menuObj.link + menuObj.title);
                    })
                })
            })
        ]
    });
};
Menu_subpages.defaultProps = {};


// EXTERNAL MODULE: ./src/utils/_enums/horizontal-position.enum.ts
var horizontal_position_enum = __webpack_require__(40579);
// EXTERNAL MODULE: ./src/components/typo/mp3/mp3.module.scss
var mp3_module = __webpack_require__(71033);
var mp3_module_default = /*#__PURE__*/__webpack_require__.n(mp3_module);
// EXTERNAL MODULE: ./src/components/typo/mp3/utility/audio-bar/audio-bar.module.scss
var audio_bar_module = __webpack_require__(5855);
var audio_bar_module_default = /*#__PURE__*/__webpack_require__.n(audio_bar_module);
;// CONCATENATED MODULE: ./src/components/typo/mp3/utility/audio-bar/audio-bar.tsx



var AudioBar = function(props) {
    var trackProgress = props.trackProgress, duration = props.duration, onScrub = props.onScrub, onScrubEnd = props.onScrubEnd, trackStyling = props.trackStyling;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (audio_bar_module_default()).bar,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            type: "range",
            value: trackProgress,
            step: "1",
            min: "0",
            max: duration ? duration : "".concat(duration),
            className: (audio_bar_module_default()).progress,
            onChange: function(e) {
                return onScrub(e.target.value);
            },
            onMouseUp: onScrubEnd,
            onKeyUp: onScrubEnd,
            style: {
                background: trackStyling
            }
        })
    });
};
AudioBar.defaultProps = {};


// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./src/components/typo/mp3/utility/audio-controls/audio-controls.module.scss
var audio_controls_module = __webpack_require__(99404);
var audio_controls_module_default = /*#__PURE__*/__webpack_require__.n(audio_controls_module);
;// CONCATENATED MODULE: ./src/components/typo/mp3/utility/audio-controls/audio-controls.tsx




var AudioControls = function(props) {
    var tracks = props.tracks, isPlaying = props.isPlaying, onPlayPauseClick = props.onPlayPauseClick, onPrevClick = props.onPrevClick, onNextClick = props.onNextClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (audio_controls_module_default())["audio-controls"],
        children: [
            tracks > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (audio_controls_module_default()).prev,
                "aria-label": "Previous",
                onClick: onPrevClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoIosSkipBackward */.MZe, {})
            }),
            isPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (audio_controls_module_default()).pause,
                onClick: function() {
                    return onPlayPauseClick(false);
                },
                "aria-label": "Pause",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoMdPause */.IWN, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (audio_controls_module_default()).play,
                onClick: function() {
                    return onPlayPauseClick(true);
                },
                "aria-label": "Play",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoMdPlay */.v$e, {})
            }),
            tracks > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (audio_controls_module_default()).next,
                "aria-label": "Next",
                onClick: onNextClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoIosSkipForward */.C_s, {})
            })
        ]
    });
};
AudioControls.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/mp3/utility/audio-volume/audio-volume.module.scss
var audio_volume_module = __webpack_require__(97955);
var audio_volume_module_default = /*#__PURE__*/__webpack_require__.n(audio_volume_module);
;// CONCATENATED MODULE: ./src/components/typo/mp3/utility/audio-volume/audio-volume.tsx




var AudioVolume = function(props) {
    var colorGrading = props.colorGrading, muteVolume = props.muteVolume, volume = props.volume, setVolume = props.setVolume, setMuteVolume = props.setMuteVolume;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (audio_volume_module_default()).volume,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return setMuteVolume(function(prev) {
                        return !prev;
                    });
                },
                children: muteVolume || volume < 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoMdVolumeOff */.ks2, {}) : volume < 40 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoMdVolumeLow */.qa_, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoMdVolumeHigh */.Gwd, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "range",
                className: (audio_volume_module_default()).slider,
                min: 0,
                max: 100,
                value: volume,
                style: {
                    background: "linear-gradient(to right, ".concat(colorGrading, " ").concat(volume, "%, #bababa ").concat(volume, "%)")
                },
                onChange: function(e) {
                    return setVolume(e.target.value);
                }
            })
        ]
    });
};
AudioVolume.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/mp3/templates/big/big-template.module.scss
var big_template_module = __webpack_require__(88149);
var big_template_module_default = /*#__PURE__*/__webpack_require__.n(big_template_module);
;// CONCATENATED MODULE: ./src/components/typo/mp3/templates/big/big-template.tsx






var BigTemplate = function(props) {
    var ref, ref1;
    var track = props.track, tracks = props.tracks, trackStyling = props.trackStyling, colorGrading = props.colorGrading, trackProgress = props.trackProgress, duration = props.duration, muteVolume = props.muteVolume, audioRef = props.audioRef, isPlaying = props.isPlaying, volume = props.volume, setIsPlaying = props.setIsPlaying, onScrub = props.onScrub, setMuteVolume = props.setMuteVolume, onScrubEnd = props.onScrubEnd, toPrevTrack = props.toPrevTrack, toNextTrack = props.toNextTrack, setVolume = props.setVolume, formatTime = props.formatTime;
    var title = track.title, description = track.description, image = track.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (big_template_module_default())["audio-player"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (big_template_module_default())["track-info"],
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (big_template_module_default()).artwork,
                    src: image,
                    alt: "".concat(title, " cover")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (big_template_module_default()).title,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: (big_template_module_default()).description,
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioControls, {
                    tracks: tracks,
                    isPlaying: isPlaying,
                    onPrevClick: toPrevTrack,
                    onNextClick: toNextTrack,
                    onPlayPauseClick: setIsPlaying
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (big_template_module_default())["progress-timer"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: formatTime((ref = audioRef.current) === null || ref === void 0 ? void 0 : ref.currentTime)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: formatTime((ref1 = audioRef.current) === null || ref1 === void 0 ? void 0 : ref1.duration)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (big_template_module_default()).controls,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioBar, {
                            trackProgress: trackProgress,
                            duration: duration,
                            onScrub: onScrub,
                            onScrubEnd: onScrubEnd,
                            trackStyling: trackStyling
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioVolume, {
                            colorGrading: colorGrading,
                            muteVolume: muteVolume,
                            volume: volume,
                            setVolume: setVolume,
                            setMuteVolume: setMuteVolume
                        })
                    ]
                })
            ]
        })
    });
};
BigTemplate.defaultProps = {};


// EXTERNAL MODULE: ./src/components/typo/mp3/templates/small/small-template.module.scss
var small_template_module = __webpack_require__(45244);
var small_template_module_default = /*#__PURE__*/__webpack_require__.n(small_template_module);
;// CONCATENATED MODULE: ./src/components/typo/mp3/templates/small/small-template.tsx






var SmallTemplate = function(props) {
    var ref, ref1;
    var track = props.track, tracks = props.tracks, trackStyling = props.trackStyling, colorGrading = props.colorGrading, trackProgress = props.trackProgress, duration = props.duration, muteVolume = props.muteVolume, audioRef = props.audioRef, isPlaying = props.isPlaying, volume = props.volume, setIsPlaying = props.setIsPlaying, onScrub = props.onScrub, setMuteVolume = props.setMuteVolume, onScrubEnd = props.onScrubEnd, toPrevTrack = props.toPrevTrack, toNextTrack = props.toNextTrack, setVolume = props.setVolume, formatTime = props.formatTime;
    var title = track.title, description = track.description, image = track.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (small_template_module_default())["audio-player"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (small_template_module_default())["audio-player-information"],
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (small_template_module_default()).artwork,
                        src: image,
                        alt: "".concat(title, " cover")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (small_template_module_default())["track-info"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (small_template_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: (small_template_module_default()).description,
                                children: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (small_template_module_default())["progress-timer"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: formatTime((ref = audioRef.current) === null || ref === void 0 ? void 0 : ref.currentTime)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (small_template_module_default())["progress-timer-symbol"],
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: formatTime((ref1 = audioRef.current) === null || ref1 === void 0 ? void 0 : ref1.duration)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioControls, {
                tracks: tracks,
                isPlaying: isPlaying,
                onPrevClick: toPrevTrack,
                onNextClick: toNextTrack,
                onPlayPauseClick: setIsPlaying
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (small_template_module_default()).controls,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioBar, {
                        trackProgress: trackProgress,
                        duration: duration,
                        onScrub: onScrub,
                        onScrubEnd: onScrubEnd,
                        trackStyling: trackStyling
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioVolume, {
                        colorGrading: colorGrading,
                        muteVolume: muteVolume,
                        volume: volume,
                        setVolume: setVolume,
                        setMuteVolume: setMuteVolume
                    })
                ]
            })
        ]
    });
};
SmallTemplate.defaultProps = {};


;// CONCATENATED MODULE: ./src/components/typo/mp3/mp3.tsx
function mp3_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mp3_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mp3_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var Mp3 = function(props) {
    var id = props.id, inverted = props.inverted, headerPosition = props.headerPosition, template = props.template, media = props.media, gallery = props.gallery, buttons = props.buttons, fullwidth = props.fullwidth, wrapper = props.wrapper;
    if (media.length <= 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var _appearance;
    /*--Element container specific--*/ var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var imagePosition1 = headerPosition ? headerPosition.toLowerCase() : "";
    var textClass = function(imagePosition) {
        if (imagePosition === horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT) {
            return (mp3_module_default())["left-wrapper"];
        } else if (imagePosition === horizontal_position_enum/* HorizontalPosition.CENTER */.D.CENTER) {
            return (mp3_module_default())["center-wrapper"];
        } else {
            return (mp3_module_default())["right-wrapper"];
        }
    };
    var imageClass = function(imagePosition) {
        if (imagePosition === horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT) {
            return (mp3_module_default())["right-wrapper-img"];
        } else if (imagePosition === horizontal_position_enum/* HorizontalPosition.CENTER */.D.CENTER) {
            return (mp3_module_default())["center-wrapper-img"];
        } else {
            return (mp3_module_default())["left-wrapper-img"];
        }
    };
    var generateTrackList = function() {
        var mp3MediaTracks = [];
        if (media && media.length > 0) {
            for(var key in media){
                var ref, ref6;
                var m = media[key];
                mp3MediaTracks[key] = {
                    title: m.properties.title,
                    description: m.properties.description,
                    audioSrc: m.publicUrl,
                    image: (ref6 = (ref = gallery === null || gallery === void 0 ? void 0 : gallery.rows[1]) === null || ref === void 0 ? void 0 : ref.columns[trackIndex + 1]) === null || ref6 === void 0 ? void 0 : ref6.publicUrl,
                    autoplay: m.properties.autoplay
                };
            }
        }
        return mp3MediaTracks;
    };
    /*--Audio/MP3 controls--*/ var ref7 = (0,react.useState)(0), trackIndex = ref7[0], setTrackIndex = ref7[1];
    var ref1 = (0,react.useState)(0), trackProgress = ref1[0], setTrackProgress = ref1[1];
    var ref2 = (0,react.useState)(false), isPlaying = ref2[0], setIsPlaying = ref2[1];
    var ref3 = (0,react.useState)(60), volume = ref3[0], setVolume = ref3[1];
    var ref4 = (0,react.useState)(false), muteVolume = ref4[0], setMuteVolume = ref4[1];
    var ref5 = (0,react.useState)(false), autoplayUsed = ref5[0], setAutoplayUsed = ref5[1];
    var tracks = generateTrackList();
    var _trackIndex = tracks[trackIndex], audioSrc = _trackIndex.audioSrc, autoplay = _trackIndex.autoplay;
    var audioRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        audioRef.current = new Audio(audioSrc);
    }, []);
    var intervalRef = (0,react.useRef)();
    var isReady = (0,react.useRef)(false);
    var _current;
    var duration = ((_current = audioRef.current) !== null && _current !== void 0 ? _current : 0).duration;
    var currentPercentage = duration ? "".concat(Math.ceil(trackProgress / duration * 100), "%") : "0%";
    var colorGrading = inverted ? "#ffffff" : "#000000";
    var trackStyling = "-webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(".concat(currentPercentage, ", ").concat(colorGrading, "), color-stop(").concat(currentPercentage, ", #bababa))");
    (0,react.useEffect)(function() {
        if (!autoplayUsed && autoplay) {
            audioRef.current.play();
            setAutoplayUsed(true);
        }
        // Pause and clean up on unmount
        return function() {
            audioRef.current.pause();
            clearInterval(intervalRef.current);
        };
    }, []);
    // Handle setup when changing tracks
    (0,react.useEffect)(function() {
        audioRef.current.pause();
        audioRef.current = new Audio(audioSrc);
        setTrackProgress(audioRef.current.currentTime);
        if (isReady.current) {
            audioRef.current.play();
            setIsPlaying(true);
            startTimer();
        } else {
            // Set the isReady ref as true for the next pass
            isReady.current = true;
        }
    }, [
        trackIndex
    ]);
    (0,react.useEffect)(function() {
        if (isPlaying) {
            audioRef.current.play();
            startTimer();
        } else {
            clearInterval(intervalRef.current);
            audioRef.current.pause();
        }
    }, [
        isPlaying
    ]);
    (0,react.useEffect)(function() {
        if (audioRef) {
            audioRef.current.volume = volume / 100;
            audioRef.current.muted = muteVolume;
        }
    }, [
        volume,
        audioRef,
        muteVolume
    ]);
    var startTimer = function() {
        // Clear any timers already running
        clearInterval(intervalRef.current);
        // @ts-ignore
        intervalRef.current = setInterval(function() {
            if (audioRef.current.ended) {
                toNextTrack();
            } else {
                setTrackProgress(audioRef.current.currentTime);
            }
        }, 100);
    };
    var onScrub = function(value) {
        // Clear any timers already running
        clearInterval(intervalRef.current);
        audioRef.current.currentTime = value;
        setTrackProgress(audioRef.current.currentTime);
    };
    var onScrubEnd = function() {
        // If not already playing, start
        if (!isPlaying) {
            setIsPlaying(true);
        }
        startTimer();
    };
    var toPrevTrack = function() {
        if (trackIndex - 1 < 0) {
            setTrackIndex(tracks.length - 1);
        } else {
            setTrackIndex(trackIndex - 1);
        }
    };
    var toNextTrack = function() {
        if (trackIndex < tracks.length - 1) {
            setTrackIndex(trackIndex + 1);
        } else if (tracks.length === 1 && trackIndex === tracks.length - 1) {
            setIsPlaying(false);
        } else {
            setTrackIndex(0);
        }
    };
    var formatTime = function(timeInSeconds) {
        if (!timeInSeconds) {
            return "00:00";
        }
        var minutes = Math.floor(Math.ceil(timeInSeconds) / 60);
        var seconds = Math.floor(Math.ceil(timeInSeconds) % 60);
        var formattedMinutes = minutes < 10 ? "0".concat(minutes) : "".concat(minutes);
        var formattedSeconds = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
        return "".concat(formattedMinutes, ":").concat(formattedSeconds);
    };
    var mp3Template = function() {
        if (template === "smallCover") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTemplate, {
                track: tracks[trackIndex],
                tracks: tracks.length,
                onScrub: onScrub,
                onScrubEnd: onScrubEnd,
                toPrevTrack: toPrevTrack,
                toNextTrack: toNextTrack,
                formatTime: formatTime,
                currentPercentage: currentPercentage,
                trackStyling: trackStyling,
                colorGrading: colorGrading,
                audioRef: audioRef,
                trackProgress: trackProgress,
                duration: duration,
                muteVolume: muteVolume,
                isPlaying: isPlaying,
                setIsPlaying: setIsPlaying,
                volume: volume,
                setVolume: setVolume,
                setMuteVolume: setMuteVolume
            });
        } else if (template === "bigCover") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BigTemplate, {
                track: tracks[trackIndex],
                tracks: tracks.length,
                onScrub: onScrub,
                onScrubEnd: onScrubEnd,
                toPrevTrack: toPrevTrack,
                toNextTrack: toNextTrack,
                formatTime: formatTime,
                currentPercentage: currentPercentage,
                trackStyling: trackStyling,
                colorGrading: colorGrading,
                audioRef: audioRef,
                trackProgress: trackProgress,
                duration: duration,
                muteVolume: muteVolume,
                isPlaying: isPlaying,
                setIsPlaying: setIsPlaying,
                volume: volume,
                setVolume: setVolume,
                setMuteVolume: setMuteVolume
            });
        } else {
            if (!media || media.length <= 0) {
                return;
            }
            var mp3Media = media[0];
            var _alternative, _autoplay, _description, _title, _link;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* Media */.pU, {
                mediaId: id,
                contentType: (0,media_media/* getMediaType */.V4)(mp3Media.properties.mimeType),
                src: mp3Media.publicUrl,
                alt: (_alternative = mp3Media.properties.alternative) !== null && _alternative !== void 0 ? _alternative : "",
                autoplay: (_autoplay = mp3Media.properties.autoplay) !== null && _autoplay !== void 0 ? _autoplay : false,
                caption: (_description = mp3Media.properties.description) !== null && _description !== void 0 ? _description : "",
                title: (_title = mp3Media.properties.title) !== null && _title !== void 0 ? _title : "",
                redirectUrl: (_link = mp3Media.properties.link) !== null && _link !== void 0 ? _link : "",
                inverted: inverted
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((mp3_module_default())["text-image-teaser"], "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (mp3_module_default()).inverted : "", "\n                ").concat(fullwidth ? (mp3_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (mp3_module_default())[wrapper] : "", "\n                ").concat(imagePosition1 === horizontal_position_enum/* HorizontalPosition.CENTER */.D.CENTER ? (mp3_module_default())["text-image-center"] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(textClass(imagePosition1)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, mp3_objectSpread({}, props, {
                        noHeadlineSpacing: true,
                        noTextAlignment: true,
                        variant: "teaser"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoButtons, {
                        inverted: inverted,
                        buttons: buttons
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(imageClass(imagePosition1)),
                children: mp3Template()
            })
        ]
    });
};
Mp3.defaultProps = {};


// EXTERNAL MODULE: ./src/components/_shared/teaser-card/teaser-card.tsx + 17 modules
var teaser_card = __webpack_require__(33076);
// EXTERNAL MODULE: ./src/utils/_helper/strapi-mapper.tsx
var strapi_mapper = __webpack_require__(962);
// EXTERNAL MODULE: ./src/components/typo/multi/templates/product-summary/product-summary.module.scss
var product_summary_module = __webpack_require__(90534);
var product_summary_module_default = /*#__PURE__*/__webpack_require__.n(product_summary_module);
;// CONCATENATED MODULE: ./src/components/typo/multi/templates/product-summary/product-summary.tsx








var ProductSummary = function(props) {
    var inverted = props.inverted, topline = props.topline, headline = props.headline, subline = props.subline, tag = props.tag, tagStyle = props.tagStyle, headlineAlign = props.headlineAlign, bodytext = props.bodytext, bordered = props.bordered, buttons = props.buttons, media = props.media;
    var callToMedia = media ? media[0] : {};
    var formattedBodytext = bodytext.split(/(<[a-zA-Z0-9]+>\[MEDIA\]<\/[a-zA-Z0-9]+>)/);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "\n                ".concat((product_summary_module_default())["product-summary"], "\n                ").concat(bordered ? (product_summary_module_default()).bordered : "", "\n                ").concat(inverted ? (product_summary_module_default()).inverted : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(headlineAlign ? (product_summary_module_default())["text-" + headlineAlign] : ""),
                children: [
                    topline && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        className: (product_summary_module_default()).topline,
                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5_LIGHT */.H.HEADING5_LIGHT,
                        inverted: inverted,
                        children: topline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        className: (product_summary_module_default()).headline,
                        variant: tagStyle ? (0,strapi_mapper/* mapStrapiHeadline */.z)(tagStyle.toUpperCase()) : typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                        inverted: inverted,
                        element: tag ? tag : "h3",
                        children: headline
                    }),
                    subline && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        className: (product_summary_module_default()).subline,
                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5_LIGHT */.H.HEADING5_LIGHT,
                        inverted: inverted,
                        children: subline
                    })
                ]
            }),
            formattedBodytext ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bodytext-container",
                children: formattedBodytext.map(function(text, i) {
                    if (text.includes("[MEDIA]")) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* default */.ZP, {
                                className: (product_summary_module_default()).media,
                                isTeaser: true,
                                contentType: (0,media_media/* getMediaType */.V4)(callToMedia === null || callToMedia === void 0 ? void 0 : (ref = callToMedia.properties) === null || ref === void 0 ? void 0 : ref.mimeType),
                                autoplay: callToMedia === null || callToMedia === void 0 ? void 0 : (ref1 = callToMedia.properties) === null || ref1 === void 0 ? void 0 : ref1.autoplay,
                                src: callToMedia === null || callToMedia === void 0 ? void 0 : callToMedia.publicUrl,
                                caption: callToMedia === null || callToMedia === void 0 ? void 0 : (ref2 = callToMedia.properties) === null || ref2 === void 0 ? void 0 : ref2.description,
                                title: callToMedia === null || callToMedia === void 0 ? void 0 : (ref3 = callToMedia.properties) === null || ref3 === void 0 ? void 0 : ref3.title,
                                alt: callToMedia === null || callToMedia === void 0 ? void 0 : (ref4 = callToMedia.properties) === null || ref4 === void 0 ? void 0 : ref4.alternative,
                                redirectUrl: callToMedia === null || callToMedia === void 0 ? void 0 : (ref5 = callToMedia.properties) === null || ref5 === void 0 ? void 0 : ref5.link,
                                linkClassName: callToMedia === null || callToMedia === void 0 ? void 0 : (ref6 = callToMedia.properties) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.linkData) === null || ref7 === void 0 ? void 0 : ref7.class,
                                inverted: inverted
                            })
                        }, i);
                    } else if (text && text.trim() != "") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bodytext-container bodytext-padding",
                            dangerouslySetInnerHTML: {
                                __html: text
                            }
                        }, i);
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: bodytext && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((product_summary_module_default()).bodytext, " bodytext-container"),
                    dangerouslySetInnerHTML: {
                        __html: bodytext
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoButtons, {
                inverted: inverted,
                buttons: buttons
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/typo/multi/multi.tsx
function multi_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var TypoMulti = function(props) {
    var ref2;
    var id = props.id, inverted = props.inverted, elementsPerRow = props.elementsPerRow, rowsMobile = props.rowsMobile, rowsTablet = props.rowsTablet, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var row = function(cols) {
        if (cols < 1) {
            cols = 1;
        }
        return cols;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n            ".concat("spaceBefore" + appearance.spaceBefore, " \n            ").concat("spaceAfter" + appearance.spaceAfter, " \n            ").concat(inverted ? (multi_module_default()).inverted : "", "\n            ").concat(fullwidth ? (multi_module_default()).fullwidth : "", "\n            ").concat(wrapper !== undefined ? (multi_module_default())[wrapper] : "", "\n        "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (multi_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, multi_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (multi_module_default()).multi,
                children: [
                    (ref2 = props.elements) === null || ref2 === void 0 ? void 0 : ref2.map(function(element, i) {
                        switch(element.type){
                            case "product-summary":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "\n                                            ".concat((multi_module_default())["multi-item-container"], " \n                                            ").concat((multi_module_default())["multi-item-row-" + row(elementsPerRow)], "\n                                            ").concat((multi_module_default())["mobile-multi-item-row-" + row(rowsMobile)], "\n                                            ").concat((multi_module_default())["tablet-multi-item-row-" + row(rowsTablet)], "\n                                         "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSummary, multi_objectSpread({}, element, {
                                        inverted: inverted
                                    }))
                                }, "multi-item-product-summary-" + element.uid);
                            case "creatoken":
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "\n                                            ".concat((multi_module_default())["multi-item-container"], " \n                                            ").concat((multi_module_default())["multi-item-row-" + row(elementsPerRow)], "\n                                            ").concat((multi_module_default())["mobile-multi-item-row-" + row(rowsMobile)], "\n                                            ").concat((multi_module_default())["tablet-multi-item-row-" + row(rowsTablet)], "\n                                         "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* Media */.pU, {
                                        mediaId: i,
                                        inverted: inverted,
                                        src: element.media.length > 0 ? element.media[0].publicUrl : undefined,
                                        contentType: element.media.length > 0 ? element.media[0].properties.mimeType : undefined,
                                        alt: element.media.length > 0 ? element.media[0].properties.alternative : undefined,
                                        caption: element.media.length > 0 ? element.media[0].properties.description : undefined,
                                        title: element.media.length > 0 ? element.media[0].properties.title : undefined,
                                        redirectUrl: element.media.length > 0 ? (ref = element.media[0].properties.linkData) === null || ref === void 0 ? void 0 : ref.href : undefined,
                                        linkClassName: element.media.length > 0 ? (ref1 = element.media[0].properties.linkData) === null || ref1 === void 0 ? void 0 : ref1.class : undefined
                                    }, "multi-media-".concat(i))
                                }, "multi-item-creatoken-" + element.uid);
                            case "teaser":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "\n                                            ".concat((multi_module_default())["multi-item-container"], " \n                                            ").concat((multi_module_default())["multi-item-row-" + row(elementsPerRow)], "\n                                            ").concat((multi_module_default())["mobile-multi-item-row-" + row(rowsMobile)], "\n                                            ").concat((multi_module_default())["tablet-multi-item-row-" + row(rowsTablet)], "\n                                         "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                                        variantId: element.variantId,
                                        variantProductId: element.variantProductId,
                                        instanceId: element.instanceId,
                                        instanceProductId: element.instanceProductId
                                    }, "multi-card-".concat(i))
                                }, "multi-item-card-" + element.uid);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((multi_module_default())["multi-item-container"], " ").concat((multi_module_default())["multi-item-placeholder"], " ").concat(elementsPerRow ? (multi_module_default())["multi-item-row-" + elementsPerRow] : ""),
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((multi_module_default())["multi-item-container"], " ").concat((multi_module_default())["multi-item-placeholder"], " ").concat(elementsPerRow ? (multi_module_default())["multi-item-row-" + elementsPerRow] : ""),
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((multi_module_default())["multi-item-container"], " ").concat((multi_module_default())["multi-item-placeholder"], " ").concat(elementsPerRow ? (multi_module_default())["multi-item-row-" + elementsPerRow] : ""),
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((multi_module_default())["multi-item-container"], " ").concat((multi_module_default())["multi-item-placeholder"], " ").concat(elementsPerRow ? (multi_module_default())["multi-item-row-" + elementsPerRow] : ""),
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((multi_module_default())["multi-item-container"], " ").concat((multi_module_default())["multi-item-placeholder"], " ").concat(elementsPerRow ? (multi_module_default())["multi-item-row-" + elementsPerRow] : ""),
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((multi_module_default())["multi-item-container"], " ").concat((multi_module_default())["multi-item-placeholder"], " ").concat(elementsPerRow ? (multi_module_default())["multi-item-row-" + elementsPerRow] : ""),
                        children: "\xa0"
                    })
                ]
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/_shared/select/select.tsx
var select_select = __webpack_require__(39382);
// EXTERNAL MODULE: ./src/components/typo/news-list/news-list.module.scss
var news_list_module = __webpack_require__(64718);
var news_list_module_default = /*#__PURE__*/__webpack_require__.n(news_list_module);
// EXTERNAL MODULE: ./src/components/typo/news-list/templates/academy/academy_template.module.scss
var academy_template_module = __webpack_require__(60848);
var academy_template_module_default = /*#__PURE__*/__webpack_require__.n(academy_template_module);
;// CONCATENATED MODULE: ./src/components/typo/news-list/templates/academy/academy_template.tsx
function academy_template_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function academy_template_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            academy_template_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var Academy_Template = function(props) {
    var uid = props.uid, title = props.title, teaser = props.teaser, bodytext = props.bodytext, categories = props.categories, author = props.author, relatedNews = props.relatedNews, falRelatedFiles = props.falRelatedFiles, datetime = props.datetime, slug = props.slug, inverted = props.inverted, returnUrl = props.returnUrl, view1 = props.view;
    var typoService = new TypoService((0,useTypoContent_hook/* useTypoContent */.f)());
    var truncateTeaser = teaser.length > 340 ? teaser.slice(0, 340).trim() + "..." : teaser;
    var mainImage = falRelatedFiles ? falRelatedFiles[0] : undefined;
    var image = mainImage === null || mainImage === void 0 ? void 0 : mainImage.images.defaultImage;
    var imageProps = mainImage === null || mainImage === void 0 ? void 0 : mainImage.properties;
    var imageUrl = image === null || image === void 0 ? void 0 : image.publicUrl;
    var imageType = imageProps === null || imageProps === void 0 ? void 0 : imageProps.mimetype;
    var generateCategories = function() {
        return categories.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                href: "".concat(returnUrl, "?catid=").concat(item.id),
                class: (academy_template_module_default()).link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (academy_template_module_default()).category,
                    children: item.title
                })
            }, "cat-".concat(item.id));
        });
    };
    var generateAuthor = function(view) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((academy_template_module_default())["card-author"], " ").concat((academy_template_module_default())[view], " ").concat(view === "detail" ? (academy_template_module_default()).spacing : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (academy_template_module_default()).author,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (academy_template_module_default())["author-image"],
                            src: "/favicon.svg",
                            alt: "Profile"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["author-name"],
                            children: (ref = author === null || author === void 0 ? void 0 : author.author) !== null && ref !== void 0 ? ref : ""
                        })
                    ]
                }),
                view === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (academy_template_module_default()).created,
                    children: datetime
                })
            ]
        });
    };
    var generateRelatedNews = function() {
        if (!relatedNews) {
            return;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "".concat((academy_template_module_default())["news-related-headline"]),
                    children: typoService.getLabel("content-elements", "related-news")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((academy_template_module_default())["news-related-news"]),
                    children: [
                        relatedNews.map(function(element) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (academy_template_module_default())["news-item"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Academy_Template, academy_template_objectSpread({}, element, {
                                    returnUrl: returnUrl,
                                    inverted: inverted,
                                    view: "list"
                                }))
                            }, "news-list-item-container-" + element.uid);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default())["news-item"]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n                ".concat((academy_template_module_default()).academy_template, " \n                ").concat((academy_template_module_default())["academy-" + view1], "\n                ").concat(inverted ? (academy_template_module_default()).inverted : "", "\n            "),
        children: String(view1) === "list" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
            href: slug !== null && slug !== void 0 ? slug : "",
            class: (academy_template_module_default()).link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (academy_template_module_default()).card,
                children: [
                    imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (academy_template_module_default())["card-image"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* Media */.pU, {
                            mediaId: uid,
                            contentType: (0,media_media/* getMediaType */.V4)(imageType),
                            src: imageUrl,
                            inverted: inverted,
                            caption: imageProps === null || imageProps === void 0 ? void 0 : imageProps.description,
                            redirectUrl: imageProps === null || imageProps === void 0 ? void 0 : imageProps.link,
                            title: imageProps === null || imageProps === void 0 ? void 0 : imageProps.title,
                            alt: imageProps === null || imageProps === void 0 ? void 0 : imageProps.alternative
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (academy_template_module_default())["card-content"],
                        children: [
                            categories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (academy_template_module_default())["card-categories"],
                                children: generateCategories()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, academy_template_objectSpread({}, props, {
                                header: title,
                                bodytext: truncateTeaser,
                                variant: "teaser"
                            })),
                            generateAuthor("list")
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (academy_template_module_default()).wrapped,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, academy_template_objectSpread({}, props, {
                    bodytext: teaser,
                    variant: "teaser"
                })),
                falRelatedFiles && falRelatedFiles.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((academy_template_module_default())["thumbnail-container"], " ").concat((academy_template_module_default()).spacing),
                    children: falRelatedFiles.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (academy_template_module_default()).thumbnail,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                href: item.images.defaultImage.publicUrl,
                                class: (academy_template_module_default()).link,
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* Media */.pU, {
                                    mediaId: item.properties.id,
                                    inverted: inverted,
                                    contentType: (0,media_media/* getMediaType */.V4)(item.type),
                                    src: item.images.defaultImage.publicUrl,
                                    caption: item.properties.description,
                                    redirectUrl: item.properties.link,
                                    title: item.properties.title,
                                    alt: item.properties.alternative
                                })
                            })
                        }, "media-".concat(item.properties.id));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bodytext-container",
                    dangerouslySetInnerHTML: {
                        __html: bodytext
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((academy_template_module_default())["card-categories"], " ").concat((academy_template_module_default()).spacing),
                    children: generateCategories()
                }),
                generateAuthor("detail"),
                generateRelatedNews()
            ]
        })
    });
};


// EXTERNAL MODULE: ./src/components/typo/news-list/templates/jobs/jobs_template.module.scss
var jobs_template_module = __webpack_require__(9659);
var jobs_template_module_default = /*#__PURE__*/__webpack_require__.n(jobs_template_module);
;// CONCATENATED MODULE: ./src/components/typo/news-list/templates/jobs/jobs_template.tsx
function jobs_template_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function jobs_template_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            jobs_template_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var Jobs_Template = function(props) {
    var uid = props.uid, relatedLinks = props.relatedLinks, title = props.title, teaser = props.teaser, bodytext = props.bodytext, datetime = props.datetime, slug = props.slug, view = props.view;
    var linkLength = relatedLinks ? relatedLinks.length : 0;
    var _uri, _uri1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((jobs_template_module_default()).jobs_template, " ").concat((jobs_template_module_default())["jobs-" + view]),
        children: String(view) === "list" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, jobs_template_objectSpread({}, props, {
                    header: title,
                    subheader: datetime,
                    bodytext: teaser,
                    headerLink: slug,
                    variant: "teaser"
                })),
                relatedLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (jobs_template_module_default()).buttons,
                    children: relatedLinks.map(function(args, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                                    href: (_uri = args.uri) !== null && _uri !== void 0 ? _uri : "",
                                    external: true,
                                    locale: false,
                                    children: args.title
                                }),
                                i < linkLength - 1 ? "|" : ""
                            ]
                        }, "jobs-" + uid + "-link-" + args.id);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, jobs_template_objectSpread({}, props, {
                    header: title,
                    subheader: datetime,
                    bodytext: "",
                    variant: "teaser"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bodytext-container",
                    dangerouslySetInnerHTML: {
                        __html: bodytext
                    }
                }),
                relatedLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (jobs_template_module_default()).buttons,
                    children: relatedLinks.map(function(args, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                                    href: (_uri1 = args.uri) !== null && _uri1 !== void 0 ? _uri1 : "",
                                    external: true,
                                    locale: false,
                                    children: args.title
                                }),
                                i < linkLength - 1 ? "|" : ""
                            ]
                        }, "jobs-" + uid + "-link-" + args.id);
                    })
                })
            ]
        })
    }, "jobs_template-" + uid);
};


// EXTERNAL MODULE: ./src/components/typo/news-list/templates/podcast/podcast_template.module.scss
var podcast_template_module = __webpack_require__(17544);
var podcast_template_module_default = /*#__PURE__*/__webpack_require__.n(podcast_template_module);
;// CONCATENATED MODULE: ./src/components/typo/news-list/templates/podcast/podcast_template.tsx
function podcast_template_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function podcast_template_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            podcast_template_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var Podcast_Template = function(props) {
    var uid = props.uid, relatedLinks = props.relatedLinks, title = props.title, teaser = props.teaser, bodytext = props.bodytext, falRelatedFiles = props.falRelatedFiles, datetime = props.datetime, slug = props.slug, view = props.view, inverted = props.inverted;
    var linkLength = relatedLinks ? relatedLinks.length : 0;
    var mainImage = falRelatedFiles ? falRelatedFiles[0] : undefined;
    var image = mainImage === null || mainImage === void 0 ? void 0 : mainImage.images.defaultImage;
    var imageProps = mainImage === null || mainImage === void 0 ? void 0 : mainImage.properties;
    var imageUrl = image === null || image === void 0 ? void 0 : image.publicUrl;
    var imageType = imageProps === null || imageProps === void 0 ? void 0 : imageProps.mimetype;
    var _uri, _uri1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((podcast_template_module_default()).podcast_template, " ").concat((podcast_template_module_default())["news-" + view]),
        children: String(view) === "list" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (podcast_template_module_default())["right-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, podcast_template_objectSpread({}, props, {
                            header: title,
                            subheader: datetime,
                            bodytext: teaser,
                            headerLink: slug,
                            variant: "teaser"
                        })),
                        relatedLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (podcast_template_module_default()).buttons,
                            children: relatedLinks.map(function(args, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                                            href: (_uri = args.uri) !== null && _uri !== void 0 ? _uri : "",
                                            external: true,
                                            locale: false,
                                            children: args.title
                                        }),
                                        i < linkLength - 1 ? "|" : ""
                                    ]
                                }, "news-" + uid + "-link-" + args.id);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (podcast_template_module_default())["left-wrapper-img"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media_media/* Media */.pU, {
                        mediaId: uid,
                        contentType: (0,media_media/* getMediaType */.V4)(imageType),
                        src: imageUrl,
                        inverted: inverted,
                        caption: imageProps === null || imageProps === void 0 ? void 0 : imageProps.description,
                        title: imageProps === null || imageProps === void 0 ? void 0 : imageProps.title,
                        redirectUrl: imageProps === null || imageProps === void 0 ? void 0 : imageProps.link,
                        alt: imageProps === null || imageProps === void 0 ? void 0 : imageProps.alternative
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, podcast_template_objectSpread({}, props, {
                    header: title,
                    subheader: datetime,
                    bodytext: "",
                    variant: "teaser"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bodytext-container",
                    dangerouslySetInnerHTML: {
                        __html: bodytext
                    }
                }),
                relatedLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (podcast_template_module_default()).buttons,
                    children: relatedLinks.map(function(args, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                                    href: (_uri1 = args.uri) !== null && _uri1 !== void 0 ? _uri1 : "",
                                    external: true,
                                    locale: false,
                                    children: args.title
                                }),
                                i < linkLength - 1 ? "|" : ""
                            ]
                        }, "news-" + uid + "-link-" + args.id);
                    })
                })
            ]
        })
    }, "podcast_template-" + uid);
};


;// CONCATENATED MODULE: ./src/components/typo/news-list/news-list.tsx
function news_list_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function news_list_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            news_list_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var NewsList = function(props) {
    var id = props.id, inverted = props.inverted, news1 = props.news, fullwidth = props.fullwidth;
    var _wrapper;
    var wrapper = (_wrapper = props.wrapper) !== null && _wrapper !== void 0 ? _wrapper : props.content.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var newsType = news1.settings.templateLayout;
    var router = (0,next_router.useRouter)();
    var catid = router.query.catid;
    var ref = (0,react.useState)(false), initialFilter = ref[0], setInitialFilter = ref[1];
    var ref1 = (0,react.useState)(), filter = ref1[0], setFilter = ref1[1];
    var typoService = new TypoService((0,useTypoContent_hook/* useTypoContent */.f)());
    if (!news1.list && !news1.detail) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var newsTypeElements = function(data, view) {
        switch(newsType){
            case "jobs":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_Template, news_list_objectSpread({}, data, {
                        view: view
                    }));
                }
            case "podcast":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Podcast_Template, news_list_objectSpread({}, data, {
                        view: view
                    }));
                }
            default:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Academy_Template, news_list_objectSpread({}, data, {
                        inverted: inverted,
                        view: view,
                        returnUrl: news1.settings.returnUrl
                    }));
                }
        }
    };
    var getUniqueCategories = function() {
        if (!news1.list || newsType !== "academy" && newsType !== "academyFilter") {
            return;
        }
        var categories = [];
        var foundIds = [];
        news1.list.map(function(element) {
            element.categories.map(function(cat) {
                if (!foundIds.includes(cat.id)) {
                    categories = categories.concat(cat);
                    foundIds.push(cat.id);
                } else {
                    foundIds.push(cat.id);
                }
            });
        });
        return categories;
    };
    var generateCategories = function() {
        if (!news1.list || newsType !== "academy") {
            return;
        }
        var categories = getUniqueCategories();
        if (!categories) {
            return;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (news_list_module_default())["category-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                    label: typoService.getLabel("content-elements", "filter-category-label"),
                    placeholder: typoService.getLabel("content-elements", "filter-category-placeholder"),
                    className: (news_list_module_default()).select,
                    onChange: function(opt) {
                        return setFilter({
                            value: opt.value,
                            label: opt.label
                        });
                    },
                    name: "categoryId",
                    isSearchable: true,
                    value: filter,
                    options: categories.map(function(cat) {
                        return {
                            value: cat.id,
                            label: cat.title
                        };
                    }),
                    inverted: inverted
                }),
                filter && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    onClick: function() {
                        return setFilter("");
                    },
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    inverted: inverted,
                    icon: {
                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
                            icon: [
                                "fas",
                                "undo"
                            ]
                        }),
                        align: "right"
                    }
                })
            ]
        });
    };
    var newsFilter = function() {
        if (!news1.list) {
            return undefined;
        }
        if (!filter || !filter.value) {
            return news1.list;
        }
        var newsToReturn = [];
        news1.list.map(function(news) {
            news.categories.map(function(category) {
                if (category.id == filter.value) {
                    newsToReturn = newsToReturn.concat(news);
                    return false;
                }
            });
        });
        return newsToReturn;
    };
    if (!initialFilter && catid) {
        var categories1 = getUniqueCategories();
        if (categories1) {
            var defaultVal = catid ? categories1.find(function(cat) {
                return cat.id == catid;
            }) : undefined;
            if (defaultVal) {
                setFilter({
                    value: defaultVal.id,
                    label: defaultVal.title
                });
            }
        }
        setInitialFilter(true);
    }
    var applicationNews = newsFilter();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            generateCategories(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "c".concat(id),
                className: "\n                    ".concat((news_list_module_default())["news-list"], "\n                    ").concat((news_list_module_default())["news-" + newsType + "-" + (applicationNews ? "list" : "detail")], "\n                    ").concat("spaceBefore" + appearance.spaceBefore, " \n                    ").concat("spaceAfter" + appearance.spaceAfter, " \n                    ").concat(inverted ? (news_list_module_default()).inverted : "", "\n                    ").concat(fullwidth ? (news_list_module_default()).fullwidth : "", "\n                    ").concat(wrapper !== undefined ? (news_list_module_default())[wrapper] : "", "\n                "),
                children: applicationNews ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        applicationNews.map(function(element) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (news_list_module_default())["news-item"],
                                children: newsTypeElements(element, "list")
                            }, "news-list-item-container-" + element.uid);
                        }),
                        newsType === "academy" || newsType === "academyFilter" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (news_list_module_default())["news-item"]
                                })
                            ]
                        })
                    ]
                }) : newsTypeElements(news1.detail, "detail")
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react-parallax/lib/index.js
var react_parallax_lib = __webpack_require__(41113);
// EXTERNAL MODULE: ./src/components/typo/parallax/container/Parallax.module.scss
var Parallax_module = __webpack_require__(76919);
var Parallax_module_default = /*#__PURE__*/__webpack_require__.n(Parallax_module);
;// CONCATENATED MODULE: ./src/components/typo/parallax/container/ParallaxSizeEnum.tsx
var ParallaxSizeEnum;
(function(ParallaxSizeEnum) {
    ParallaxSizeEnum["SMALL"] = "small";
    ParallaxSizeEnum["MEDIUM"] = "medium";
    ParallaxSizeEnum["LARGE"] = "large";
    ParallaxSizeEnum["FULL_HEIGHT"] = "full-height";
    ParallaxSizeEnum["CUSTOM"] = "custom";
})(ParallaxSizeEnum || (ParallaxSizeEnum = {}));

;// CONCATENATED MODULE: ./src/components/typo/parallax/container/Parallax.tsx






var cx = bind_default().bind((Parallax_module_default()));
var ParallaxContainer = function(props) {
    var containerClassNames = cx(props.className, {
        "small": props.containerSize === ParallaxSizeEnum.SMALL,
        "medium": props.containerSize === ParallaxSizeEnum.MEDIUM,
        "large": props.containerSize === ParallaxSizeEnum.LARGE,
        "full-height": props.containerSize === ParallaxSizeEnum.FULL_HEIGHT
    });
    var contentClassNames = cx(props.contentClassName, {
        "content": true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_parallax_lib.Parallax, {
        blur: props === null || props === void 0 ? void 0 : props.blur,
        bgImage: props === null || props === void 0 ? void 0 : props.image,
        bgImageAlt: props === null || props === void 0 ? void 0 : props.imageAlt,
        strength: props === null || props === void 0 ? void 0 : props.scrollStrength,
        style: props === null || props === void 0 ? void 0 : props.style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: containerClassNames,
            style: {
                height: props.containerSize === ParallaxSizeEnum.CUSTOM && props.height ? props.height : undefined
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: contentClassNames,
                children: props.children
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/typo/parallax/parallax.module.scss
var parallax_module = __webpack_require__(10988);
var parallax_module_default = /*#__PURE__*/__webpack_require__.n(parallax_module);
;// CONCATENATED MODULE: ./src/components/typo/parallax/parallax.tsx




var Parallax = function(props) {
    var containerSize = props.containerSize, scrollStrength = props.scrollStrength, inverted = props.inverted, blur = props.blur, imageUrl = props.imageUrl, imageAlt = props.imageAlt, className = props.className, id = props.id, children = props.children, height = props.height, style = props.style, withTextBackground = props.withTextBackground, fullwidth = props.fullwidth;
    var invertedClass = inverted ? (parallax_module_default()).inverted : "";
    var textBackgroundClass = withTextBackground ? (parallax_module_default()).withBackground : "";
    var fullwidthClass = fullwidth ? (parallax_module_default()).fullwidth : "";
    if (imageUrl && imageUrl !== "") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxContainer, {
            containerSize: containerSize,
            scrollStrength: scrollStrength,
            blur: blur,
            className: className,
            image: imageUrl,
            imageAlt: imageAlt,
            height: height,
            style: style,
            contentClassName: "".concat((parallax_module_default()).content, " ").concat(invertedClass, " ").concat(textBackgroundClass, " ").concat(fullwidthClass),
            children: typeof children === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "c".concat(id),
                className: "bodytext-container ".concat((parallax_module_default()).wrapper),
                dangerouslySetInnerHTML: {
                    __html: children
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "c".concat(id),
                className: "bodytext-container ".concat((parallax_module_default()).wrapper),
                children: children
            })
        }, "typo-parallax-".concat(id));
    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};


// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/core/lib/styles/index.css
var styles = __webpack_require__(15025);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/toolbar/lib/styles/index.css
var lib_styles = __webpack_require__(57950);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/default-layout/lib/styles/index.css
var default_layout_lib_styles = __webpack_require__(76566);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/core/lib/index.js
var core_lib = __webpack_require__(54141);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/default-layout/lib/index.js
var default_layout_lib = __webpack_require__(10492);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/locales/lib/de_DE.json
var de_DE = __webpack_require__(40014);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/locales/lib/en_US.json
var en_US = __webpack_require__(87813);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/locales/lib/es_ES.json
var es_ES = __webpack_require__(30370);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/theme/lib/index.js
var theme_lib = __webpack_require__(3591);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./src/components/typo/pdf/pdf.module.scss
var pdf_module = __webpack_require__(945);
var pdf_module_default = /*#__PURE__*/__webpack_require__.n(pdf_module);
;// CONCATENATED MODULE: ./src/components/typo/pdf/pdf.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function pdf_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pdf_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            pdf_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















var Pdf = function(props1) {
    var id = props1.id, inverted = props1.inverted, height1 = props1.height, width = props1.width, scrollMode = props1.scrollMode, media = props1.media, fullwidth = props1.fullwidth, wrapper = props1.wrapper;
    var ref4 = (0,react.useState)(120), navbarSpace = ref4[0], setNavbarSpace = ref4[1];
    var ref1 = (0,react.useState)(false), resized = ref1[0], setResized = ref1[1];
    var _appearance;
    var appearance = (_appearance = props1.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var pdfUrl = media && media[0] && media[0].publicUrl ? media[0].publicUrl : "";
    var ref2 = (0,react.useState)(), signedPdfUrl = ref2[0], setSignedPdfUrl = ref2[1];
    var scroll = scrollMode && scrollMode === "horizontal" ? core_lib.ScrollMode.Horizontal : core_lib.ScrollMode.Vertical;
    var router = (0,client_router.useRouter)();
    var lang = router.locale ? router.locale.toLowerCase() : "en";
    var locale = function() {
        switch(lang){
            case "de":
                return de_DE;
            case "es":
                return es_ES;
            default:
                return en_US;
        }
    };
    var themePluginInstance = (0,theme_lib.themePlugin)();
    var ref3 = _slicedToArray((0,useCookies/* default */.Z)([
        "pdf_token"
    ]), 2), cookies = ref3[0], setCookie = ref3[1];
    var tokenName = "pdf-" + (id !== null && id !== void 0 ? id : 0);
    // Get signed pdf url
    if (!signedPdfUrl) {
        try {
            if (pdfUrl) {
                var AWS = __webpack_require__(98690);
                var s3 = new AWS.S3({
                    signatureVersion: "v4",
                    accessKeyId: "AKIATGBGY4IHHSVMJMFL",
                    secretAccessKey: "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",
                    region: "eu-central-1"
                });
                var params = {
                    Bucket: "creatokia-rs-staging",
                    Key: encodeURIComponent(pdfUrl.replace(/^.*\/\/[^\/]+\/?/, "").trim()),
                    Expires: 60
                };
                var url = s3.getSignedUrl("getObject", params);
                if (url) {
                    setSignedPdfUrl(url);
                }
            }
        } catch (err) {
            console.error("SignedURL: ".concat(err));
        }
    }
    var handleResize = function() {
        if (typeof document !== "undefined") {
            var ref;
            var height = (ref = document.getElementById("main-navbar")) === null || ref === void 0 ? void 0 : ref.offsetHeight;
            setNavbarSpace(height !== null && height !== void 0 ? height : 120);
            setResized(true);
        }
    };
    (0,react.useLayoutEffect)(function() {
        if (!resized) {
            handleResize();
        }
        window.addEventListener("resize", handleResize, false);
    }, []);
    /**
     * Save current page for user to come back to after visiting the viewer again
     *
     * @param e
     */ var onPageChange = function(e) {
        if (tokenName === "pdf-0") {
            return;
        }
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        setCookie("pdf_token", pdf_objectSpread({}, cookies.pdf_token, pdf_defineProperty({}, tokenName, e.currentPage)), {
            path: "/",
            expires: expires
        });
    };
    /**
     * Top toolbar
     *
     * @param Toolbar
     */ var renderToolbar = function(Toolbar) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar, {
            children: function(props) {
                var CurrentPageInput = props.CurrentPageInput, GoToNextPage = props.GoToNextPage, GoToPreviousPage = props.GoToPreviousPage, NumberOfPages = props.NumberOfPages, ZoomIn = props.ZoomIn, Zoom = props.Zoom, ZoomOut = props.ZoomOut, ShowSearchPopover = props.ShowSearchPopover, EnterFullScreen = props.EnterFullScreen;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (pdf_module_default())["toolbar-left"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((pdf_module_default())["toolbar-item"], " ").concat((pdf_module_default())["hide-mobile"]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowSearchPopover, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pdf_module_default())["toolbar-item"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoToPreviousPage, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pdf_module_default())["toolbar-item"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentPageInput, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((pdf_module_default())["toolbar-item"], " ").concat((pdf_module_default())["hide-mobile"]),
                                    children: [
                                        "/ ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberOfPages, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pdf_module_default())["toolbar-item"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoToNextPage, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (pdf_module_default())["toolbar-center"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pdf_module_default())["toolbar-item"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomOut, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pdf_module_default())["toolbar-item"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Zoom, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pdf_module_default())["toolbar-item"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomIn, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (pdf_module_default())["toolbar-right"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (pdf_module_default())["toolbar-item"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterFullScreen, {})
                            })
                        })
                    ]
                });
            }
        });
    };
    /**
     * Render page without the ability that user can highlight text
     *
     * @param props
     */ var renderPage = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                props.canvasLayer.children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        userSelect: "none"
                    },
                    children: props.textLayer.children
                }),
                props.annotationLayer.children
            ]
        });
    };
    /**
     * Shows a loading bar while loading the pdf file
     *
     * @param percentages
     */ var renderLoader = function(percentages) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (pdf_module_default()).loader,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_lib.ProgressBar, {
                progress: Math.round(percentages)
            })
        });
    };
    /**
     * Display error while trying to load the pdf file
     *
     * The `LoadError` type consists of two properties:
     * - `message` which indicates the error message
     * - `name` which indicates the name of exception
     *
     * The `name` property can take one of the values below:
     * - `AbortException`
     * - `FormatError`
     * - `InvalidPDFException`
     * - `MissingPDFException`
     * - `PasswordException`
     * - `UnexpectedResponseException`
     * - `UnknownErrorException`
     *
     * @param error
     */ var renderError = function(error) {
        var message;
        switch(error.name){
            case "InvalidPDFException":
                message = "The document is invalid or corrupted";
                break;
            case "MissingPDFException":
                message = "The document is missing";
                break;
            case "UnexpectedResponseException":
                message = "Unexpected server response";
                break;
            case "UnknownErrorException":
                message = "An unknown error occurred";
                break;
            default:
                message = "Cannot load the document";
                break;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (pdf_module_default())["error-container"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (pdf_module_default()).error,
                children: message
            })
        });
    };
    /**
     * Complete toolbar inclusive sidebar
     */ var defaultLayoutPluginInstance = (0,default_layout_lib.defaultLayoutPlugin)({
        renderToolbar: renderToolbar,
        sidebarTabs: function(defaultTabs) {
            return [
                defaultTabs[0],
                defaultTabs[1]
            ];
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                rpv-core__viewer\n                ".concat((pdf_module_default())["pdf-container"], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (pdf_module_default()).inverted : "", "\n                ").concat(fullwidth ? (pdf_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (pdf_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (pdf_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, pdf_objectSpread({}, props1))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((pdf_module_default()).pdf),
                style: {
                    height: height1 ? "calc(".concat(height1, "vh - ").concat(navbarSpace, "px)") : "auto",
                    maxWidth: width ? width + "px" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_lib.Viewer, {
                    fileUrl: signedPdfUrl !== null && signedPdfUrl !== void 0 ? signedPdfUrl : pdfUrl,
                    renderLoader: renderLoader,
                    renderError: renderError,
                    renderPage: renderPage,
                    onPageChange: onPageChange,
                    theme: inverted ? "light" : "dark",
                    scrollMode: scroll,
                    defaultScale: core_lib.SpecialZoomLevel.PageFit,
                    localization: locale,
                    initialPage: cookies.pdf_token && cookies.pdf_token[tokenName] && tokenName !== "pdf-0" ? cookies.pdf_token[tokenName] : undefined,
                    plugins: [
                        defaultLayoutPluginInstance,
                        themePluginInstance
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/typo/quote/quote.module.scss
var quote_module = __webpack_require__(8632);
var quote_module_default = /*#__PURE__*/__webpack_require__.n(quote_module);
;// CONCATENATED MODULE: ./src/components/typo/quote/quote.tsx
function quote_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function quote_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            quote_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var Quote = function(props) {
    var id = props.id, inverted = props.inverted, bodytext = props.bodytext;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "              \n                ".concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (quote_module_default()).inverted : "", "\n             "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (quote_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, quote_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (quote_module_default())["quote-section"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (quote_module_default())["quote-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        className: "".concat((quote_module_default()).quote, " ").concat(inverted ? (quote_module_default()).inverted : ""),
                        variant: typeography_variants_enum/* TypographyVariantsEnum.QUOTE */.H.QUOTE,
                        inverted: inverted,
                        children: bodytext
                    })
                })
            })
        ]
    });
};
Quote.defaultProps = {};


// EXTERNAL MODULE: ./node_modules/animate.css/animate.css
var animate = __webpack_require__(42523);
;// CONCATENATED MODULE: ./src/components/typo/stage/stage.tsx
function stage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function stage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            stage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var Stage = function(props) {
    var ref, ref1;
    var id = props.id, inverted = props.inverted, fullwidth = props.fullwidth, header = props.header, logo = props.logo, backgrounds = props.backgrounds, buttons = props.buttons, imageUrl = props.imageUrl, animationClass = props.animationClass, animationSpeedClass = props.animationSpeedClass;
    var decButton = props.decButton;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var verticalOrientation = props.contentVertical.toUpperCase();
    var size = props.contentSize.charAt(0).toUpperCase() + props.contentSize.slice(1);
    var orientation = props.contentHorizontal.toUpperCase();
    var textDirection = "horizontal";
    if (!decButton || typeof decButton != "object" || Object.keys(decButton).length <= 0) {
        decButton = Stage.defaultProps.decButton;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "c".concat(id),
        "data-testid": "stage",
        className: "\n                ".concat((stage_module_default()).stage, " \n                ").concat((stage_module_default())[size], " \n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (stage_module_default()).inverted : "", "\n                ").concat(fullwidth ? (stage_module_default()).fullwidth : "", "\n            "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((stage_module_default())["stage-background"], " ").concat(backgrounds || imageUrl ? "" : (stage_module_default())["default-background"], "}"),
            style: backgrounds ? {
                backgroundImage: "url(".concat(imageUrl ? imageUrl : "", ")")
            } : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((stage_module_default())[orientation], " ").concat(inverted ? (stage_module_default()).inverted : "", " ").concat((stage_module_default())["vert-".concat(verticalOrientation === null || verticalOrientation === void 0 ? void 0 : verticalOrientation.toLowerCase())]),
                    children: [
                        logo,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: textDirection === alignment_enum/* Alignment.HORIZONTAL */.v.HORIZONTAL ? (stage_module_default())["horizontal-text-alignment"] : "",
                            children: [
                                header && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((stage_module_default()).title),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, stage_objectSpread({}, props, {
                                        headerClass: "\n                                    ".concat(animationClass !== "" ? "animate__animated animate__".concat(animationClass) : "", "\n                                     ").concat(animationSpeedClass !== "" ? "animate__".concat(animationSpeedClass) : "", "\n                                    "),
                                        subHeaderClass: "\n                                    ".concat(animationClass !== "" ? "animate__animated animate__".concat(animationClass) : "", "\n                                     ").concat(animationSpeedClass !== "" ? "animate__".concat(animationSpeedClass) : "", "\n                                    "),
                                        variantHeader: "heading1",
                                        variantSubHeader: "introtext"
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: textDirection === alignment_enum/* Alignment.HORIZONTAL */.v.HORIZONTAL ? (stage_module_default())["flex-container"] : ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoButtons, {
                            inverted: inverted,
                            buttons: buttons
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: ((ref = decButton) === null || ref === void 0 ? void 0 : ref.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (stage_module_default()).decButtonCustomContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StageImageButtonToken, stage_objectSpread({}, decButton, {
                            shadow: true
                        }))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (stage_module_default()).decButtonContainer,
                        children: decButton === null || decButton === void 0 ? void 0 : (ref1 = decButton.icon) === null || ref1 === void 0 ? void 0 : ref1.element
                    })
                })
            ]
        })
    });
};
Stage.defaultProps = {
    orientation: "CENTER",
    inverted: false,
    size: "Large",
    decButton: {
        icon: {
            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(creatoken_svg/* default */.Z, {}),
            align: "right"
        }
    },
    verticalOrientation: "CENTER"
};


// EXTERNAL MODULE: ./node_modules/react-super-responsive-table/dist/SuperResponsiveTableStyle.css
var SuperResponsiveTableStyle = __webpack_require__(23825);
// EXTERNAL MODULE: ./node_modules/react-super-responsive-table/dist/index.js
var dist = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/components/typo/table/table.module.scss
var table_module = __webpack_require__(49402);
var table_module_default = /*#__PURE__*/__webpack_require__.n(table_module);
;// CONCATENATED MODULE: ./src/components/typo/table/table.tsx
function table_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            table_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// @ts-nocheck





var TypoTable = function(props) {
    var ref = (0,react.useState)([]), tableDataArray = ref[0], setTableDataArray = ref[1];
    var ref1 = (0,react.useState)([]), tableHeadArray = ref1[0], setTableHeadArray = ref1[1];
    var ref2 = (0,react.useState)([]), tableBodyArray = ref2[0], setTableBodyArray = ref2[1];
    (0,react.useEffect)(function() {
        if (props.bodytext !== undefined || props.bodytext.length !== 0) {
            setTableDataArray(props.bodytext);
        }
    }, [
        props.bodytext
    ]);
    (0,react.useEffect)(function() {
        if (tableDataArray.length > 0) {
            var tableHeadData = tableDataArray[0];
            var tableBodyData = tableDataArray.filter(function(data, i) {
                return i !== 0;
            });
            setTableHeadArray(tableHeadData);
            setTableBodyArray(tableBodyData);
        }
    }, [
        tableDataArray
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(props.id),
        className: "\n            ".concat(props.inverted ? (table_module_default()).inverted : "", "\n            ").concat(props.fullwidth ? (table_module_default()).fullwidth : "", "\n            ").concat(props.wrapper !== undefined ? (table_module_default())[props.wrapper] : "", "\n          "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (table_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, table_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Table */.iA, {
                className: (table_module_default()).table,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Thead */.hr, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Tr, {
                            children: tableHeadArray.map(function(cell, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Th, {
                                    children: cell
                                }, "head-cell-".concat(i));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Tbody */.p3, {
                        children: tableBodyArray.map(function(rows, i1) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Tr, {
                                children: rows.map(function(cells, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Td, {
                                        children: cells
                                    }, "body-cell-".concat(i));
                                })
                            }, "table-row-".concat(i1));
                        })
                    })
                ]
            }, "table-".concat(props.id))
        ]
    });
};
TypoTable.defaultProps = {};


;// CONCATENATED MODULE: ./src/components/typo/text/text.tsx
function text_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function text_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            text_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var Text = function(props) {
    var id = props.id, inverted = props.inverted, bodytext = props.bodytext, fullwidth = props.fullwidth, wrapper = props.wrapper;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((text_module_default())["text-section"], "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (text_module_default()).inverted : "", "\n                ").concat(fullwidth ? (text_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (text_module_default())[wrapper] : "", "\n            "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_module_default()).headline,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, text_objectSpread({}, props, {
                    noContentSpacing: true
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bodytext-container",
                dangerouslySetInnerHTML: {
                    __html: bodytext
                }
            })
        ]
    });
};
Text.defaultProps = {};


// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./src/components/typo/textimg/textimg.module.scss
var textimg_module = __webpack_require__(44014);
var textimg_module_default = /*#__PURE__*/__webpack_require__.n(textimg_module);
;// CONCATENATED MODULE: ./src/components/typo/textimg/textimg.tsx
function textimg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function textimg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            textimg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var Textimg = function(props) {
    var id = props.id, inverted = props.inverted, gallery = props.gallery, images = props.images, headerPosition = props.headerPosition, buttons = props.buttons, textAnimationClass = props.textAnimationClass, textAnimationSpeedClass = props.textAnimationSpeedClass, imageAnimationClass = props.imageAnimationClass, imageAnimationSpeedClass = props.imageAnimationSpeedClass, columnsMobile = props.columnsMobile, columnsTablet = props.columnsTablet, fullwidth = props.fullwidth, enlargeImageOnClick = props.enlargeImageOnClick, wrapper = props.wrapper, imageEffect = props.imageEffect, withSubline = props.withSubline;
    var _appearance;
    var appearance = (_appearance = props.appearance) !== null && _appearance !== void 0 ? _appearance : {
        spaceBefore: "",
        spaceAfter: ""
    };
    var imagePosition1 = headerPosition ? headerPosition.toLowerCase() : "";
    var textClass = function(imagePosition) {
        if (imagePosition === horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT) {
            return (textimg_module_default())["left-wrapper"];
        } else if (imagePosition === horizontal_position_enum/* HorizontalPosition.CENTER */.D.CENTER) {
            return (textimg_module_default())["center-wrapper"];
        } else {
            return (textimg_module_default())["right-wrapper"];
        }
    };
    var imageClass = function(imagePosition) {
        if (imagePosition === horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT) {
            return (textimg_module_default())["right-wrapper-img"];
        } else if (imagePosition === horizontal_position_enum/* HorizontalPosition.CENTER */.D.CENTER) {
            return (textimg_module_default())["center-wrapper-img"];
        } else {
            return (textimg_module_default())["left-wrapper-img"];
        }
    };
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        /* Optional options */ triggerOnce: true,
        threshold: 0
    }), ref1 = ref.ref, inView = ref.inView;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "c".concat(id),
        className: "\n                ".concat((textimg_module_default())["text-image-teaser"], "\n                ").concat("spaceBefore" + appearance.spaceBefore, " \n                ").concat("spaceAfter" + appearance.spaceAfter, " \n                ").concat(inverted ? (textimg_module_default()).inverted : "", "\n                ").concat(fullwidth ? (textimg_module_default()).fullwidth : "", "\n                ").concat(wrapper !== undefined ? (textimg_module_default())[wrapper] : "", "\n                ").concat(imagePosition1 === horizontal_position_enum/* HorizontalPosition.CENTER */.D.CENTER ? (textimg_module_default())["text-image-center"] : "", "\n            "),
        ref: textAnimationClass !== "" || imageAnimationClass !== "" ? ref1 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n                    ".concat(textClass(imagePosition1), "\n                    ").concat(textAnimationClass !== "" && inView ? "animate__animated animate__".concat(textAnimationClass) : "", "\n                    ").concat(textAnimationSpeedClass !== "" && inView ? "animate__".concat(textAnimationSpeedClass) : "", "\n                "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, textimg_objectSpread({}, props, {
                        noHeadlineSpacing: true,
                        noTextAlignment: true,
                        variant: "teaser"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoButtons, {
                        inverted: inverted,
                        buttons: buttons
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n                    ".concat(imageClass(imagePosition1), "\n                    ").concat(imageAnimationClass !== "" && inView ? "animate__animated animate__".concat(imageAnimationClass) : "", "\n                    ").concat(imageAnimationSpeedClass !== "" && inView ? "animate__".concat(imageAnimationSpeedClass) : "", "\n                "),
                children: images && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (textimg_module_default()).images,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Multirow, {
                        images: images,
                        rowsDesktop: gallery.count.columns,
                        rowsTablet: columnsTablet,
                        rowsMobile: columnsMobile,
                        galleryOptions: {
                            imageEffect: {
                                effect: imageEffect !== null && imageEffect !== void 0 ? imageEffect : "",
                                withSubline: withSubline !== null && withSubline !== void 0 ? withSubline : false
                            },
                            enlargeOnClick: enlargeImageOnClick
                        },
                        inverted: inverted
                    })
                })
            })
        ]
    });
};
Textimg.defaultProps = {};


;// CONCATENATED MODULE: ./src/components/typo/textmedia/textmedia.tsx
function textmedia_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function textmedia_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            textmedia_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var Textmedia = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Textimg, textmedia_objectSpread({}, props));
};


;// CONCATENATED MODULE: ./src/components/typo/textpic/textpic.tsx
function textpic_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function textpic_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            textpic_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var Textpic = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Textimg, textpic_objectSpread({}, props));
};


;// CONCATENATED MODULE: ./src/utils/_helper/typo-content.helper.tsx
function typo_content_helper_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function typo_content_helper_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function typo_content_helper_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            typo_content_helper_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};



































/**
 * Typo3 Content Helper
 */ var TypoContentHelper = /*#__PURE__*/ function() {
    "use strict";
    function TypoContentHelper(typoData) {
        typo_content_helper_classCallCheck(this, TypoContentHelper);
        /**
     * Has painted the first element
     *
     * @private
     */ this.hasFirstElement = false;
        /**
     * Has painted the first element
     *
     * @private
     */ this.hasPulledNews = undefined;
        /**
     * Bans element ids from being repainted again
     *
     * @private
     */ this.bannedIds = [];
        this.json = typoData;
    }
    var _proto = TypoContentHelper.prototype;
    /**
     * Get the academy news content element for the stage header on the news detail page
     */ _proto.getNewsContent = function getNewsContent() {
        var ref, ref1;
        if (this.hasPulledNews) {
            return this.hasPulledNews;
        }
        var pageContent = (ref = this.json) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.colPos20;
        if (!pageContent) {
            return undefined;
        }
        var newsItemCE = undefined;
        pageContent.map(function(item) {
            if (item.type === "news_pi1") {
                var newsItem = item;
                if ((newsItem.news.settings.templateLayout === "academy" || newsItem.news.settings.templateLayout === "") && newsItem.news.settings.action === "detail") {
                    newsItemCE = newsItem;
                }
            }
        });
        this.hasPulledNews = newsItemCE;
        return newsItemCE;
    };
    /**
     * Creates react components from typo3 content elements
     * @param getFirstElementStage  Gets the first element and removes it from being painted again
     *                              because it will be used in the 100% with container
     *
     * @param data
     * @param pid
     */ _proto.createContentElement = function createContentElement(data) {
        var getFirstElementStage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, pid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        if (!data || _typeof(data.id) === undefined || !data.type) {
            return;
        }
        var id = data.id;
        var appearance = TypoContentHelper.getAppearance(data.appearance);
        var content1;
        if (!id || this.bannedIds.includes(id)) {
            return;
        }
        var hasFirstElement = this.hasFirstElement;
        var newsCE = this.getNewsContent();
        this.hasFirstElement = true;
        if (getFirstElementStage && !hasFirstElement && (data.type == "stage" || data.type == "animated_stage")) {
            this.bannedIds.push(id);
        } else if (getFirstElementStage && !hasFirstElement && typeof newsCE !== "undefined") {
            var ref10;
            var ref2;
            var newsDetail = (ref2 = newsCE === null || newsCE === void 0 ? void 0 : (ref10 = newsCE.news) === null || ref10 === void 0 ? void 0 : ref10.detail) !== null && ref2 !== void 0 ? ref2 : undefined;
            if (newsDetail) {
                var ref3, ref4, ref5;
                this.bannedIds.push(id);
                content1 = data.content;
                var image = content1 && content1.gallery ? content1.gallery[0] : undefined;
                var firstImage = newsDetail.media !== undefined && newsDetail.media[0] !== undefined ? newsDetail.media[0] : undefined;
                var ref6;
                var imageUrl = (ref6 = firstImage === null || firstImage === void 0 ? void 0 : (ref3 = firstImage.images) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.defaultImage) === null || ref4 === void 0 ? void 0 : ref4.publicUrl) !== null && ref6 !== void 0 ? ref6 : "";
                if (!imageUrl && (image === null || image === void 0 ? void 0 : image.publicUrl)) {
                    imageUrl = image.publicUrl;
                }
                var ref7;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Parallax, {
                    id: content1.id,
                    className: content1.className,
                    inverted: !newsDetail.isTopNews,
                    fullwidth: this.setFullwidth(content1),
                    withTextBackground: content1.withTextBackground,
                    containerSize: content1.containerSize,
                    height: content1.height,
                    imageUrl: imageUrl,
                    imageAlt: "Background",
                    scrollStrength: content1.scrollStrength,
                    style: {
                        marginTop: "-181px"
                    },
                    blur: content1.blur,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((academy_template_module_default())["card-categories"], " ").concat((academy_template_module_default()).spacing),
                                style: {
                                    justifyContent: "center"
                                },
                                children: newsDetail.categories.map(function(item, i) {
                                    var ref, ref9;
                                    if (i >= 3) {
                                        return;
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                        href: "".concat(newsCE === null || newsCE === void 0 ? void 0 : (ref = newsCE.news) === null || ref === void 0 ? void 0 : (ref9 = ref.settings) === null || ref9 === void 0 ? void 0 : ref9.returnUrl, "?catid=").concat(item.id),
                                        class: (academy_template_module_default()).link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (academy_template_module_default()).category,
                                            children: item.title
                                        })
                                    }, "cat-".concat(item.id));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                style: {
                                    textAlign: "center",
                                    width: "100%"
                                },
                                children: newsDetail.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (academy_template_module_default())["author-image"],
                                style: {
                                    display: "block",
                                    width: "80px",
                                    margin: "20px auto 0 auto"
                                },
                                src: "/favicon.svg",
                                alt: "Profile"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (academy_template_module_default())["author-name"],
                                style: {
                                    fontWeight: "bold",
                                    flex: "0 0 100%",
                                    textAlign: "center"
                                },
                                children: (ref7 = (ref5 = newsDetail.author) === null || ref5 === void 0 ? void 0 : ref5.author) !== null && ref7 !== void 0 ? ref7 : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (academy_template_module_default()).created,
                                style: {
                                    marginTop: "8px",
                                    flex: "0 0 100%",
                                    textAlign: "center"
                                },
                                children: newsDetail.datetime
                            })
                        ]
                    })
                });
            }
        } else if (getFirstElementStage && data.type != "stage" && data.type != "animated_stage") {
            return;
        }
        switch(data.type){
            case "stage":
                {
                    content1 = data.content;
                    content1.className = "";
                    var buttons = content1.buttons ? this.getAllButtons(content1.buttons) : [];
                    var decButton = content1.icon !== undefined && content1.icon[0] !== undefined ? {
                        image: content1.icon[0].publicUrl,
                        shadow: true
                    } : {};
                    var images = this.getAllImagesFromGallery(content1.gallery);
                    var img = images !== undefined ? images[0] : {};
                    var _properties;
                    var imgProps = (_properties = img.properties) !== null && _properties !== void 0 ? _properties : [];
                    var backgrounds = imgProps && imgProps.dimensions ? {
                        large: {
                            ext: "." + imgProps.extension,
                            hash: "large_typo_" + id,
                            height: imgProps.dimensions.height,
                            mime: imgProps.mimeType,
                            name: imgProps.filename,
                            path: null,
                            size: parseFloat(imgProps.size),
                            url: img.publicUrl,
                            width: imgProps.dimensions.width
                        }
                    } : {};
                    var image1 = this.getAllImagesFromGallery(content1.gallery);
                    var imageUrl1 = image1 !== undefined && image1[0] !== undefined ? image1[0].publicUrl : "";
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stage, typo_content_helper_objectSpread({
                        id: id,
                        backgrounds: backgrounds,
                        imageUrl: imageUrl1,
                        buttons: buttons,
                        decButton: decButton,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "faq":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accord, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "textimg":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Textimg, typo_content_helper_objectSpread({
                        id: id,
                        images: this.getAllImagesFromGallery(content1.gallery),
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "textpic":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Textpic, typo_content_helper_objectSpread({
                        id: id,
                        images: this.getAllImagesFromGallery(content1.gallery),
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "textmedia":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Textmedia, typo_content_helper_objectSpread({
                        id: id,
                        images: this.getAllImagesFromGallery(content1.gallery),
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "image":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, typo_content_helper_objectSpread({
                        id: id,
                        images: this.getAllImagesFromGallery(content1.gallery),
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "header":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "text":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_sitemap":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_sitemap, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_pages":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_pages, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_categorized_content":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_categorized_content, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_sitemap_pages":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_sitemap_pages, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_section_pages":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_related_pages, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_related_pages":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_related_pages, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_abstract":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_abstract, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_categorized_pages":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_categorized_pages, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "menu_subpages":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_subpages, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "table":
                {
                    content1 = data.content;
                    var _bodytext;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoTable, typo_content_helper_objectSpread({}, content1, {
                        id: id,
                        bodytext: (_bodytext = content1.bodytext) !== null && _bodytext !== void 0 ? _bodytext : [],
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }));
                }
            case "bullets":
                {
                    content1 = data.content;
                    var _bodytext1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoBullets, typo_content_helper_objectSpread({}, content1, {
                        id: id,
                        bodytext: (_bodytext1 = content1.bodytext) !== null && _bodytext1 !== void 0 ? _bodytext1 : [],
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }));
                }
            case "uploads":
                {
                    content1 = data.content;
                    var _media;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoFileLinks, typo_content_helper_objectSpread({}, content1, {
                        id: id,
                        media: (_media = content1.media) !== null && _media !== void 0 ? _media : [],
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }));
                }
            case "multi":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypoMulti, typo_content_helper_objectSpread({}, content1, {
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }));
                }
            case "news_pi1":
                {
                    content1 = data;
                    if (content1.news.settings.templateLayout == "") {
                        content1.news.settings.templateLayout = "academy";
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsList, typo_content_helper_objectSpread({}, content1, {
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }));
                }
            case "html":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTypo, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "iframe":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "div":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DivTypo, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "shortcut":
                {
                    var _this = this;
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: data.content.shortcut.map(function(content) {
                            return _this.createContentElement(content);
                        })
                    });
                }
            case "parallax":
                {
                    var ref8;
                    content1 = data.content;
                    var image2 = content1 && content1.gallery ? content1.gallery[0] : {};
                    var imageUrl2 = image2 === null || image2 === void 0 ? void 0 : image2.publicUrl;
                    var imageAlt = image2 === null || image2 === void 0 ? void 0 : (ref8 = image2.properties) === null || ref8 === void 0 ? void 0 : ref8.alternative;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Parallax, {
                        id: content1.id,
                        className: content1.className,
                        inverted: content1.contentStyle === "inverted",
                        fullwidth: this.setFullwidth(content1),
                        withTextBackground: content1.withTextBackground,
                        containerSize: content1.containerSize,
                        height: content1.height,
                        imageUrl: imageUrl2,
                        imageAlt: imageAlt,
                        scrollStrength: content1.scrollStrength,
                        blur: content1.blur,
                        children: content1.children
                    });
                }
            case "animated_stage":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedStage, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "pdf":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pdf, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1),
                        fullwidth: this.setFullwidth(content1)
                    }, content1));
                }
            case "countdown":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1)
                    }, content1));
                }
            case "quote":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1)
                    }, content1));
                }
            case "mp3":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mp3, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1)
                    }, content1));
                }
            case "comments":
                {
                    content1 = data.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments, typo_content_helper_objectSpread({
                        id: id,
                        appearance: appearance,
                        inverted: this.setInverted(content1)
                    }, content1, {
                        pid: pid
                    }));
                }
            default:
                console.log("Typo3 CElement has not been found: " + data.type);
                break;
        }
    };
    /**
     * Sets Inverted Option for CElements
     *
     * @param content
     * @private
     */ _proto.setInverted = function setInverted(content) {
        var style = "";
        if (content.contentStyle !== undefined) {
            style = content.contentStyle;
        } else if (content.style !== undefined) {
            style = content.style;
        } else {
            // Content Element has no "Inverted" Option so use Page Option
            return this.json.creatokia.style === "inverted";
        }
        return style === "inverted" || style === "default" && this.json.creatokia.style == "inverted";
    };
    /**
     * Sets Fullwidth Option for CElements
     *
     * @param content
     * @private
     */ _proto.setFullwidth = function setFullwidth(content) {
        var style = "";
        if (content.contentStyle !== undefined) {
            style = content.contentStyle;
        } else if (content.style !== undefined) {
            style = content.style;
        } else {
            // Content Element has no "Fullwidth" Option so use Page Option
            return this.json.creatokia.page === "fullwidth";
        }
        return style === "fullwidth" || style === "default" && this.json.creatokia.page == "fullwidth";
    };
    /**
     * Get all images from a gallery content type
     *
     * @param gallery
     * @private
     */ _proto.getAllImagesFromGallery = function getAllImagesFromGallery(gallery) {
        if (gallery === undefined) {
            return undefined;
        }
        var images = [];
        Object.keys(gallery.rows).map(function(key) {
            var obj = gallery.rows[key];
            Object.keys(obj.columns).map(function(k) {
                images.push(obj.columns[k]);
            });
        });
        return images;
    };
    /**
     * Get all buttons from Content Element
     *
     * @private
     * @param contentButtons
     */ _proto.getAllButtons = function getAllButtons(contentButtons) {
        var _this = this;
        if (!contentButtons) {
            return [];
        }
        var buttons = [];
        contentButtons.map(function(data) {
            var icon = data.icon !== undefined && data.icon[0] !== undefined ? {
                element: data.icon[0].publicUrl,
                align: data.icon_align,
                flip: data.icon_flip
            } : null;
            buttons.push({
                variant: data.variant,
                className: data.uri.class,
                children: data.title,
                disabled: data.disabled,
                type: data.type,
                icon: icon,
                inverted: _this.setInverted(data),
                buttonUrl: data.uri.href,
                external: data.uri.target === "_blank",
                pending: data.pending
            });
        });
        return buttons;
    };
    /**
     * Converts Typo3 spacing to X em or X px values
     *
     * @param appearance
     * @private
     */ TypoContentHelper.getAppearance = function getAppearance(appearance) {
        return appearance;
    };
    return TypoContentHelper;
}();


;// CONCATENATED MODULE: ./src/api/services/typo.service.tsx
function typo_service_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function typo_service_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function typo_service_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            typo_service_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







/**
 * Typo3 service
 */ var TypoService = /*#__PURE__*/ function() {
    "use strict";
    function TypoService(typoData) {
        typo_service_classCallCheck(this, TypoService);
        if (!typoData || typeof typoData == "number") {
            typoData = {};
        }
        this.json = typoData;
        this.json = this.convertPlaceholderText(this.json);
        this.typoContentHelper = new TypoContentHelper(this.json);
    }
    var _proto = TypoService.prototype;
    /**
     * Get Json
     */ _proto.getJson = function getJson() {
        return this.json;
    };
    /**
     * Get all content output from typo3 including header, footer and page content
     */ _proto.getTypoContent = function getTypoContent() {
        var json = this.json;
        return json && json.content ? json.content : [];
    };
    /**
     * Get header content
     */ _proto.getHeaderContent = function getHeaderContent() {
        var json = this.json;
        var defaultHeader = json && json.creatokia && json.creatokia.defaultNav && json.creatokia.defaultNav.header ? [
            {
                type: "shortcut",
                content: {
                    shortcut: json.creatokia.defaultNav.header
                }
            }
        ] : [];
        return json && json.content && json.content.colPos10 ? json.content.colPos10 : defaultHeader;
    };
    /**
     * Get page content
     */ _proto.getPageContent = function getPageContent() {
        var json = this.json;
        return json && json.content && json.content.colPos20 ? json.content.colPos20 : [];
    };
    /**
     * Get footer content
     */ _proto.getFooterContent = function getFooterContent() {
        var json = this.json;
        var defaultFooter = json && json.creatokia && json.creatokia.defaultNav && json.creatokia.defaultNav.footer ? [
            {
                type: "shortcut",
                content: {
                    shortcut: json.creatokia.defaultNav.footer
                }
            }
        ] : [];
        return json && json.content && json.content.colPos30 ? json.content.colPos30 : defaultFooter;
    };
    /**
     * Get the page news content element
     */ _proto.getNewsContent = function getNewsContent() {
        return this.typoContentHelper.getNewsContent();
    };
    /**
     * Get the page response
     */ _proto.getPageResponse = function getPageResponse() {
        var ref;
        return (ref = this.json.response) === null || ref === void 0 ? void 0 : ref.join(", ");
    };
    /**
     * Get all languages
     */ _proto.getLocalizations = function getLocalizations() {
        var json = this.json;
        return json && json.localizations ? json.localizations : false;
    };
    /**
     * Get only the current active language
     */ _proto.getCurrentLocalization = function getCurrentLocalization() {
        var localisations = this.getLocalizations();
        if (localisations && typeof localisations !== "boolean") {
            localisations.map(function(local) {
                if (local.active) {
                    return local;
                }
            });
        }
    };
    /**
     * Get page settings
     */ _proto.getCreatokiaContent = function getCreatokiaContent() {
        return this.json && this.json.creatokia ? this.json.creatokia : false;
    };
    /**
     * Creates react components from typo3 content elements
     *
     * @param data
     */ _proto.createContentElement = function createContentElement(data) {
        return this.typoContentHelper.createContentElement(data, false, this.json.id);
    };
    /**
     * Creates Full-Width stage element when it's the first element and removes it from json
     *
     * @param data
     */ _proto.createStageElement = function createStageElement(data) {
        return this.typoContentHelper.createContentElement(data, true, this.json.id);
    };
    /**
     * Get header nav links
     */ _proto.getHeaderNavLinks = function getHeaderNavLinks() {
        var navElementId = 1;
        var typoNavObj = this.getHeaderContent();
        if (!typoNavObj || !(0,equal_object_helper/* isObject */.K)(typoNavObj)) {
            return [];
        }
        var typoNav = {};
        typoNavObj.map(function(data) {
            if (data.type !== "shortcut" || data.content === undefined) {
                return;
            }
            data = data;
            data.content = data.content;
            data.content.shortcut = data.content.shortcut;
            if (data.content.shortcut === undefined || data.content.shortcut[0] === undefined) {
                return;
            }
            var navObj = data.content.shortcut[0];
            if (navObj.id == navElementId) {
                typoNav = navObj;
                return;
            }
        });
        if (!typoNav || typoNav.content === undefined) {
            return [];
        }
        var mainNavObject = typoNav.content;
        if (!mainNavObject) {
            return [];
        }
        var mainNavMenu = [];
        mainNavObject.menu.map(function(data, idx) {
            mainNavMenu.push({
                external: !!data.target,
                id: idx,
                label: data.title,
                link: data.link,
                active: data.active
            });
        });
        return mainNavMenu;
    };
    /**
     * Generates footer nav links
     */ _proto.getFooterNavLinks = function getFooterNavLinks() {
        var aboutNavId = 2;
        var supportNavId = 3;
        var legalNavId = 4;
        var typoNavObj = this.getFooterContent();
        if (!typoNavObj || !(0,equal_object_helper/* isObject */.K)(typoNavObj)) {
            return [];
        }
        var typoNavs = [];
        typoNavObj.map(function(data) {
            if (data.type !== "shortcut" || data.content === undefined || data.content.shortcut === undefined) {
                return;
            }
            data.content.shortcut.map(function(menuData) {
                if (menuData.id == aboutNavId || menuData.id == supportNavId || menuData.id == legalNavId) {
                    typoNavs.push(menuData);
                }
            });
        });
        var mainFooterMenu = [];
        typoNavs.map(function(data1, i) {
            var links = [];
            var headline = {
                Style: null,
                cssClass: null,
                element: null,
                headlineContent: data1.content.header,
                id: i,
                identifier: null,
                style: null,
                textAlign: null
            };
            data1.content.menu.map(function(data, idx) {
                links.push({
                    external: !!data.target,
                    id: idx,
                    linkText: data.title,
                    url: data.link,
                    active: data.active
                });
            });
            mainFooterMenu.push({
                headline: headline,
                id: i,
                links: links
            });
        });
        return mainFooterMenu;
    };
    /**
     * Get specific "label" by parent category or first by parent and then find a child category
     *
     * @param category
     * @param subCategory
     */ _proto.getLabel = function getLabel(category) {
        var subCategory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        var data = this.getCreatokiaContent();
        if (!data || typeof data === "boolean") {
            return "";
        }
        var categoryItem = data.labels.find(function(item) {
            return item.slug === category;
        });
        if (categoryItem) {
            if (!subCategory) {
                return categoryItem.title;
            } else {
                var subCategoryItem = categoryItem.subcategories.find(function(item) {
                    return item.slug === subCategory;
                });
                if (subCategoryItem) {
                    return subCategoryItem.title;
                }
            }
        }
        return "";
    };
    _proto.getAllowedDimensionalCardProductOwners = function getAllowedDimensionalCardProductOwners() {
        var allowedProductOwners = this.getLabel("system", "product-owner-dimensional-card");
        if (!allowedProductOwners) {
            return [];
        }
        return allowedProductOwners.trim().split("|").map(function(str) {
            return str.trim();
        });
    };
    /**
     * Converts special patterns like button json placed from the RTE Editor in Typo3
     *
     * @param json
     * @private
     */ _proto.convertPlaceholderText = function convertPlaceholderText(json) {
        var currentLocal = this.getCurrentLocalization();
        var langSlug = currentLocal && (0,equal_object_helper/* isObject */.K)(currentLocal) ? currentLocal.twoLetterIsoCode : "en";
        for(var key in json){
            if (typeof json[key] == "object" && json[key] !== null) {
                this.convertPlaceholderText(json[key]);
            } else if (json[key] && typeof json[key] == "string") {
                // Spacing in RTE
                if (key === "bodytext" || key === "answer") {
                    json[key] = json[key].split("\n\n").join("<p>&nbsp;</p>");
                }
                // RTE button
                var regex = /<pre class="rtebutton(.*)">[\s\\r\\n]*<code>[\s\\r\\n]*(.*)[\s\\r\\n]*<\/code>[\s\\r\\n]*<\/pre>/gm;
                var matches = json[key].matchAll(regex);
                if (matches) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var match = _step.value;
                            var classes = "rtebutton-base" + match[1].replace("rtebutton", "");
                            var jsonButton = JSON.parse(match[2]);
                            var variant = jsonButton.inputVariant !== "" ? jsonButton.inputVariant : "primary";
                            // Uses Page-Styling when button has no set styling
                            if (this.json.creatokia !== undefined) {
                                jsonButton.inputStyle = this.json.creatokia.style;
                            }
                            var buttonData = {
                                variant: variant,
                                className: "rtebutton ".concat(variant),
                                disabled: jsonButton.inputDisabled,
                                type: "button",
                                inverted: jsonButton.inputStyle === "inverted",
                                buttonUrl: jsonButton.inputUri,
                                external: jsonButton.inputTarget === "_blank",
                                pending: jsonButton.inputPending
                            };
                            jsonButton.inputButtonAlignment !== "" ? classes += " text-" + jsonButton.inputButtonAlignment : 0;
                            if (buttonData.buttonUrl && !buttonData.disabled) {
                                json[key] = json[key].replace(match[0], server_browser.renderToString(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                                        href: buttonData.buttonUrl,
                                        external: buttonData.external,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, typo_service_objectSpread({}, buttonData, {
                                            children: jsonButton.inputTitle
                                        }))
                                    }, jsonButton.inputTitle)
                                })));
                            } else {
                                json[key] = json[key].replace(match[0], server_browser.renderToString(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, typo_service_objectSpread({}, buttonData, {
                                        children: jsonButton.inputTitle
                                    }))
                                })));
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // Adds language slug to urls on a tags
                regex = /href="(\/page\/.*?)"/gm;
                matches = json[key].matchAll(regex);
                if (matches) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = matches[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var match1 = _step1.value;
                            var newUrl = match1[1].replace("/page/", "/" + langSlug + "/page/");
                            json[key] = json[key].replace(match1[0], 'href="' + newUrl + '"');
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                // Adds langauge slug to page urls from json
                var allowedKeys = [
                    "href",
                    "headerLink",
                    "link"
                ];
                if (allowedKeys.includes(key)) {
                    regex = /^(\/page\/.*?)$/gm;
                    matches = json[key].matchAll(regex);
                    if (matches) {
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = matches[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var match2 = _step2.value;
                                var newUrl1 = match2[1].replace("/page/", "/" + langSlug + "/page/");
                                json[key] = json[key].replace(match2[0], newUrl1);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
            }
        }
        return json;
    };
    return TypoService;
}();



/***/ }),

/***/ 19910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Close; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Close = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        id: "close",
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "Vector_-_Kontur",
            "data-name": "Vector - Kontur",
            d: "M14.74,18,9.027,11,3.368,18H.157L7.545,9.152,0,0H2.937L8.915,7.557,15.006,0H18L10.523,9.3,17.808,18Z",
            transform: "translate(18 18) rotate(180)",
            fill: "#fff"
        })
    });
};


/***/ }),

/***/ 43301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var CreatokenSVGComponent = function(_param) {
    var fill = _param.fill, size = _param.size, props = _objectWithoutProperties(_param, [
        "fill",
        "size"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", _objectSpread({
        id: "Creatoken",
        xmlns: "http://www.w3.org/2000/svg",
        width: 135,
        height: 140.295,
        viewBox: "0 0 144.46 139.008"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: "\n      .cls-1 {\n        fill: #fff;\n      }\n    "
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_1427",
                "data-name": "Path 1427",
                className: "cls-1",
                d: "M83.4,0H27.8L0,48.153,27.8,96.307H83.4l27.8-48.153Z",
                transform: "translate(0 55.603) rotate(-30)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_1747",
                "data-name": "Path 1747",
                d: "M70.024,0H23.341L0,40.428,23.341,80.856H70.024L93.365,40.428Z",
                transform: "translate(11.945 58.163) rotate(-30)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Group_16615",
                "data-name": "Group 16615",
                transform: "translate(46.508 54.712)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Group_16618",
                    "data-name": "Group 16618",
                    transform: "translate(-284.277 -2345.048)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "Group_16618-2",
                        "data-name": "Group 16618",
                        transform: "translate(0 10)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                id: "Ellipse_3",
                                "data-name": "Ellipse 3",
                                className: "cls-1",
                                cx: 1.869,
                                cy: 1.869,
                                rx: 1.869,
                                ry: 1.869,
                                transform: "translate(311.311 2333.585)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                id: "Path_109",
                                "data-name": "Path 109",
                                className: "cls-1",
                                d: "M3938.809,2400.6l-4.046,2.923.272.167,7.8-4.773,3.983,2.437.111-.113-2.007-1.826,3.551-3.656,6.278,7.347-5.991,3.878.219.176,7.364-4.238,2.7,2.894,2.307-1.365,7.692,7.638-55.553-.006,8.855-10.659,3.615,3.374.194-.316-1.884-2.188,7.846-11.589Z",
                                transform: "translate(-3629.574 -55.246)"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
CreatokenSVGComponent.defaultProps = {
    fill: "#fff"
};
/* harmony default export */ __webpack_exports__["Z"] = (CreatokenSVGComponent);


/***/ }),

/***/ 85256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77872);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28773);
/* harmony import */ var _accordion_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71821);
/* harmony import */ var _accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Accordion = function(props) {
    var inverted = props.inverted;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.initialOpen), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.initialOpen ? "".concat((_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion), " ").concat((_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)) : (_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion)), contentStyle = ref1[0], setContentStyle = ref1[1];
    var toggleAccordion = function() {
        if (!isOpen) {
            setContentStyle("".concat((_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion), " ").concat((_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)));
        } else {
            setContentStyle((_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion));
        }
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "accordion ".concat(contentStyle, " ").concat(inverted ? (_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inverted) : "", " ").concat(props.onlyMobil ? (_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["only-mobile"]) : ""),
        "data-testid": "accordion",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    return toggleAccordion();
                },
                className: "accordion-header ".concat((_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["accordion-header"])),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z, {
                        element: "span",
                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantsEnum.FAQ_HEADING */ .H.FAQ_HEADING,
                        className: (_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["accordion-label"]),
                        children: props.label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["accordion-icon-wrapper"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                            className: (_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["accordion-icon"]),
                            icon: isOpen ? [
                                "far",
                                "chevron-up"
                            ] : [
                                "far",
                                "chevron-down"
                            ],
                            color: "black"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content), " ").concat(props.reverseContent ? (_accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["content-reverse"]) : ""),
                id: "content",
                children: props.children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 93217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_spinners_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79608);
/* harmony import */ var react_spinners_kit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_spinners_kit__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63367);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_enums_button_types_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30830);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92212);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77872);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28773);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1198);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_7__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var Button = function(props) {
    var renderText = function() {
        if (props.children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                className: props.pending ? "" : (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["not-pending"]),
                variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.BUTTON */ .H.BUTTON,
                children: props.children
            });
        } else {
            return null;
        }
    };
    switch(props.variant){
        case _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .ButtonVariantsEnum.PRIMARY */ .l.PRIMARY:
            {
                var ref, ref1;
                var _className;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    "data-testid": "button",
                    style: props === null || props === void 0 ? void 0 : props.style,
                    disabled: props.disabled || props.pending,
                    onClick: props === null || props === void 0 ? void 0 : props.onClick,
                    className: "\n                    ".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[props.variant], "\n                    ").concat(props.inverted ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inverted) : "", "\n                    ").concat((_className = props.className) !== null && _className !== void 0 ? _className : "", "\n                    "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                renderText(),
                                props.pending ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: props.icon ? "" : (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["loading-spinner"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spinners_kit__WEBPACK_IMPORTED_MODULE_2__.ImpulseSpinner, {
                                        size: 18,
                                        frontColor: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().primary_accent),
                                        backColor: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_light)
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: props.children && ((ref = props.icon) === null || ref === void 0 ? void 0 : ref.element) ? "withText" : undefined,
                                    children: (ref1 = props.icon) === null || ref1 === void 0 ? void 0 : ref1.element
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shadow)
                        })
                    ]
                });
            }
        case _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .ButtonVariantsEnum.SELECTED */ .l.SELECTED:
            {
                var ref2, ref3;
                var _className1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    "data-testid": "button",
                    style: props === null || props === void 0 ? void 0 : props.style,
                    disabled: props.disabled || props.pending,
                    onClick: props === null || props === void 0 ? void 0 : props.onClick,
                    className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[props.variant], " ").concat(props.inverted ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inverted) : "", " ").concat((_className1 = props.className) !== null && _className1 !== void 0 ? _className1 : ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                renderText(),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: props.children && ((ref2 = props.icon) === null || ref2 === void 0 ? void 0 : ref2.element) ? "withText" : undefined,
                                    children: (ref3 = props.icon) === null || ref3 === void 0 ? void 0 : ref3.element
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shadow)
                        })
                    ]
                });
            }
        case _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .ButtonVariantsEnum.LEFT_ARROW */ .l.LEFT_ARROW:
            {
                var ref4, ref5, ref6, ref7, ref8;
                var _className2;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    "data-testid": "button",
                    style: props === null || props === void 0 ? void 0 : props.style,
                    disabled: props.disabled,
                    onClick: props === null || props === void 0 ? void 0 : props.onClick,
                    className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[props.variant], " ").concat(props.inverted ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inverted) : "", " ").concat((_className2 = props.className) !== null && _className2 !== void 0 ? _className2 : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            ((ref4 = props.icon) === null || ref4 === void 0 ? void 0 : ref4.align) === "left" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: props.children && props.icon ? "withText left" : undefined,
                                children: (ref5 = props.icon) === null || ref5 === void 0 ? void 0 : ref5.element
                            }),
                            renderText(),
                            ((ref6 = props.icon) === null || ref6 === void 0 ? void 0 : ref6.align) === "right" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: props.children && ((ref7 = props.icon) === null || ref7 === void 0 ? void 0 : ref7.element) ? "withText right" : undefined,
                                children: (ref8 = props.icon) === null || ref8 === void 0 ? void 0 : ref8.element
                            })
                        ]
                    })
                });
            }
        case _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .ButtonVariantsEnum.STAGE */ .l.STAGE:
            {
                var ref9, ref10, ref11, ref12, ref13;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: _objectSpread({
                        position: "relative"
                    }, props === null || props === void 0 ? void 0 : props.style),
                    className: props.className,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            "data-testid": "button",
                            disabled: props.disabled,
                            onClick: props === null || props === void 0 ? void 0 : props.onClick,
                            className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["secondary-filled"]), "  ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[props.variant], " ").concat(props.inverted ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inverted) : "", " "),
                            children: [
                                ((ref9 = props.icon) === null || ref9 === void 0 ? void 0 : ref9.align) === "left" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: props.children && props.icon ? "withText left" : undefined,
                                    children: (ref10 = props.icon) === null || ref10 === void 0 ? void 0 : ref10.element
                                }) : undefined,
                                renderText(),
                                ((ref11 = props.icon) === null || ref11 === void 0 ? void 0 : ref11.align) === "right" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: props.children && ((ref12 = props.icon) === null || ref12 === void 0 ? void 0 : ref12.element) ? "withText right" : undefined,
                                    children: (ref13 = props.icon) === null || ref13 === void 0 ? void 0 : ref13.element
                                }) : undefined
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shadow)
                        })
                    ]
                });
            }
        default:
            {
                var ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
                var _className3;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    "data-testid": "button",
                    style: props === null || props === void 0 ? void 0 : props.style,
                    disabled: props.disabled || props.pending,
                    onClick: props === null || props === void 0 ? void 0 : props.onClick,
                    className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button), "  ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[props.variant], " ").concat(props.inverted ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inverted) : "", " ").concat((_className3 = props.className) !== null && _className3 !== void 0 ? _className3 : ""),
                    children: [
                        props.icon ? undefined : renderText(),
                        props.pending ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: props.icon ? "" : (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["loading-spinner"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spinners_kit__WEBPACK_IMPORTED_MODULE_2__.ImpulseSpinner, {
                                size: 18,
                                frontColor: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().primary_accent),
                                backColor: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_light)
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                ((ref14 = props.icon) === null || ref14 === void 0 ? void 0 : ref14.align) === "left" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: " \n                                        ".concat(props.children && props.icon ? "withText left" : undefined, "\n                                        ").concat(((ref15 = props.icon) === null || ref15 === void 0 ? void 0 : ref15.className) ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[(ref16 = props.icon) === null || ref16 === void 0 ? void 0 : ref16.className] : "", "\n                                    "),
                                    children: (ref17 = props.icon) === null || ref17 === void 0 ? void 0 : ref17.element
                                }) : undefined,
                                props.icon ? renderText() : undefined,
                                ((ref18 = props.icon) === null || ref18 === void 0 ? void 0 : ref18.align) === "right" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "\n                                            ".concat(props.children && ((ref19 = props.icon) === null || ref19 === void 0 ? void 0 : ref19.element) ? "withText right" : undefined, "\n                                            ").concat(((ref20 = props.icon) === null || ref20 === void 0 ? void 0 : ref20.className) ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[(ref21 = props.icon) === null || ref21 === void 0 ? void 0 : ref21.className] : "", "\n                                        "),
                                    children: (ref22 = props.icon) === null || ref22 === void 0 ? void 0 : ref22.element
                                }) : undefined
                            ]
                        })
                    ]
                });
            }
    }
};
Button.defaultProps = {
    variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .ButtonVariantsEnum.PRIMARY */ .l.PRIMARY,
    type: _utils_enums_button_types_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonTypesEnum.SUBMIT */ .J.SUBMIT
};


/***/ }),

/***/ 72807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dialog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/assets/icons/close.svg.tsx
var close_svg = __webpack_require__(19910);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/utils/_helper/isServer.ts
var isServer = __webpack_require__(63755);
;// CONCATENATED MODULE: ./src/components/_shared/modal/modal.tsx



/**
 * Generates a new Element as an Child of the body tag by default and if an
 * `selector` prop is provided, it will be set as an child of that element instead.
 *
 * @example
 * <Modal>
 *  <div> Hello World </div>
 * </Modal>
 */ var Modal = function(param) {
    var children = param.children, selector = param.selector;
    var element;
    if ((0,isServer/* isServer */.s)()) return null;
    if (!selector) {
        var existingElement = document.getElementById("modal");
        if (existingElement) {
            element = existingElement;
        } else {
            var ref;
            element = document.createElement("div");
            element.setAttribute("id", "modal");
            (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.appendChild(element);
        }
    } else {
        element = document.querySelector(selector);
    }
    if (element) return /*#__PURE__*/ react_dom.createPortal(children, element);
    else throw new Error("Selector ".concat(selector, " not found in DOM"));
};

// EXTERNAL MODULE: ./src/components/_shared/dialog/button/modal-button.module.scss
var modal_button_module = __webpack_require__(89498);
var modal_button_module_default = /*#__PURE__*/__webpack_require__.n(modal_button_module);
;// CONCATENATED MODULE: ./src/components/_shared/dialog/button/modal-button.tsx



// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var ModalButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (modal_button_module_default())["hexagon-wrapper"],
        onClick: props.onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (modal_button_module_default()).hexagon,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (modal_button_module_default()).content,
                children: props.children
            })
        })
    });
};
/* harmony default export */ var modal_button = (ModalButton);

// EXTERNAL MODULE: ./src/components/_shared/dialog/dialog.module.scss
var dialog_module = __webpack_require__(66725);
var dialog_module_default = /*#__PURE__*/__webpack_require__.n(dialog_module);
;// CONCATENATED MODULE: ./src/components/_shared/dialog/dialog.tsx






var Dialog = function(props) {
    if (props.children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (dialog_module_default())["modal-wrapper"],
                onClick: function(e) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (e.target.id === "dialog") {
                        props.onClose();
                    }
                },
                id: "dialog",
                "data-testid": "dialog",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (dialog_module_default())["modal-container"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (dialog_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (dialog_module_default())["backdrop-wrapper"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (dialog_module_default()).content,
                                    children: props.children
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (dialog_module_default())["close-wrapper"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_button, {
                                    onClick: props.onClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_svg/* Close */.x, {})
                                })
                            })
                        ]
                    })
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};
/* harmony default export */ var dialog = (Dialog);


/***/ }),

/***/ 63879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ErrorMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _error_message_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78044);
/* harmony import */ var _error_message_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_error_message_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var ErrorMessage = function(param) {
    var children = param.children, withoutGlobalClass = param.withoutGlobalClass, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "error-message",
        className: "".concat(withoutGlobalClass ? "" : "error-message", " ").concat((_error_message_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["error-message-wrapper"]), " ").concat(className !== null && className !== void 0 ? className : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_error_message_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["error-message"]),
            children: children
        })
    });
};
ErrorMessage.defaultProps = {
    withoutGlobalClass: false
};


/***/ }),

/***/ 46051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useTypoContent.hook.ts
var useTypoContent_hook = __webpack_require__(80612);
// EXTERNAL MODULE: ./src/api/services/typo.service.tsx + 53 modules
var typo_service = __webpack_require__(55584);
;// CONCATENATED MODULE: ./src/assets/icons/logo-horizontal.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var LogoHorizontalSVGComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", _objectSpread({
        viewBox: "0 0 501 162",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M220.325 107.36C223.084 107.36 225.884 106.658 228.004 105.435H228.007C229.737 104.531 231.329 103.194 232.607 101.928C232.594 101.947 236.379 105.613 236.379 105.613L235.962 106.072C231.876 110.554 226.753 112.827 220.734 112.827H220.003C214.381 112.827 209.488 110.73 205.459 106.596C201.441 102.476 199.405 97.5761 199.405 92.0064C199.405 86.4367 201.476 81.5608 205.559 77.5192C209.64 73.4776 214.695 71.4285 220.65 71.4285C226.604 71.4285 231.751 73.6963 235.94 78.1645L236.336 78.6072C236.336 78.6072 232.385 82.4518 232.399 82.4788C231.264 81.4798 228.99 79.598 227.549 78.7827C225.307 77.5139 222.943 76.8956 220.325 76.8956C216.296 76.8956 212.732 78.4128 209.732 81.4042C206.732 84.3956 205.21 88.0026 205.21 92.1279C205.21 96.2532 206.732 99.8601 209.732 102.852C212.732 105.843 216.296 107.36 220.325 107.36Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M279.446 72.2762H302.272V77.3572H285.283V89.3741H301.21V94.4038H285.283V106.844H302.54V111.98H279.446V72.2762Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M321.35 72.2762H328.889L342.162 111.98H335.896L332.764 101.974H317.313L314.126 111.98H308.074L321.35 72.2762ZM318.962 96.839H331.12L325.174 77.9944H324.963L318.962 96.839Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M341.569 77.3572H352.186V111.977H358.027V77.3572H368.647V72.2762H341.569V77.3572Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M453.862 72.2762H459.702V111.98H453.862V72.2762Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M479.656 72.0888H487.194L500.467 111.792H494.202L491.069 101.787H475.618L472.431 111.792H466.38L479.656 72.0888ZM477.267 96.6516H489.425L483.479 77.8069H483.268L477.267 96.6516Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M402.353 85.8374L406.755 81.496H406.758C408.434 84.5522 409.371 88.1618 409.371 92.1279C409.371 104.093 401.034 112.827 389.141 112.827C377.249 112.827 368.86 104.093 368.86 92.1279C368.86 80.1624 377.409 71.4285 389.141 71.4285C393.82 71.4285 397.982 72.8216 401.294 75.2514L397.359 79.1445C395.098 77.5327 392.301 76.6175 389.139 76.6175C380.696 76.6175 374.855 83.0214 374.855 92.0738C374.855 101.126 380.696 107.53 389.139 107.53C397.581 107.53 403.422 101.126 403.422 92.0738C403.422 89.8169 403.046 87.7191 402.353 85.8374Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M261.561 95.6727C267.347 94.3498 271.171 89.8492 271.171 84.1337C271.171 77.4113 265.701 72.2222 258.057 72.2222H243.351V111.926H249.192V77.3032H257.475C262.306 77.3032 265.227 80.3729 265.227 84.185C265.227 87.9971 262.308 91.1208 257.475 91.1208H252.36L255.247 96.0453L264.856 111.926H271.599L261.564 95.6727H261.561Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M444.597 111.791H437.715L426.122 94.5337H421.993V111.791H416.17V72.0888H421.993V89.5048H426.175L437.715 72.0888H444.438L430.939 91.9928L444.597 111.791Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M133.756 91.6545C137.469 91.6545 140.479 88.6496 140.479 84.9429C140.479 81.2362 137.469 78.2313 133.756 78.2313C130.043 78.2313 127.033 81.2362 127.033 84.9429C127.033 88.6496 130.043 91.6545 133.756 91.6545Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M201.095 134.285L192.799 139.184L183.135 128.86L183.078 128.798L156.597 144.017L155.813 143.384L177.351 129.47H177.36L177.351 129.453V43.3115L177.355 42.0603L165.711 46.1544V0H0V104.936L0.00885802 105.692L11.635 101.603V161.706H228.754L201.09 134.29L201.095 134.285ZM10.9795 10.9561H154.741V50.0187L10.9795 100.577V10.9561ZM149.231 122.763L148.832 123.165L134.509 114.416L106.465 131.553L105.486 130.951L120.035 120.46L95.9634 84.9297L67.7462 126.535L74.5181 134.391L73.8183 135.528L60.8192 123.413L38.0762 150.746H22.619V97.7383L166.38 47.1669V116.622L154.785 103.079L142.016 116.202L149.236 122.759L149.231 122.763Z",
                fill: "white"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/_shared/newsletter-input/newsletter-input.tsx + 1 modules
var newsletter_input = __webpack_require__(48887);
// EXTERNAL MODULE: ./src/components/_shared/seperator/seperator.tsx
var seperator = __webpack_require__(59688);
// EXTERNAL MODULE: ./src/components/_shared/spacer/spacer.tsx
var spacer = __webpack_require__(4363);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/footer/footer.module.scss
var footer_module = __webpack_require__(52931);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/icons/discord.png
/* harmony default export */ var discord = ({"src":"/_next/static/media/discord.649760f1.png","height":66,"width":69,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEVMaXHx8fF/f39ubm6ZmZlaWlr///+BgYHKysr////Nzc2zs7O+vr4yMjJAQEASEhIHBweTes45AAAADXRSTlMAT/fcn/EMpVYV+IB+BYtFLQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADdJREFUCJkli8EWABAIBLdERPT/X+vJXHYOswDQGhIqhd6ufc6eANTNXFOYU3qNqP1FQ2T8W3IBKlIBIvDuuYQAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/icons/facebook.png
/* harmony default export */ var facebook = ({"src":"/_next/static/media/facebook.3eb4ac35.png","height":66,"width":69,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXGOjo5dXV3ExMT///97e3v///+zs7Pq6uqNjY1qamrLy8sYGBhDQ0Oa8/OVAAAADHRSTlMAofNWFaYMf0/43PjPeoYIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVQImSWLSRIAIAjDyqKglv9/1xFzaQ4pAMyJJvfOt1FkBQDhWRwtS1tMSbUXuYj/W3MBKHUA+PPBqh4AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/icons/instagram.png
/* harmony default export */ var instagram = ({"src":"/_next/static/media/instagram.11ccc399.png","height":66,"width":69,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEVMaXHFxcX///+BgYGPj49aWlr///+1tbXs7OxxcXGVlZUrKytGRkYICAg/Pz+77ScGAAAADXRSTlMAVhWmoPEMf0/covf4Kx6bAAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADVJREFUCJkli7kRACAMw8SfAGb/cTmCGquwAHonMHd7O450BlC1twowtVZIalJL75RnzT8LLi1EASE4XFrPAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/icons/linkedin.png
/* harmony default export */ var linkedin = ({"src":"/_next/static/media/linkedin.524ea0d0.png","height":66,"width":69,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXHU1NSHh4f///9nZ2ejo6Ourq7///9QUFBdXV2KioqXl5cSEhI3NzcwA2HmAAAADHRSTlMAU6UV8Z9/DPfc+PhSD9btAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVQImSWLMRIAIAjDioKKlv9/17NmaYYUAOaEsEx7O4qsAaBxHzbJWhJz0hX1iP5v4gIlhwDwrvGBqAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/icons/twitter.png
/* harmony default export */ var twitter = ({"src":"/_next/static/media/twitter.352ec4ca.png","height":66,"width":69,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEVMaXH///+zs7Nubm6MjIydnZ3q6uq/v7////9XV1d4eHh+fn6QkJBfX1+Xl5eAgICpqakDAwNEREQyqPgWAAAAEXRSTlMADH/cpZRPYxX026P48ab3+H4u6yQAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA5SURBVAiZJYs5EsAgEMPEQLiSLJj/P5ZZUONCFkAIHHKP2bcsaT1A0jf1AqbRlFz9Uit+qmb1ZocNNHkBefII/EwAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/components/_shared/footer/footer-additional-links/footer-additional-links.module.scss
var footer_additional_links_module = __webpack_require__(35903);
var footer_additional_links_module_default = /*#__PURE__*/__webpack_require__.n(footer_additional_links_module);
;// CONCATENATED MODULE: ./src/components/_shared/footer/footer-additional-links/footer-additional-links.tsx













var FooterCopyright = function(param) {
    var notReduced = param.notReduced, typoService = param.typoService;
    if (!typoService) {
        typoService = new typo_service/* TypoService */.$((0,useTypoContent_hook/* useTypoContent */.f)());
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (footer_additional_links_module_default())["footer-additional-links"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.INPUT */.H.INPUT,
                    element: "span",
                    children: typoService.getLabel("page", "footer-copyright")
                })
            }),
            notReduced && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (footer_additional_links_module_default())["footer-social-links"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: typoService.getLabel("page", "url-facebook"),
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: facebook.src,
                            width: facebook.width,
                            height: facebook.height,
                            alt: "facebook"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: typoService.getLabel("page", "url-linkedin"),
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: linkedin.src,
                            width: linkedin.width,
                            height: linkedin.height,
                            alt: "linkedin"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: typoService.getLabel("page", "url-instagram"),
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: instagram.src,
                            width: instagram.width,
                            height: instagram.height,
                            alt: "instagram"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: typoService.getLabel("page", "url-discord"),
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: discord.src,
                            width: discord.width,
                            height: discord.height,
                            alt: "discord"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: typoService.getLabel("page", "url-twitter"),
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: twitter.src,
                            width: twitter.width,
                            height: twitter.height,
                            alt: "twitter"
                        })
                    })
                ]
            })
        ]
    });
};
FooterCopyright.defaultProps = {
    notReduced: false
};

// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/components/_shared/footer/footer-link-container/footer-link-container.module.scss
var footer_link_container_module = __webpack_require__(19615);
var footer_link_container_module_default = /*#__PURE__*/__webpack_require__.n(footer_link_container_module);
;// CONCATENATED MODULE: ./src/components/_shared/footer/footer-link-container/footer-link-container.tsx







var FooterLinkContainer = function(param1) {
    var links = param1.links, headline = param1.headline;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (footer_link_container_module_default())["footer-link-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                style: {
                    color: "white"
                },
                disableMarkdown: true,
                variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5,
                children: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                height: "40px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (footer_link_container_module_default())["footer-link-body"],
                children: links === null || links === void 0 ? void 0 : links.map(function(param, index) {
                    var value = param.linkText, href = param.url, external = param.external;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                        href: href !== null && href !== void 0 ? href : "",
                        target: external ? "_target" : undefined,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            disableMarkdown: true,
                            variant: typeography_variants_enum/* TypographyVariantsEnum.FOOTER_LINK */.H.FOOTER_LINK,
                            children: value
                        })
                    }, href !== null && href !== void 0 ? href : index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/_shared/footer/footer.tsx














var Footer = function(props) {
    var typoService = props.typoService ? props.typoService : new typo_service/* TypoService */.$((0,useTypoContent_hook/* useTypoContent */.f)());
    var footerLinks = typoService.getFooterNavLinks();
    var newsletterPlaceholder = {
        id: 62,
        fieldHint: typoService.getLabel("page", "footer-email-placeholder"),
        fieldLabel: typoService.getLabel("page", "footer-email-placeholder"),
        fieldType: "",
        fieldName: ""
    };
    var ref, ref1, _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (footer_module_default())["footer-wrapper"],
        "data-testid": "footer-wrapper",
        style: {
            backgroundColor: props.isReduced ? (ref = typoService.getLabel("page", "footer-background-color")) !== null && ref !== void 0 ? ref : "#1a1a1a" : undefined,
            display: !props.isReduced ? "flex" : undefined,
            flexDirection: !props.isReduced ? "column" : undefined
        },
        children: [
            !props.isReduced && /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
                className: (footer_module_default())["footer-image"],
                src: typoService.getLabel("page", "footer-background-url"),
                alt: typoService.getLabel("page", "footer-background-alttext")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundColor: !props.isReduced ? (ref1 = typoService.getLabel("page", "footer-background-color")) !== null && ref1 !== void 0 ? ref1 : "#1a1a1a" : undefined
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    "data-testid": "footer",
                    className: "\n                ".concat(props.isReduced ? (footer_module_default())["reduced-footer"] : (footer_module_default()).footer, " ").concat((_className = props.className) !== null && _className !== void 0 ? _className : ""),
                    children: props.isReduced ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCopyright, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (footer_module_default())["footer-full-body"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        zIndex: 3,
                                        margin: "0 10px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoHorizontalSVGComponent, {
                                        fill: "white",
                                        width: "220px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        zIndex: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                        variant: typeography_variants_enum/* TypographyVariantsEnum.FOOTER_PARAGRAPH */.H.FOOTER_PARAGRAPH,
                                                        children: typoService.getLabel("page", "footer-paragraph")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            style: {
                                                                color: "white",
                                                                fontSize: "23px"
                                                            },
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                                                            children: typoService.getLabel("page", "footer-email-headline")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                                            height: "40px"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.FOOTER_PARAGRAPH */.H.FOOTER_PARAGRAPH,
                                                            children: typoService.getLabel("page", "footer-email-paragraph")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                                            height: "40px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_input/* default */.Z, {
                                                            successMessage: typoService.getLabel("page", "footer-email-success"),
                                                            errorMessage: typoService.getLabel("page", "footer-email-error"),
                                                            inputTexts: newsletterPlaceholder,
                                                            inverted: true,
                                                            otherIcon: [
                                                                "fas",
                                                                "paper-plane"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                minWidth: " 300px",
                                                flexDirection: "row",
                                                flex: 1,
                                                marginRight: "unset"
                                            },
                                            children: footerLinks.map(function(param) {
                                                var links = param.links, headline = param.headline;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FooterLinkContainer, {
                                                    headline: headline === null || headline === void 0 ? void 0 : headline.headlineContent,
                                                    links: links
                                                }, (headline === null || headline === void 0 ? void 0 : headline.headlineContent) + links.join(" "));
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(seperator/* Seperator */.t, {
                                    width: "100%",
                                    color: "white",
                                    height: "1px",
                                    margin: "20px 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCopyright, {
                                        typoService: typoService,
                                        notReduced: true
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
Footer.defaultProps = {
    isReduced: false
};


/***/ }),

/***/ 3143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ HeaderFooterWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useFooter_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47536);
/* harmony import */ var _footer_footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46051);
/* harmony import */ var _header_default_header_default_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4302);
/* harmony import */ var _header_footer_wrapper_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21269);
/* harmony import */ var _header_footer_wrapper_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_header_footer_wrapper_module_scss__WEBPACK_IMPORTED_MODULE_5__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var HeaderFooterWrapper = function(param) {
    var children = param.children, header = param.header, footer = param.footer, className = param.className, stage = param.stage, inverted = param.inverted;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_header_footer_wrapper_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["header-footer-wrapper"]), "  ").concat(inverted && (_header_footer_wrapper_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inverted), " ").concat(className !== null && className !== void 0 ? className : ""),
        children: [
            header,
            stage,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: children
            }),
            footer
        ]
    });
};
HeaderFooterWrapper.defaultProps = {
    header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_header_default_header_default_header__WEBPACK_IMPORTED_MODULE_4__/* .DefaultHeader */ .y, {}),
    footer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_footer_footer__WEBPACK_IMPORTED_MODULE_3__/* .Footer */ .$, {})
};
HeaderFooterWrapper.dataHooks = _toConsumableArray(_header_default_header_default_header__WEBPACK_IMPORTED_MODULE_4__/* .DefaultHeader.dataHooks */ .y.dataHooks).concat([
    _api_hooks_useFooter_hook__WEBPACK_IMPORTED_MODULE_2__/* .useFooter */ .T
]);


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DefaultHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useAccountBasePage.ts
var useAccountBasePage = __webpack_require__(72341);
// EXTERNAL MODULE: ./src/api/hooks/useLanguageDependentDataSsr.hook.ts
var useLanguageDependentDataSsr_hook = __webpack_require__(18060);
;// CONCATENATED MODULE: ./src/api/hooks/useAdminHeader.hook.ts

var useAdminHeader = (0,useLanguageDependentDataSsr_hook/* useLanguageDependentDataSSr */.Y)("admin-header");

// EXTERNAL MODULE: ./src/api/hooks/useHeader.hook.ts
var useHeader_hook = __webpack_require__(81548);
// EXTERNAL MODULE: ./src/api/hooks/useLoginPage.hook.ts
var useLoginPage_hook = __webpack_require__(92534);
// EXTERNAL MODULE: ./src/api/hooks/useTypoContent.hook.ts
var useTypoContent_hook = __webpack_require__(80612);
// EXTERNAL MODULE: ./src/api/services/typo.service.tsx + 53 modules
var typo_service = __webpack_require__(55584);
;// CONCATENATED MODULE: ./src/assets/icons/menu-icon.svg.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var MenuIcon = function(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", _objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "21.1",
        height: "11.872",
        viewBox: "0 0 21.1 11.872"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "menu-bar-ico",
            "data-name": "menu bar-ico",
            transform: "translate(-1 11.872) rotate(-90)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0,0,1.545,1.03V19.089H0Z",
                    transform: "translate(10.327 3.009)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0,1l1.545.949V22.1H0Z",
                    transform: "translate(5.164)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0,1l1.545.949V16.035H0Z",
                    transform: "translate(0 6.063)",
                    fill: "#fff"
                })
            ]
        })
    }));
};


;// CONCATENATED MODULE: ./src/assets/icons/user-icon.svg.tsx
function user_icon_svg_extends() {
    user_icon_svg_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return user_icon_svg_extends.apply(this, arguments);
}


var UserIcon = function(_param) {
    var props = user_icon_svg_extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.034,17.75l-5.17-4.865.422-.525a9.026,9.026,0,0,0,1.863-5.182V7.166c.026-.551.028-.7.028-.845,0-4.1-2.079-4.583-3.142-4.548A2.841,2.841,0,0,0,6.758,2.816a5.483,5.483,0,0,0-.789,3.4l.008.449.008.248A13.361,13.361,0,0,0,7.419,12.36l.334.525L2.7,17.75H0l5.346-4.865A18.527,18.527,0,0,1,3.917,7.021l0-.058-.01-.3L3.9,6.182C3.9.823,6.729-.25,9.036-.25a4.569,4.569,0,0,1,3.859,1.738,7.763,7.763,0,0,1,1.25,4.746c0,.2,0,.392-.03.932a11.688,11.688,0,0,1-1.625,5.72c2.154,2.1,5.475,4.779,5.513,4.808Z",
            fill: "#fff",
            transform: "translate(-0.003 0.25)"
        })
    });
};


// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/utils/_enums/DefaultHeaderMobileLoginFormContext.enum.ts
var DefaultHeaderMobileLoginFormContext_enum = __webpack_require__(64889);
// EXTERNAL MODULE: ./src/utils/_hooks/useBreakpoints.hook.ts
var useBreakpoints_hook = __webpack_require__(93890);
;// CONCATENATED MODULE: ./src/components/_shared/header/default-header/default-header-mobile-login-form/default-header-mobile-login-form-context/default-header-mobile-login-form-context.tsx
function default_header_mobile_login_form_context_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_header_mobile_login_form_context_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_header_mobile_login_form_context_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var initialData = {
    loginFormOpen: false,
    mobileNavOpen: false,
    myAccountNavOpen: false,
    dispatch: function() {
        alert("Error");
        return;
    }
};
var reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialData, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLELOGINFORM */.E.TOGGLELOGINFORM:
            {
                return default_header_mobile_login_form_context_objectSpread({}, state, {
                    mobileNavOpen: !state.loginFormOpen ? false : state.mobileNavOpen,
                    loginFormOpen: !state.loginFormOpen
                });
            }
        case DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMOBILENAVIGATION */.E.TOGGLEMOBILENAVIGATION:
            {
                return default_header_mobile_login_form_context_objectSpread({}, state, {
                    loginFormOpen: !state.mobileNavOpen ? false : state.loginFormOpen,
                    mobileNavOpen: !state.mobileNavOpen
                });
            }
        case DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMYACCOUNTNAVIGATION */.E.TOGGLEMYACCOUNTNAVIGATION:
            {
                return default_header_mobile_login_form_context_objectSpread({}, state, {
                    myAccountNavOpen: !state.myAccountNavOpen
                });
            }
        case DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.RESET */.E.RESET:
            {
                return default_header_mobile_login_form_context_objectSpread({}, state, {
                    loginFormOpen: false,
                    mobileNavOpen: false,
                    myAccountNavOpen: false
                });
            }
        default:
            return state;
    }
};
var DefaultHeaderMobileLoginFormContext = /*#__PURE__*/ react.createContext(initialData);
var DefaultHeaderMobileLoginFormContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useReducer)(reducer, initialData), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHeaderMobileLoginFormContext.Provider, {
        value: default_header_mobile_login_form_context_objectSpread({}, state, {
            dispatch: dispatch
        }),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/utils/_hooks/useDefaultHeaderMobileLoginContext.hook.ts


var useDefaultHeaderMobileLoginContext = function() {
    return (0,react.useContext)(DefaultHeaderMobileLoginFormContext);
};

// EXTERNAL MODULE: ./src/components/_shared/header/header.tsx + 2 modules
var header = __webpack_require__(83086);
// EXTERNAL MODULE: ./src/components/_shared/header/header-background/header-background.tsx
var header_background = __webpack_require__(67822);
// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.module.scss
var default_header_module = __webpack_require__(6);
var default_header_module_default = /*#__PURE__*/__webpack_require__.n(default_header_module);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/utils/_enums/link-variants.enum.tsx
var link_variants_enum = __webpack_require__(11702);
// EXTERNAL MODULE: ./src/utils/_enums/route-path.enum.tsx
var route_path_enum = __webpack_require__(16837);
// EXTERNAL MODULE: ./src/components/_shared/link/link.tsx
var link_link = __webpack_require__(46164);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/error/error-message.tsx
var error_message = __webpack_require__(63879);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/input/input.tsx
var input = __webpack_require__(17850);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/text-area/text-area.tsx
var text_area = __webpack_require__(47085);
// EXTERNAL MODULE: ./src/components/_shared/radio-button-group/radio-button-group.tsx
var radio_button_group = __webpack_require__(86499);
// EXTERNAL MODULE: ./src/components/_shared/select/select.tsx
var select_select = __webpack_require__(39382);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/header/header-mobile/header-mobile-popup.tsx
var header_mobile_popup = __webpack_require__(92750);
// EXTERNAL MODULE: ./src/components/_shared/header/header-mobile/header-mobile-form/header-mobile-form.module.scss
var header_mobile_form_module = __webpack_require__(77467);
var header_mobile_form_module_default = /*#__PURE__*/__webpack_require__.n(header_mobile_form_module);
;// CONCATENATED MODULE: ./src/components/_shared/header/header-mobile/header-mobile-form/header-mobile-form.tsx
function header_mobile_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_mobile_form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_mobile_form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


















var resolveVariant = function(variant, register, props, errorMessage) {
    switch(variant){
        case "input":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, header_mobile_form_objectSpread({
                    errorMessage: errorMessage,
                    register: register,
                    name: props === null || props === void 0 ? void 0 : props.name
                }, props), props === null || props === void 0 ? void 0 : props.name);
            }
        case "select":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, header_mobile_form_objectSpread({
                    errorMessage: errorMessage,
                    register: register,
                    name: props === null || props === void 0 ? void 0 : props.name
                }, props), props === null || props === void 0 ? void 0 : props.name);
            }
        case "radio":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_button_group/* default */.Z, header_mobile_form_objectSpread({
                    errorMessage: errorMessage,
                    register: register,
                    name: props === null || props === void 0 ? void 0 : props.name
                }, props), props === null || props === void 0 ? void 0 : props.name);
            }
        default:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_area/* default */.Z, header_mobile_form_objectSpread({
                    errorMessage: errorMessage,
                    register: register,
                    name: props === null || props === void 0 ? void 0 : props.name
                }, props), props === null || props === void 0 ? void 0 : props.name);
            }
    }
};
var HeaderMobileForm = function(param) {
    var onCancelClick = param.onCancelClick, formConfig = param.formConfig, forgotPassword = param.forgotPassword, fields = param.fields, onSubmit = param.onSubmit, submitButtonProps = param.submitButtonProps, formtitle = param.formtitle, children = param.children, className = param.className, open = param.open, globalError = param.globalError;
    var ref1 = (0,index_esm/* useForm */.cI)(formConfig), register = ref1.register, handleSubmit = ref1.handleSubmit, errors = ref1.formState.errors, reset = ref1.reset;
    var dispatch = (0,es/* useDispatch */.I0)();
    var loginStatus = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.authentification.loginStatus;
    });
    (0,react.useEffect)(function() {
        if (!open) {
            dispatch((0,redux/* resetLoginState */.Iy)());
            reset();
        }
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,redux/* resetLoginState */.Iy)());
        };
    }, []);
    if (!open) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_mobile_popup/* HeaderMobilePopup */.S, {
        className: className,
        backgroundColor: "white",
        onClick: function() {
            return onCancelClick(!open);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "".concat((header_mobile_form_module_default())["header-mobile-form"]),
            noValidate: true,
            onSubmit: handleSubmit(function(data) {
                onSubmit(data);
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5,
                    children: formtitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        fields.map(function(_param) {
                            var variant = _param.variant, props = _objectWithoutProperties(_param, [
                                "variant"
                            ]);
                            var ref;
                            return resolveVariant(variant, register, props, errors === null || errors === void 0 ? void 0 : (ref = errors[props === null || props === void 0 ? void 0 : props.name]) === null || ref === void 0 ? void 0 : ref.message);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(error_message/* ErrorMessage */.B, {
                            className: (header_mobile_form_module_default())["global-error-message"],
                            withoutGlobalClass: true,
                            children: globalError && (Object.keys(errors).length > 0 || loginStatus && loginStatus !== 200) ? globalError.message : undefined
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (header_mobile_form_module_default())["forgot-password-container"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        variant: link_variants_enum/* LinkVariants.READ_MORE */.C.READ_MORE,
                        className: (header_mobile_form_module_default())["forgot-password"],
                        href: route_path_enum/* RoutePath.RESET_PASSWORD */.h3.RESET_PASSWORD,
                        children: forgotPassword
                    }, "password-link")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (header_mobile_form_module_default())["submit-button-container"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, header_mobile_form_objectSpread({}, submitButtonProps))
                }),
                children
            ]
        })
    });
};

HeaderMobileForm.defaultProps = {
    formConfig: {},
    fields: []
};

// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header-mobile-login-form/default-header-mobile-login-form.module.scss
var default_header_mobile_login_form_module = __webpack_require__(71742);
var default_header_mobile_login_form_module_default = /*#__PURE__*/__webpack_require__.n(default_header_mobile_login_form_module);
;// CONCATENATED MODULE: ./src/components/_shared/header/default-header/default-header-mobile-login-form/default-header-mobile-login-form.tsx















var DefaultHeaderMobileLoginForm = function() {
    var ref, ref1;
    var data1 = (0,useHeader_hook/* useHeader */.g)();
    var loginData = (0,useLoginPage_hook/* useLoginPage */.Y)();
    if (!data1 || !loginData) return null;
    var loginButton = loginData.loginButton, emailOrUsername = loginData.emailOrUsername, password = loginData.password, forgotPassword = loginData.forgotPassword;
    var mobileLoginFormTitle = data1.mobileLoginFormTitle, mobileLoginFormErrorMessage = data1.mobileLoginFormErrorMessage, registerLinkText = data1.registerLinkText;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = useDefaultHeaderMobileLoginContext(), loginFormOpen = ref2.loginFormOpen, contextDispatch = ref2.dispatch;
    var ref3, ref4;
    var schema = yup_es/* object */.Ry({
        emailOrUsername: yup_es/* string */.Z_().required((ref3 = emailOrUsername === null || emailOrUsername === void 0 ? void 0 : (ref = emailOrUsername.fieldErrorMessages) === null || ref === void 0 ? void 0 : ref.required) !== null && ref3 !== void 0 ? ref3 : " "),
        password: yup_es/* string */.Z_().required((ref4 = password === null || password === void 0 ? void 0 : (ref1 = password.fieldErrorMessages) === null || ref1 === void 0 ? void 0 : ref1.required) !== null && ref4 !== void 0 ? ref4 : " ")
    });
    var resolver = (0,yup_module/* yupResolver */.X)(schema);
    var ref5 = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.authentification;
    }), loggedIn = ref5.loggedIn, pending = ref5.pending;
    var dataSubmitted = function(data) {
        dispatch((0,redux/* login */.x4)(data));
    };
    (0,react.useEffect)(function() {
        if (loggedIn) {
            contextDispatch({
                type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.RESET */.E.RESET
            });
        }
    }, [
        loggedIn
    ]);
    var ref6, ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileForm, {
        globalError: {
            message: mobileLoginFormErrorMessage !== null && mobileLoginFormErrorMessage !== void 0 ? mobileLoginFormErrorMessage : ""
        },
        open: loginFormOpen !== null && loginFormOpen !== void 0 ? loginFormOpen : false,
        className: "".concat((default_header_mobile_login_form_module_default())["default-header-mobile-login-form"], " ").concat((default_header_mobile_login_form_module_default()).showOnlyLeastError),
        formConfig: {
            resolver: resolver,
            mode: "onChange"
        },
        onCancelClick: function() {
            return contextDispatch({
                type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLELOGINFORM */.E.TOGGLELOGINFORM
            });
        },
        fields: [
            {
                name: "emailOrUsername",
                variant: "input",
                placeholder: (ref6 = emailOrUsername === null || emailOrUsername === void 0 ? void 0 : emailOrUsername.fieldHint) !== null && ref6 !== void 0 ? ref6 : "",
                title: (ref7 = emailOrUsername === null || emailOrUsername === void 0 ? void 0 : emailOrUsername.fieldLabel) !== null && ref7 !== void 0 ? ref7 : ""
            },
            {
                name: "password",
                variant: "input",
                placeholder: (ref8 = password === null || password === void 0 ? void 0 : password.fieldHint) !== null && ref8 !== void 0 ? ref8 : "",
                title: (ref9 = password === null || password === void 0 ? void 0 : password.fieldLabel) !== null && ref9 !== void 0 ? ref9 : "",
                type: "password"
            }
        ],
        forgotPassword: (ref10 = forgotPassword === null || forgotPassword === void 0 ? void 0 : forgotPassword.linkText) !== null && ref10 !== void 0 ? ref10 : "",
        submitButtonProps: {
            children: (ref11 = loginButton === null || loginButton === void 0 ? void 0 : loginButton.buttonText) !== null && ref11 !== void 0 ? ref11 : "",
            pending: pending !== null && pending !== void 0 ? pending : false
        },
        formtitle: mobileLoginFormTitle,
        onSubmit: dataSubmitted,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (default_header_mobile_login_form_module_default())["register-link-container"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                variant: link_variants_enum/* LinkVariants.READ_MORE */.C.READ_MORE,
                className: (default_header_mobile_login_form_module_default()).registerLink,
                href: route_path_enum/* RoutePath.REGISTER */.h3.REGISTER,
                children: registerLinkText !== null && registerLinkText !== void 0 ? registerLinkText : ""
            }, "register-link")
        })
    });
};

// EXTERNAL MODULE: ./src/utils/_helper/enum-to-language-mapper.tsx
var enum_to_language_mapper = __webpack_require__(15487);
// EXTERNAL MODULE: ./src/components/_shared/seperator/seperator.tsx
var seperator = __webpack_require__(59688);
// EXTERNAL MODULE: ./src/components/_shared/spacer/spacer.tsx
var spacer = __webpack_require__(4363);
// EXTERNAL MODULE: ./src/components/_shared/header/header-mobile/header-mobile-navigation/header-mobile-navigation.tsx + 1 modules
var header_mobile_navigation = __webpack_require__(49229);
// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header-mobile-my-account-navigation/default-header-mobile-my-account-navigation.module.scss
var default_header_mobile_my_account_navigation_module = __webpack_require__(49068);
var default_header_mobile_my_account_navigation_module_default = /*#__PURE__*/__webpack_require__.n(default_header_mobile_my_account_navigation_module);
;// CONCATENATED MODULE: ./src/components/_shared/header/default-header/default-header-mobile-my-account-navigation/default-header-mobile-my-account-navigation.tsx
function default_header_mobile_my_account_navigation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_header_mobile_my_account_navigation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_header_mobile_my_account_navigation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function default_header_mobile_my_account_navigation_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = default_header_mobile_my_account_navigation_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function default_header_mobile_my_account_navigation_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
















var DefaultHeaderMobileMyAccountNavigation = function(props) {
    var ref3 = useDefaultHeaderMobileLoginContext(), dispatchContext = ref3.dispatch, myAccountNavOpen = ref3.myAccountNavOpen;
    var data1 = (0,useAccountBasePage/* useAccountBasePage */.W)();
    var adminHeaderData = useAdminHeader();
    var dispatch = (0,es/* useDispatch */.I0)();
    var headerData = (0,useHeader_hook/* useHeader */.g)();
    if (!headerData || !data1) return null;
    var logoutLinkText = headerData.logoutLinkText;
    var ref1 = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref, ref2;
        return {
            loggedIn: state.authentification.loggedIn,
            userRole: (ref = state.userSlice.user) === null || ref === void 0 ? void 0 : (ref2 = ref.role) === null || ref2 === void 0 ? void 0 : ref2.type
        };
    }), loggedIn = ref1.loggedIn, userRole = ref1.userRole;
    (0,react.useEffect)(function() {
        if (loggedIn !== undefined && !loggedIn) {
            dispatchContext({
                type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.RESET */.E.RESET
            });
        }
    }, [
        loggedIn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_mobile_navigation/* HeaderMobileNavigation */.p, {
        cancelButtonOffset: 0,
        className: (default_header_mobile_my_account_navigation_module_default())["default-header-mobile-my-account-navigation"],
        open: myAccountNavOpen,
        localizations: props.localization,
        pageType: props.pageType,
        userRole: userRole,
        adminNavLinks: adminHeaderData.navLinks,
        onCancelClick: function() {
            return dispatchContext({
                type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMYACCOUNTNAVIGATION */.E.TOGGLEMYACCOUNTNAVIGATION
            });
        },
        navLinks: enum_to_language_mapper/* EnumToLanguageMapper.accountRoutesMapping */.H.accountRoutesMapping(data1).map(function(_param) {
            var value = _param.value, data = default_header_mobile_my_account_navigation_objectWithoutProperties(_param, [
                "value"
            ]);
            return default_header_mobile_my_account_navigation_objectSpread({}, data, {
                value: route_path_enum/* RoutePath.MY_ACCOUNT */.h3.MY_ACCOUNT + value
            });
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                height: "20px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seperator/* Seperator */.t, {
                width: "100%",
                height: "1px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (default_header_mobile_my_account_navigation_module_default())["logout-button-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                    className: (default_header_mobile_my_account_navigation_module_default())["logout-button"],
                    href: "",
                    onClick: function() {
                        dispatch((0,redux/* logout */.kS)());
                    },
                    children: logoutLinkText !== null && logoutLinkText !== void 0 ? logoutLinkText : ""
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header-mobile-navigation/default-header-mobile-navigation.module.scss
var default_header_mobile_navigation_module = __webpack_require__(54049);
var default_header_mobile_navigation_module_default = /*#__PURE__*/__webpack_require__.n(default_header_mobile_navigation_module);
;// CONCATENATED MODULE: ./src/components/_shared/header/default-header/default-header-mobile-navigation/default-header-mobile-navigation.tsx







var DefaultHeaderMobileNavigation = function(props) {
    var ref = useDefaultHeaderMobileLoginContext(), mobileNavOpen = ref.mobileNavOpen, dispatch = ref.dispatch;
    var data = (0,useHeader_hook/* useHeader */.g)();
    if (!data) return null;
    var navLinks = data.navLinks;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_mobile_navigation/* HeaderMobileNavigation */.p, {
        cancelButtonOffset: 123,
        className: (default_header_mobile_navigation_module_default())["default-header-mobile-navigation"],
        open: mobileNavOpen,
        localizations: props.localization,
        forStaticPage: props.forStaticPage,
        pageType: props.pageType,
        onCancelClick: function() {
            return dispatch({
                type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMOBILENAVIGATION */.E.TOGGLEMOBILENAVIGATION
            });
        },
        navLinks: (ref1 = navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function(param) {
            var external = param.external, label = param.label, link = param.link;
            return {
                label: label,
                value: link,
                external: external
            };
        })) !== null && ref1 !== void 0 ? ref1 : []
    });
};

;// CONCATENATED MODULE: ./src/components/_shared/header/default-header/default-header.tsx
function default_header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






















var DefaultHeaderComponent = function(param1) {
    var isAdmin = param1.isAdmin, availableLanguages = param1.availableLanguages, forStaticPage = param1.forStaticPage, pageType = param1.pageType, typoService = param1.typoService;
    var defaultHeaderData = (0,useHeader_hook/* useHeader */.g)();
    // Typo Nav Overwrite
    if (!typoService) {
        typoService = new typo_service/* TypoService */.$((0,useTypoContent_hook/* useTypoContent */.f)());
    }
    defaultHeaderData.navLinks = typoService.getHeaderNavLinks();
    var adminHeaderData = useAdminHeader();
    var dispatch = useDefaultHeaderMobileLoginContext().dispatch;
    var value = (0,useBreakpoints_hook/* default */.Z)();
    var ref1 = (0,react.useState)([]), buttonList = ref1[0], setButtonList = ref1[1];
    var username = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref;
        return (ref = state.userSlice.user) === null || ref === void 0 ? void 0 : ref.username;
    });
    var userIcon = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref;
        return (ref = state.userSlice.user) === null || ref === void 0 ? void 0 : ref.profileImageUrl;
    });
    (0,react.useEffect)(function() {
        if (value === "desktop" || value === "desktopSmall") {
            setButtonList([
                {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    icon: {
                        element: userIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: userIcon,
                            className: (default_header_module_default())["header-profile-icon"]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon, {}),
                        className: userIcon ? "small-p" : "",
                        align: "right"
                    },
                    children: username !== null && username !== void 0 ? username : "Login",
                    onClick: function() {
                        if (username) dispatch({
                            type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMYACCOUNTNAVIGATION */.E.TOGGLEMYACCOUNTNAVIGATION
                        });
                        else dispatch({
                            type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLELOGINFORM */.E.TOGGLELOGINFORM
                        });
                    }
                }
            ]);
            dispatch({
                type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.RESET */.E.RESET
            });
        } else {
            setButtonList([
                {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    icon: {
                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {}),
                        align: "right"
                    },
                    onClick: function() {
                        dispatch({
                            type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMOBILENAVIGATION */.E.TOGGLEMOBILENAVIGATION
                        });
                    }
                },
                {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    icon: {
                        element: userIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: userIcon,
                            className: (default_header_module_default())["header-profile-mobile-icon"]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon, {}),
                        className: userIcon ? "icon-container" : "",
                        align: "right"
                    },
                    onClick: function() {
                        if (username) dispatch({
                            type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMYACCOUNTNAVIGATION */.E.TOGGLEMYACCOUNTNAVIGATION
                        });
                        else dispatch({
                            type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLELOGINFORM */.E.TOGGLELOGINFORM
                        });
                    }
                }
            ]);
        }
    }, [
        value,
        username
    ]);
    var renderNavLinks = function() {
        if (isAdmin) {
            var ref;
            var ref2;
            return (ref2 = adminHeaderData === null || adminHeaderData === void 0 ? void 0 : (ref = adminHeaderData.navLinks) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var label = param.label, link = param.link, external = param.external;
                return {
                    label: label,
                    value: link,
                    external: external
                };
            })) !== null && ref2 !== void 0 ? ref2 : [];
        } else {
            var ref3;
            var ref4;
            return (ref4 = defaultHeaderData === null || defaultHeaderData === void 0 ? void 0 : (ref3 = defaultHeaderData.navLinks) === null || ref3 === void 0 ? void 0 : ref3.map(function(param) {
                var label = param.label, link = param.link, external = param.external;
                return {
                    label: label,
                    value: link,
                    external: external
                };
            })) !== null && ref4 !== void 0 ? ref4 : [];
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (default_header_module_default())["default-header-container"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header_background/* HeaderBackground */.w, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                    languages: availableLanguages,
                    element: "div",
                    forStaticPage: forStaticPage,
                    inverted: true,
                    loggedIn: Boolean(username),
                    navLinks: renderNavLinks(),
                    pageType: pageType,
                    buttons: buttonList
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHeaderMobileLoginForm, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHeaderMobileNavigation, {
                    localization: availableLanguages,
                    forStaticPage: forStaticPage,
                    pageType: pageType
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHeaderMobileMyAccountNavigation, {
                    localization: availableLanguages,
                    pageType: pageType
                })
            ]
        })
    });
};
var WithContext = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHeaderMobileLoginFormContextProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHeaderComponent, default_header_objectSpread({}, props))
    });
};
var DefaultHeader = WithContext;
WithContext.dataHooks = [
    useTypoContent_hook/* useTypoContent */.f,
    useHeader_hook/* useHeader */.g,
    useAdminHeader,
    useLoginPage_hook/* useLoginPage */.Y,
    useAccountBasePage/* useAccountBasePage */.W
];
WithContext.defaultProps = {
    isAdmin: false
};


/***/ }),

/***/ 67822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ HeaderBackground; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _header_background_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46615);
/* harmony import */ var _header_background_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_header_background_module_scss__WEBPACK_IMPORTED_MODULE_2__);



/**
 * An HeaderBackground React Component.
 * @author
 * @version 0.1
 */ var HeaderBackground = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_header_background_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["header-background"])
    });
};


/***/ }),

/***/ 49229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ HeaderMobileNavigation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/language-selector/language-selector.tsx
var language_selector = __webpack_require__(51768);
// EXTERNAL MODULE: ./src/components/_shared/seperator/seperator.tsx
var seperator = __webpack_require__(59688);
// EXTERNAL MODULE: ./src/components/_shared/header/header-mobile/header-mobile-popup.tsx
var header_mobile_popup = __webpack_require__(92750);
// EXTERNAL MODULE: ./src/components/_shared/header/header-mobile/header-mobile-navigation/header-mobile-navigation.module.scss
var header_mobile_navigation_module = __webpack_require__(82215);
var header_mobile_navigation_module_default = /*#__PURE__*/__webpack_require__.n(header_mobile_navigation_module);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/header/header-mobile/header-mobile-navigation/header-mobile-navigation-item/header-mobile-navigation-item.module.scss
var header_mobile_navigation_item_module = __webpack_require__(83846);
var header_mobile_navigation_item_module_default = /*#__PURE__*/__webpack_require__.n(header_mobile_navigation_item_module);
;// CONCATENATED MODULE: ./src/components/_shared/header/header-mobile/header-mobile-navigation/header-mobile-navigation-item/header-mobile-navigation-item.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var HeaderMobileNavigationItem = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, _objectSpread({
        className: (header_mobile_navigation_item_module_default())["header-mobile-navigation-item"]
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
            variant: typeography_variants_enum/* TypographyVariantsEnum.MOBILENAVLINK */.H.MOBILENAVLINK,
            children: children
        })
    }));
};


;// CONCATENATED MODULE: ./src/components/_shared/header/header-mobile/header-mobile-navigation/header-mobile-navigation.tsx
function header_mobile_navigation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_mobile_navigation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_mobile_navigation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var HeaderMobileNavigation = function(param1) {
    var open = param1.open, navLinks = param1.navLinks, adminNavLinks = param1.adminNavLinks, userRole = param1.userRole, onCancelClick = param1.onCancelClick, submitButtonProps = param1.submitButtonProps, className = param1.className, cancelButtonOffset = param1.cancelButtonOffset, children = param1.children, localizations = param1.localizations, forStaticPage = param1.forStaticPage, pageType = param1.pageType;
    if (open) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_mobile_popup/* HeaderMobilePopup */.S, {
            cancelButtonOffset: cancelButtonOffset,
            className: className,
            backgroundColor: "white",
            onClick: function() {
                return onCancelClick(!open);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (header_mobile_navigation_module_default())["header-mobile-navigation"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function(param) {
                                var label = param.label, value = param.value, external = param.external;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileNavigationItem, {
                                        external: external,
                                        href: value,
                                        children: label
                                    })
                                }, value);
                            }),
                            localizations && localizations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (header_mobile_navigation_module_default())["language-selector"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(language_selector/* default */.Z, {
                                    isInverted: true,
                                    isStaticPage: forStaticPage,
                                    pageType: pageType,
                                    languageOptions: localizations
                                })
                            }, "localization")
                        ]
                    }),
                    userRole && adminNavLinks && adminNavLinks.filter(function(param) {
                        var role = param.role;
                        return userRole === role;
                    }).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(seperator/* Seperator */.t, {
                                height: "1px",
                                margin: "25px 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: adminNavLinks.filter(function(param) {
                                    var role = param.role;
                                    return userRole === role;
                                }).map(function(param) {
                                    var label = param.label, link = param.link, external = param.external;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileNavigationItem, {
                                            external: external,
                                            href: link,
                                            children: label
                                        })
                                    }, link);
                                })
                            })
                        ]
                    }) : undefined,
                    submitButtonProps ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(seperator/* Seperator */.t, {
                                height: "1px",
                                margin: "25px 0"
                            }, "seperator"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, header_mobile_navigation_objectSpread({}, submitButtonProps), "submit-button")
                        ]
                    }) : undefined,
                    children
                ]
            })
        });
    } else return null;
};
HeaderMobileNavigation.defaultProps = {
    open: false
};


/***/ }),

/***/ 92750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ HeaderMobilePopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _assets_icons_close_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19910);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92212);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93217);
/* harmony import */ var _header_mobile_nav_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57142);
/* harmony import */ var _header_mobile_nav_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_header_mobile_nav_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var HeaderMobilePopup = function(param) {
    var children = param.children, onClick = param.onClick, backgroundColor = param.backgroundColor, className = param.className, cancelButtonOffset = param.cancelButtonOffset;
    var ref2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createRef();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), containerHeight = ref1[0], setContainerHeight = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var height = (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        if (height && height < 400) {
            setContainerHeight(400);
        } else if (height) {
            setContainerHeight(height);
        }
    }, [
        children
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_header_mobile_nav_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["header-mobile-container"]), " ").concat(className !== null && className !== void 0 ? className : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: ref2,
                className: (_header_mobile_nav_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["header-mobile-nav"]),
                style: {
                    clipPath: "polygon(0 0, 100% 0, 100% calc(calc(100% - calc(calc(".concat(containerHeight, "px / 100) * 10)) + 0.5px), calc(calc(100% - calc(calc(").concat(containerHeight - containerHeight / 100 * 45, "px / 100) * 10)) + 0.5px) 100%, 0 100%)"),
                    backgroundColor: backgroundColor
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_header_mobile_nav_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["header-mobile-nav-container"]),
                        style: {
                            clipPath: "polygon(0 50%,1px 50%,1px 1px,calc(100% - 1px) 1px,calc(100% - 1px) calc(100% - calc(calc(".concat(containerHeight, "px / 100) * 10)),calc(100% - calc(calc(").concat(containerHeight - containerHeight / 100 * 45, "px / 100) * 10)) calc(100% - 1px),1px calc(100% - 1px),50% calc(100% - 1px),1px calc(100% - 1px),1px 50%,0 50%,0 100%,100% 100%,100% 50%,100% 0,0 0)")
                        }
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                style: cancelButtonOffset ? {
                    right: cancelButtonOffset - 44
                } : undefined,
                onClick: onClick,
                className: (_header_mobile_nav_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cancelButton),
                variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                icon: {
                    element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons_close_svg__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x, {}),
                    align: "right"
                }
            })
        ]
    });
};
HeaderMobilePopup.defaultProps = {
    cancelButtonOffset: 0
};


/***/ }),

/***/ 83086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 174 modules
var motion = __webpack_require__(42660);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
;// CONCATENATED MODULE: ./src/assets/icons/logo.svg.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var LogoSvgComponent = function(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", _objectSpread({
        viewBox: "0 0 229 201",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M131.163 90.0304C134.803 90.0304 137.754 87.0797 137.754 83.4399C137.754 79.7998 134.803 76.849 131.163 76.849C127.523 76.849 124.572 79.7998 124.572 83.4399C124.572 87.0797 127.523 90.0304 131.163 90.0304Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M197.196 131.912L189.061 136.724L179.529 126.515L153.563 141.462L152.793 140.842L173.912 127.173L173.922 127.166L173.912 127.155V42.5442L173.918 41.3173L162.5 45.3395V0H0.00417131V102.589H0L0.00417131 102.935V103.079L0.012514 103.821L11.4107 99.8047V158.844H173.906V158.838L224.318 158.844L197.196 131.912ZM10.7657 10.7606H151.738V49.1309L10.7657 98.7973V10.7606ZM146.332 120.59L145.941 120.987L131.893 112.393L104.394 129.229L103.433 128.64L117.702 118.334L94.0996 83.4306L66.4291 124.301L73.0718 132.017L72.3858 133.132L59.634 121.232L37.3327 148.081H22.1738V96.0118L163.146 46.338V114.565L151.777 101.26L139.255 114.152L146.332 120.59Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.812 196.363C26.7773 196.363 28.7716 195.863 30.2818 194.992H30.2837C31.5161 194.348 32.6502 193.396 33.5606 192.494C33.551 192.508 36.2473 195.119 36.2473 195.119L35.9502 195.446C33.0398 198.638 29.3907 200.258 25.1032 200.258H24.5824C20.5784 200.258 17.0932 198.763 14.2233 195.819C11.3611 192.885 9.91074 189.394 9.91074 185.427C9.91074 181.46 11.3862 177.987 14.2947 175.108C17.2012 172.229 20.8021 170.769 25.0434 170.769C29.2847 170.769 32.9511 172.385 35.9349 175.567L36.2165 175.883C36.2165 175.883 33.4025 178.621 33.4121 178.64C32.604 177.929 30.9839 176.589 29.9578 176.008C28.3608 175.104 26.6771 174.664 24.812 174.664C21.9421 174.664 19.4038 175.744 17.2669 177.875C15.1298 180.006 14.0459 182.575 14.0459 185.514C14.0459 188.452 15.1298 191.021 17.2669 193.152C19.4038 195.283 21.9421 196.363 24.812 196.363Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M66.9235 171.373H83.1825V174.992H71.0818V183.552H82.4264V187.135H71.0818V195.996H83.3734V199.654H66.9235V171.373Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M96.7722 171.373H102.142L111.596 199.654H107.133L104.902 192.527H93.8965L91.6264 199.654H87.3158L96.7722 171.373ZM95.0711 188.869H103.731L99.4956 175.446H99.3452L95.0711 188.869Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M111.174 174.992H118.736V199.652H122.897V174.992H130.461V171.373H111.174V174.992Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M191.159 171.373H195.32V199.654H191.159V171.373Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M209.532 171.24H214.902L224.357 199.52H219.893L217.662 192.393H206.657L204.387 199.52H200.076L209.532 171.24ZM207.831 188.736H216.491L212.256 175.313H212.105L207.831 188.736Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.47 181.033L157.606 177.941H157.608C158.802 180.117 159.469 182.689 159.469 185.514C159.469 194.037 153.53 200.258 145.059 200.258C136.589 200.258 130.613 194.037 130.613 185.514C130.613 176.991 136.702 170.769 145.059 170.769C148.392 170.769 151.357 171.762 153.716 173.492L150.913 176.265C149.303 175.117 147.31 174.466 145.057 174.466C139.044 174.466 134.884 179.027 134.884 185.475C134.884 191.923 139.044 196.485 145.057 196.485C151.071 196.485 155.231 191.923 155.231 185.475C155.231 183.867 154.963 182.373 154.47 181.033Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54.1843 188.039C58.306 187.096 61.0293 183.89 61.0293 179.819C61.0293 175.031 57.1333 171.335 51.6886 171.335H41.2137V199.615H45.374V174.954H51.2739C54.7148 174.954 56.7958 177.14 56.7958 179.856C56.7958 182.571 54.7167 184.796 51.2739 184.796H47.6305L49.6866 188.304L56.5316 199.615H61.3341L54.1863 188.039H54.1843Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M184.56 199.519H179.658L171.4 187.227H168.459V199.519H164.312V171.24H168.459V183.645H171.438L179.658 171.24H184.447L174.832 185.417L184.56 199.519Z",
                fill: "white"
            })
        ]
    }));
};


// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/utils/_enums/response-codes.enum.ts
var response_codes_enum = __webpack_require__(23430);
// EXTERNAL MODULE: ./src/utils/_enums/route-path.enum.tsx
var route_path_enum = __webpack_require__(16837);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/language-selector/language-selector.tsx
var language_selector = __webpack_require__(51768);
// EXTERNAL MODULE: ./src/components/_shared/header/header.module.scss
var header_module = __webpack_require__(48296);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./src/components/_shared/header/header-background/header-background.tsx
var header_background = __webpack_require__(67822);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/header/header-nav-item/header-nav-item.module.scss
var header_nav_item_module = __webpack_require__(8306);
var header_nav_item_module_default = /*#__PURE__*/__webpack_require__.n(header_nav_item_module);
;// CONCATENATED MODULE: ./src/components/_shared/header/header-nav-item/header-nav-item.tsx







var HeaderNavItem = function(param) {
    var href = param.href, children = param.children, target = param.target, inverted = param.inverted, external = param.external, onClick = param.onClick;
    var countArray = children.length;
    var asPath = (0,next_router.useRouter)().asPath;
    var isActive = function() {
        var hrefWithoutDomain = href.replace(/^.*\/\/[^\/]+/, "");
        var hrefWithoutLang = hrefWithoutDomain.replace(/^\/[a-z]{2}\//, "/");
        if (asPath == href) {
            return true;
        } else if (asPath == hrefWithoutDomain) {
            return true;
        } else if (asPath == hrefWithoutLang) {
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
        style: {
            width: "".concat(countArray * 11, "px")
        },
        external: external,
        href: href,
        target: target,
        className: "".concat((header_nav_item_module_default())["header-nav-item"], " ").concat(inverted ? (header_nav_item_module_default()).inverted : "", " ").concat(isActive() ? (header_nav_item_module_default()).active : ""),
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
            variant: typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
            element: "span",
            children: children
        })
    });
};
HeaderNavItem.defaultProps = {
    inverted: false
};

;// CONCATENATED MODULE: ./src/components/_shared/header/header.tsx
function header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















var Header = function(param1) {
    var navLinks = param1.navLinks, buttons = param1.buttons, inverted = param1.inverted, element = param1.element, className = param1.className, showBackground = param1.showBackground, loggedIn = param1.loggedIn, onLogoClick = param1.onLogoClick, forStaticPage = param1.forStaticPage, languages = param1.languages, pageType = param1.pageType;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)(true), showMenu = ref3[0], setShowMenu = ref3[1];
    var ref1 = (0,react.useState)(0), scrollPosition = ref1[0], setScrollPosition = ref1[1];
    var ref2 = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.checkoutSlice;
    }), fetchCurrentProductModelStatus = ref2.fetchCurrentProductModelStatus, basket = ref2.basket, pending = ref2.pending;
    var hasElementsInBasket = (0,hooks/* useAppSelector */.C)(function(state) {
        var ref;
        return {
            hasElementsInBasket: (ref = state.userSlice.user) === null || ref === void 0 ? void 0 : ref.hasElementsInBasket
        };
    }).hasElementsInBasket;
    // Add event listener to update scroll position
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var currentPosition = window.scrollY;
            setShowMenu(currentPosition <= scrollPosition || currentPosition === 0);
            setScrollPosition(currentPosition);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        scrollPosition
    ]);
    (0,react.useEffect)(function() {
        if (basket && fetchCurrentProductModelStatus === 200) {
            router.push(route_path_enum/* RoutePath.CHECKOUT */.h3.CHECKOUT);
        }
    }, [
        basket,
        fetchCurrentProductModelStatus
    ]);
    (0,react.useEffect)(function() {
        if (fetchCurrentProductModelStatus && fetchCurrentProductModelStatus !== 200 && router.pathname !== route_path_enum/* RoutePath.CHECKOUT */.h3.CHECKOUT) {
            dispatch((0,redux/* resetFetchCurrentProductState */.yb)());
        }
    }, [
        fetchCurrentProductModelStatus
    ]);
    var childElements = /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        id: "main-navbar",
        className: "\n                ".concat((header_module_default()).sticky, " \n                ").concat(scrollPosition === 0 ? (header_module_default()).transparent : "", "\n                ").concat(showMenu ? (header_module_default()).normal : (header_module_default()).scrolled, "\n            "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((header_module_default())["header-container"], " ").concat(inverted ? (header_module_default()).inverted : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (header_module_default()).logo,
                    onClick: function() {
                        onLogoClick ? onLogoClick() : undefined;
                        router.push(route_path_enum/* RoutePath.DEFAULT_PAGE */.h3.DEFAULT_PAGE);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoSvgComponent, {
                        height: "100%"
                    })
                }),
                navLinks && navLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: (header_module_default())["nav-container"],
                    children: [
                        navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function(param, index) {
                            var value = param.value, label = param.label, external = param.external;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavItem, {
                                external: external,
                                href: value,
                                inverted: inverted,
                                children: label
                            }, value + index);
                        }),
                        languages && languages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(language_selector/* default */.Z, {
                            isStaticPage: forStaticPage,
                            pageType: pageType,
                            languageOptions: languages
                        })
                    ]
                }),
                buttons && buttons.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (header_module_default()).buttons,
                    children: [
                        loggedIn && hasElementsInBasket ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default())["checkout-button-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                onClick: function() {
                                    dispatch((0,redux/* fetchCurrentProduct */.FF)());
                                },
                                inverted: inverted,
                                variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                                icon: {
                                    element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: [
                                            "fas",
                                            "shopping-cart"
                                        ]
                                    }),
                                    align: "left"
                                },
                                pending: pending || fetchCurrentProductModelStatus === response_codes_enum/* ResponseCodes.OK */.Y.OK
                            })
                        }) : null,
                        buttons === null || buttons === void 0 ? void 0 : buttons.map(function(props) {
                            return /*#__PURE__*/ (0,react.createElement)(button_button/* Button */.z, header_objectSpread({}, props, {
                                inverted: inverted,
                                key: props.children
                            }));
                        })
                    ]
                })
            ]
        })
    });
    var wrapWithBackground = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (header_module_default())["header-background-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_background/* HeaderBackground */.w, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: childElements
            })
        ]
    });
    return /*#__PURE__*/ react.createElement(element, {
        className: "".concat((header_module_default())[showBackground ? "header-container lite" : "header-container"], " ").concat(inverted ? (header_module_default()).inverted : "", " ").concat(className !== null && className !== void 0 ? className : ""),
        "data-testid": "header-container"
    }, showBackground ? wrapWithBackground : childElements);
};
Header.defaultProps = {
    navLinks: [],
    buttons: [],
    inverted: false,
    element: "header",
    showBackground: false,
    loggedIn: false
};


/***/ }),

/***/ 17850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _error_error_message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63879);
/* harmony import */ var _tool_tip_tool_tip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62486);
/* harmony import */ var _input_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60173);
/* harmony import */ var _input_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_input_module_scss__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var Input = function(_param) {
    var register = _param.register, validation = _param.validation, errorMessage = _param.errorMessage, className = _param.className, props = _objectWithoutProperties(_param, [
        "register",
        "validation",
        "errorMessage",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "input",
        className: "".concat((_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["input-field-wrapper"]), "\n        ").concat(props.disabled ? (_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default().disabled) : "", "\n        ").concat(props.inverted ? (_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inverted) : "", "\n        ").concat(className ? className : ""),
        children: [
            props.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: errorMessage ? (_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default().error) : "",
                htmlFor: props.title,
                children: [
                    props.title + (props.required ? "*" : ""),
                    props.fieldToolTip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tool_tip_tool_tip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        toolTip: props.fieldToolTip
                    }) : null
                ]
            }) : undefined,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["input-field"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                        className: "".concat(props.valid ? (_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default().valid) : "", " ").concat(errorMessage ? (_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default().error) : "")
                    }, props, register(props.name, _objectSpread({}, validation, {
                        valueAsNumber: props.type === "number"
                    })), {
                        placeholder: props.placeholder
                    })),
                    props.valid ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_input_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["valid-icon"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                            icon: [
                                "far",
                                "check"
                            ]
                        })
                    }) : undefined,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error_error_message__WEBPACK_IMPORTED_MODULE_3__/* .ErrorMessage */ .B, {
                        children: errorMessage
                    })
                ]
            })
        ]
    });
};



/***/ }),

/***/ 47085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _error_error_message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63879);
/* harmony import */ var _tool_tip_tool_tip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62486);
/* harmony import */ var _text_area_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52039);
/* harmony import */ var _text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var TextArea = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.defaultCount), count = ref[0], setCount = ref[1];
    var textAreaLengthCheck = function(event) {
        setCount(event.target.value.length);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "text-area",
        className: "".concat((_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["text-area-field-wrapper"]), "\n        ").concat(props.className ? props.className : "", "\n        ").concat(props.inverted ? (_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default().inverted) : "", "\n        ").concat(props.disabled ? (_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default().disabled) : ""),
        children: [
            props.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: props.title,
                className: props.errorMessage ? (_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error) : "",
                children: [
                    props.title + (props.required ? "*" : ""),
                    props.fieldToolTip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tool_tip_tool_tip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        toolTip: props.fieldToolTip
                    }) : null
                ]
            }) : undefined,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["text-area"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", _objectSpread({
                        className: props.errorMessage ? (_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error) : "",
                        rows: props.rows
                    }, props.register(props.name, props.validation), {
                        placeholder: props.placeholder,
                        onChange: function(event) {
                            return textAreaLengthCheck(event);
                        }
                    })),
                    props.max ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["char-counter"]),
                        children: [
                            count,
                            "/",
                            props.max
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_text_area_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["char-counter"])
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error_error_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .B, {
                        children: props.errorMessage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextArea);


/***/ }),

/***/ 51768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80880);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64884);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88734);
/* harmony import */ var _api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91785);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63367);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88092);
/* harmony import */ var _utils_hooks_useMounted_hook__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35339);
/* harmony import */ var _language_selector_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81814);
/* harmony import */ var _language_selector_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_language_selector_module_scss__WEBPACK_IMPORTED_MODULE_8__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var LanguageSelector = function(props1) {
    var currLang = (0,_api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_4__/* .useCurrentLanguage */ .U)();
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isMounted = (0,_utils_hooks_useMounted_hook__WEBPACK_IMPORTED_MODULE_6__/* .useMounted */ .s)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isMenuOpen = ref2[0], setIsMenuOpen = ref2[1];
    var changeLanguage = function(lang) {
        var ref;
        var locale = (ref = lang === null || lang === void 0 ? void 0 : lang.value) !== null && ref !== void 0 ? ref : "";
        if (props1.isStaticPage) {
            var ref1;
            // Typo3 Routing
            if (router.query.typoPage !== undefined || router.pathname === "/page") {
                var pathname = router.pathname, asPath = router.asPath, query = router.query;
                router.push({
                    pathname: pathname,
                    query: query
                }, asPath, {
                    locale: lang.label.toLowerCase()
                });
                return;
            }
            var pageTypePrefix = props1.pageType === _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_5__/* .ArticlePageTypes.CONFIRMATION_PAGE */ .W.CONFIRMATION_PAGE ? "/c/" : "/s/";
            var queryString = props1.pageType === _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_5__/* .ArticlePageTypes.CONFIRMATION_PAGE */ .W.CONFIRMATION_PAGE ? router.query.confirmationPage : router.query.articlePage;
            router.push({
                pathname: pageTypePrefix + queryString + "/" + locale
            }, {
                pathname: pageTypePrefix + queryString + "/" + locale
            }, {
                locale: props1.languageOptions ? (ref1 = props1.languageOptions.find(function(it) {
                    return it.id.toString() === locale;
                })) === null || ref1 === void 0 ? void 0 : ref1.locale : "en"
            });
        } else if (locale !== "en") {
            router.push(router.asPath, router.asPath, {
                locale: locale
            });
        } else {
            router.push(router.asPath, router.asPath, {
                locale: "en"
            });
        }
    };
    var DropdownIndicator = function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_7__.c.DropdownIndicator, _objectSpread({}, props, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_language_selector_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["dropdown-indicator"]), " ").concat(isMenuOpen ? (_language_selector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().open) : (_language_selector_module_scss__WEBPACK_IMPORTED_MODULE_8___default().closed)),
                children: isMenuOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: [
                        "far",
                        "chevron-up"
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: [
                        "far",
                        "chevron-down"
                    ]
                })
            })
        }));
    };
    var customStyles = {
        singleValue: function(base) {
            return _objectSpread({}, base, {
                color: props1.isInverted ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_dark) : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_light)
            });
        },
        control: function(base) {
            return _objectSpread({}, base, {
                width: "64px",
                borderRadius: 0,
                cursor: "pointer",
                borderColor: props1.isInverted ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_dark) : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_light),
                border: "none",
                boxShadow: "none",
                backgroundColor: "transparent",
                "&:hover *": {
                    color: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().primary_middleDark)
                }
            });
        },
        menu: function(base) {
            return _objectSpread({}, base, {
                marginBottom: "unset",
                marginTop: "unset",
                zIndex: 50,
                boxShadow: "unset",
                backgroundColor: "transparent"
            });
        },
        menuList: function(base) {
            return _objectSpread({}, base, {
                paddingTop: "unset",
                paddingBottom: "unset",
                backgroundColor: "transparent"
            });
        },
        dropdownIndicator: function(base) {
            return _objectSpread({}, base, {
                color: props1.isInverted ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_dark) : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_light)
            });
        },
        indicatorSeparator: function(base) {
            return _objectSpread({}, base, {
                visibility: "hidden"
            });
        },
        option: function(base) {
            return _objectSpread({}, base, {
                backgroundColor: "transparent",
                cursor: "pointer",
                marginTop: "-12px",
                marginLeft: "-2px",
                color: props1.isInverted ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_dark) : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().greys_light),
                "&:hover": {
                    color: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_9___default().primary_middleDark)
                },
                "&:active": {
                    backgroundColor: "transparent"
                }
            });
        }
    };
    if (isMounted.hasMounted) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_language_selector_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["language-switch-wrapper"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                onChange: function(lang) {
                    return changeLanguage(lang !== null && lang !== void 0 ? lang : "");
                },
                options: props1.languageOptions.map(function(lang) {
                    return {
                        value: props1.isStaticPage ? lang.id.toString() : lang.locale,
                        label: lang.locale.toUpperCase()
                    };
                }),
                components: {
                    DropdownIndicator: DropdownIndicator
                },
                onMenuOpen: function() {
                    return setIsMenuOpen(true);
                },
                onMenuClose: function() {
                    return setIsMenuOpen(false);
                },
                styles: customStyles,
                isSearchable: false,
                defaultValue: {
                    value: currLang,
                    label: currLang.toUpperCase()
                }
            })
        });
    } else {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (LanguageSelector);


/***/ }),

/***/ 27397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LinkBase; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _link_base_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32735);
/* harmony import */ var _link_base_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_link_base_module_scss__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var LinkBase = function(_param) {
    var href = _param.href, locale = _param.locale, target = _param.target, children = _param.children, onClick = _param.onClick, external = _param.external, className = _param.className, scroll = _param.scroll, anchorProps = _objectWithoutProperties(_param, [
        "href",
        "locale",
        "target",
        "children",
        "onClick",
        "external",
        "className",
        "scroll"
    ]);
    if (onClick && !href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", _objectSpread({
            "data-testid": "link-base"
        }, anchorProps, {
            className: "".concat((_link_base_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["link-base"]), " ").concat(className),
            onClick: onClick,
            children: children
        }));
    }
    if (external || target) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({
        "data-testid": "link-base"
    }, anchorProps, {
        className: "".concat((_link_base_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["link-base"]), " ").concat(className),
        href: href,
        onClick: onClick,
        target: target ? target : external ? "_blank" : undefined,
        rel: target === "_blank" ? "noreferrer" : undefined,
        children: children
    }));
    else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        scroll: scroll,
        locale: locale,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({
            "data-testid": "link-base"
        }, anchorProps, {
            onClick: onClick,
            className: "".concat((_link_base_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["link-base"]), " ").concat(className),
            children: children
        }))
    });
};

LinkBase.defaultProps = {
    external: false,
    scroll: true
};


/***/ }),

/***/ 46164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11702);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77872);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28773);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99604);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_link_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _link_base_link_base__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27397);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var Link = function(_param) {
    var href = _param.href, target = _param.target, children = _param.children, icon = _param.icon, external = _param.external, disabled = _param.disabled, className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .LinkVariants.READ_MORE */ .C.READ_MORE : _variant, inverted = _param.inverted, anchorProps = _objectWithoutProperties(_param, [
        "href",
        "target",
        "children",
        "icon",
        "external",
        "disabled",
        "className",
        "variant",
        "inverted"
    ]);
    var _variant1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_link_base_link_base__WEBPACK_IMPORTED_MODULE_6__/* .LinkBase */ .w, _objectSpread({
        className: "".concat((_link_module_scss__WEBPACK_IMPORTED_MODULE_7___default().link), " ").concat(disabled ? (_link_module_scss__WEBPACK_IMPORTED_MODULE_7___default().disabled) : "", " ").concat(className !== null && className !== void 0 ? className : "", " ").concat((_variant1 = (_link_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[variant]) !== null && _variant1 !== void 0 ? _variant1 : ""),
        href: href,
        external: external,
        target: target
    }, anchorProps, {
        children: [
            icon,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .Z, {
                inverted: inverted,
                variant: variant === _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .LinkVariants.READ_MORE */ .C.READ_MORE ? _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.BUTTON */ .H.BUTTON : variant === _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .LinkVariants.SMALL_LINK */ .C.SMALL_LINK ? _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.LINK_SMALL */ .H.LINK_SMALL : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_4__/* .TypographyVariantsEnum.LINK */ .H.LINK,
                className: className !== null && className !== void 0 ? className : "",
                children: children
            }),
            variant !== _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .LinkVariants.STANDARD_LINK */ .C.STANDARD_LINK && variant !== _utils_enums_link_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .LinkVariants.BUTTON_SECONDARY_OUTLINED */ .C.BUTTON_SECONDARY_OUTLINED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: [
                    "fas",
                    "chevron-right"
                ],
                className: "".concat((_link_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["link-icon"]), "\n                    ").concat(inverted ? (_link_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inverted) : "")
            }) : null
        ]
    }));
};

Link.defaultProps = {
    external: false
};


/***/ }),

/***/ 16308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80880);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var _api_hooks_useGlobal_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77459);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37287);
/* harmony import */ var _redux_slices_wallet_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41731);
/* harmony import */ var _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23430);
/* harmony import */ var _utils_enums_route_path_enum__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16837);
/* harmony import */ var _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9943);
/* harmony import */ var _utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(962);
/* harmony import */ var _utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62251);
/* harmony import */ var _login_login_form_login_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30030);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93217);
/* harmony import */ var _dialog_dialog__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(72807);
/* harmony import */ var _text_section_text_section__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29209);
/* harmony import */ var _wallet_connect_button_wallet_connect_button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30613);

















var LoginDialog = function(props) {
    var ref3;
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!!props.onClose), showDialog = ref1[0], setShowDialog = ref1[1];
    var data = (0,_api_hooks_useGlobal_hook__WEBPACK_IMPORTED_MODULE_4__/* .useGlobal */ .O)();
    var ref2 = (0,_utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_11__/* .useAppSelector */ .C)(function(state) {
        return {
            instanceInBasket: state.checkoutSlice.basket,
            loggedIn: state.authentification.loggedIn,
            addToBasketStatus: state.checkoutSlice.addToBasketStatus,
            addWalletStatus: state.walletSlice.addWalletModel.status
        };
    }), instanceInBasket = ref2.instanceInBasket, loggedIn = ref2.loggedIn, addToBasketStatus = ref2.addToBasketStatus, addWalletStatus = ref2.addWalletStatus;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (props.withBuyOption && props.withBuyOption.idToBuy) {
            if (loggedIn) {
                dispatch((0,_redux__WEBPACK_IMPORTED_MODULE_5__/* .addToBasket */ .H)({
                    id: props.withBuyOption.idToBuy,
                    idType: props.withBuyOption.salesType === _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_9__/* .SalesType.T_DROP */ .r.T_DROP ? "VARIANT" : "INSTANCE"
                }));
            } else {
                setShowDialog(true);
            }
        }
    }, [
        (ref3 = props.withBuyOption) === null || ref3 === void 0 ? void 0 : ref3.idToBuy,
        loggedIn
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (props.withBuyOption && props.withBuyOption.idToBuy && loggedIn && addWalletStatus === _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.OK */ .Y.OK) {
            dispatch((0,_redux__WEBPACK_IMPORTED_MODULE_5__/* .addToBasket */ .H)({
                id: props.withBuyOption.idToBuy,
                idType: props.withBuyOption.salesType === _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_9__/* .SalesType.T_DROP */ .r.T_DROP ? "VARIANT" : "INSTANCE"
            }));
        }
    }, [
        addWalletStatus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if (instanceInBasket && ((ref = props.withBuyOption) === null || ref === void 0 ? void 0 : ref.idToBuy)) {
            setShowDialog(false);
            router.push(_utils_enums_route_path_enum__WEBPACK_IMPORTED_MODULE_8__/* .RoutePath.CHECKOUT */ .h3.CHECKOUT);
        }
    }, [
        instanceInBasket
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return function() {
            dispatch((0,_redux__WEBPACK_IMPORTED_MODULE_5__/* .resetAddToBasketState */ .cV)());
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (addToBasketStatus === _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.CHECKOUT_NOT_ON_ALLOWLIST_MAIL */ .Y.CHECKOUT_NOT_ON_ALLOWLIST_MAIL || addToBasketStatus === _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.CHECKOUT_NOT_ON_ALLOWLIST_MAIL_AND_WALLET */ .Y.CHECKOUT_NOT_ON_ALLOWLIST_MAIL_AND_WALLET) {
            setShowDialog(true);
        }
        if (addToBasketStatus && addToBasketStatus !== _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.OK */ .Y.OK && addToBasketStatus !== _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.CHECKOUT_NOT_ON_ALLOWLIST_MAIL */ .Y.CHECKOUT_NOT_ON_ALLOWLIST_MAIL) {
            var ref;
            (ref = props.withBuyOption) === null || ref === void 0 ? void 0 : ref.setIdToBuy(undefined);
        }
    }, [
        addToBasketStatus
    ]);
    var onDialogClosed = function() {
        var ref;
        (ref = props.withBuyOption) === null || ref === void 0 ? void 0 : ref.setIdToBuy(undefined);
        dispatch((0,_redux_slices_wallet_slice__WEBPACK_IMPORTED_MODULE_6__/* .resetWalletModel */ .U3)());
        if (props.onClose) {
            props.onClose();
        } else {
            setShowDialog(false);
        }
    };
    var renderDialogComponent = function() {
        if (!loggedIn) {
            var ref, ref4, ref5, ref6, ref7, ref8;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_section_text_section__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        title: (data === null || data === void 0 ? void 0 : (ref = data.dialogs) === null || ref === void 0 ? void 0 : (ref4 = ref.loginDialogHeadline) === null || ref4 === void 0 ? void 0 : ref4.headlineContent) || "Login",
                        titleVariant: (0,_utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_10__/* .mapStrapiHeadline */ .z)(data === null || data === void 0 ? void 0 : (ref5 = data.dialogs) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.loginDialogHeadline) === null || ref6 === void 0 ? void 0 : ref6.style),
                        description: data === null || data === void 0 ? void 0 : (ref7 = data.dialogs) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.loginDialogDescription) === null || ref8 === void 0 ? void 0 : ref8.content
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_login_login_form_login_form__WEBPACK_IMPORTED_MODULE_12__/* .LoginForm */ .U, {
                        withRegisterLink: true
                    })
                ]
            });
        } else if (addToBasketStatus === _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.CHECKOUT_NOT_ON_ALLOWLIST_MAIL */ .Y.CHECKOUT_NOT_ON_ALLOWLIST_MAIL) {
            var ref9, ref10, ref11, ref12, ref13, ref14;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_section_text_section__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        title: (data === null || data === void 0 ? void 0 : (ref9 = data.dialogs) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.connectWalletHeadline) === null || ref10 === void 0 ? void 0 : ref10.headlineContent) || "Login",
                        titleVariant: (0,_utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_10__/* .mapStrapiHeadline */ .z)(data === null || data === void 0 ? void 0 : (ref11 = data.dialogs) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.connectWalletHeadline) === null || ref12 === void 0 ? void 0 : ref12.style),
                        description: data === null || data === void 0 ? void 0 : (ref13 = data.dialogs) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.connectWalletDescription) === null || ref14 === void 0 ? void 0 : ref14.content
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wallet_connect_button_wallet_connect_button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
                ]
            });
        } else if (addToBasketStatus === _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.CHECKOUT_NOT_ON_ALLOWLIST_MAIL_AND_WALLET */ .Y.CHECKOUT_NOT_ON_ALLOWLIST_MAIL_AND_WALLET) {
            var ref15, ref16, ref17, ref18, ref19, ref20;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_section_text_section__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        title: (data === null || data === void 0 ? void 0 : (ref15 = data.dialogs) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.allowListNotAllowedHeadline) === null || ref16 === void 0 ? void 0 : ref16.headlineContent) || "Login",
                        titleVariant: (0,_utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_10__/* .mapStrapiHeadline */ .z)(data === null || data === void 0 ? void 0 : (ref17 = data.dialogs) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.allowListNotAllowedHeadline) === null || ref18 === void 0 ? void 0 : ref18.style),
                        description: data === null || data === void 0 ? void 0 : (ref19 = data.dialogs) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.allowListNotAllowed) === null || ref20 === void 0 ? void 0 : ref20.content
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                        onClick: function() {
                            setShowDialog(false);
                        },
                        variant: data === null || data === void 0 ? void 0 : data.buttons.confirmation.buttonStyle,
                        children: data === null || data === void 0 ? void 0 : data.buttons.confirmation.buttonText
                    })
                ]
            });
        } else if (addToBasketStatus === _utils_enums_response_codes_enum__WEBPACK_IMPORTED_MODULE_7__/* .ResponseCodes.CHECKOUT_MAX_INSTANCES_BOUGHT */ .Y.CHECKOUT_MAX_INSTANCES_BOUGHT) {
            var ref21, ref22, ref23, ref24, ref25, ref26;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_section_text_section__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        title: (data === null || data === void 0 ? void 0 : (ref21 = data.dialogs) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.maxInstancesBoughtHeadline) === null || ref22 === void 0 ? void 0 : ref22.headlineContent) || "Login",
                        titleVariant: (0,_utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_10__/* .mapStrapiHeadline */ .z)(data === null || data === void 0 ? void 0 : (ref23 = data.dialogs) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.maxInstancesBoughtHeadline) === null || ref24 === void 0 ? void 0 : ref24.style),
                        description: data === null || data === void 0 ? void 0 : (ref25 = data.dialogs) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.maxInstancesBought) === null || ref26 === void 0 ? void 0 : ref26.content
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                        onClick: function() {
                            setShowDialog(false);
                        },
                        variant: data === null || data === void 0 ? void 0 : data.buttons.confirmation.buttonStyle,
                        children: data === null || data === void 0 ? void 0 : data.buttons.confirmation.buttonText
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: showDialog ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dialog_dialog__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            onClose: onDialogClosed,
            children: renderDialogComponent()
        }) : undefined
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginDialog);


/***/ }),

/***/ 38925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pU": function() { return /* binding */ Media; },
  "ZP": function() { return /* binding */ media; },
  "V4": function() { return /* binding */ getMediaType; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cool-dimensions/dist/index.esm.js
var index_esm = __webpack_require__(9701);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/_enums/image-content-type.enum.tsx
var image_content_type_enum = __webpack_require__(26884);
// EXTERNAL MODULE: ./src/api/services/variant.service.ts
var variant_service = __webpack_require__(36430);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./src/api/hooks/use-load-image.hook.tsx
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var useLoadImage = function(imageId, isAdmin, imageSize) {
    var ref = (0,react.useState)({}), imageSrc = ref[0], setImageSrc = ref[1];
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    (0,react.useEffect)(function() {
        if (!imageId) {
            return;
        }
        var variantService = new variant_service/* default */.Z();
        if (isAdmin) {
            _asyncToGenerator(runtime_default().mark(function _callee() {
                var imageRes, imageUrl;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return variantService.getPermAttachmentContent(imageId, publicRuntimeConfig.backendURL, isAdmin, imageSize);
                        case 2:
                            imageRes = _ctx.sent;
                            if (imageRes.data) {
                                imageUrl = "data:".concat(imageRes.headers["content-type"], ";base64,").concat(new Buffer(imageRes.data).toString("base64"));
                                setImageSrc({
                                    url: imageUrl,
                                    type: image_content_type_enum/* MediaContentType.PNG */.L.PNG
                                });
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        } else {
            _asyncToGenerator(runtime_default().mark(function _callee() {
                var attachment, url;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return variantService.getPermAttachment(imageId);
                        case 2:
                            attachment = _ctx.sent;
                            url = "".concat(publicRuntimeConfig.backendURL, "api/perm-attachments/").concat(imageId, "/content").concat(imageSize ? "?resolution=".concat(imageSize) : "");
                            setImageSrc({
                                url: url,
                                type: attachment === null || attachment === void 0 ? void 0 : attachment.data.contentContentType
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    }, [
        imageId
    ]);
    return imageSrc;
};
/* harmony default export */ var use_load_image_hook = (useLoadImage);

// EXTERNAL MODULE: ./src/assets/creatoki.png
var creatoki = __webpack_require__(13692);
;// CONCATENATED MODULE: ./src/assets/icons/controls-btn-pause.svg.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var ControlsPauseButton = function(_param) {
    var fill = _param.fill, size = _param.size, props = _objectWithoutProperties(_param, [
        "fill",
        "size"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        id: "controls_btn_ellipse_pause_default",
        "data-name": "controls/btn/ellipse/pause/default",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                id: "Ellipse_265",
                "data-name": "Ellipse 265",
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#b3b3b3",
                opacity: "0.9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "ico_pause",
                "data-name": "ico pause",
                transform: "translate(13.5 -22.416)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vereinigungsmenge_26",
                    "data-name": "Vereinigungsmenge 26",
                    d: "M14710.151,14520.882v-11h2.016v11Zm-4.952,0v-11h2v11Z",
                    transform: "translate(-14706.184 -14476.964)",
                    fill: "#fff"
                })
            })
        ]
    });
};
ControlsPauseButton.defaultProps = {
    fill: "#fff"
};
/* harmony default export */ var controls_btn_pause_svg = (ControlsPauseButton);

;// CONCATENATED MODULE: ./src/assets/icons/controls-btn-play.svg.tsx
function controls_btn_play_svg_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = controls_btn_play_svg_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function controls_btn_play_svg_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var ControlsPlayButton = function(_param) {
    var fill = _param.fill, size = _param.size, props = controls_btn_play_svg_objectWithoutProperties(_param, [
        "fill",
        "size"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        id: "controls_btn_ellipse_play_default",
        "data-name": "controls/btn/ellipse/play/default",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                id: "Ellipse_264",
                "data-name": "Ellipse 264",
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#b3b3b3",
                opacity: "0.9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "ico_play",
                "data-name": "ico play",
                d: "M1313.123,752.261l7.641,6.766-7.641,6.333Zm4.628,6.766-2.756-2.525v4.9Z",
                transform: "translate(-1300.123 -742.811)",
                fill: fill
            })
        ]
    });
};
ControlsPlayButton.defaultProps = {
    fill: "#fff"
};
/* harmony default export */ var controls_btn_play_svg = (ControlsPlayButton);

// EXTERNAL MODULE: ./src/utils/_hooks/useBreakpoints.hook.ts
var useBreakpoints_hook = __webpack_require__(93890);
// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/components/_shared/media/media.module.scss
var media_module = __webpack_require__(25340);
var media_module_default = /*#__PURE__*/__webpack_require__.n(media_module);
;// CONCATENATED MODULE: ./src/components/_shared/media/media.tsx












var getMediaType = function(mediaType) {
    switch(mediaType){
        case "image/jpg":
            return image_content_type_enum/* MediaContentType.JPG */.L.JPG;
        case "image/png":
            return image_content_type_enum/* MediaContentType.PNG */.L.PNG;
        case "video/mp4":
            return image_content_type_enum/* MediaContentType.MP4 */.L.MP4;
        case "audio/mpeg":
            return image_content_type_enum/* MediaContentType.MP3 */.L.MP3;
        case "image/gif":
            return image_content_type_enum/* MediaContentType.GIF */.L.GIF;
        case "video/youtube":
            return image_content_type_enum/* MediaContentType.YOUTUBE */.L.YOUTUBE;
        case "video/vimeo":
            return image_content_type_enum/* MediaContentType.YOUTUBE */.L.YOUTUBE;
        default:
            return image_content_type_enum/* MediaContentType.JPEG */.L.JPEG;
    }
};
var Media = function(props) {
    var content = !props.src && props.mediaId ? use_load_image_hook(props.mediaId, props.isAdmin, props.imageSize) : {
        url: props.src,
        type: props.contentType
    };
    var caption = props.caption, title = props.title;
    var ref5 = (0,react.useState)(false), profilePictureError = ref5[0], setProfilePictureError = ref5[1];
    var dimensionalContainer = react.useRef(null);
    var ref1 = (0,react.useState)(props.squared ? "100%" : "0"), paddingTop = ref1[0], setPaddingTop = ref1[1];
    var ref2 = (0,react.useState)(false), playing = ref2[0], setPlaying = ref2[1];
    var ref3 = (0,index_esm/* default */.ZP)(), observe = ref3.observe, width = ref3.width, height = ref3.height;
    var breakpoint = (0,useBreakpoints_hook/* default */.Z)();
    var imageSizes = [
        16,
        32,
        64,
        128,
        256,
        512,
        1024,
        2048
    ];
    var resetVideo = function() {
        setPlaying(false);
    };
    var videoRef = (0,react.useRef)(null);
    var isVideoPlaying = function(video) {
        return !!(video && video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    };
    var switchVideoControl = function(e) {
        e.preventDefault();
        setPlaying(!isVideoPlaying(videoRef.current));
        {
            var ref, ref4;
            isVideoPlaying(videoRef.current) ? (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.pause() : (ref4 = videoRef.current) === null || ref4 === void 0 ? void 0 : ref4.play();
        }
    };
    var map = function(val, minA, maxA, minB, maxB) {
        return minB + (val - minA) * (maxB - minB) / (maxA - minA);
    };
    var cardDimensional = function(ev, type) {
        var mouseX = function() {
            if (type === "touch") {
                var rect = ev.target.getBoundingClientRect();
                return ev.targetTouches[0].pageX - rect.left;
            } else {
                return ev.nativeEvent.offsetX;
            }
        };
        var mouseY = function() {
            if (type === "touch") {
                var rect = ev.target.getBoundingClientRect();
                return ev.targetTouches[0].pageY - rect.top;
            } else {
                return ev.nativeEvent.offsetY;
            }
        };
        var rotateY = map(mouseX(), 0, Math.floor(width !== null && width !== void 0 ? width : 480), -30, 30);
        var rotateX = map(mouseY(), 0, Math.floor(height !== null && height !== void 0 ? height : 480), 30, -30);
        var brightness = map(mouseY(), 0, Math.floor(height !== null && height !== void 0 ? height : 480), 1.5, .5);
        var scale = .9;
        if (dimensionalContainer && dimensionalContainer.current) {
            // @ts-ignore
            var obj = dimensionalContainer.current.querySelector("img");
            obj.style.filter = "brightness(".concat(brightness, ")");
            obj.style.transform = "rotateX(".concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
            if (breakpoint === "mobile") {
                document.body.style.overflowY = "hidden";
            }
        }
    };
    var onTouchMove = function(ev) {
        if (props.dimensionalCard) {
            cardDimensional(ev, "touch");
        }
    };
    var onMouseMove = function(ev) {
        if (props.dimensionalCard) {
            cardDimensional(ev, "mouse");
        }
    };
    var onMouseLeave = function() {
        if (props.dimensionalCard) {
            if (dimensionalContainer && dimensionalContainer.current) {
                // @ts-ignore
                var obj = dimensionalContainer.current.querySelector("img");
                obj.style.filter = "brightness(1)";
                obj.style.transform = "rotateX(0deg) rotateY(0deg) scale(1)";
                if (breakpoint === "mobile") {
                    document.body.style.overflowY = "auto";
                }
            }
        }
    };
    var renderCaption = function() {
        return caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (media_module_default()).caption,
            children: caption
        });
    };
    var renderMedia = function() {
        return width && content.url ? content.type === image_content_type_enum/* MediaContentType.MP4 */.L.MP4 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    autoPlay: props.autoplay !== undefined ? props.autoplay : !props.isTeaser,
                    controls: props.controls !== undefined ? props.controls : !props.isTeaser,
                    loop: !props.isTeaser,
                    muted: !props.isTeaser,
                    poster: props.posterUrl,
                    className: props.className ? props.className : "",
                    src: content.url + "#t=0.01",
                    ref: videoRef,
                    onEnded: resetVideo
                }),
                props.isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (media_module_default())["custom-play-button"],
                    onClick: function(e) {
                        switchVideoControl(e);
                    },
                    children: playing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(controls_btn_pause_svg, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(controls_btn_play_svg, {})
                })
            ]
        }) : content.type === image_content_type_enum/* MediaContentType.YOUTUBE */.L.YOUTUBE ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (media_module_default())["yt-wrap"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (media_module_default())["yt-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: props.autoplay ? content.url + "&autoplay=1" : content.url,
                    title: props.alt,
                    frameBorder: "0",
                    allow: props.autoplay ? "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" : "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true
                })
            })
        }) : content.type === image_content_type_enum/* MediaContentType.MP3 */.L.MP3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
            className: (media_module_default())["audio-wrap"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                controls: true,
                controlsList: "nodownload",
                autoPlay: Boolean(props.autoplay).valueOf(),
                src: content.url
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "\n                                    ".concat(props.className ? props.className : "", " \n                                    ").concat(props.dimensionalCard ? (media_module_default())["dimensional-card"] : "", "\n                                "),
            style: {
                paddingTop: paddingTop,
                position: "relative"
            },
            onMouseMove: function(ev) {
                return onMouseMove(ev);
            },
            onMouseLeave: function() {
                return onMouseLeave();
            },
            onTouchMove: function(ev) {
                return onTouchMove(ev);
            },
            onTouchEnd: function() {
                return onMouseLeave();
            },
            ref: dimensionalContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: profilePictureError ? creatoki/* default.src */.Z.src : content.url,
                style: props.dimensionalCard ? {
                    perspective: "800px"
                } : {},
                alt: props.alt,
                priority: props.initialLoad,
                layout: "fill",
                onError: function() {
                    if (props.isProfile) {
                        setProfilePictureError(true);
                    }
                },
                sizes: "".concat(imageSizes.find(function(value) {
                    return value > width;
                }), "px"),
                objectFit: props.objectFit,
                onLoad: function(param) {
                    var target = param.target;
                    if (!props.squared) {
                        var naturalWidth = target.naturalWidth, naturalHeight = target.naturalHeight;
                        setPaddingTop("calc(100% / (".concat(naturalWidth, " / ").concat(naturalHeight, ")"));
                    }
                }
            })
        }) : undefined;
    };
    var renderMediaComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "\n                ".concat((media_module_default())["media-component"], "\n                ").concat(props.dimensionalCard ? (media_module_default()).dimensional : "", "\n                ").concat(props.hexagon ? (media_module_default()).hexagon : "", "\n                ").concat(props.inverted ? (media_module_default()).inverted : "", "\n                ").concat(content.type === image_content_type_enum/* MediaContentType.MP4 */.L.MP4 && props.squared ? (media_module_default())["squared-video"] : "", "\n                ").concat(props.classNameWrapper ? props.classNameWrapper : "", "\n            "),
            title: title !== null && title !== void 0 ? title : undefined,
            ref: observe,
            children: props.imageEffect && props.imageEffect.effect && props.imageEffect.withSubline ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((media_module_default()).animate__animated, " ").concat((media_module_default())["animate__" + props.imageEffect.effect]),
                children: [
                    renderMedia(),
                    renderCaption()
                ]
            }) : props.imageEffect && props.imageEffect.effect ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((media_module_default()).animate__animated, " ").concat((media_module_default())["animate__" + props.imageEffect.effect]),
                        children: renderMedia()
                    }),
                    renderCaption()
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    renderMedia(),
                    renderCaption()
                ]
            })
        });
    };
    var linkedImage = function() {
        if (props.redirectUrl) {
            return props.redirectUrl;
        } else if (props.enlargeOnClick) {
            return content.url;
        }
        return false;
    };
    var linkedImg = linkedImage();
    if (linkedImg && typeof linkedImg === "string") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
            target: props.enlargeOnClick ? "_blank" : "",
            href: linkedImg,
            className: "".concat((media_module_default()).clickable, " ").concat(props.linkClassName),
            children: renderMediaComponent()
        });
    } else {
        return renderMediaComponent();
    }
};

/* harmony default export */ var media = (Media);
Media.defaultProps = {
    objectFit: "cover"
};


/***/ }),

/***/ 66743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MetaTagsResolver; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useContextSSr_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63794);
/* harmony import */ var _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88092);





var MetaTagsResolver = function(param) {
    var tags = param.tags, title = param.title, articlePageType = param.articlePageType, isTypoPage = param.isTypoPage, languageAlternates = param.languageAlternates;
    var ref = (0,_api_hooks_useContextSSr_hook__WEBPACK_IMPORTED_MODULE_3__/* .useContextSsr */ ._)(), host = ref.host, locale = ref.locale;
    var protocol = (host === null || host === void 0 ? void 0 : host.includes("creatokia")) ? "https://" : "http://";
    if (tags) {
        var ref1, ref2, ref3, ref4;
        var ref5;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: title !== null && title !== void 0 ? title : tags === null || tags === void 0 ? void 0 : tags.metaTagTitle,
            description: !isTypoPage ? tags === null || tags === void 0 ? void 0 : tags.metaOgDescription : tags === null || tags === void 0 ? void 0 : tags.metaTagDescription,
            canonical: tags === null || tags === void 0 ? void 0 : tags.metaTagCanonical,
            openGraph: {
                description: tags === null || tags === void 0 ? void 0 : tags.metaOgDescription,
                title: tags === null || tags === void 0 ? void 0 : tags.metaOgTitle,
                site_name: tags === null || tags === void 0 ? void 0 : tags.metaOgSiteName,
                locale: locale,
                images: [
                    {
                        url: (ref5 = tags === null || tags === void 0 ? void 0 : (ref1 = tags.MetaOgImage) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref5 !== void 0 ? ref5 : "",
                        alt: tags === null || tags === void 0 ? void 0 : (ref2 = tags.MetaOgImage) === null || ref2 === void 0 ? void 0 : ref2.alternativeText,
                        height: tags === null || tags === void 0 ? void 0 : (ref3 = tags.MetaOgImage) === null || ref3 === void 0 ? void 0 : ref3.height,
                        width: tags === null || tags === void 0 ? void 0 : (ref4 = tags.MetaOgImage) === null || ref4 === void 0 ? void 0 : ref4.width
                    }
                ],
                url: tags === null || tags === void 0 ? void 0 : tags.metaOgUrl,
                type: tags === null || tags === void 0 ? void 0 : tags.metaOgType
            },
            twitter: {
                site: tags === null || tags === void 0 ? void 0 : tags.metaTwitterSite
            },
            nofollow: tags === null || tags === void 0 ? void 0 : tags.metaNoFollow,
            noindex: tags === null || tags === void 0 ? void 0 : tags.metaNoIndex,
            languageAlternates: languageAlternates && languageAlternates.length > 0 ? languageAlternates : (tags === null || tags === void 0 ? void 0 : tags.alternateLinkEn) && (tags === null || tags === void 0 ? void 0 : tags.alternateLinkDe) ? [
                {
                    hrefLang: "de",
                    href: "".concat(protocol).concat(host, "/de/").concat(articlePageType ? articlePageType === _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_4__/* .ArticlePageTypes.ARTICLE_PAGE */ .W.ARTICLE_PAGE || articlePageType === _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_4__/* .ArticlePageTypes.ARTICLE_PAGE_STRAPIID */ .W.ARTICLE_PAGE_STRAPIID ? "s/" : "c/" : "").concat(tags === null || tags === void 0 ? void 0 : tags.alternateLinkDe)
                },
                {
                    hrefLang: "en",
                    href: "".concat(protocol).concat(host, "/en/").concat(articlePageType ? articlePageType === _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_4__/* .ArticlePageTypes.ARTICLE_PAGE */ .W.ARTICLE_PAGE || articlePageType === _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_4__/* .ArticlePageTypes.ARTICLE_PAGE_STRAPIID */ .W.ARTICLE_PAGE_STRAPIID ? "s/" : "c/" : "").concat(tags === null || tags === void 0 ? void 0 : tags.alternateLinkEn)
                }
            ] : [],
            additionalMetaTags: [
                {
                    property: "og:locale:alternative",
                    content: locale === "de" ? "en" : "de"
                }
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
};
MetaTagsResolver.dataHooks = [
    _api_hooks_useContextSSr_hook__WEBPACK_IMPORTED_MODULE_3__/* .useContextSsr */ ._
];


/***/ }),

/***/ 48887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ newsletter_input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(80880);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var dist = __webpack_require__(85611);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/toaster-types.enum.tsx
var toaster_types_enum = __webpack_require__(18152);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/utils/_enums/button-types.enum.tsx
var button_types_enum = __webpack_require__(30830);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/error/error-message.tsx
var error_message = __webpack_require__(63879);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/submit-input/submit-input.module.scss
var submit_input_module = __webpack_require__(43046);
var submit_input_module_default = /*#__PURE__*/__webpack_require__.n(submit_input_module);
;// CONCATENATED MODULE: ./src/components/_shared/input-fields/submit-input/submit-input.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var SubmitInput = function(props) {
    var ref, ref1;
    var ref2 = (0,index_esm/* useForm */.cI)({
        resolver: (props === null || props === void 0 ? void 0 : props.schema) ? (0,yup_module/* yupResolver */.X)(props === null || props === void 0 ? void 0 : props.schema) : undefined
    }), register = ref2.register, getValues = ref2.getValues, reset = ref2.reset, handleSubmit = ref2.handleSubmit, errors = ref2.formState.errors;
    var onSubmit = function() {
        props.submitForm(getValues("value"));
        reset();
    };
    var _otherIcon, _errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        "data-testid": "submit-input",
        noValidate: true,
        onSubmit: handleSubmit(onSubmit),
        className: "".concat((submit_input_module_default())["input-field-wrapper"], " ").concat(props.className ? props.className : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (submit_input_module_default())["submit-input"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({}, register("value"), {
                        placeholder: props.placeholder,
                        className: "\n                    ".concat(((ref = errors["value"]) === null || ref === void 0 ? void 0 : ref.message) ? (submit_input_module_default()).error : "", "\n                    ").concat(props.inputClassName ? props.inputClassName : "", "\n                    ").concat(props.inverted ? (submit_input_module_default()).inverted : "", "\n                    ")
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        type: button_types_enum/* ButtonTypesEnum.SUBMIT */.J.SUBMIT,
                        inverted: props.inverted,
                        className: "".concat((submit_input_module_default())["submit-button"], " ").concat(props.inverted ? (submit_input_module_default()).inverted : ""),
                        pending: props.submitPending,
                        icon: {
                            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: (_otherIcon = props.otherIcon) !== null && _otherIcon !== void 0 ? _otherIcon : [
                                    "far",
                                    "long-arrow-alt-right"
                                ]
                            }),
                            align: "left"
                        },
                        variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_FILLED */.l.SECONDARY_FILLED
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(error_message/* ErrorMessage */.B, {
                children: (_errorMessage = props.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : (ref1 = errors["value"]) === null || ref1 === void 0 ? void 0 : ref1.message
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/_shared/newsletter-input/newsletter-input.module.scss
var newsletter_input_module = __webpack_require__(77604);
var newsletter_input_module_default = /*#__PURE__*/__webpack_require__.n(newsletter_input_module);
;// CONCATENATED MODULE: ./src/components/_shared/newsletter-input/newsletter-input.tsx












var NewsletterInput = function(props) {
    var router = (0,client_router.useRouter)();
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), formSubmitted = ref[0], setFormSubmitted = ref[1];
    var ref1 = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.newsletterSlice.newsletter;
    }), pending = ref1.pending, submitted = ref1.submitted;
    var error = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.globalSlice.errorCodes;
    });
    var addToast = (0,dist/* useToasts */.e1)().addToast;
    (0,react.useEffect)(function() {
        if (formSubmitted) {
            if (submitted && !pending && props.successMessage) {
                addToast(props.successMessage, {
                    appearance: toaster_types_enum/* ToasterTypes.SUCCESS */.p.SUCCESS
                });
                dispatch((0,redux/* resetNewsletterSubscription */.iZ)());
            } else if (!pending && error && error.length > 0) {
                dispatch((0,redux/* resetNewsletterSubscription */.iZ)());
            }
            setFormSubmitted(false);
        }
    }, [
        submitted,
        error
    ]);
    var subscribeToNewsletter = function(email) {
        setFormSubmitted(true);
        if (executeRecaptcha) {
            var token1 = executeRecaptcha("newsletter_subscription");
            token1.then(function(res) {
                var token = res;
                var _locale;
                dispatch((0,redux/* sendNewsletterSubscription */.qw)({
                    email: email,
                    token: token,
                    languageCode: (_locale = router.locale) !== null && _locale !== void 0 ? _locale : "de"
                }));
            });
        }
    };
    if (props.inputTexts) {
        var ref2, ref3;
        var _className;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitInput, {
            placeholder: props.inputTexts.fieldHint,
            submitForm: subscribeToNewsletter,
            className: (newsletter_input_module_default())["newsletter-input"],
            inputClassName: (_className = props.className) !== null && _className !== void 0 ? _className : "",
            name: "email",
            inverted: props.inverted,
            submitPending: pending,
            otherIcon: props.otherIcon,
            schema: props.inputTexts.fieldErrorMessages ? yup_es/* object */.Ry({
                value: yup_es/* string */.Z_().required((ref2 = props.inputTexts.fieldErrorMessages) === null || ref2 === void 0 ? void 0 : ref2.required).email((ref3 = props.inputTexts.fieldErrorMessages) === null || ref3 === void 0 ? void 0 : ref3.valid)
            }) : undefined
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var newsletter_input = (NewsletterInput);


/***/ }),

/***/ 86499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76221);
/* harmony import */ var _error_error_message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63879);
/* harmony import */ var _radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47319);
/* harmony import */ var _radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var RadioButtonGroup = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-button-group"]), " ").concat(props.disabled ? (_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default().disabled) : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default().label),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: props.label
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-buttons"]), "\n                ").concat(props.direction === _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_2__/* .Alignment.VERTICAL */ .v.VERTICAL ? (_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[_utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_2__/* .Alignment.VERTICAL */ .v.VERTICAL] : ""),
                children: props.options.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: "".concat((_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container), " ").concat(props.disabled ? (_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default().disabled) : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["checkmark-outer-border-wrapper"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["checkmark-inner-border-wrapper"]),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                                            disabled: props.disabled
                                        }, props.register(props.name), {
                                            type: "radio",
                                            value: option.value
                                        })),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_radio_button_group_module_scss__WEBPACK_IMPORTED_MODULE_4___default().checkmark)
                                        })
                                    ]
                                })
                            }),
                            option.label
                        ]
                    }, option.value);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error_error_message__WEBPACK_IMPORTED_MODULE_3__/* .ErrorMessage */ .B, {
                children: props.errorMessage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButtonGroup);


/***/ }),

/***/ 39382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3522);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87536);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64884);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88734);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63367);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _error_error_message__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63879);
/* harmony import */ var _tool_tip_tool_tip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62486);
/* harmony import */ var _select_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69596);
/* harmony import */ var _select_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_select_module_scss__WEBPACK_IMPORTED_MODULE_7__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var MAX_DISPLAYED_OPTIONS = 100;
var Select = function(props1) {
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isMenuOpen = ref5[0], setIsMenuOpen = ref5[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), inputValue = ref1[0], setInputValue = ref1[1];
    var DropdownIndicator = function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_6__.c.DropdownIndicator, _objectSpread({}, props, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["dropdown-indicator"]), " ").concat(isMenuOpen ? (_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default().open) : (_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default().closed)),
                children: isMenuOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: [
                        "far",
                        "times"
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: [
                        "far",
                        "chevron-down"
                    ]
                })
            })
        }));
    };
    var customStyles = {
        input: function(base) {
            return _objectSpread({}, base, {
                color: (props1 === null || props1 === void 0 ? void 0 : props1.inverted) ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_light) : base === null || base === void 0 ? void 0 : base.color
            });
        },
        singleValue: function(base) {
            return _objectSpread({}, base, {
                color: (props1 === null || props1 === void 0 ? void 0 : props1.inverted) ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_light) : base.color
            });
        },
        valueContainer: function(base) {
            return _objectSpread({}, base, {
                height: "55px",
                marginLeft: "8px"
            });
        },
        control: function(base, state) {
            return _objectSpread({}, base, {
                borderRadius: 0,
                cursor: "pointer",
                borderColor: props1.errorMessage ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().signalColors_error) : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_middleLight),
                boxShadow: "none",
                backgroundColor: state.isDisabled ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_lightDark) : (props1 === null || props1 === void 0 ? void 0 : props1.inverted) ? "transparent" : (props1 === null || props1 === void 0 ? void 0 : props1.inverted) ? "transparent" : base.backgroundColor
            });
        },
        menu: function(base) {
            return _objectSpread({}, base, {
                zIndex: 50,
                borderRadius: 0
            });
        },
        menuList: function(base) {
            return _objectSpread({}, base, {
                height: "203px",
                scrollbarWidth: "thin",
                "::-webkit-scrollbar": {
                    width: "9px"
                },
                "::-webkit-scrollbar-track": {
                    background: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_light)
                },
                "::-webkit-scrollbar-thumb": {
                    background: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_middleLight)
                }
            });
        },
        dropdownIndicator: function(base) {
            return _objectSpread({}, base, {
                backgroundColor: (props1 === null || props1 === void 0 ? void 0 : props1.inverted) ? "white" : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_dark),
                color: (props1 === null || props1 === void 0 ? void 0 : props1.inverted) ? "black" : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_light),
                clipPath: "polygon(100% 0%,30% 0%,0% 50%,30% 100%,100% 100%)",
                paddingRight: "8px",
                paddingLeft: "16px",
                paddingTop: "16px",
                height: "100%",
                "&:hover": {
                    color: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().primary_middleDark)
                }
            });
        },
        indicatorSeparator: function(base) {
            return _objectSpread({}, base, {
                visibility: "hidden"
            });
        },
        option: function(base, state) {
            return _objectSpread({}, base, {
                paddingTop: "13px",
                paddingBottom: "13px",
                backgroundColor: state.isSelected || state.isDisabled ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_lightDark) : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_light),
                color: state.isSelected || state.isDisabled ? (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_dark) : (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_middleLight),
                "&:hover": {
                    backgroundColor: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_lightDark)
                },
                paddingLeft: "16px",
                borderBottom: "1px solid " + (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_lightDark),
                "&:last-child": {
                    borderBottom: "none"
                }
            });
        },
        placeholder: function(base) {
            return _objectSpread({}, base, {
                color: (_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().greys_middleLight)
            });
        }
    };
    var filteredOptions = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!inputValue) {
            return props1.options;
        }
        var matchByStart = [];
        var matchByInclusion = [];
        var regByInclusion = new RegExp(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default()(inputValue), "i");
        var regByStart = new RegExp("^".concat(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default()(inputValue)), "i");
        if (props1.options) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = props1.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var option = _step.value;
                    if (regByInclusion.test(option.label)) {
                        if (regByStart.test(option.label)) {
                            matchByStart.push(option);
                        } else {
                            matchByInclusion.push(option);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return _toConsumableArray(matchByStart).concat(_toConsumableArray(matchByInclusion));
    }, [
        inputValue,
        props1.options
    ]);
    var slicedOptions = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return filteredOptions && filteredOptions.length > MAX_DISPLAYED_OPTIONS ? filteredOptions.slice(0, MAX_DISPLAYED_OPTIONS) : filteredOptions;
    }, [
        filteredOptions
    ]);
    var renderSelectComponent = function(field) {
        var ref7, ref2, ref3;
        var ref4, _noOptionsMessage;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, _objectSpread({
            "data-testid": "select"
        }, field, {
            components: {
                DropdownIndicator: DropdownIndicator
            },
            className: (_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default().select),
            styles: customStyles,
            onMenuOpen: function() {
                return setIsMenuOpen(true);
            },
            onMenuClose: function() {
                return setIsMenuOpen(false);
            },
            options: slicedOptions,
            isOptionDisabled: props1.isOptionDisabled ? props1.isOptionDisabled : undefined,
            filterOption: function() {
                return true;
            },
            value: field ? props1.isMulti ? (ref4 = field === null || field === void 0 ? void 0 : (ref7 = field.value) === null || ref7 === void 0 ? void 0 : (ref2 = ref7.map) === null || ref2 === void 0 ? void 0 : ref2.call(ref7, function(v) {
                var ref, ref6;
                return props1 === null || props1 === void 0 ? void 0 : (ref = props1.options) === null || ref === void 0 ? void 0 : (ref6 = ref.find) === null || ref6 === void 0 ? void 0 : ref6.call(ref, function(val) {
                    if (v === Number(val.value)) {
                        return val;
                    }
                });
            })) !== null && ref4 !== void 0 ? ref4 : [] : (ref3 = props1.options) === null || ref3 === void 0 ? void 0 : ref3.filter(function(option) {
                return option.value === field.value;
            }) : props1.value,
            onChange: field ? function(values) {
                if (props1.isMulti) {
                    var ref, ref8;
                    field.onChange((ref = values) === null || ref === void 0 ? void 0 : ref.map(function(value) {
                        return Number(value.value);
                    }));
                    props1 === null || props1 === void 0 ? void 0 : (ref8 = props1.onChange) === null || ref8 === void 0 ? void 0 : ref8.call(props1, values);
                } else {
                    var ref9, ref10;
                    field.onChange((ref9 = values) === null || ref9 === void 0 ? void 0 : ref9.value);
                    props1 === null || props1 === void 0 ? void 0 : (ref10 = props1.onChange) === null || ref10 === void 0 ? void 0 : ref10.call(props1, values);
                }
            } : props1.onChange,
            placeholder: props1.placeholder,
            closeMenuOnSelect: !props1.isMulti,
            noOptionsMessage: function() {
                return (_noOptionsMessage = props1.noOptionsMessage) !== null && _noOptionsMessage !== void 0 ? _noOptionsMessage : null;
            },
            onInputChange: function(value) {
                setInputValue(value);
                if (props1.onInputChange) {
                    props1.onInputChange(value);
                }
            },
            isMulti: props1.isMulti,
            isSearchable: props1.isSearchable,
            isClearable: props1.isClearable,
            isDisabled: props1.isDisabled
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "select",
        className: "\n    ".concat((_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["select-wrapper"]), "\n    ").concat(props1.isDisabled ? (_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default().disabled) : "", "\n    ").concat(props1.className ? props1.className : "", "\n    "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: props1.errorMessage ? (_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["input-label-error"]) : (_select_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["input-label"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: props1.label
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: props1.fieldToolTip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tool_tip_tool_tip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                toolTip: props1.fieldToolTip
                            }) : undefined
                        })
                    ]
                })
            }),
            props1.control ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .Controller */ .Qr, {
                control: props1.control,
                name: props1.name,
                render: function(param) {
                    var field = param.field;
                    return renderSelectComponent(field);
                }
            }) : renderSelectComponent(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error_error_message__WEBPACK_IMPORTED_MODULE_4__/* .ErrorMessage */ .B, {
                children: props1.errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 59688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Seperator; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _seperator_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95155);
/* harmony import */ var _seperator_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_seperator_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Seperator = function(param) {
    var margin = param.margin, height = param.height, width = param.width, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "seperator",
        className: (_seperator_module_scss__WEBPACK_IMPORTED_MODULE_2___default().seperator),
        style: {
            width: width,
            margin: margin,
            height: height,
            backgroundColor: color !== null && color !== void 0 ? color : "black"
        }
    });
};
Seperator.defaultProps = {
    margin: "0",
    height: "0px",
    width: "auto"
};


/***/ }),

/***/ 4363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Spacer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Spacer = function(param) {
    var width = param.width, height = param.height, id = param.id;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: id,
        style: {
            width: width,
            height: height
        }
    });
};
Spacer.defaultProps = {
    width: "auto",
    height: "auto"
};


/***/ }),

/***/ 33997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useCardText_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14375);
/* harmony import */ var _utils_enums_basic_card_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90017);
/* harmony import */ var _utils_enums_currency_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25444);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50325);
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46164);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27397);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28773);
/* harmony import */ var _teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47699);
/* harmony import */ var _teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10__);











var TeaserCardText = function(props) {
    var ref3;
    var data = (0,_api_hooks_useCardText_hook__WEBPACK_IMPORTED_MODULE_2__/* .useCardText */ .G)();
    var getSubHeadlineVariant = function() {
        switch(props.variant){
            case _utils_enums_basic_card_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .BasicCardVariants.TEXT_ONLY_TEASER_NORMAL */ .I.TEXT_ONLY_TEASER_NORMAL:
                return _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING5_LIGHT */ .H.HEADING5_LIGHT;
            case _utils_enums_basic_card_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .BasicCardVariants.TEXT_ONLY_TEASER_LARGE */ .I.TEXT_ONLY_TEASER_LARGE:
                return _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING4_LIGHT */ .H.HEADING4_LIGHT;
            default:
                return _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING5_LIGHT */ .H.HEADING5_LIGHT;
        }
    };
    var generateDescription = function() {
        var updatedDescription;
        if (props.description && props.readMore) {
            var ref;
            updatedDescription = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                        inverted: props.inverted,
                        children: props.description
                    }),
                    props.readMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
                        onClick: props.readMore,
                        href: "",
                        className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["read-more"]),
                        children: (ref = data === null || data === void 0 ? void 0 : data.readMore) !== null && ref !== void 0 ? ref : ""
                    })
                ]
            });
        } else {
            var _description;
            updatedDescription = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                inverted: props.inverted,
                children: (_description = props.description) !== null && _description !== void 0 ? _description : ""
            });
        }
        return updatedDescription;
    };
    var _toplineStyle, _headlineElement, _headlineStyle, _redirectUrl, _headlineElement1, _headlineStyle1, _headlineElement2, _headlineStyle2, _subHeadlineElement, _subHeadlineStyle, ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["product-card-details-wrapper"]), " ").concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default())["".concat(props.variant ? props.variant : "")]),
        children: [
            props.topline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default().topline), " ").concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default())["topline-".concat(props.variant)]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.TOPLINE_OR_LABEL */ .H.TOPLINE_OR_LABEL,
                    inverted: props.inverted,
                    disableMarkdown: true,
                    style: (_toplineStyle = props.toplineStyle) !== null && _toplineStyle !== void 0 ? _toplineStyle : undefined,
                    children: props.topline
                })
            }),
            props.variant === _utils_enums_basic_card_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .BasicCardVariants.TEXT_IMAGE_TEASER */ .I.TEXT_IMAGE_TEASER ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: props.headline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                    inverted: props.inverted,
                    variant: props.headlineVariant ? props.headlineVariant : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING3_BOLD */ .H.HEADING3_BOLD,
                    element: (_headlineElement = props.headlineElement) !== null && _headlineElement !== void 0 ? _headlineElement : undefined,
                    style: (_headlineStyle = props.headlineStyle) !== null && _headlineStyle !== void 0 ? _headlineStyle : undefined,
                    children: props.headline
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["headline-wrapper"]),
                children: props.redirectUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_8__/* .LinkBase */ .w, {
                    href: (_redirectUrl = props.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                        disableMarkdown: true,
                        className: "".concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default().headline), " ").concat(props.redirectUrl ? (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["headline-clickable"]) : ""),
                        inverted: props.inverted,
                        variant: props.headlineVariant ? props.headlineVariant : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6,
                        element: (_headlineElement1 = props.headlineElement) !== null && _headlineElement1 !== void 0 ? _headlineElement1 : "span",
                        style: (_headlineStyle1 = props.headlineStyle) !== null && _headlineStyle1 !== void 0 ? _headlineStyle1 : undefined,
                        children: props.headline
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                    disableMarkdown: true,
                    inverted: props.inverted,
                    className: "".concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default().headline), " ").concat(props.redirectUrl ? (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["headline-clickable"]) : ""),
                    variant: props.headlineVariant ? props.headlineVariant : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6,
                    element: (_headlineElement2 = props.headlineElement) !== null && _headlineElement2 !== void 0 ? _headlineElement2 : "span",
                    style: (_headlineStyle2 = props.headlineStyle) !== null && _headlineStyle2 !== void 0 ? _headlineStyle2 : undefined,
                    children: props.headline
                })
            }),
            props.subHeadline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["sub-headline"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                    inverted: props.inverted,
                    disableMarkdown: true,
                    variant: props.subHeadlineVariant ? props.subHeadlineVariant : getSubHeadlineVariant(),
                    element: (_subHeadlineElement = props.subHeadlineElement) !== null && _subHeadlineElement !== void 0 ? _subHeadlineElement : "span",
                    style: (_subHeadlineStyle = props.subHeadlineStyle) !== null && _subHeadlineStyle !== void 0 ? _subHeadlineStyle : undefined,
                    children: props.subHeadline
                })
            }),
            props.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["description-wrapper"]), " ").concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default())["description-wrapper-".concat(props.variant)]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description), " ").concat((_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default())["description-".concat(props.variant)]),
                    children: generateDescription()
                })
            }),
            props.serialNumber && props.variant === _utils_enums_basic_card_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .BasicCardVariants.PURCHASE_CARD_NORMAL */ .I.PURCHASE_CARD_NORMAL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["optional-info"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                    inverted: props.inverted,
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.TOPLINE_OR_LABEL */ .H.TOPLINE_OR_LABEL,
                    disableMarkdown: true,
                    children: (ref3 = props.serialNumber) === null || ref3 === void 0 ? void 0 : ref3.toString()
                })
            }),
            props.paidPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["paid-price-wrapper"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                        inverted: props.inverted,
                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.TOPLINE_OR_LABEL */ .H.TOPLINE_OR_LABEL,
                        disableMarkdown: true,
                        children: (ref1 = data === null || data === void 0 ? void 0 : data.pricePaid) !== null && ref1 !== void 0 ? ref1 : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                        inverted: props.inverted,
                        disableMarkdown: true,
                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING4_BOLD */ .H.HEADING4_BOLD,
                        className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["paid-price"]),
                        element: "span",
                        children: props.paidPrice === -1 ? "-" : props.currency === _utils_enums_currency_enum__WEBPACK_IMPORTED_MODULE_4__/* .Currency.EUR */ .F.EUR ? (0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_6__/* .getLocalePrice */ .yb)(props.paidPrice) + " \u20AC" : (0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_6__/* .getLocaleEthPrice */ .af)(props.paidPrice) + "\u039E"
                    })
                ]
            }),
            props.tokenId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["token-id-wrapper"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                        inverted: props.inverted,
                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.TOPLINE_OR_LABEL */ .H.TOPLINE_OR_LABEL,
                        disableMarkdown: true,
                        children: (ref2 = data === null || data === void 0 ? void 0 : data.tokenId) !== null && ref2 !== void 0 ? ref2 : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_9__/* .Typography */ .Z, {
                        inverted: props.inverted,
                        disableMarkdown: true,
                        variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6,
                        className: (_teaser_card_text_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["token-id"]),
                        element: "span",
                        children: props.tokenId.toString()
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TeaserCardText);


/***/ }),

/***/ 33076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ teaser_card; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useCategories.hook.ts
var useCategories_hook = __webpack_require__(28955);
// EXTERNAL MODULE: ./src/api/hooks/useGenres.hook.ts
var useGenres_hook = __webpack_require__(26323);
// EXTERNAL MODULE: ./src/api/hooks/useLookupTableData.hook.ts
var useLookupTableData_hook = __webpack_require__(12310);
// EXTERNAL MODULE: ./src/api/hooks/useSubCategories.hook.ts
var useSubCategories_hook = __webpack_require__(71887);
// EXTERNAL MODULE: ./src/api/hooks/useTypoContent.hook.ts
var useTypoContent_hook = __webpack_require__(80612);
// EXTERNAL MODULE: ./src/api/models/instance-status.tsx
var instance_status = __webpack_require__(23812);
// EXTERNAL MODULE: ./src/api/models/variant-image-type.tsx
var variant_image_type = __webpack_require__(84623);
// EXTERNAL MODULE: ./src/api/services/instances.service.tsx
var instances_service = __webpack_require__(21804);
// EXTERNAL MODULE: ./src/api/services/product.service.tsx
var product_service = __webpack_require__(22205);
// EXTERNAL MODULE: ./src/api/services/variant.service.ts
var variant_service = __webpack_require__(36430);
;// CONCATENATED MODULE: ./src/utils/_enums/blockchain.enum.ts
var Blockchain;
(function(Blockchain) {
    Blockchain[Blockchain["ETHEREUM"] = 0] = "ETHEREUM";
    Blockchain[Blockchain["POLYGON"] = 1] = "POLYGON";
})(Blockchain || (Blockchain = {}));

// EXTERNAL MODULE: ./src/utils/_enums/filter-expression.enum.tsx
var filter_expression_enum = __webpack_require__(55190);
// EXTERNAL MODULE: ./src/utils/_enums/sales-type.tsx
var sales_type = __webpack_require__(9943);
// EXTERNAL MODULE: ./src/utils/_helper/enum-to-language-mapper.tsx
var enum_to_language_mapper = __webpack_require__(15487);
// EXTERNAL MODULE: ./src/utils/_helper/select-language-for-product-attribute.ts
var select_language_for_product_attribute = __webpack_require__(24997);
// EXTERNAL MODULE: ./src/utils/_helper/time-helper.tsx
var time_helper = __webpack_require__(28508);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/components/_shared/login-dialog/login-dialog.tsx
var login_dialog = __webpack_require__(16308);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/utils/_helper/generate-url-to-details-page-helper.ts
var generate_url_to_details_page_helper = __webpack_require__(49352);
// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/card-title/card-title.module.scss
var card_title_module = __webpack_require__(51667);
var card_title_module_default = /*#__PURE__*/__webpack_require__.n(card_title_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/card-title/card-title.tsx







var CardTitle = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.inverted ? (card_title_module_default()).inverted : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: typeography_variants_enum/* TypographyVariantsEnum.TOPLINE_OR_LABEL */.H.TOPLINE_OR_LABEL,
                className: (card_title_module_default()).topline,
                children: props.topline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_title_module_default())["title-wrapper"],
                children: props.productName && props.title && props.productId && props.variantId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                    href: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(props.productName, props.title, props.productId, props.variantId, props.instanceId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6,
                        className: "".concat((card_title_module_default()).title, " ").concat((card_title_module_default())["link-title"]),
                        children: props.title
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6,
                    className: (card_title_module_default()).title,
                    children: props.title
                })
            })
        ]
    });
};
/* harmony default export */ var card_title = (CardTitle);

// EXTERNAL MODULE: ./src/components/_shared/teaser-card/card-detail/card-detail.module.scss
var card_detail_module = __webpack_require__(80769);
var card_detail_module_default = /*#__PURE__*/__webpack_require__.n(card_detail_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/card-detail/card-detail.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var CardDetail = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((card_detail_module_default()).detail, " ").concat(props.inverted ? (card_detail_module_default()).inverted : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_detail_module_default()).head,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_title, _objectSpread({}, props))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_detail_module_default())["content-wrapper"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (card_detail_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                                className: (card_detail_module_default()).description,
                                children: props.description
                            })
                        })
                    })
                ]
            }),
            props.variantAttributes ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((card_detail_module_default()).attributes, " ").concat(props.inverted ? (card_detail_module_default()).inverted : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                    className: (card_detail_module_default()).table,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: props.variantAttributes.map(function(attributes, i) {
                            if (i >= 4) return;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: (card_detail_module_default()).row,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (card_detail_module_default())["cell-attribute"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                                            className: "".concat((card_detail_module_default()).cell, " ").concat(props.inverted ? (card_detail_module_default()).inverted : ""),
                                            children: attributes === null || attributes === void 0 ? void 0 : attributes.label
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (card_detail_module_default())["cell-value"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                                            className: "".concat((card_detail_module_default()).cell, " ").concat(props.inverted ? (card_detail_module_default()).inverted : ""),
                                            children: attributes === null || attributes === void 0 ? void 0 : attributes.value
                                        })
                                    })
                                ]
                            }, i);
                        })
                    })
                })
            }) : undefined,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((card_detail_module_default())["link-wrapper"], " ").concat(props.inverted ? (card_detail_module_default()).inverted : ""),
                children: props.productName && props.title && props.productId && props.variantId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_base/* LinkBase */.w, {
                    href: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(props.productName, props.title, props.productId, props.variantId, props.instanceId),
                    className: (card_detail_module_default()).link,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            variant: typeography_variants_enum/* TypographyVariantsEnum.BUTTON */.H.BUTTON,
                            children: (ref = props.teaserMenuLabels) === null || ref === void 0 ? void 0 : ref.more
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            className: (card_detail_module_default()).icon,
                            icon: [
                                "far",
                                "external-link"
                            ]
                        })
                    ]
                }) : undefined
            })
        ]
    });
};
/* harmony default export */ var card_detail = (CardDetail);

;// CONCATENATED MODULE: ./src/assets/icons/eth.svg.tsx
function eth_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function eth_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            eth_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var EthSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", eth_svg_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24.195,
        height: 20.793
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "data-name": "hexagon eth",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "data-name": "Pfad 442",
                    d: "M18.147 0H6.049L0 10.4l6.049 10.4h12.1L24.2 10.4Z",
                    fill: "#E2E7FB"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3836",
                d: "m11.647 3.638-4.148 6.884 4.148-1.885Z",
                fill: "#8a92b2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3837",
                d: "m11.647 8.636-4.148 1.885 4.148 2.453Z",
                fill: "#62688f"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3838",
                d: "m15.796 10.522-4.149-6.884v5Z",
                fill: "#62688f"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3839",
                d: "m11.647 12.974 4.149-2.453-4.149-1.885Z",
                fill: "#454a75"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3840",
                d: "m7.499 11.309 4.148 5.846v-3.4Z",
                fill: "#8a92b2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3841",
                d: "M11.647 13.76v3.4l4.151-5.846Z",
                fill: "#62688f"
            })
        ]
    }));
};
/* harmony default export */ var eth_svg = (EthSVG);

// EXTERNAL MODULE: ./src/assets/icons/icon-styles.module.scss
var icon_styles_module = __webpack_require__(70927);
var icon_styles_module_default = /*#__PURE__*/__webpack_require__.n(icon_styles_module);
;// CONCATENATED MODULE: ./src/assets/icons/flip.svg.tsx
function flip_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function flip_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            flip_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var FlipSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", flip_svg_objectSpread({}, props, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26.667,
        height: 44.172,
        className: "".concat((icon_styles_module_default())["flip-icon"], " ").concat(props.inverted ? (icon_styles_module_default()).inverted : "", " ").concat(props.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3843",
                d: "M26.667 0v44.172H0Z",
                className: (icon_styles_module_default()).outside
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Vereinigungsmenge 29",
                className: (icon_styles_module_default()).inside,
                d: "m15.318 38.978 1.237-1.595c2.17-.362 3.812-1.528 3.812-3.905a3.746 3.746 0 0 0-3.572-3.875l1.619 2.511h-1.859L14.348 28.8l2.207-3.045h1.859l-1.684 2.386c2.918.137 5.233 1.885 5.238 5.437v.017c0 3.693-2.847 5.353-6.65 5.383Z"
            })
        ]
    }));
};
/* harmony default export */ var flip_svg = (FlipSVG);

;// CONCATENATED MODULE: ./src/assets/icons/polygon.svg.tsx
function polygon_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function polygon_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            polygon_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var PolygonSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", polygon_svg_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24.195,
        height: 20.793
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "data-name": "hexagon eth",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "data-name": "Pfad 442",
                    d: "M18.147 0H6.049L0 10.4l6.049 10.4h12.1L24.2 10.4Z",
                    fill: "#E4D8FA"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Pfad 3803",
                d: "m14.569 15.379-2.89-1.795v-1.85h1.148v1.211l1.729 1.074 1.841-1.2v-2.191l-1.835-1.059-4.913 2.822-3-1.77V7.357l3-1.951 3.083 1.945v1.436h-1.148v-.8L9.658 6.772 7.799 7.983v1.986l1.858 1.1 4.907-2.822 2.984 1.719v3.48Z",
                fill: "#7b3fe4"
            })
        ]
    }));
};
/* harmony default export */ var polygon_svg = (PolygonSVG);

// EXTERNAL MODULE: ./src/utils/_enums/currency.enum.ts
var currency_enum = __webpack_require__(25444);
// EXTERNAL MODULE: ./src/utils/_helper/locale-helper.tsx
var locale_helper = __webpack_require__(50325);
// EXTERNAL MODULE: ./src/utils/_hooks/useTimer.hook.ts
var useTimer_hook = __webpack_require__(55816);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/_shared/button/nav-button/nav-button.module.scss
var nav_button_module = __webpack_require__(41227);
var nav_button_module_default = /*#__PURE__*/__webpack_require__.n(nav_button_module);
;// CONCATENATED MODULE: ./src/components/_shared/button/nav-button/nav-button.tsx







var NavButton = function(props) {
    var renderButton = function() {
        var _icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: props.onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6,
                    className: (nav_button_module_default()).text,
                    children: props.children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    className: (nav_button_module_default()).icon,
                    icon: [
                        "fas",
                        (_icon = props.icon) !== null && _icon !== void 0 ? _icon : "chevron-right"
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (nav_button_module_default())["nav-button"],
        children: props.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: props.href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: renderButton()
            })
        }) : renderButton()
    });
};
/* harmony default export */ var nav_button = (NavButton);

// EXTERNAL MODULE: ./src/components/_shared/tool-tip/tool-tip.tsx
var tool_tip = __webpack_require__(62486);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/card-footer/card-footer.module.scss
var card_footer_module = __webpack_require__(11930);
var card_footer_module_default = /*#__PURE__*/__webpack_require__.n(card_footer_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/card-footer/card-footer.tsx
function card_footer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function card_footer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            card_footer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















var CardFooter = function(props) {
    var ref4, ref1, ref2;
    var renderBlockchainIcon = function() {
        if (props.blockchain === Blockchain.ETHEREUM) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tool_tip/* default */.Z, {
                toolTip: (ref = props.blockchainStrings) === null || ref === void 0 ? void 0 : ref.ethereum,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eth_svg, {})
            });
        } else if (props.blockchain === Blockchain.POLYGON) {
            var ref3;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tool_tip/* default */.Z, {
                toolTip: (ref3 = props.blockchainStrings) === null || ref3 === void 0 ? void 0 : ref3.polygon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(polygon_svg, {})
            });
        }
    };
    var getPrimaryPriceAsString = function() {
        if (props.currency === currency_enum/* Currency.ETH */.F.ETH) {
            return (0,locale_helper/* getLocaleEthPrice */.af)(props.ethPrice) + "\u039E";
        } else {
            return (0,locale_helper/* getLocalePrice */.yb)(props.fiatPrice) + "\u20AC";
        }
    };
    var getSecondaryPriceAsString = function() {
        var price;
        if (props.currency === currency_enum/* Currency.ETH */.F.ETH) {
            price = (0,locale_helper/* getLocalePrice */.yb)(props.fiatPrice) + "\u20AC";
        } else {
            price = (0,locale_helper/* getLocaleEthPrice */.af)(props.ethPrice) + "\u039E";
        }
        return "(".concat(price, ")");
    };
    var renderCountdown = function() {
        var _salesFrom;
        var salesFromDate = new Date((_salesFrom = props.salesFrom) !== null && _salesFrom !== void 0 ? _salesFrom : "");
        var startTimer = (0,useTimer_hook/* useTimer */.J)(salesFromDate.getTime());
        var countdownCheck = startTimer.timer < 60 * 60 * 24;
        var countdown = (0,time_helper/* toCountdown */._z)(startTimer.timer);
        var onlyDateString = (0,time_helper/* formatDate */.p6)(salesFromDate);
        return countdownCheck ? countdown : onlyDateString;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((card_footer_module_default()).footer, " ").concat(props.inverted ? (card_footer_module_default()).inverted : "", " ").concat(props.className ? props.className : ""),
        children: [
            props.isFront ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card_title, card_footer_objectSpread({}, props)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_footer_module_default())["blockchain-icon"],
                        children: renderBlockchainIcon()
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_footer_module_default()).separator
            }),
            props.canBuy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (card_footer_module_default())["price-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.PARAGRAPH */.H.PARAGRAPH,
                        className: (card_footer_module_default())["price-prefix"],
                        children: (ref4 = props.generalStrings) === null || ref4 === void 0 ? void 0 : ref4.fromLowest
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6,
                        className: (card_footer_module_default()).price,
                        children: getPrimaryPriceAsString()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.PARAGRAPH */.H.PARAGRAPH,
                        className: (card_footer_module_default())["secondary-price"],
                        children: getSecondaryPriceAsString()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_footer_module_default())["buy-button"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_button, {
                            onClick: props.onBuy,
                            children: (ref1 = props.generalStrings) === null || ref1 === void 0 ? void 0 : ref1.buy
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_footer_module_default())["price-wrapper"],
                children: props.productName && props.title && props.productId && props.variantId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (card_footer_module_default()).countdown,
                    children: (0,time_helper/* isDateInFuture */.ek)(props === null || props === void 0 ? void 0 : props.salesFrom) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                            variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6,
                            className: (card_footer_module_default()).countdown,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (card_footer_module_default()).clock,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: [
                                            "far",
                                            "clock"
                                        ]
                                    })
                                }),
                                renderCountdown()
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_button, {
                        href: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(props.productName, props.title, props.productId, props.variantId, props.instanceId),
                        children: (ref2 = props.generalStrings) === null || ref2 === void 0 ? void 0 : ref2.options
                    })
                }) : undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(flip_svg, {
                onClick: props.onSwap,
                className: (card_footer_module_default())["swap-icon"],
                inverted: props.inverted
            })
        ]
    });
};
/* harmony default export */ var card_footer = (CardFooter);

// EXTERNAL MODULE: ./src/components/_shared/teaser-card/card-back/card-back.module.scss
var card_back_module = __webpack_require__(4461);
var card_back_module_default = /*#__PURE__*/__webpack_require__.n(card_back_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/card-back/card-back.tsx
function card_back_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function card_back_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            card_back_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var CardBack = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((card_back_module_default()).back, " ").concat(props.inverted ? (card_back_module_default()).inverted : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_back_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_detail, card_back_objectSpread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_footer, card_back_objectSpread({}, props, {
                isFront: false,
                onBuy: props.onBuy,
                onSwap: props.onSwap,
                className: (card_back_module_default()).footer
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((card_back_module_default())["teaser-border"], " ").concat(props.inverted ? (card_back_module_default()).inverted : "")
            })
        ]
    });
};
/* harmony default export */ var card_back = (CardBack);

// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
;// CONCATENATED MODULE: ./src/assets/icons/book.svg.tsx
function book_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function book_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            book_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var BookSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", book_svg_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24.308,
        height: 20.045
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.18 2.906C9.131 1.008 4.755.15 0 0v17.786c4.084.124 9.2.9 12.179 2.26a57.174 57.174 0 0 1 12.13-2.506V.05c-4.756.142-9.083.958-12.129 2.856ZM1.79 16.163V1.95c5.349.4 7.808 1.518 9.336 2.421v13.657a35.4 35.4 0 0 0-9.336-1.865Zm20.746 0a35.317 35.317 0 0 0-9.336 1.866V4.367c1.508-.893 3.974-2.017 9.336-2.417Zm-2.075-10.6a28.632 28.632 0 0 0-6.224 1.734l.568-1.394a32.188 32.188 0 0 1 6.219-1.526Zm.417 3.143a30.589 30.589 0 0 0-6.073 1.554l-.568 1.262a28.63 28.63 0 0 1 6.224-1.735Zm0-2.107a30.589 30.589 0 0 0-6.073 1.554l-.568 1.262a28.63 28.63 0 0 1 6.224-1.735Zm0 6.32a52.481 52.481 0 0 0-6.073 1.554l-.568 1.262A28.63 28.63 0 0 1 20.461 14l.417-1.081Zm0-2.107a30.589 30.589 0 0 0-6.073 1.554l-.568 1.262a28.63 28.63 0 0 1 6.224-1.735ZM3.503 4.486A32.444 32.444 0 0 1 9.75 6.04l.339 1.262a28.574 28.574 0 0 0-6.224-1.734Zm.362 5.305a28.572 28.572 0 0 1 6.224 1.735l-.339-1.262A32.444 32.444 0 0 0 3.503 8.71Zm0-2.107a28.571 28.571 0 0 1 6.224 1.735L9.75 8.157a32.368 32.368 0 0 0-6.247-1.552Zm0 6.32a28.572 28.572 0 0 1 6.224 1.735l-.339-1.262a32.444 32.444 0 0 0-6.247-1.554Zm0-2.107a28.571 28.571 0 0 1 6.224 1.735L9.75 12.37a32.444 32.444 0 0 0-6.247-1.554Z"
        })
    }));
};
/* harmony default export */ var book_svg = (BookSVG);

;// CONCATENATED MODULE: ./src/assets/icons/color-palette.svg.tsx
function color_palette_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function color_palette_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            color_palette_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var ColorPaletteSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", color_palette_svg_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20.176,
        height: 20.219
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            "data-name": "Gruppe 18303",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "data-name": "Vereinigungsmenge 25",
                d: "M12.321 18.537c1.668-.512 3.768-1.8 3.716-4.037.343-.322 1.479-1.467 1.479-1.467.845 4.651-1.923 6.7-5.92 7.186a5.114 5.114 0 0 0 .725-1.682ZM3.7 18c3.489.312 2.325-3.462 5.554-3.5l.888 1.7c.2 2.6-1.256 3.827-2.923 3.827A4.343 4.343 0 0 1 3.7 18ZM0 9.768C-.037 4.314 3.983.052 9.019.007a9.668 9.668 0 0 1 6.733 2.322L14.5 3.556a9.841 9.841 0 0 0-5.481-1.793c-3.772-.128-7.235 3.47-7.2 8a7.328 7.328 0 0 0 1.831 5.556l-1.713.793A10.367 10.367 0 0 1 0 9.768Zm10.79 5.305-.649-1.408c1.474-1.491 10.035-11.9 10.035-11.9V4.2S15 11.585 13.912 13.427a4.989 4.989 0 0 1-3.012 1.878ZM4.593 13.2l-.7-1.208.7-1.209h1.394l.7 1.209-.7 1.208Zm-.231-4.1-.7-1.208.7-1.207h1.393l.7 1.207-.7 1.208Zm7.063-2.417-.7-1.208.7-1.209h1.393l.7 1.209-.7 1.208Zm-4.044-.616-.7-1.207.7-1.208h1.393l.7 1.208-.7 1.207Z"
            })
        })
    }));
};
/* harmony default export */ var color_palette_svg = (ColorPaletteSVG);

;// CONCATENATED MODULE: ./src/assets/icons/headphones.svg.tsx
function headphones_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function headphones_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            headphones_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var HeadphonesSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", headphones_svg_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 23.645,
        height: 18.446
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "data-name": "Vereinigungsmenge 23",
            d: "m2.559 18.447-2.56-4.43 2.558-4.431h2.559v8.861Zm15.97-.122V9.463h2.558l2.558 4.431-2.558 4.431Zm-8.113-1.737-1-3.059-.119.62-.019.116-.079.493H7.368l-.584-.659h1.8l.215-.612.4-1.17a.348.348 0 0 1 .044-.091.314.314 0 0 1 .566.09l.609 2.438.785-4.268c.056-.344.661-.345.739 0l.915 3.658.465-1.061c.105-.266.3-.418.418-.156l.751 1.715.478-.547h2.048l-.6.659h-1.118l-.61.609c-.147.2-.511.228-.609 0l-.527-1.268-.692 1.268a.318.318 0 0 1-.609 0l-.61-3.048-.609 4.268a.289.289 0 0 1-.292.255.327.327 0 0 1-.324-.25ZM3.099 8.053C3.646 3.28 6.792 0 11.636 0c4.746 0 7.86 3.119 8.521 7.93a12.6 12.6 0 0 0-1.729 0 6.953 6.953 0 0 0-6.792-6.413c-2.837.039-6.137 1.689-6.656 6.536Z"
        })
    }));
};
/* harmony default export */ var headphones_svg = (HeadphonesSVG);

;// CONCATENATED MODULE: ./src/assets/icons/menu.svg.tsx
function menu_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menu_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var MenuSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", menu_svg_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 54.946,
        height: 37.497
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.812 0h33.133v37.5H0Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: props.fill,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "data-name": "Pfad 2630",
                    d: "M41.244 22.443h2.97l1.485-2.506-1.485-2.594h-2.97l-1.485 2.6ZM33.714 22.443h2.97l1.485-2.506-1.485-2.594h-2.97l-1.485 2.6ZM26.184 22.443h2.97l1.485-2.506-1.485-2.594h-2.97l-1.485 2.6Z"
                })
            })
        ]
    }));
};
/* harmony default export */ var menu_svg = (MenuSVG);

;// CONCATENATED MODULE: ./src/assets/icons/unlockables.svg.tsx
function unlockables_svg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function unlockables_svg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            unlockables_svg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var UnlockablesSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", unlockables_svg_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14.57,
        height: 19
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "data-name": "Vereinigungsmenge 31",
            d: "M0 19V7.5h2.971l-.073-4.844L7.356 0l4.25 2.938v2.094H9.893V3.657l-2.5-1.594-2.785 1.406V7.5h9.966V19Zm1.617-1.625h11.336v-8.25H1.617Zm5.761-1.5H6.223l.22-2.219a1.637 1.637 0 1 1 2.44-1.406 1.684 1.684 0 0 1-.794 1.406l.326 2.219Z",
            fill: "#426dfd"
        })
    }));
};
/* harmony default export */ var unlockables_svg = (UnlockablesSVG);

// EXTERNAL MODULE: ./src/components/_shared/teaser-card/card-header/card-header.module.scss
var card_header_module = __webpack_require__(22906);
var card_header_module_default = /*#__PURE__*/__webpack_require__.n(card_header_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/card-header/card-header.tsx









var CardHeader = function(props) {
    var ref, ref1, ref2, ref3;
    var categorySVGs = [
        {
            id: 1,
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(headphones_svg, {
                fill: "white"
            }, "headphones-svg"),
            label: (ref = props.productCategories) === null || ref === void 0 ? void 0 : ref.audio
        },
        {
            id: 2,
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(book_svg, {
                fill: "white"
            }, "book-svg"),
            label: (ref1 = props.productCategories) === null || ref1 === void 0 ? void 0 : ref1.text
        },
        {
            id: 3,
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_palette_svg, {
                fill: "white"
            }, "color-palette-svg"),
            label: (ref2 = props.productCategories) === null || ref2 === void 0 ? void 0 : ref2.art
        }
    ];
    var renderCategories = function() {
        var _label;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (card_header_module_default()).categories,
            children: categorySVGs.filter(function(item) {
                return item.id === props.category;
            }).map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tool_tip/* default */.Z, {
                        toolTip: (_label = item.label) !== null && _label !== void 0 ? _label : "",
                        children: item.value
                    })
                }, "category-icon-".concat(item.id));
            })
        });
    };
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (card_header_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_header_module_default())["left-header"],
                children: renderCategories()
            }),
            props.unlockables ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_header_module_default()).unlockables,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tool_tip/* default */.Z, {
                    toolTip: (ref4 = (ref3 = props.generalStrings) === null || ref3 === void 0 ? void 0 : ref3.unlockables) !== null && ref4 !== void 0 ? ref4 : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(unlockables_svg, {})
                })
            }) : undefined,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_svg, {
                className: "".concat((card_header_module_default()).menu, " ").concat(props.isOverlayActive ? (card_header_module_default()).active : ""),
                onClick: props.onToggleOverlay
            })
        ]
    });
};
/* harmony default export */ var card_header = (CardHeader);

// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var dist = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/api/hooks/useGlobal.hook.ts
var useGlobal_hook = __webpack_require__(77459);
// EXTERNAL MODULE: ./src/utils/_enums/toaster-types.enum.tsx
var toaster_types_enum = __webpack_require__(18152);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/card-overlay/card-overlay.module.scss
var card_overlay_module = __webpack_require__(26527);
var card_overlay_module_default = /*#__PURE__*/__webpack_require__.n(card_overlay_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/card-overlay/card-overlay.tsx









var CardOverlay = function(props) {
    var ref9, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    // const dispatch = useDispatch();
    // const [modalType, setModalType] = useState<CardModalTypes | undefined>(undefined);
    var addToast = (0,dist/* useToasts */.e1)().addToast;
    var globalData = (0,useGlobal_hook/* useGlobal */.O)();
    var renderLinkToDetailPage = function(label, toSalesBox) {
        if (props.productName && props.title && props.productId && props.variantId) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(props.productName, props.title, props.productId, props.variantId, props.instanceId, undefined, undefined, toSalesBox),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: label
                })
            });
        }
    };
    // const renderModalContent = () => {
    //     switch (modalType) {
    //         case CardModalTypes.MINT:
    //             return props.instanceId && props.tokenContract
    //                 ? <MintingBox
    //                     instanceId={props.instanceId}
    //                     tokenContract={props.tokenContract}/>
    //                 : undefined
    //         case CardModalTypes.RESALE:
    //             return <ResaleBox/>;
    //         case CardModalTypes.CANCEL_RESALE:
    //             return 'Cancel resale';
    //     }
    // }
    // const cancelResale = () => {
    //     if (props.instanceId) {
    //         dispatch(cancelFixPrice(props.instanceId));
    //     }
    // }
    var copyLinkToClipboard = function() {
        if (props.productName && props.title && props.productId && props.variantId) {
            var ref;
            var ta = document.createElement("textarea");
            ta.innerText = "".concat((0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(props.productName, props.title, props.productId, props.variantId, props.instanceId, undefined, true));
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            ta.remove();
            var ref8;
            addToast((ref8 = (ref = globalData.errorMessages) === null || ref === void 0 ? void 0 : ref.copiedSuccessfully) !== null && ref8 !== void 0 ? ref8 : "", {
                appearance: toaster_types_enum/* ToasterTypes.SUCCESS */.p.SUCCESS
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (card_overlay_module_default()).overlay,
        children: [
            props.canBuy ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    onClick: props.onBuy,
                    children: (ref9 = props.teaserMenuLabels) === null || ref9 === void 0 ? void 0 : ref9.buyNow
                })
            }) : undefined,
            props.canMint ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: renderLinkToDetailPage((ref1 = props.teaserMenuLabels) === null || ref1 === void 0 ? void 0 : ref1.mint, true)
            }) : undefined,
            props.canCancelResale ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: renderLinkToDetailPage((ref2 = props.teaserMenuLabels) === null || ref2 === void 0 ? void 0 : ref2.cancelResale, true)
            }) : undefined,
            props.canSell ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: renderLinkToDetailPage((ref3 = props.teaserMenuLabels) === null || ref3 === void 0 ? void 0 : ref3.sell, true)
            }) : undefined,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    onClick: function() {
                        return copyLinkToClipboard();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (ref4 = props.teaserMenuLabels) === null || ref4 === void 0 ? void 0 : ref4.share
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (card_overlay_module_default())["copy-icon-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: [
                                    "far",
                                    "copy"
                                ]
                            })
                        })
                    ]
                })
            }),
            props.productName && props.title && props.productId && props.variantId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: renderLinkToDetailPage(props.instanceId ? (ref5 = props.teaserMenuLabels) === null || ref5 === void 0 ? void 0 : ref5.instanceDetails : (ref6 = props.teaserMenuLabels) === null || ref6 === void 0 ? void 0 : ref6.variantDetails)
            }) : undefined,
            props.instanceId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat((ref7 = props.teaserMenuLabels) === null || ref7 === void 0 ? void 0 : ref7.instanceIDString, ": ").concat(props.instanceId)
            }) : undefined
        ]
    });
};
/* harmony default export */ var card_overlay = (CardOverlay);

// EXTERNAL MODULE: ./src/components/_shared/teaser-card/card-front/card-front.module.scss
var card_front_module = __webpack_require__(53777);
var card_front_module_default = /*#__PURE__*/__webpack_require__.n(card_front_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/card-front/card-front.tsx
function card_front_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function card_front_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            card_front_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var CardFront = function(props) {
    var ref = (0,react.useState)(false), showOverlay = ref[0], setShowOverlay = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((card_front_module_default()).front, " ").concat(props.inverted ? (card_front_module_default()).inverted : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (card_front_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card_header, card_front_objectSpread({}, props, {
                        onToggleOverlay: function() {
                            return setShowOverlay(function(prevState) {
                                return !prevState;
                            });
                        },
                        isOverlayActive: showOverlay
                    })),
                    showOverlay ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_front_module_default()).overlay,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_overlay, card_front_objectSpread({}, props))
                    }) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_front_module_default()).media,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.ZP, {
                            src: props.mediaUrl,
                            contentType: props.mediaContentType,
                            redirectUrl: props.productName && props.title && props.productId && props.variantId ? (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(props.productName, props.title, props.productId, props.variantId, props.instanceId) : undefined,
                            objectFit: "contain",
                            squared: true,
                            isTeaser: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_footer, card_front_objectSpread({}, props, {
                isFront: true,
                onSwap: props.onSwap,
                onBuy: props.onBuy
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((card_front_module_default())["teaser-border"], " ").concat(props.inverted ? (card_front_module_default()).inverted : "")
            })
        ]
    });
};
/* harmony default export */ var card_front = (CardFront);

// EXTERNAL MODULE: ./src/components/_shared/teaser-card/teaser-card.module.scss
var teaser_card_module = __webpack_require__(55792);
var teaser_card_module_default = /*#__PURE__*/__webpack_require__.n(teaser_card_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card/teaser-card.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function teaser_card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function teaser_card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            teaser_card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
























var TeaserCard = function(props) {
    var ref9 = (0,react.useState)(false), showBack = ref9[0], setShowBack = ref9[1];
    var ref1 = (0,react.useState)(undefined), elementToBuy = ref1[0], setElementToBuy = ref1[1];
    var ref2 = (0,react.useState)({}), teaserProps = ref2[0], setTeaserProps = ref2[1];
    var ref3 = (0,react.useState)(undefined), cheapestInstance = ref3[0], setCheapestInstance = ref3[1];
    var ref4 = (0,react.useState)({
        data: undefined,
        finished: false
    }), unlockables = ref4[0], setUnlockables = ref4[1];
    var ref5 = (0,react.useState)({
        data: undefined,
        finished: false
    }), instanceMeta = ref5[0], setInstanceMeta = ref5[1];
    var ref6 = (0,react.useState)({
        data: undefined,
        finished: false
    }), product1 = ref6[0], setProduct = ref6[1];
    var ref7 = (0,react.useState)({
        data: undefined,
        finished: false
    }), instance = ref7[0], setInstance = ref7[1];
    var ref8 = (0,react.useState)([]), attributes = ref8[0], setAttributes = ref8[1];
    var user = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            user: state.userSlice.user
        };
    }).user;
    var categories = (0,useCategories_hook/* useCategories */.L)();
    var subCategories = (0,useSubCategories_hook/* useSubCategories */.z)();
    var genres = (0,useGenres_hook/* useGenres */.F)();
    var data = (0,useTypoContent_hook/* useTypoContent */.f)();
    var onBuy = function() {
        if (teaserProps.instanceIdToBuy) {
            setElementToBuy({
                id: teaserProps.instanceIdToBuy,
                type: sales_type/* SalesType.FIXED_PRICE */.r.FIXED_PRICE
            });
        } else if (teaserProps.salesType === sales_type/* SalesType.T_DROP */.r.T_DROP && teaserProps.variantId) {
            setElementToBuy({
                id: teaserProps.variantId,
                type: sales_type/* SalesType.T_DROP */.r.T_DROP
            });
        }
    };
    function getInstanceMeta(url) {
        return _getInstanceMeta.apply(this, arguments);
    }
    function _getInstanceMeta() {
        _getInstanceMeta = _asyncToGenerator(runtime_default().mark(function _callee(url) {
            var instancesService;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        instancesService = new instances_service/* default */.Z();
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return instancesService.getJsonMetaDataByMetaUrl(url);
                    case 4:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return _getInstanceMeta.apply(this, arguments);
    }
    function getUnlockables(variantId) {
        return _getUnlockables.apply(this, arguments);
    }
    function _getUnlockables() {
        _getUnlockables = _asyncToGenerator(runtime_default().mark(function _callee(variantId) {
            var variantService;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        variantService = new variant_service/* default */.Z();
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return variantService.getPermAttachments(variantId, variant_image_type/* VariantImageType.ADDITIONAL_FILES */.W.ADDITIONAL_FILES);
                    case 4:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return _getUnlockables.apply(this, arguments);
    }
    function getProduct(productId) {
        return _getProduct.apply(this, arguments);
    }
    function _getProduct() {
        _getProduct = _asyncToGenerator(runtime_default().mark(function _callee(productId) {
            var productService;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        productService = new product_service/* default */.Z();
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return productService.getProductById(productId);
                    case 4:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return _getProduct.apply(this, arguments);
    }
    function getFullInstance(productId) {
        return _getFullInstance.apply(this, arguments);
    }
    function _getFullInstance() {
        _getFullInstance = _asyncToGenerator(runtime_default().mark(function _callee(productId) {
            var instanceService;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        instanceService = new instances_service/* default */.Z();
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return instanceService.getInstancesById(productId);
                    case 4:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return _getFullInstance.apply(this, arguments);
    }
    // const getEtherscanUrl = () => {
    //     const prefix = Number(process.env.NEXT_PUBLIC_CHAIN_ID) === 4 ? 'rinkeby.' : '';
    //     const id = props.instance
    //         ? props.instance.creatoken
    //             ? props.instance.token
    //             : props.instance.id
    //         : undefined;
    //     const contract = props.instance
    //         ? props.instance.creatoken
    //             ? props.instance.contract
    //             : product?.data?.publisherTokenContract
    //         : undefined;
    //     return `https://${prefix}etherscan.io/token/${contract}?a=${id}`;
    // }
    (0,react.useEffect)(function() {
        if (props.variant) {
            getUnlockables(props.variant.id).then(function(value) {
                return setUnlockables({
                    data: value,
                    finished: true
                });
            }).catch(function() {
                return setUnlockables({
                    data: undefined,
                    finished: true
                });
            });
            if (props.variant.productId) {
                getProduct(props.variant.productId).then(function(value) {
                    return setProduct({
                        data: value,
                        finished: true
                    });
                }).catch(function() {
                    return setProduct({
                        data: undefined,
                        finished: true
                    });
                });
            }
        } else if (props.instance) {
            getUnlockables(props.instance.variant.id).then(function(value) {
                return setUnlockables({
                    data: value,
                    finished: true
                });
            }).catch(function() {
                return setUnlockables({
                    data: undefined,
                    finished: true
                });
            });
            if (props.instance.metaUrl) {
                getInstanceMeta(props.instance.metaUrl).then(function(value) {
                    return setInstanceMeta({
                        data: value,
                        finished: true
                    });
                }).catch(function() {
                    return setInstanceMeta({
                        data: undefined,
                        finished: true
                    });
                });
            }
            if (props.instance.variant.productId) {
                getProduct(props.instance.variant.productId).then(function(value) {
                    return setProduct({
                        data: value,
                        finished: true
                    });
                }).catch(function() {
                    return setProduct({
                        data: undefined,
                        finished: true
                    });
                });
            }
        }
    }, [
        props.variant,
        props.instance
    ]);
    (0,react.useEffect)(function() {
        if (!props.variant && !props.instance) {
            if (props.variantId !== 0 && props.variantProductId !== 0) {
                getUnlockables(props.variantId).then(function(value) {
                    return setUnlockables({
                        data: value,
                        finished: true
                    });
                }).catch(function() {
                    return setUnlockables({
                        data: undefined,
                        finished: true
                    });
                });
                if (props.variantProductId) {
                    getProduct(props.variantProductId).then(function(value) {
                        return setProduct({
                            data: value,
                            finished: true
                        });
                    }).catch(function() {
                        return setProduct({
                            data: undefined,
                            finished: true
                        });
                    });
                    var variantService = new variant_service/* default */.Z();
                    variantService.getDetailedVariants([
                        {
                            param: "productId",
                            value: props.variantProductId.toString(),
                            comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
                        }
                    ]).then(function(value) {
                        var product = value.data.find(function(item) {
                            return item.id === props.variantId;
                        });
                        setCheapestInstance(product === null || product === void 0 ? void 0 : product.cheapestInstanceId);
                    });
                }
            } else if (props.instanceId && props.instanceProductId && props.variantId === 0 && props.variantProductId === 0) {
                getUnlockables(props.instanceId).then(function(value) {
                    return setUnlockables({
                        data: value,
                        finished: true
                    });
                }).catch(function() {
                    return setUnlockables({
                        data: undefined,
                        finished: true
                    });
                });
                if (props.instanceId) {
                    getFullInstance(props.instanceId).then(function(value) {
                        return setInstance({
                            data: value,
                            finished: true
                        });
                    }).catch(function() {
                        return setInstance({
                            data: undefined,
                            finished: true
                        });
                    });
                }
                if (instance.data) {
                    var ref;
                    getInstanceMeta((ref = instance.data) === null || ref === void 0 ? void 0 : ref.metaUrl).then(function(value) {
                        return setInstanceMeta({
                            data: value,
                            finished: true
                        });
                    }).catch(function() {
                        return setInstanceMeta({
                            data: undefined,
                            finished: true
                        });
                    });
                }
                if (props.instanceProductId) {
                    getProduct(props.instanceProductId).then(function(value) {
                        return setProduct({
                            data: value,
                            finished: true
                        });
                    }).catch(function() {
                        return setProduct({
                            data: undefined,
                            finished: true
                        });
                    });
                }
            }
        }
    }, [
        props.variantId,
        props.variantProductId,
        props.instanceId,
        props.instanceProductId,
        instance.finished
    ]);
    (0,react.useEffect)(function() {
        var tempAttributes = [];
        var tempCategory;
        var tempSubCategory;
        var tempGenre;
        var tempLabels;
        var tempProductLabels;
        var releaseDate;
        var endOfSale;
        var units;
        var categoryLabel;
        var subCategoryLabel;
        var genreLabel;
        if (data) {
            tempLabels = data.creatokia.labels;
            tempProductLabels = tempLabels.find(function(item) {
                return item.slug === "teaser";
            });
            if ((tempProductLabels === null || tempProductLabels === void 0 ? void 0 : tempProductLabels.subcategories) !== undefined) {
                var ref, ref10, ref11, ref12, ref13, ref14;
                releaseDate = (ref = tempProductLabels.subcategories.find(function(item) {
                    return item.slug === "release-date";
                })) === null || ref === void 0 ? void 0 : ref.title;
                endOfSale = (ref10 = tempProductLabels.subcategories.find(function(item) {
                    return item.slug === "end-of-sale";
                })) === null || ref10 === void 0 ? void 0 : ref10.title;
                units = (ref11 = tempProductLabels.subcategories.find(function(item) {
                    return item.slug === "units";
                })) === null || ref11 === void 0 ? void 0 : ref11.title;
                categoryLabel = (ref12 = tempProductLabels.subcategories.find(function(item) {
                    return item.slug === "category";
                })) === null || ref12 === void 0 ? void 0 : ref12.title;
                subCategoryLabel = (ref13 = tempProductLabels.subcategories.find(function(item) {
                    return item.slug === "sub-category";
                })) === null || ref13 === void 0 ? void 0 : ref13.title;
                genreLabel = (ref14 = tempProductLabels.subcategories.find(function(item) {
                    return item.slug === "genre";
                })) === null || ref14 === void 0 ? void 0 : ref14.title;
            } else {
                console.error("Product labels could not be found!");
                releaseDate = "";
                endOfSale = "";
                units = "";
                categoryLabel = "";
                subCategoryLabel = "";
                genreLabel = "";
            }
        }
        if (props.variant) {
            var ref15, ref16, ref17, ref18, ref19, ref20, ref21;
            if (props.variant.salesAttribute) {
                if (props.variant.salesAttribute.saleFrom) {
                    tempAttributes.push({
                        label: releaseDate,
                        value: (0,time_helper/* formatDateAndTime */.sb)(props.variant.salesAttribute.saleFrom)
                    });
                }
                if (props.variant.salesAttribute.saleTo) {
                    tempAttributes.push({
                        label: endOfSale,
                        value: (0,time_helper/* formatDateAndTime */.sb)(props.variant.salesAttribute.saleTo)
                    });
                }
                if (props.variant.salesAttribute.mintingCount) {
                    tempAttributes.push({
                        label: units,
                        value: props.variant.salesAttribute.mintingCount
                    });
                }
            }
            (ref15 = props.variant) === null || ref15 === void 0 ? void 0 : ref15.variantAttributes.map(function(item) {
                var ref;
                var ref41;
                var res = (0,select_language_for_product_attribute/* selectLanguageForProductAttribute */.B)(((ref41 = (ref = product1.data) === null || ref === void 0 ? void 0 : ref.productAttributes) !== null && ref41 !== void 0 ? ref41 : []).find(function(att) {
                    return att.id === item.productAttributeId;
                }));
                if (!res || !item.value) return undefined;
                tempAttributes.push({
                    label: res,
                    value: item.value
                });
            });
            tempCategory = (ref17 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref16 = categories.data) === null || ref16 === void 0 ? void 0 : ref16.data).find(function(att) {
                var ref;
                return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.categoryId);
            })) === null || ref17 === void 0 ? void 0 : ref17.text;
            tempSubCategory = (ref19 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref18 = subCategories.data) === null || ref18 === void 0 ? void 0 : ref18.data).find(function(att) {
                var ref;
                return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.subCategoryId);
            })) === null || ref19 === void 0 ? void 0 : ref19.text;
            tempGenre = (ref21 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref20 = genres.data) === null || ref20 === void 0 ? void 0 : ref20.data).find(function(att) {
                var ref;
                return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.genreId);
            })) === null || ref21 === void 0 ? void 0 : ref21.text;
            if (tempCategory) {
                tempAttributes.push({
                    label: categoryLabel,
                    value: tempCategory
                });
            }
            if (tempSubCategory) {
                tempAttributes.push({
                    label: subCategoryLabel,
                    value: tempSubCategory
                });
            }
            if (tempGenre) {
                tempAttributes.push({
                    label: genreLabel,
                    value: tempGenre
                });
            }
            setAttributes(tempAttributes);
        }
        if (props.instance) {
            var ref22, ref23, ref24, ref25, ref26, ref27, ref28;
            if (props.instance.variant.salesAttribute) {
                if (props.instance.variant.salesAttribute.saleFrom) {
                    tempAttributes.push({
                        label: releaseDate,
                        value: (0,time_helper/* formatDateAndTime */.sb)(props.instance.variant.salesAttribute.saleFrom)
                    });
                }
                if (props.instance.variant.salesAttribute.saleTo) {
                    tempAttributes.push({
                        label: endOfSale,
                        value: (0,time_helper/* formatDateAndTime */.sb)(props.instance.variant.salesAttribute.saleTo)
                    });
                }
                if (props.instance.variant.salesAttribute.mintingCount) {
                    tempAttributes.push({
                        label: units,
                        value: props.instance.variant.salesAttribute.mintingCount
                    });
                }
            }
            (ref22 = props.instance.variant) === null || ref22 === void 0 ? void 0 : ref22.variantAttributes.map(function(item) {
                var ref;
                var ref42;
                var res = (0,select_language_for_product_attribute/* selectLanguageForProductAttribute */.B)(((ref42 = (ref = product1.data) === null || ref === void 0 ? void 0 : ref.productAttributes) !== null && ref42 !== void 0 ? ref42 : []).find(function(att) {
                    return att.id === item.productAttributeId;
                }));
                if (!res || !item.value) return undefined;
                tempAttributes.push({
                    label: res,
                    value: item.value
                });
            });
            tempCategory = (ref24 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref23 = categories.data) === null || ref23 === void 0 ? void 0 : ref23.data).find(function(att) {
                var ref;
                return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.categoryId);
            })) === null || ref24 === void 0 ? void 0 : ref24.text;
            tempSubCategory = (ref26 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref25 = subCategories.data) === null || ref25 === void 0 ? void 0 : ref25.data).find(function(att) {
                var ref;
                return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.subCategoryId);
            })) === null || ref26 === void 0 ? void 0 : ref26.text;
            tempGenre = (ref28 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref27 = genres.data) === null || ref27 === void 0 ? void 0 : ref27.data).find(function(att) {
                var ref;
                return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.genreId);
            })) === null || ref28 === void 0 ? void 0 : ref28.text;
            if (tempCategory) {
                tempAttributes.push({
                    label: categoryLabel,
                    value: tempCategory
                });
            }
            if (tempSubCategory) {
                tempAttributes.push({
                    label: subCategoryLabel,
                    value: tempSubCategory
                });
            }
            if (tempGenre) {
                tempAttributes.push({
                    label: genreLabel,
                    value: tempGenre
                });
            }
            setAttributes(tempAttributes);
        }
        if (!props.variant && !props.instance) {
            if (props.variantId !== 0 && props.variantProductId !== 0) {
                var ref29, ref30, ref31, ref32, ref33, ref34;
                var productData = product1.data;
                var variantData = productData === null || productData === void 0 ? void 0 : productData.variants.find(function(variant) {
                    return variant.id === props.variantId;
                });
                if (productData && (variantData === null || variantData === void 0 ? void 0 : variantData.salesAttribute)) {
                    if (variantData === null || variantData === void 0 ? void 0 : variantData.salesAttribute.saleFrom) {
                        tempAttributes.push({
                            label: releaseDate,
                            value: (0,time_helper/* formatDateAndTime */.sb)(variantData === null || variantData === void 0 ? void 0 : variantData.salesAttribute.saleFrom)
                        });
                    }
                    if (variantData === null || variantData === void 0 ? void 0 : variantData.salesAttribute.saleTo) {
                        tempAttributes.push({
                            label: endOfSale,
                            value: (0,time_helper/* formatDateAndTime */.sb)(variantData === null || variantData === void 0 ? void 0 : variantData.salesAttribute.saleTo)
                        });
                    }
                    if (variantData === null || variantData === void 0 ? void 0 : variantData.salesAttribute.mintingCount) {
                        tempAttributes.push({
                            label: units,
                            value: variantData === null || variantData === void 0 ? void 0 : variantData.salesAttribute.mintingCount
                        });
                    }
                }
                variantData === null || variantData === void 0 ? void 0 : variantData.variantAttributes.map(function(item) {
                    var ref;
                    var res = (0,select_language_for_product_attribute/* selectLanguageForProductAttribute */.B)(((ref = productData === null || productData === void 0 ? void 0 : productData.productAttributes) !== null && ref !== void 0 ? ref : []).find(function(att) {
                        return att.id === item.productAttributeId;
                    }));
                    if (!res || !item.value) return undefined;
                    tempAttributes.push({
                        label: res,
                        value: item.value
                    });
                });
                tempCategory = (ref30 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref29 = categories.data) === null || ref29 === void 0 ? void 0 : ref29.data).find(function(att) {
                    var ref;
                    return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.categoryId);
                })) === null || ref30 === void 0 ? void 0 : ref30.text;
                tempSubCategory = (ref32 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref31 = subCategories.data) === null || ref31 === void 0 ? void 0 : ref31.data).find(function(att) {
                    var ref;
                    return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.subCategoryId);
                })) === null || ref32 === void 0 ? void 0 : ref32.text;
                tempGenre = (ref34 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref33 = genres.data) === null || ref33 === void 0 ? void 0 : ref33.data).find(function(att) {
                    var ref;
                    return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.genreId);
                })) === null || ref34 === void 0 ? void 0 : ref34.text;
                if (tempCategory) {
                    tempAttributes.push({
                        label: categoryLabel,
                        value: tempCategory
                    });
                }
                if (tempSubCategory) {
                    tempAttributes.push({
                        label: subCategoryLabel,
                        value: tempSubCategory
                    });
                }
                if (tempGenre) {
                    tempAttributes.push({
                        label: genreLabel,
                        value: tempGenre
                    });
                }
                setAttributes(tempAttributes);
            }
            if (props.instanceId && props.instanceProductId && props.variantId === 0 && props.variantProductId === 0) {
                var ref35, ref36, ref37, ref38, ref39, ref40;
                var productData1 = product1.data;
                var instanceVariantData = productData1 === null || productData1 === void 0 ? void 0 : productData1.variants.find(function(variant) {
                    return variant.productId === props.instanceProductId;
                });
                if (instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute) {
                    if (instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.saleFrom) {
                        tempAttributes.push({
                            label: releaseDate,
                            value: (0,time_helper/* formatDateAndTime */.sb)(instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.saleFrom)
                        });
                    }
                    if (instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.saleTo) {
                        tempAttributes.push({
                            label: endOfSale,
                            value: (0,time_helper/* formatDateAndTime */.sb)(instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.saleTo)
                        });
                    }
                    if (instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.mintingCount) {
                        tempAttributes.push({
                            label: units,
                            value: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.mintingCount
                        });
                    }
                }
                instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.variantAttributes.map(function(item) {
                    var ref;
                    var res = (0,select_language_for_product_attribute/* selectLanguageForProductAttribute */.B)(((ref = productData1 === null || productData1 === void 0 ? void 0 : productData1.productAttributes) !== null && ref !== void 0 ? ref : []).find(function(att) {
                        return att.id === item.productAttributeId;
                    }));
                    if (!res || !item.value) return undefined;
                    tempAttributes.push({
                        label: res,
                        value: item.value
                    });
                });
                tempCategory = (ref36 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref35 = categories.data) === null || ref35 === void 0 ? void 0 : ref35.data).find(function(att) {
                    var ref;
                    return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.categoryId);
                })) === null || ref36 === void 0 ? void 0 : ref36.text;
                tempSubCategory = (ref38 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref37 = subCategories.data) === null || ref37 === void 0 ? void 0 : ref37.data).find(function(att) {
                    var ref;
                    return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.subCategoryId);
                })) === null || ref38 === void 0 ? void 0 : ref38.text;
                tempGenre = (ref40 = (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref39 = genres.data) === null || ref39 === void 0 ? void 0 : ref39.data).find(function(att) {
                    var ref;
                    return att.id === (product1 === null || product1 === void 0 ? void 0 : (ref = product1.data) === null || ref === void 0 ? void 0 : ref.genreId);
                })) === null || ref40 === void 0 ? void 0 : ref40.text;
                if (tempCategory) {
                    tempAttributes.push({
                        label: categoryLabel,
                        value: tempCategory
                    });
                }
                if (tempSubCategory) {
                    tempAttributes.push({
                        label: subCategoryLabel,
                        value: tempSubCategory
                    });
                }
                if (tempGenre) {
                    tempAttributes.push({
                        label: genreLabel,
                        value: tempGenre
                    });
                }
                setAttributes(tempAttributes);
            }
        }
    }, [
        props.variant,
        props.variantId,
        props.variantProductId,
        props.instance,
        props.instanceId,
        props.instanceProductId,
        product1,
        categories.isSuccess,
        subCategories.isSuccess,
        genres.isSuccess,
        data,
        cheapestInstance
    ]);
    (0,react.useEffect)(function() {
        var tempProps;
        var tempLabels;
        var tempCategoryLabels;
        var categoryObject;
        var tempGeneralStrings;
        var generalStringObject;
        var blockchainStrings;
        var blockchainObject;
        var teaserMenuStrings;
        var teaserMenuObject;
        if (data) {
            tempLabels = data.creatokia.labels;
            tempCategoryLabels = tempLabels.find(function(item) {
                return item.slug === "product-category";
            });
            tempGeneralStrings = tempLabels.find(function(item) {
                return item.slug === "teaser";
            });
            blockchainStrings = tempLabels.find(function(item) {
                return item.slug === "blockchains";
            });
            teaserMenuStrings = tempLabels.find(function(item) {
                return item.slug === "teaser-menu";
            });
            if ((tempCategoryLabels === null || tempCategoryLabels === void 0 ? void 0 : tempCategoryLabels.subcategories) !== undefined) {
                var ref, ref43, ref44;
                categoryObject = {
                    audio: (ref = tempCategoryLabels.subcategories.find(function(item) {
                        return item.slug === "audio";
                    })) === null || ref === void 0 ? void 0 : ref.title,
                    art: (ref43 = tempCategoryLabels.subcategories.find(function(item) {
                        return item.slug === "art";
                    })) === null || ref43 === void 0 ? void 0 : ref43.title,
                    text: (ref44 = tempCategoryLabels.subcategories.find(function(item) {
                        return item.slug === "text";
                    })) === null || ref44 === void 0 ? void 0 : ref44.title
                };
            } else {
                console.error("Category labels could not be found!");
                categoryObject = {
                    audio: "",
                    art: "",
                    text: ""
                };
            }
            if ((tempGeneralStrings === null || tempGeneralStrings === void 0 ? void 0 : tempGeneralStrings.subcategories) !== undefined) {
                var ref45, ref46, ref47, ref48;
                generalStringObject = {
                    fromLowest: (ref45 = tempGeneralStrings.subcategories.find(function(item) {
                        return item.slug === "from";
                    })) === null || ref45 === void 0 ? void 0 : ref45.title,
                    buy: (ref46 = tempGeneralStrings.subcategories.find(function(item) {
                        return item.slug === "buy";
                    })) === null || ref46 === void 0 ? void 0 : ref46.title,
                    options: (ref47 = tempGeneralStrings.subcategories.find(function(item) {
                        return item.slug === "options";
                    })) === null || ref47 === void 0 ? void 0 : ref47.title,
                    unlockables: (ref48 = tempGeneralStrings.subcategories.find(function(item) {
                        return item.slug === "unlockables";
                    })) === null || ref48 === void 0 ? void 0 : ref48.title
                };
            } else {
                console.error("General strings could not be found!");
                generalStringObject = {
                    fromLowest: "",
                    buy: "",
                    options: "",
                    unlockables: ""
                };
            }
            if ((blockchainStrings === null || blockchainStrings === void 0 ? void 0 : blockchainStrings.subcategories) !== undefined) {
                var ref49, ref50;
                blockchainObject = {
                    ethereum: (ref49 = blockchainStrings.subcategories.find(function(item) {
                        return item.slug === "ethereum";
                    })) === null || ref49 === void 0 ? void 0 : ref49.title,
                    polygon: (ref50 = blockchainStrings.subcategories.find(function(item) {
                        return item.slug === "polygon";
                    })) === null || ref50 === void 0 ? void 0 : ref50.title
                };
            } else {
                console.error("Blockchain strings could not be found!");
                blockchainObject = {
                    ethereum: "",
                    polygon: ""
                };
            }
            if ((teaserMenuStrings === null || teaserMenuStrings === void 0 ? void 0 : teaserMenuStrings.subcategories) !== undefined) {
                var ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60;
                teaserMenuObject = {
                    buyNow: (ref51 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "buy-now";
                    })) === null || ref51 === void 0 ? void 0 : ref51.title,
                    cancelResale: (ref52 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "cancel-resale";
                    })) === null || ref52 === void 0 ? void 0 : ref52.title,
                    mint: (ref53 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "mint";
                    })) === null || ref53 === void 0 ? void 0 : ref53.title,
                    sell: (ref54 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "sell";
                    })) === null || ref54 === void 0 ? void 0 : ref54.title,
                    share: (ref55 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "share";
                    })) === null || ref55 === void 0 ? void 0 : ref55.title,
                    instanceDetails: (ref56 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "instance-details";
                    })) === null || ref56 === void 0 ? void 0 : ref56.title,
                    variantDetails: (ref57 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "variant-details";
                    })) === null || ref57 === void 0 ? void 0 : ref57.title,
                    more: (ref58 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "more";
                    })) === null || ref58 === void 0 ? void 0 : ref58.title,
                    instanceIDString: (ref59 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "instance-id";
                    })) === null || ref59 === void 0 ? void 0 : ref59.title,
                    variantIDString: (ref60 = teaserMenuStrings.subcategories.find(function(item) {
                        return item.slug === "variant-id";
                    })) === null || ref60 === void 0 ? void 0 : ref60.title
                };
            } else {
                console.error("Teaser Menu strings could not be found!");
                teaserMenuObject = {
                    buyNow: "",
                    cancelResale: "",
                    mint: "",
                    sell: "",
                    share: "",
                    instanceDetails: "",
                    variantDetails: "",
                    more: "",
                    instanceIDString: "",
                    variantIDString: ""
                };
            }
        }
        if (props.variant) {
            var ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75;
            var _cheapestEthPrice, _cheapestFiatPrice;
            tempProps = {
                unlockables: unlockables.data && unlockables.data.length > 0,
                category: props.variant.categoryId,
                mediaUrl: (ref61 = props.variant) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.coverArt) === null || ref62 === void 0 ? void 0 : ref62.url,
                mediaContentType: (ref63 = props.variant) === null || ref63 === void 0 ? void 0 : (ref64 = ref63.coverArt) === null || ref64 === void 0 ? void 0 : ref64.contentContentType,
                title: props.variant.title,
                topline: (ref65 = product1.data) === null || ref65 === void 0 ? void 0 : ref65.seriesName,
                description: props.variant.variantDescriptionLong,
                variantAttributes: attributes,
                blockchain: Blockchain.ETHEREUM,
                instanceIdToBuy: props.variant.cheapestInstanceId,
                ethPrice: (_cheapestEthPrice = props.variant.cheapestEthPrice) !== null && _cheapestEthPrice !== void 0 ? _cheapestEthPrice : (ref66 = props.variant.salesAttribute) === null || ref66 === void 0 ? void 0 : ref66.priceEth,
                fiatPrice: (_cheapestFiatPrice = props.variant.cheapestFiatPrice) !== null && _cheapestFiatPrice !== void 0 ? _cheapestFiatPrice : (ref67 = props.variant.salesAttribute) === null || ref67 === void 0 ? void 0 : ref67.priceFiat,
                currency: (ref68 = props.variant.salesAttribute) === null || ref68 === void 0 ? void 0 : ref68.currency,
                inverted: props.inverted,
                canBuy: !!props.variant.cheapestInstanceId || ((ref69 = props.variant.salesAttribute) === null || ref69 === void 0 ? void 0 : ref69.salesType) === sales_type/* SalesType.T_DROP */.r.T_DROP && (0,time_helper/* isDateInPast */.OF)((ref70 = props.variant.salesAttribute) === null || ref70 === void 0 ? void 0 : ref70.saleFrom) && (0,time_helper/* isDateInFuture */.ek)((ref71 = props.variant.salesAttribute) === null || ref71 === void 0 ? void 0 : ref71.saleTo, true),
                productName: props.variant.productName,
                productId: props.variant.productId,
                variantId: props.variant.id,
                salesType: (ref72 = props.variant.salesAttribute) === null || ref72 === void 0 ? void 0 : ref72.salesType,
                tokenContract: (ref73 = props.variant.salesAttribute) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.contract) === null || ref74 === void 0 ? void 0 : ref74.contractAddress,
                salesFrom: (ref75 = props.variant.salesAttribute) === null || ref75 === void 0 ? void 0 : ref75.saleFrom,
                productCategories: categoryObject,
                generalStrings: generalStringObject,
                blockchainStrings: blockchainObject,
                teaserMenuLabels: teaserMenuObject
            };
            setTeaserProps(tempProps);
        } else if (props.instance && instanceMeta.finished) {
            var ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91;
            var ref92, ref93;
            tempProps = {
                unlockables: unlockables.data && unlockables.data.length > 0,
                category: props.instance.variant.categoryId,
                mediaUrl: (ref92 = (ref76 = instanceMeta.data) === null || ref76 === void 0 ? void 0 : ref76.image) !== null && ref92 !== void 0 ? ref92 : props.instance.variant.coverArt.url,
                mediaContentType: ((ref77 = instanceMeta.data) === null || ref77 === void 0 ? void 0 : ref77.image) ? enum_to_language_mapper/* EnumToLanguageMapper.urlWithExtensionToMediaContentType */.H.urlWithExtensionToMediaContentType(instanceMeta.data.image) : props.instance.variant.coverArt.contentContentType,
                title: (ref93 = (ref78 = instanceMeta.data) === null || ref78 === void 0 ? void 0 : ref78.name) !== null && ref93 !== void 0 ? ref93 : props.instance.variant.title,
                topline: (ref79 = product1.data) === null || ref79 === void 0 ? void 0 : ref79.seriesName,
                description: props.instance.variant.variantDescriptionLong,
                variantAttributes: attributes,
                blockchain: Blockchain.ETHEREUM,
                ethPrice: props.instance.priceEth,
                fiatPrice: props.instance.priceFiat,
                currency: props.instance.currency,
                instanceId: props.instance.id,
                instanceIdToBuy: props.instance.id,
                inverted: props.inverted,
                canBuy: props.instance.status === instance_status/* InstanceStatus.OPEN */.O.OPEN && (!props.instance.ownerId && !props.instance.ownerWallet ? (0,time_helper/* isDateInPast */.OF)((ref80 = props.instance.variant.salesAttribute) === null || ref80 === void 0 ? void 0 : ref80.saleFrom) && (0,time_helper/* isDateInFuture */.ek)((ref81 = props.instance.variant.salesAttribute) === null || ref81 === void 0 ? void 0 : ref81.saleTo, true) : props.instance.ownerId && props.instance.ownerId === (user === null || user === void 0 ? void 0 : user.id) || !!props.instance.ownerWallet && ((ref82 = props.instance.ownerWallet) === null || ref82 === void 0 ? void 0 : ref82.toLowerCase()) === (user === null || user === void 0 ? void 0 : (ref83 = user.wallet) === null || ref83 === void 0 ? void 0 : ref83.toLowerCase()) ? false : (0,time_helper/* isDateInPast */.OF)(props.instance.saleStartDate)),
                productName: props.instance.variant.productName,
                productId: props.instance.variant.productId,
                variantId: props.instance.variant.id,
                salesType: (ref84 = props.instance.variant.salesAttribute) === null || ref84 === void 0 ? void 0 : ref84.salesType,
                canMint: props.instance.status === instance_status/* InstanceStatus.SOLD */.O.SOLD && !props.instance.minted && !!props.instance.ownerId && props.instance.ownerId === (user === null || user === void 0 ? void 0 : user.id),
                canCancelResale: props.instance.status === instance_status/* InstanceStatus.OPEN */.O.OPEN && (props.instance.ownerId && props.instance.ownerId === (user === null || user === void 0 ? void 0 : user.id) || !!props.instance.ownerWallet && ((ref85 = props.instance.ownerWallet) === null || ref85 === void 0 ? void 0 : ref85.toLowerCase()) === (user === null || user === void 0 ? void 0 : (ref86 = user.wallet) === null || ref86 === void 0 ? void 0 : ref86.toLowerCase())),
                canSell: props.instance.status === instance_status/* InstanceStatus.SOLD */.O.SOLD && props.instance.minted && (props.instance.ownerId && props.instance.ownerId === (user === null || user === void 0 ? void 0 : user.id) || !!props.instance.ownerWallet && ((ref87 = props.instance.ownerWallet) === null || ref87 === void 0 ? void 0 : ref87.toLowerCase()) === (user === null || user === void 0 ? void 0 : (ref88 = user.wallet) === null || ref88 === void 0 ? void 0 : ref88.toLowerCase())),
                tokenContract: (ref89 = props.instance.variant.salesAttribute) === null || ref89 === void 0 ? void 0 : (ref90 = ref89.contract) === null || ref90 === void 0 ? void 0 : ref90.contractAddress,
                salesFrom: (ref91 = props.instance.variant.salesAttribute) === null || ref91 === void 0 ? void 0 : ref91.saleFrom,
                productCategories: categoryObject,
                generalStrings: generalStringObject,
                blockchainStrings: blockchainObject,
                teaserMenuLabels: teaserMenuObject
            };
            setTeaserProps(tempProps);
        }
        if (!props.variant && !props.instance) {
            if (props.variantId !== 0 && props.variantProductId !== 0) {
                var ref94, ref95, ref96, ref97, ref98, ref99, ref100, ref101, ref102, ref103;
                var productData = product1.data;
                var variantData = productData === null || productData === void 0 ? void 0 : productData.variants.find(function(variant) {
                    return variant.id === props.variantId;
                });
                tempProps = {
                    unlockables: unlockables.data && unlockables.data.length > 0,
                    category: productData === null || productData === void 0 ? void 0 : productData.categoryId,
                    mediaUrl: variantData === null || variantData === void 0 ? void 0 : variantData.coverArt.url,
                    mediaContentType: variantData === null || variantData === void 0 ? void 0 : variantData.coverArt.contentContentType,
                    title: variantData === null || variantData === void 0 ? void 0 : variantData.title,
                    topline: productData === null || productData === void 0 ? void 0 : productData.seriesName,
                    description: variantData === null || variantData === void 0 ? void 0 : variantData.variantDescriptionLong,
                    variantAttributes: attributes,
                    blockchain: Blockchain.ETHEREUM,
                    ethPrice: variantData === null || variantData === void 0 ? void 0 : (ref94 = variantData.salesAttribute) === null || ref94 === void 0 ? void 0 : ref94.priceEth,
                    fiatPrice: variantData === null || variantData === void 0 ? void 0 : (ref95 = variantData.salesAttribute) === null || ref95 === void 0 ? void 0 : ref95.priceFiat,
                    currency: variantData === null || variantData === void 0 ? void 0 : (ref96 = variantData.salesAttribute) === null || ref96 === void 0 ? void 0 : ref96.currency,
                    inverted: props.inverted,
                    instanceIdToBuy: cheapestInstance,
                    canBuy: !!cheapestInstance || (variantData === null || variantData === void 0 ? void 0 : (ref97 = variantData.salesAttribute) === null || ref97 === void 0 ? void 0 : ref97.salesType) === sales_type/* SalesType.T_DROP */.r.T_DROP && (0,time_helper/* isDateInPast */.OF)(variantData === null || variantData === void 0 ? void 0 : (ref98 = variantData.salesAttribute) === null || ref98 === void 0 ? void 0 : ref98.saleFrom) && (0,time_helper/* isDateInFuture */.ek)(variantData === null || variantData === void 0 ? void 0 : (ref99 = variantData.salesAttribute) === null || ref99 === void 0 ? void 0 : ref99.saleTo, true),
                    productName: productData === null || productData === void 0 ? void 0 : productData.productName,
                    productId: props.variantProductId,
                    variantId: props.variantId,
                    salesType: variantData === null || variantData === void 0 ? void 0 : (ref100 = variantData.salesAttribute) === null || ref100 === void 0 ? void 0 : ref100.salesType,
                    tokenContract: variantData === null || variantData === void 0 ? void 0 : (ref101 = variantData.salesAttribute) === null || ref101 === void 0 ? void 0 : (ref102 = ref101.contract) === null || ref102 === void 0 ? void 0 : ref102.contractAddress,
                    salesFrom: variantData === null || variantData === void 0 ? void 0 : (ref103 = variantData.salesAttribute) === null || ref103 === void 0 ? void 0 : ref103.saleFrom,
                    productCategories: categoryObject,
                    generalStrings: generalStringObject,
                    blockchainStrings: blockchainObject,
                    teaserMenuLabels: teaserMenuObject
                };
                setTeaserProps(tempProps);
            } else if (props.instanceId && props.instanceProductId && props.variantId === 0 && props.variantProductId === 0) {
                var ref104, ref105, ref106, ref107, ref108, ref109, ref110, ref111, ref112, ref113, ref114, ref115, ref116, ref117, ref118;
                var productData2 = product1.data;
                var instanceData = instance.data;
                var instanceVariantData = productData2 === null || productData2 === void 0 ? void 0 : productData2.variants.find(function(variant) {
                    return variant.id === (instanceData === null || instanceData === void 0 ? void 0 : instanceData.variant.id);
                });
                var ref119, ref120;
                tempProps = {
                    unlockables: unlockables.data && unlockables.data.length > 0,
                    category: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.categoryId,
                    mediaUrl: (ref119 = (ref104 = instanceMeta.data) === null || ref104 === void 0 ? void 0 : ref104.image) !== null && ref119 !== void 0 ? ref119 : "",
                    mediaContentType: ((ref105 = instanceMeta.data) === null || ref105 === void 0 ? void 0 : ref105.image) ? enum_to_language_mapper/* EnumToLanguageMapper.urlWithExtensionToMediaContentType */.H.urlWithExtensionToMediaContentType(instanceMeta.data.image) : instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.coverArt.contentContentType,
                    title: (ref120 = (ref106 = instanceMeta.data) === null || ref106 === void 0 ? void 0 : ref106.name) !== null && ref120 !== void 0 ? ref120 : instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.title,
                    topline: productData2 === null || productData2 === void 0 ? void 0 : productData2.seriesName,
                    description: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.variantDescriptionLong,
                    variantAttributes: attributes,
                    blockchain: Blockchain.ETHEREUM,
                    ethPrice: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.priceEth,
                    fiatPrice: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.priceFiat,
                    currency: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.salesAttribute.currency,
                    instanceId: props.instanceId,
                    instanceIdToBuy: props.instanceId,
                    inverted: props.inverted,
                    canBuy: (instanceData === null || instanceData === void 0 ? void 0 : instanceData.status) === instance_status/* InstanceStatus.OPEN */.O.OPEN && (!(instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) && !(instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerWallet) ? (0,time_helper/* isDateInPast */.OF)(instanceVariantData === null || instanceVariantData === void 0 ? void 0 : (ref107 = instanceVariantData.salesAttribute) === null || ref107 === void 0 ? void 0 : ref107.saleFrom) && (0,time_helper/* isDateInFuture */.ek)(instanceVariantData === null || instanceVariantData === void 0 ? void 0 : (ref108 = instanceVariantData.salesAttribute) === null || ref108 === void 0 ? void 0 : ref108.saleTo, true) : (instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) && (instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) === (user === null || user === void 0 ? void 0 : user.id) || !!(instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerWallet) && (instanceData === null || instanceData === void 0 ? void 0 : (ref109 = instanceData.ownerWallet) === null || ref109 === void 0 ? void 0 : ref109.toLowerCase()) === (user === null || user === void 0 ? void 0 : (ref110 = user.wallet) === null || ref110 === void 0 ? void 0 : ref110.toLowerCase()) ? false : (0,time_helper/* isDateInPast */.OF)(instanceData === null || instanceData === void 0 ? void 0 : instanceData.saleStartDate)),
                    productName: productData2 === null || productData2 === void 0 ? void 0 : productData2.productName,
                    productId: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.productId,
                    variantId: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : instanceVariantData.id,
                    salesType: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : (ref111 = instanceVariantData.salesAttribute) === null || ref111 === void 0 ? void 0 : ref111.salesType,
                    canMint: (instanceData === null || instanceData === void 0 ? void 0 : instanceData.status) === instance_status/* InstanceStatus.SOLD */.O.SOLD && !(instanceData === null || instanceData === void 0 ? void 0 : instanceData.minted) && !!(instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) && (instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) === (user === null || user === void 0 ? void 0 : user.id),
                    canCancelResale: (instanceData === null || instanceData === void 0 ? void 0 : instanceData.status) === instance_status/* InstanceStatus.OPEN */.O.OPEN && ((instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) && (instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) === (user === null || user === void 0 ? void 0 : user.id) || !!(instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerWallet) && (instanceData === null || instanceData === void 0 ? void 0 : (ref112 = instanceData.ownerWallet) === null || ref112 === void 0 ? void 0 : ref112.toLowerCase()) === (user === null || user === void 0 ? void 0 : (ref113 = user.wallet) === null || ref113 === void 0 ? void 0 : ref113.toLowerCase())),
                    canSell: (instanceData === null || instanceData === void 0 ? void 0 : instanceData.status) === instance_status/* InstanceStatus.SOLD */.O.SOLD && (instanceData === null || instanceData === void 0 ? void 0 : instanceData.minted) && ((instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) && (instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerId) === (user === null || user === void 0 ? void 0 : user.id) || !!(instanceData === null || instanceData === void 0 ? void 0 : instanceData.ownerWallet) && (instanceData === null || instanceData === void 0 ? void 0 : (ref114 = instanceData.ownerWallet) === null || ref114 === void 0 ? void 0 : ref114.toLowerCase()) === (user === null || user === void 0 ? void 0 : (ref115 = user.wallet) === null || ref115 === void 0 ? void 0 : ref115.toLowerCase())),
                    tokenContract: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : (ref116 = instanceVariantData.salesAttribute) === null || ref116 === void 0 ? void 0 : (ref117 = ref116.contract) === null || ref117 === void 0 ? void 0 : ref117.contractAddress,
                    salesFrom: instanceVariantData === null || instanceVariantData === void 0 ? void 0 : (ref118 = instanceVariantData.salesAttribute) === null || ref118 === void 0 ? void 0 : ref118.saleFrom,
                    productCategories: categoryObject,
                    generalStrings: generalStringObject,
                    blockchainStrings: blockchainObject,
                    teaserMenuLabels: teaserMenuObject
                };
                setTeaserProps(tempProps);
            }
        }
    }, [
        user,
        unlockables.data,
        instanceMeta.data,
        product1.data,
        instance.data,
        attributes,
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (teaser_card_module_default())["teaser-card"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n            ".concat((teaser_card_module_default())["teaser-card-content"], "\n            ").concat(showBack ? (teaser_card_module_default())["card-animation"] : "", "\n            ").concat(props.inverted ? (teaser_card_module_default()).inverted : "", "\n            "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card_front, teaser_card_objectSpread({}, teaserProps, {
                        onBuy: onBuy,
                        onSwap: function() {
                            return setShowBack(function(prevState) {
                                return !prevState;
                            });
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card_back, teaser_card_objectSpread({}, teaserProps, {
                        onBuy: onBuy,
                        onSwap: function() {
                            return setShowBack(function(prevState) {
                                return !prevState;
                            });
                        }
                    }))
                ]
            }),
            elementToBuy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(login_dialog/* default */.Z, {
                withBuyOption: {
                    setIdToBuy: function(id) {
                        return setElementToBuy({
                            id: id,
                            type: elementToBuy.type
                        });
                    },
                    idToBuy: elementToBuy.id,
                    salesType: elementToBuy.type
                }
            }) : undefined
        ]
    });
};
/* harmony default export */ var teaser_card = (TeaserCard);


/***/ }),

/***/ 29209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77872);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28773);
/* harmony import */ var _text_section_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76098);
/* harmony import */ var _text_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_text_section_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var TextSection = function(props) {
    var _titleVariant, _description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_text_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["text-section"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z, {
                variant: (_titleVariant = props.titleVariant) !== null && _titleVariant !== void 0 ? _titleVariant : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantsEnum.HEADING3_BOLD */ .H.HEADING3_BOLD,
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_text_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z, {
                    children: (props === null || props === void 0 ? void 0 : props.richDescription) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((_description = props.description) !== null && _description !== void 0 ? _description : "") : props.description
                })
            })
        ]
    });
};
TextSection.defaultProps = {
    richDescription: false
};
/* harmony default export */ __webpack_exports__["Z"] = (TextSection);


/***/ }),

/***/ 62486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30316);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77872);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28773);
/* harmony import */ var _tool_tip_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49734);
/* harmony import */ var _tool_tip_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_tool_tip_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var ToolTip = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
            inverted: true,
            variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .TypographyVariantsEnum.CAPTION */ .H.CAPTION,
            className: (_tool_tip_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["tool-tip-typo"]),
            children: props.toolTip
        }),
        placement: "top-start",
        arrow: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: props.children ? props.children : "?"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToolTip);


/***/ }),

/***/ 30613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _api_hooks_useGlobal_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77459);
/* harmony import */ var _redux_actions_blockchain_action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39025);
/* harmony import */ var _redux_slices_wallet_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41731);
/* harmony import */ var _utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62251);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93217);








var WalletConnectButton = function(props) {
    var ref, ref1, ref2, ref3;
    var data = (0,_api_hooks_useGlobal_hook__WEBPACK_IMPORTED_MODULE_3__/* .useGlobal */ .O)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref4 = (0,_utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .C)(function(state) {
        return state.blockchainSlice;
    }), pending = ref4.pending, walletId = ref4.walletId;
    var addWalletState = (0,_utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .C)(function(state) {
        return state.walletSlice.addWalletModel;
    });
    var getUnlockablesWithWalletModel = (0,_utils_hooks_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .C)(function(state) {
        return state.walletSlice.getUnlockablesWithWalletModel;
    });
    var ref5, _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
        inverted: (ref5 = props === null || props === void 0 ? void 0 : props.inverted) !== null && ref5 !== void 0 ? ref5 : false,
        className: (_className = props.className) !== null && _className !== void 0 ? _className : "",
        pending: pending || addWalletState.pending || getUnlockablesWithWalletModel.pending,
        onClick: function() {
            if (walletId) {
                if (props.variantId) {
                    dispatch((0,_redux_slices_wallet_slice__WEBPACK_IMPORTED_MODULE_5__/* .getUnlockablesWithWallet */ .A)({
                        wallet: walletId,
                        variant: props.variantId
                    }));
                } else {
                    dispatch((0,_redux_slices_wallet_slice__WEBPACK_IMPORTED_MODULE_5__/* .addWallet */ .ry)(walletId));
                }
            } else {
                dispatch((0,_redux_actions_blockchain_action__WEBPACK_IMPORTED_MODULE_4__/* .connectToMetaMask */ ._)());
            }
        },
        children: props.buttonText ? props.buttonText : walletId ? data === null || data === void 0 ? void 0 : (ref = data.buttons) === null || ref === void 0 ? void 0 : (ref1 = ref.signMessage) === null || ref1 === void 0 ? void 0 : ref1.buttonText : data === null || data === void 0 ? void 0 : (ref2 = data.buttons) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.connectMetamask) === null || ref3 === void 0 ? void 0 : ref3.buttonText
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WalletConnectButton);


/***/ }),

/***/ 30030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ LoginForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/api/hooks/useLoginPage.hook.ts
var useLoginPage_hook = __webpack_require__(92534);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/button-types.enum.tsx
var button_types_enum = __webpack_require__(30830);
// EXTERNAL MODULE: ./src/utils/_enums/route-path.enum.tsx
var route_path_enum = __webpack_require__(16837);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/input/input.tsx
var input = __webpack_require__(17850);
// EXTERNAL MODULE: ./src/components/_shared/link/link.tsx
var link_link = __webpack_require__(46164);
// EXTERNAL MODULE: ./src/components/login/login-form/login-form.module.scss
var login_form_module = __webpack_require__(8556);
var login_form_module_default = /*#__PURE__*/__webpack_require__.n(login_form_module);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/login/login-form/login-form-submit-button/login-form-submit-button.module.scss
var login_form_submit_button_module = __webpack_require__(88249);
var login_form_submit_button_module_default = /*#__PURE__*/__webpack_require__.n(login_form_submit_button_module);
;// CONCATENATED MODULE: ./src/components/login/login-form/login-form-submit-button/login-form-submit-button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var AuthenticationFormSubmitButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (login_form_submit_button_module_default())["authentication-form-submit-button-wrapper"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, _objectSpread({}, props))
    });
};

// EXTERNAL MODULE: ./src/api/hooks/useCurrentLanguage.hook.ts + 1 modules
var useCurrentLanguage_hook = __webpack_require__(91785);
;// CONCATENATED MODULE: ./src/components/login/login-form/login-form.tsx















var LoginForm = function(param) {
    var withRegisterLink = param.withRegisterLink;
    var ref, ref1;
    var data1 = (0,useLoginPage_hook/* useLoginPage */.Y)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var currLang = (0,useCurrentLanguage_hook/* useCurrentLanguage */.U)();
    var pending = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.authentification.pending;
    });
    (0,react.useEffect)(function() {
        return function() {
            reset();
            dispatch((0,redux/* resetLoginState */.Iy)());
        };
    }, []);
    var ref2, ref3;
    var schema = yup_es/* object */.Ry({
        emailOrUsername: yup_es/* string */.Z_().required((ref2 = (ref = data1 === null || data1 === void 0 ? void 0 : data1.emailOrUsername.fieldErrorMessages) === null || ref === void 0 ? void 0 : ref.required) !== null && ref2 !== void 0 ? ref2 : ""),
        password: yup_es/* string */.Z_().required((ref3 = (ref1 = data1 === null || data1 === void 0 ? void 0 : data1.password.fieldErrorMessages) === null || ref1 === void 0 ? void 0 : ref1.required) !== null && ref3 !== void 0 ? ref3 : "")
    });
    var ref4 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(schema),
        mode: "onChange"
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, reset = ref4.reset, errors = ref4.formState.errors;
    var dataSubmitted = function(data) {
        dispatch((0,redux/* login */.x4)(data));
    };
    if (data1) {
        var ref5, ref6, ref7, ref8, ref9;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                className: (login_form_module_default())["authentification-form"],
                onSubmit: handleSubmit(dataSubmitted),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                        register: register,
                        name: "emailOrUsername",
                        title: data1.emailOrUsername.fieldLabel,
                        placeholder: data1.emailOrUsername.fieldHint,
                        errorMessage: (ref5 = errors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5["emailOrUsername"]) === null || ref6 === void 0 ? void 0 : ref6.message
                    }, "emailOrUsername-input"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                        register: register,
                        name: "password",
                        title: data1.password.fieldLabel,
                        placeholder: data1.password.fieldHint,
                        errorMessage: (ref7 = errors) === null || ref7 === void 0 ? void 0 : (ref8 = ref7["password"]) === null || ref8 === void 0 ? void 0 : ref8.message,
                        type: "password"
                    }, "password-input"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (login_form_module_default())["forgot-password-link"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                            href: route_path_enum/* RoutePath.RESET_PASSWORD */.h3.RESET_PASSWORD,
                            children: (ref9 = data1.forgotPassword) === null || ref9 === void 0 ? void 0 : ref9.linkText
                        })
                    }, "forgot-password-link"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (login_form_module_default())["submit-button"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticationFormSubmitButton, {
                            type: button_types_enum/* ButtonTypesEnum.SUBMIT */.J.SUBMIT,
                            pending: pending,
                            children: data1.loginButton.buttonText
                        })
                    }, "login-submit-button"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (login_form_module_default())["register-link"],
                        children: withRegisterLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                            href: "/".concat(currLang).concat(route_path_enum/* RoutePath.REGISTER */.h3.REGISTER),
                            target: "_blank",
                            children: data1.registerLinkText
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    }, "register-link")
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};


/***/ }),

/***/ 64889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ DefaultHeaderMobileLoginFormContextEnum; }
/* harmony export */ });
var DefaultHeaderMobileLoginFormContextEnum;
(function(DefaultHeaderMobileLoginFormContextEnum) {
    DefaultHeaderMobileLoginFormContextEnum[DefaultHeaderMobileLoginFormContextEnum["TOGGLELOGINFORM"] = 0] = "TOGGLELOGINFORM";
    DefaultHeaderMobileLoginFormContextEnum[DefaultHeaderMobileLoginFormContextEnum["TOGGLEMOBILENAVIGATION"] = 1] = "TOGGLEMOBILENAVIGATION";
    DefaultHeaderMobileLoginFormContextEnum[DefaultHeaderMobileLoginFormContextEnum["TOGGLEMYACCOUNTNAVIGATION"] = 2] = "TOGGLEMYACCOUNTNAVIGATION";
    DefaultHeaderMobileLoginFormContextEnum[DefaultHeaderMobileLoginFormContextEnum["RESET"] = 3] = "RESET";
})(DefaultHeaderMobileLoginFormContextEnum || (DefaultHeaderMobileLoginFormContextEnum = {}));


/***/ }),

/***/ 76221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Alignment; }
/* harmony export */ });
var Alignment;
(function(Alignment) {
    Alignment["VERTICAL"] = "vertical";
    Alignment["HORIZONTAL"] = "horizontal";
})(Alignment || (Alignment = {}));


/***/ }),

/***/ 88092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ArticlePageTypes; }
/* harmony export */ });
var ArticlePageTypes;
(function(ArticlePageTypes) {
    ArticlePageTypes["ARTICLE_PAGE"] = "ARTICLE_PAGE";
    ArticlePageTypes["CONFIRMATION_PAGE"] = "CONFIRMATION_PAGE";
    ArticlePageTypes["ARTICLE_PAGE_STRAPIID"] = "ARTICLE_PAGE_STRAPIID";
    ArticlePageTypes["CONFIRMATION_PAGE_STRAPIID"] = "CONFIRMATION_PAGE_STRAPIID";
})(ArticlePageTypes || (ArticlePageTypes = {}));


/***/ }),

/***/ 90017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ BasicCardVariants; }
/* harmony export */ });
var BasicCardVariants;
(function(BasicCardVariants) {
    BasicCardVariants["BASIC_CARD_SMALL"] = "basic-card-small";
    BasicCardVariants["BASIC_CARD_HORIZONTAL_SMALL"] = "basic-card-horizontal-small";
    BasicCardVariants["BASIC_CARD_HORIZONTAL_NORMAL"] = "basic-card-horizontal-normal";
    BasicCardVariants["TEXT_IMAGE_TEASER"] = "text-image-teaser";
    BasicCardVariants["MAGAZINE_CONTENT_TEASER"] = "magazine-content-teaser";
    BasicCardVariants["TEXT_ONLY_TEASER_NORMAL"] = "text-only-teaser-normal";
    BasicCardVariants["TEXT_ONLY_TEASER_LARGE"] = "text-only-teaser-large";
    BasicCardVariants["CONTENT_TEASER_SMALL"] = "content-teaser-small";
    BasicCardVariants["CONTENT_TEASER_NORMAL"] = "content-teaser-normal";
    BasicCardVariants["PURCHASE_CARD_NORMAL"] = "purchase-card-normal";
    BasicCardVariants["VARIANT_DETAIL"] = "variant-detail";
    BasicCardVariants["PODCAST_TEASER"] = "podcast-teaser";
    BasicCardVariants["CREATOKEN_CARD"] = "creatoken-card";
})(BasicCardVariants || (BasicCardVariants = {}));


/***/ }),

/***/ 30830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ButtonTypesEnum; }
/* harmony export */ });
var ButtonTypesEnum;
(function(ButtonTypesEnum) {
    ButtonTypesEnum["BUTTON"] = "button";
    ButtonTypesEnum["SUBMIT"] = "submit";
    ButtonTypesEnum["RESET"] = "reset";
})(ButtonTypesEnum || (ButtonTypesEnum = {}));


/***/ }),

/***/ 92212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ButtonVariantsEnum; }
/* harmony export */ });
var ButtonVariantsEnum;
(function(ButtonVariantsEnum) {
    ButtonVariantsEnum["PRIMARY"] = "primary";
    ButtonVariantsEnum["SECONDARY_FILLED"] = "secondary-filled";
    ButtonVariantsEnum["SECONDARY_OUTLINED"] = "secondary-outlined";
    ButtonVariantsEnum["SECONDARY_OUTLINED_FILLED_ICON"] = "secondary-outlined-filled-icon";
    ButtonVariantsEnum["STAGE"] = "stage";
    ButtonVariantsEnum["NAVIGATION"] = "navigation";
    ButtonVariantsEnum["SELECTED"] = "selected";
    ButtonVariantsEnum["LEFT_ARROW"] = "left-arrow";
})(ButtonVariantsEnum || (ButtonVariantsEnum = {}));


/***/ }),

/***/ 25444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; }
/* harmony export */ });
var Currency;
(function(Currency) {
    Currency["ETH"] = "ETH";
    Currency["EUR"] = "EUR";
})(Currency || (Currency = {}));


/***/ }),

/***/ 40579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ HorizontalPosition; }
/* harmony export */ });
var HorizontalPosition;
(function(HorizontalPosition) {
    HorizontalPosition["LEFT"] = "left";
    HorizontalPosition["RIGHT"] = "right";
    HorizontalPosition["CENTER"] = "center";
})(HorizontalPosition || (HorizontalPosition = {}));


/***/ }),

/***/ 26884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ MediaContentType; }
/* harmony export */ });
var MediaContentType;
(function(MediaContentType) {
    MediaContentType["JPG"] = "image/jpg";
    MediaContentType["PNG"] = "image/png";
    MediaContentType["JPEG"] = "image/jpeg";
    MediaContentType["MP4"] = "video/mp4";
    MediaContentType["MP3"] = "audio/mpeg";
    MediaContentType["GIF"] = "image/gif";
    MediaContentType["YOUTUBE"] = "video/youtube";
    MediaContentType["ZIP"] = "zip";
})(MediaContentType || (MediaContentType = {}));


/***/ }),

/***/ 11702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ LinkVariants; }
/* harmony export */ });
var LinkVariants;
(function(LinkVariants) {
    LinkVariants["READ_MORE"] = "read-more";
    LinkVariants["STANDARD_LINK"] = "standard-link";
    LinkVariants["SMALL_LINK"] = "small-link";
    LinkVariants["BUTTON_SECONDARY_OUTLINED"] = "button-secondary-outlined";
})(LinkVariants || (LinkVariants = {}));


/***/ }),

/***/ 38204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ProductCategories; }
/* harmony export */ });
var ProductCategories;
(function(ProductCategories) {
    ProductCategories["AUDIO"] = "audio";
    ProductCategories["ART"] = "art";
    ProductCategories["EBOOK"] = "ebook";
    ProductCategories["BOOK"] = "book";
})(ProductCategories || (ProductCategories = {}));


/***/ }),

/***/ 9943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SalesType; }
/* harmony export */ });
var SalesType;
(function(SalesType) {
    SalesType["AUCTION"] = "AUCTION";
    SalesType["FIXED_PRICE"] = "FIXED_PRICE";
    SalesType["T_DROP"] = "FIXED_PRICE_TDROP";
})(SalesType || (SalesType = {}));


/***/ }),

/***/ 705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ StrapiHeadlineStyles; }
/* harmony export */ });
var StrapiHeadlineStyles;
(function(StrapiHeadlineStyles) {
    StrapiHeadlineStyles["H1"] = "H1";
    StrapiHeadlineStyles["H2"] = "H2";
    StrapiHeadlineStyles["H3"] = "H3";
    StrapiHeadlineStyles["H4"] = "H4";
    StrapiHeadlineStyles["H5"] = "H5";
    StrapiHeadlineStyles["H6"] = "H6";
    StrapiHeadlineStyles["H2_LIGHT"] = "H2_LIGHT";
    StrapiHeadlineStyles["H3_LIGHT"] = "H3_LIGHT";
    StrapiHeadlineStyles["H4_LIGHT"] = "H4_LIGHT";
})(StrapiHeadlineStyles || (StrapiHeadlineStyles = {}));


/***/ }),

/***/ 15487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ EnumToLanguageMapper; }
/* harmony export */ });
/* harmony import */ var i18n_iso_countries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18975);
/* harmony import */ var iso_639_1__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79574);
/* harmony import */ var _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26884);
/* harmony import */ var _enums_product_categories_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38204);
/* harmony import */ var _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16837);
/* harmony import */ var _enums_sales_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9943);
/* harmony import */ var _locale_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50325);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}







// eslint-disable-next-line @typescript-eslint/no-var-requires
i18n_iso_countries__WEBPACK_IMPORTED_MODULE_0__.registerLocale(__webpack_require__(48491));
// eslint-disable-next-line @typescript-eslint/no-var-requires
i18n_iso_countries__WEBPACK_IMPORTED_MODULE_0__.registerLocale(__webpack_require__(41086));
// eslint-disable-next-line @typescript-eslint/no-var-requires
i18n_iso_countries__WEBPACK_IMPORTED_MODULE_0__.registerLocale(__webpack_require__(6655));
var EnumToLanguageMapper = /*#__PURE__*/ function() {
    "use strict";
    function EnumToLanguageMapper() {
        _classCallCheck(this, EnumToLanguageMapper);
    }
    EnumToLanguageMapper.accountRoutesMapping = function accountRoutesMapping(data) {
        if (data) {
            return [
                {
                    value: _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_4__/* .AccountRoutePath.PROFILE */ .ql.PROFILE,
                    label: data === null || data === void 0 ? void 0 : data.profileButton.buttonText
                },
                {
                    value: _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_4__/* .AccountRoutePath.NOTIFICATIONS */ .ql.NOTIFICATIONS,
                    label: data === null || data === void 0 ? void 0 : data.notificationsButton.buttonText
                },
                {
                    value: _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_4__/* .AccountRoutePath.PORTFOLIO_AND_GALLERY */ .ql.PORTFOLIO_AND_GALLERY,
                    label: data === null || data === void 0 ? void 0 : data.portfolioAndGalleryButton.buttonText
                },
                {
                    value: _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_4__/* .AccountRoutePath.CHANGE_PASSWORD */ .ql.CHANGE_PASSWORD,
                    label: data === null || data === void 0 ? void 0 : data.changePasswordButton.buttonText
                },
                {
                    value: _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_4__/* .AccountRoutePath.INVOICE_ADDRESS */ .ql.INVOICE_ADDRESS,
                    label: data === null || data === void 0 ? void 0 : data.invoiceAddressButton.buttonText
                },
                {
                    value: _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_4__/* .AccountRoutePath.SUPPORT_AND_CONTACT */ .ql.SUPPORT_AND_CONTACT,
                    label: data === null || data === void 0 ? void 0 : data.supportAndContactButton.buttonText
                }
            ];
        } else return [];
    };
    EnumToLanguageMapper.salesTypeToStringMapping = function salesTypeToStringMapping(fixPrice, auction) {
        return [
            {
                value: _enums_sales_type__WEBPACK_IMPORTED_MODULE_5__/* .SalesType.FIXED_PRICE */ .r.FIXED_PRICE,
                label: fixPrice
            },
            {
                value: _enums_sales_type__WEBPACK_IMPORTED_MODULE_5__/* .SalesType.AUCTION */ .r.AUCTION,
                label: auction
            }
        ];
    };
    EnumToLanguageMapper.countriesMapping = function countriesMapping() {
        return Object.keys(i18n_iso_countries__WEBPACK_IMPORTED_MODULE_0__.getNames((0,_locale_helper__WEBPACK_IMPORTED_MODULE_6__/* .getLanguage */ .G3)())).map(function(country) {
            return {
                label: i18n_iso_countries__WEBPACK_IMPORTED_MODULE_0__.getNames((0,_locale_helper__WEBPACK_IMPORTED_MODULE_6__/* .getLanguage */ .G3)())[country],
                value: country
            };
        });
    };
    EnumToLanguageMapper.countryCodeToLabel = function countryCodeToLabel(code) {
        return i18n_iso_countries__WEBPACK_IMPORTED_MODULE_0__.getNames((0,_locale_helper__WEBPACK_IMPORTED_MODULE_6__/* .getLanguage */ .G3)())[code];
    };
    EnumToLanguageMapper.languageMapping = function languageMapping() {
        return iso_639_1__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getLanguages */ .Z.getLanguages(iso_639_1__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAllCodes */ .Z.getAllCodes()).map(function(language) {
            return {
                label: language.nativeName,
                value: language.code
            };
        });
    };
    EnumToLanguageMapper.languageCodeToLabel = function languageCodeToLabel(name) {
        var language = iso_639_1__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getLanguages */ .Z.getLanguages(iso_639_1__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAllCodes */ .Z.getAllCodes()).find(function(lng) {
            return lng.nativeName === name;
        });
        return language ? language.code : "";
    };
    EnumToLanguageMapper.categoryIdToCategoryEnum = function categoryIdToCategoryEnum(id) {
        switch(id){
            case 1:
                return _enums_product_categories_enum__WEBPACK_IMPORTED_MODULE_3__/* .ProductCategories.AUDIO */ .p.AUDIO;
            case 2:
                return _enums_product_categories_enum__WEBPACK_IMPORTED_MODULE_3__/* .ProductCategories.EBOOK */ .p.EBOOK;
            case 3:
                return _enums_product_categories_enum__WEBPACK_IMPORTED_MODULE_3__/* .ProductCategories.ART */ .p.ART;
        }
    };
    EnumToLanguageMapper.chainIdToName = function chainIdToName(chainId, defaultMessage) {
        switch(chainId){
            case 1:
                return "Mainnet";
            case 5:
                return "Goerli";
            default:
                return defaultMessage;
        }
    };
    EnumToLanguageMapper.urlWithExtensionToMediaContentType = function urlWithExtensionToMediaContentType(url) {
        if (url) {
            var indexOfExtension = url.lastIndexOf(".");
            if (indexOfExtension) {
                var extension = url.substring(indexOfExtension).toLowerCase();
                switch(extension){
                    case ".mp4":
                        return _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__/* .MediaContentType.MP4 */ .L.MP4;
                    case ".png":
                        return _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__/* .MediaContentType.PNG */ .L.PNG;
                    case ".gif":
                        return _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__/* .MediaContentType.GIF */ .L.GIF;
                    case ".jpg":
                        return _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__/* .MediaContentType.JPG */ .L.JPG;
                    case ".jpeg":
                        return _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__/* .MediaContentType.JPEG */ .L.JPEG;
                    default:
                        return _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__/* .MediaContentType.PNG */ .L.PNG;
                }
            }
        }
        return _enums_image_content_type_enum__WEBPACK_IMPORTED_MODULE_2__/* .MediaContentType.PNG */ .L.PNG;
    };
    return EnumToLanguageMapper;
}();


/***/ }),

/***/ 91946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ isObject; },
/* harmony export */   "v": function() { return /* binding */ deepEqual; }
/* harmony export */ });
var isObject = function(object) {
    return object != null && typeof object === "object";
};
var deepEqual = function(object1, object2) {
    if (object2 !== undefined) {
        var keys1 = Object.keys(object1);
        var keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var val1 = object1[key];
                var val2 = object2[key];
                var areObjects = isObject(val1) && isObject(val2);
                if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    }
    return false;
};


/***/ }),

/***/ 49352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ generateUrlToDetailedPage; }
/* harmony export */ });
/* harmony import */ var _api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91785);
/* harmony import */ var _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16837);


var generateUrlToDetailedPage = function(productName, variantTitle, productId, variantId, instanceId, isFromProductsPage, abs, toSalesBox) {
    var ref, ref1;
    var url = "";
    var productTitleString = productName === null || productName === void 0 ? void 0 : (ref = productName.replaceAll) === null || ref === void 0 ? void 0 : ref.call(productName, " ", "-");
    var variantTitleString = variantTitle === null || variantTitle === void 0 ? void 0 : (ref1 = variantTitle.replaceAll) === null || ref1 === void 0 ? void 0 : ref1.call(variantTitle, " ", "-");
    if (true) {
        var ref2, ref3, ref4, ref5;
        var absolutePrefix = "".concat(window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.protocol, "//").concat(window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : ref3.hostname).concat((window === null || window === void 0 ? void 0 : (ref4 = window.location) === null || ref4 === void 0 ? void 0 : ref4.port) ? ":" : "").concat(window === null || window === void 0 ? void 0 : (ref5 = window.location) === null || ref5 === void 0 ? void 0 : ref5.port, "/").concat((0,_api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentLanguage */ .U)());
        url = "".concat(abs ? absolutePrefix : "").concat(!isFromProductsPage ? _enums_route_path_enum__WEBPACK_IMPORTED_MODULE_1__/* .RoutePath.PRODUCTS */ .h3.PRODUCTS : "", "/").concat(productTitleString, "-").concat(variantTitleString, "-").concat(productId, "-").concat(variantId, "/").concat(instanceId ? instanceId : "").concat(toSalesBox ? "#salesbox" : "");
    }
    return url;
};



/***/ }),

/***/ 50325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G3": function() { return /* binding */ getLanguage; },
/* harmony export */   "af": function() { return /* binding */ getLocaleEthPrice; },
/* harmony export */   "yb": function() { return /* binding */ getLocalePrice; }
/* harmony export */ });
/* harmony import */ var _config_supportedLang_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9682);
/* harmony import */ var _isServer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63755);


var isStorybook = function() {
    var ref;
    if ((0,_isServer__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .s)()) return false;
    return ((ref = window) === null || ref === void 0 ? void 0 : ref.STORYBOOK_ENV) === "react";
};
var getLanguage = function() {
    var ref;
    if ((0,_isServer__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .s)() || isStorybook()) return "en";
    var currentLang = (ref = location.pathname.split("/")) === null || ref === void 0 ? void 0 : ref[1];
    if (_config_supportedLang_json__WEBPACK_IMPORTED_MODULE_0__.includes(currentLang)) return currentLang;
    else return "en";
};
var getLocalePrice = function(num) {
    if (num === undefined || num === null) return "";
    if (Math.round(num).toString().length >= 7) {
        return new Intl.NumberFormat(getLanguage(), {
            notation: "compact",
            compactDisplay: "short"
        }).format(num);
    } else if (num % 1 === 0) {
        return num.toLocaleString(getLanguage());
    } else {
        return num.toLocaleString(getLanguage(), {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
};
var getLocaleEthPrice = function(num) {
    if (num === undefined || num === null) return "";
    return num.toLocaleString(getLanguage(), {
        minimumFractionDigits: 0,
        maximumFractionDigits: 5
    });
};



/***/ }),

/***/ 24997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ selectLanguageForProductAttribute; }
/* harmony export */ });
/* harmony import */ var _api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91785);

var selectLanguageForProductAttribute = function(productAttribute) {
    var ref;
    var ref1;
    var language = (ref1 = _api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentLanguage */ .U === null || _api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentLanguage */ .U === void 0 ? void 0 : (ref = (0,_api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentLanguage */ .U)()) === null || ref === void 0 ? void 0 : ref.slice(0, 2)) !== null && ref1 !== void 0 ? ref1 : "en";
    if (!productAttribute) return undefined;
    if (language === "de") return productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.translationDE;
    else return productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.translationEN;
};


/***/ }),

/***/ 962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ mapStrapiHeadline; }
/* harmony export */ });
/* harmony import */ var _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(705);
/* harmony import */ var _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77872);


var mapStrapiHeadline = function(headlineString) {
    switch(headlineString){
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H1 */ .N.H1:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING1 */ .H.HEADING1;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H2 */ .N.H2:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING2_BOLD */ .H.HEADING2_BOLD;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H3 */ .N.H3:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING3_BOLD */ .H.HEADING3_BOLD;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H4 */ .N.H4:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING4_BOLD */ .H.HEADING4_BOLD;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H5 */ .N.H5:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING5 */ .H.HEADING5;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H6 */ .N.H6:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H2_LIGHT */ .N.H2_LIGHT:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING2_LIGHT */ .H.HEADING2_LIGHT;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H3_LIGHT */ .N.H3_LIGHT:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING3_LIGHT */ .H.HEADING3_LIGHT;
        case _enums_strapi_headline_styles_enum__WEBPACK_IMPORTED_MODULE_0__/* .StrapiHeadlineStyles.H4_LIGHT */ .N.H4_LIGHT:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING4_LIGHT */ .H.HEADING4_LIGHT;
        default:
            return _enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_1__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6;
    }
};



/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63367);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helper_isServer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63755);

//@ts-ignore


var removePxAndConvertToNumber = function(value) {
    var length = value.length;
    var newValue = value.slice(0, length - 2);
    return Number(newValue);
};
var getDeviceConfig = function(width) {
    var desktopNumber = removePxAndConvertToNumber(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_1__.desktop);
    var desktopSmallNumber = removePxAndConvertToNumber(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_1__.desktopSmall);
    var mobileNumber = removePxAndConvertToNumber(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_1__.mobile);
    if (width <= mobileNumber) {
        return "mobile";
    } else if (width >= desktopNumber) {
        return "desktop";
    } else if (width >= desktopSmallNumber && width < desktopNumber) {
        return "desktopSmall";
    } else {
        return "tablet";
    }
};
var useBreakpoint = function() {
    if ((0,_helper_isServer__WEBPACK_IMPORTED_MODULE_2__/* .isServer */ .s)()) return "desktop";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return getDeviceConfig(window.innerWidth);
    }), brkPnt = ref[0], setBrkPnt = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var calcInnerWidth = function calcInnerWidth() {
            setBrkPnt(getDeviceConfig(window.innerWidth));
        };
        window.addEventListener("resize", calcInnerWidth, {
            passive: true
        });
        calcInnerWidth();
        return function() {
            return window.removeEventListener("resize", calcInnerWidth);
        };
    }, []);
    return brkPnt;
};
/* harmony default export */ __webpack_exports__["Z"] = (useBreakpoint);


/***/ }),

/***/ 35339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMounted = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasMounted = ref[0], setHasMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setHasMounted(true);
    }, []);
    return {
        hasMounted: hasMounted
    };
};


/***/ }),

/***/ 55816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useTimer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helper_time_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28508);


var useTimer = function(timestamp) {
    if (!timestamp) {
        return {
            timerString: "",
            timer: 0,
            done: false
        };
    }
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Math.round((timestamp - Date.now()) / 1000)), timer = ref[0], setTimer = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), done = ref1[0], setDone = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (Date.now() > timestamp) {
            setDone(true);
        } else {
            setTimer(Math.round((timestamp - Date.now()) / 1000));
            setDone(false);
        }
    }, [
        timestamp
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timeout = setTimeout(function() {
            return setTimer(timer - 1);
        }, 1000);
        if (timer === -1) {
            setTimer(0);
            setDone(true);
        }
        return function() {
            clearTimeout(timeout);
        };
    }, [
        timer
    ]);
    return {
        timerString: (0,_helper_time_helper__WEBPACK_IMPORTED_MODULE_1__/* .toCountdown */ ._z)(timer),
        timer: timer,
        done: done
    };
};


/***/ }),

/***/ 29486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helper_isServer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63755);


var useWindowSize = function() {
    if ((0,_helper_isServer__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .s)()) return [];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([
        0,
        0
    ]), size = ref[0], setSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        var updateSize = function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        };
        window.addEventListener("resize", updateSize);
        updateSize();
        return function() {
            return window.removeEventListener("resize", updateSize);
        };
    }, []);
    return size;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);


/***/ }),

/***/ 70927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","flip-icon":"icon-styles_flip-icon__TY_1W","outside":"icon-styles_outside__v_iO0","inside":"icon-styles_inside__8BVbg","inverted":"icon-styles_inverted__PJYNG"};

/***/ }),

/***/ 71821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","accordion":"accordion_accordion__tyzaw","accordion-header":"accordion_accordion-header__Ffc6t","accordion-label":"accordion_accordion-label__dwTCB","accordion-icon-wrapper":"accordion_accordion-icon-wrapper__5F8U4","accordion-icon":"accordion_accordion-icon__PEwUM","content":"accordion_content__jSwvE","content-reverse":"accordion_content-reverse__vLqG8","inverted":"accordion_inverted__TaZKD","active":"accordion_active__QmQEj","only-mobile":"accordion_only-mobile__49W7k"};

/***/ }),

/***/ 1198:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","button-container":"button_button-container__Y7ZEa","button":"button_button__BrZ5g","primary":"button_primary__5rEnb","shadow":"button_shadow__3X23D","not-pending":"button_not-pending__ka4Ht","loading-spinner":"button_loading-spinner__u2Ll1","inverted":"button_inverted__B6dbC","secondary-filled":"button_secondary-filled__B9KZS","selected":"button_selected__YBex7","secondary-outlined":"button_secondary-outlined__yAgop","stage":"button_stage__asrxs","icon-container":"button_icon-container__QuU6Q","small-p":"button_small-p__WaeNC","navigation":"button_navigation__zCZc3","secondary-outlined-filled-icon":"button_secondary-outlined-filled-icon__dSdYE","left-arrow":"button_left-arrow__TIcog"};

/***/ }),

/***/ 41227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","nav-button":"nav-button_nav-button__PH6NK","text":"nav-button_text__UFt65","icon":"nav-button_icon__Is83V"};

/***/ }),

/***/ 89498:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","hexagon-wrapper":"modal-button_hexagon-wrapper___2_us","hexagon":"modal-button_hexagon__XcCye","content":"modal-button_content__9c_eL"};

/***/ }),

/***/ 66725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","modal-wrapper":"dialog_modal-wrapper__7Q_yK","modal-container":"dialog_modal-container__ig0Z0","wrapper":"dialog_wrapper__uXEMB","close-wrapper":"dialog_close-wrapper__a8ggC","backdrop-wrapper":"dialog_backdrop-wrapper__VTHsh","content":"dialog_content__UzZqY"};

/***/ }),

/***/ 78044:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","error-message-wrapper":"error-message_error-message-wrapper__2Wusp","error-message":"error-message_error-message__ST586"};

/***/ }),

/***/ 35903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","footer-additional-links":"footer-additional-links_footer-additional-links__ZbF2i","footer-social-links":"footer-additional-links_footer-social-links__yL_MJ","copyright":"footer-additional-links_copyright__4_JTF"};

/***/ }),

/***/ 19615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","footer-link-container":"footer-link-container_footer-link-container__HfITC","footer-link-body":"footer-link-container_footer-link-body__Vfad2"};

/***/ }),

/***/ 52931:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","footer-wrapper":"footer_footer-wrapper___H3N3","footer-image":"footer_footer-image__sERn2","footer":"footer_footer__zsaB_","reduced-footer":"footer_reduced-footer__Nixqt","logo-paragraph":"footer_logo-paragraph__56pQG","footer-full-body":"footer_footer-full-body__vZDrK"};

/***/ }),

/***/ 21269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header-footer-wrapper":"header-footer-wrapper_header-footer-wrapper__uGcxw","inverted":"header-footer-wrapper_inverted__gyhF_"};

/***/ }),

/***/ 71742:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","default-header-mobile-login-form":"default-header-mobile-login-form_default-header-mobile-login-form__vwYdO","showOnlyLeastError":"default-header-mobile-login-form_showOnlyLeastError__ZZd4z","register-link-container":"default-header-mobile-login-form_register-link-container__R8pm6","registerLink":"default-header-mobile-login-form_registerLink__MtzCi"};

/***/ }),

/***/ 49068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","default-header-mobile-my-account-navigation":"default-header-mobile-my-account-navigation_default-header-mobile-my-account-navigation__3_HC5","logout-button-container":"default-header-mobile-my-account-navigation_logout-button-container__KgYv6","logout-button":"default-header-mobile-my-account-navigation_logout-button__0G0kH"};

/***/ }),

/***/ 54049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","default-header-mobile-navigation":"default-header-mobile-navigation_default-header-mobile-navigation__VTB3g"};

/***/ }),

/***/ 6:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","default-header-container":"default-header_default-header-container__mFtne","header-profile-icon":"default-header_header-profile-icon__cYJqv","header-profile-mobile-icon":"default-header_header-profile-mobile-icon__jmHlv"};

/***/ }),

/***/ 46615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header-background":"header-background_header-background__ebxu9"};

/***/ }),

/***/ 77467:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header-mobile-form":"header-mobile-form_header-mobile-form__AxnKL","global-error-message":"header-mobile-form_global-error-message__If8c4","forgot-password-container":"header-mobile-form_forgot-password-container__n8cW3","forgot-password":"header-mobile-form_forgot-password__OPjOS","submit-button-container":"header-mobile-form_submit-button-container__U__M_"};

/***/ }),

/***/ 57142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header-mobile-container":"header-mobile-nav_header-mobile-container__JEiQC","header-mobile-nav":"header-mobile-nav_header-mobile-nav__y0sXO","header-mobile-nav-container":"header-mobile-nav_header-mobile-nav-container__U_0fg","header-mobile-nav-item":"header-mobile-nav_header-mobile-nav-item__Q_Av4","cancelButton":"header-mobile-nav_cancelButton__MdBby"};

/***/ }),

/***/ 83846:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header-mobile-navigation-item":"header-mobile-navigation-item_header-mobile-navigation-item__6mHkh"};

/***/ }),

/***/ 82215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header-mobile-navigation":"header-mobile-navigation_header-mobile-navigation__J5maC","language-selector":"header-mobile-navigation_language-selector__sCGAg"};

/***/ }),

/***/ 8306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header-nav-item":"header-nav-item_header-nav-item___a2xI","inverted":"header-nav-item_inverted__US4P5","active":"header-nav-item_active__cjX5k"};

/***/ }),

/***/ 48296:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header":"header_header__5sCGL","header-container":"header_header-container__Q8JYY","lite":"header_lite__O436b","header-background-container":"header_header-background-container__5S4ns","sticky":"header_sticky__iC5Uj","inverted":"header_inverted__5aYHk","logo":"header_logo__5ORh0","nav-container":"header_nav-container__m07aL","buttons":"header_buttons__aCtlb","checkout-button-wrapper":"header_checkout-button-wrapper__NzN0G","transparent":"header_transparent__sA0hx","scrolled":"header_scrolled__8aopK"};

/***/ }),

/***/ 60173:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","input-field-wrapper":"input_input-field-wrapper__C1ACl","input-field":"input_input-field__QYW1Q","valid-icon":"input_valid-icon__kO0Zh","valid":"input_valid__E92aL","error":"input_error__qsPjZ","disabled":"input_disabled__wfjMF","inverted":"input_inverted__XoxHE"};

/***/ }),

/***/ 43046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","submit-input":"submit-input_submit-input__8uiYb","error":"submit-input_error__zBoPt","inverted":"submit-input_inverted__nIURx"};

/***/ }),

/***/ 52039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-area-field-wrapper":"text-area_text-area-field-wrapper__UdXQr","error":"text-area_error__fCn0L","text-area":"text-area_text-area__CoVAe","char-counter":"text-area_char-counter__xntnq","disabled":"text-area_disabled__YLtPE","inverted":"text-area_inverted__g8YK3"};

/***/ }),

/***/ 81814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"language-switch-wrapper":"language-selector_language-switch-wrapper__oSWw5"};

/***/ }),

/***/ 32735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","link-base":"link-base_link-base__jb2iB","inverted":"link-base_inverted__aR_oE"};

/***/ }),

/***/ 99604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","read-more":"link_read-more__JF05p","link-small":"link_link-small__bc86e","link-icon":"link_link-icon__tSQou","disabled":"link_disabled__SfSAZ","button-secondary-outlined":"link_button-secondary-outlined__oizWL","inverted":"link_inverted__W7JTd"};

/***/ }),

/***/ 25340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","media-component":"media_media-component__TmQLS","dimensional":"media_dimensional__OLone","caption":"media_caption__txW53","inverted":"media_inverted__kxJ21","clickable":"media_clickable__0_T2Y","squared-video":"media_squared-video__64d8u","hexagon":"media_hexagon__IlEMG","custom-play-button":"media_custom-play-button__PiGCM","dimensional-card":"media_dimensional-card__diZWw","yt-container":"media_yt-container__lGxsg","yt-wrap":"media_yt-wrap__kS2f0","audio-wrap":"media_audio-wrap__G8cV3","animate__animated":"media_animate__animated__jlPEO","animate__zoomIn":"media_animate__zoomIn__N_Y65","animate__transparent":"media_animate__transparent__dpdnh"};

/***/ }),

/***/ 77604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","newsletter-input":"newsletter-input_newsletter-input__k0NGk"};

/***/ }),

/***/ 47319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","radio-button-group":"radio-button-group_radio-button-group___NH7a","label":"radio-button-group_label__uX6DG","radio-buttons":"radio-button-group_radio-buttons__pAGSC","container":"radio-button-group_container__gihBh","checkmark-outer-border-wrapper":"radio-button-group_checkmark-outer-border-wrapper__w9a7n","checkmark-inner-border-wrapper":"radio-button-group_checkmark-inner-border-wrapper__qZ1Tz","checkmark":"radio-button-group_checkmark__OcF66","vertical":"radio-button-group_vertical__iNvzN","disabled":"radio-button-group_disabled__6Qdw9"};

/***/ }),

/***/ 69596:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","select-wrapper":"select_select-wrapper__aU0Ul","input-label":"select_input-label__QyRMV","input-label-error":"select_input-label-error__mdl_A","select":"select_select__5tsA_","dropdown-indicator":"select_dropdown-indicator__GDJUd","open":"select_open__78TNa","closed":"select_closed__iDZz6","disabled":"select_disabled__Fkc19"};

/***/ }),

/***/ 95155:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","seperator":"seperator_seperator__53C_I"};

/***/ }),

/***/ 47699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","product-card-details-wrapper":"teaser-card-text_product-card-details-wrapper__lxH20","link":"teaser-card-text_link__0TjYY","headline-url":"teaser-card-text_headline-url__swgQK","topline":"teaser-card-text_topline__ECB5n","markdown-text":"teaser-card-text_markdown-text__n28km","topline-text-image-teaser":"teaser-card-text_topline-text-image-teaser__XEuZI","headline-wrapper":"teaser-card-text_headline-wrapper__42Bb_","headline":"teaser-card-text_headline__RceoO","headline-clickable":"teaser-card-text_headline-clickable__la62u","sub-headline":"teaser-card-text_sub-headline__fUD56","description-wrapper":"teaser-card-text_description-wrapper__tb1dj","description":"teaser-card-text_description__4nyYx","description-basic-card-horizontal-small":"teaser-card-text_description-basic-card-horizontal-small__uzXf4","description-magazine-content-teaser":"teaser-card-text_description-magazine-content-teaser__wJ0ye","description-podcast-teaser":"teaser-card-text_description-podcast-teaser__e5kTX","description-text-image-teaser":"teaser-card-text_description-text-image-teaser__X0evc","description-wrapper-text-image-teaser":"teaser-card-text_description-wrapper-text-image-teaser__O_F7E","purchase-card-normal":"teaser-card-text_purchase-card-normal__PWtmy","basic-card-small":"teaser-card-text_basic-card-small__V5NZR","creatoken-card":"teaser-card-text_creatoken-card__1qkuN","basic-card-horizontal-small":"teaser-card-text_basic-card-horizontal-small__zWat1","podcast-teaser":"teaser-card-text_podcast-teaser__Hz4er","paid-price-wrapper":"teaser-card-text_paid-price-wrapper__gkUfB","paid-price":"teaser-card-text_paid-price__5Kv_f","token-id-wrapper":"teaser-card-text_token-id-wrapper__OXWaD","token-id":"teaser-card-text_token-id__M9FBL"};

/***/ }),

/***/ 4461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","back":"card-back_back__SAanT","inverted":"card-back_inverted__NUqZg","content":"card-back_content__ZqK2V","overlay":"card-back_overlay__9Sih4","footer":"card-back_footer__4kUbO","teaser-border":"card-back_teaser-border__Q8Zqu"};

/***/ }),

/***/ 80769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","detail":"card-detail_detail__Co6Iq","content-wrapper":"card-detail_content-wrapper__vdSqh","content":"card-detail_content__6IBqW","attributes":"card-detail_attributes__Ri3UI","inverted":"card-detail_inverted__6SLAl","table":"card-detail_table__8CiIY","row":"card-detail_row__turkc","cell":"card-detail_cell__apO6t","cell-value":"card-detail_cell-value__yNylK","link-wrapper":"card-detail_link-wrapper__50eMV","link":"card-detail_link__Uo1Vh","icon":"card-detail_icon__jqfqr","description":"card-detail_description__O4yPJ"};

/***/ }),

/***/ 11930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","footer":"card-footer_footer__vp2wX","blockchain-icon":"card-footer_blockchain-icon__vMm9q","separator":"card-footer_separator__G71Rj","price-wrapper":"card-footer_price-wrapper__vFDb4","price-prefix":"card-footer_price-prefix__1G6rv","price":"card-footer_price__olxaR","secondary-price":"card-footer_secondary-price__9vFyw","buy-button":"card-footer_buy-button__J23D_","swap-icon":"card-footer_swap-icon__b_b3l","inverted":"card-footer_inverted__ciq7s","countdown":"card-footer_countdown__A1akS","clock":"card-footer_clock__QrwkE"};

/***/ }),

/***/ 53777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","front":"card-front_front__uc7bV","inverted":"card-front_inverted__2pZnR","content":"card-front_content__9dIGe","overlay":"card-front_overlay__zPN1G","media":"card-front_media__B_Fr9","teaser-border":"card-front_teaser-border__jljbb"};

/***/ }),

/***/ 22906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","header":"card-header_header__goEpd","left-header":"card-header_left-header__bRI3t","categories":"card-header_categories__6Kli4","unlockables":"card-header_unlockables__Mx0uS","menu":"card-header_menu__elyby","active":"card-header_active__KuzjS"};

/***/ }),

/***/ 26527:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","overlay":"card-overlay_overlay__bZ6F4","copy-icon-wrapper":"card-overlay_copy-icon-wrapper__6jDbt"};

/***/ }),

/***/ 51667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","topline":"card-title_topline__gFaff","title-wrapper":"card-title_title-wrapper__Bcdvv","title":"card-title_title__z2Lii","link-title":"card-title_link-title__IlG_C","inverted":"card-title_inverted__5HGAc"};

/***/ }),

/***/ 55792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","teaser-card":"teaser-card_teaser-card__Acv5Y","teaser-card-content":"teaser-card_teaser-card-content__zY3r8","inverted":"teaser-card_inverted__Kyc3w","card-animation":"teaser-card_card-animation__4tV50"};

/***/ }),

/***/ 76098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-section":"text-section_text-section__eDqvG","text":"text-section_text__BOtnq"};

/***/ }),

/***/ 49734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tool-tip-typo":"tool-tip_tool-tip-typo__spA5Z","tool-tip-wrap":"tool-tip_tool-tip-wrap__jZtm7"};

/***/ }),

/***/ 88249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","authentication-form-submit-button-wrapper":"login-form-submit-button_authentication-form-submit-button-wrapper__4TOSY"};

/***/ }),

/***/ 8556:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","authentification-form":"login-form_authentification-form__zf6Xq","create-wallet-link":"login-form_create-wallet-link__ukE0r","register-link":"login-form_register-link__vTmsk","forgot-password-link":"login-form_forgot-password-link__D9Tin","submit-button":"login-form_submit-button__6HsOM"};

/***/ }),

/***/ 41374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","headline-section":"headline_headline-section___566B","headline":"headline_headline__c5NTq","nospace":"headline_nospace__7Z4_i","subheader":"headline_subheader__H0_mB","inverted":"headline_inverted__HsltT","text-center":"headline_text-center__EFO7d","text-right":"headline_text-right__7UwyX","text-left":"headline_text-left__4u6Z0","text":"headline_text__ZwOK2"};

/***/ }),

/***/ 63384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","typoimage":"multirow_typoimage__ytV7T","typoimage-container":"multirow_typoimage-container__S2PUZ","multi-item-container":"multirow_multi-item-container__x9J3B","multi-item-row-1":"multirow_multi-item-row-1__QBWdN","multi-item-row-2":"multirow_multi-item-row-2__sx6ZV","multi-item-row-3":"multirow_multi-item-row-3__mpVI9","multi-item-row-4":"multirow_multi-item-row-4___t5Jy","multi-item-row-5":"multirow_multi-item-row-5__Dskci","multi-item-row-6":"multirow_multi-item-row-6___zKUg","multi-item-row-7":"multirow_multi-item-row-7__4yjui","multi-item-row-8":"multirow_multi-item-row-8__A9zNB","tablet-multi-item-row-1":"multirow_tablet-multi-item-row-1__7u1yo","tablet-multi-item-row-2":"multirow_tablet-multi-item-row-2__8DirQ","tablet-multi-item-row-3":"multirow_tablet-multi-item-row-3__yJR9L","tablet-multi-item-row-4":"multirow_tablet-multi-item-row-4__tqOI0","mobile-multi-item-row-1":"multirow_mobile-multi-item-row-1__DPMOh","mobile-multi-item-row-2":"multirow_mobile-multi-item-row-2__q73VX","fullwidth":"multirow_fullwidth__P_O_X","fullwidth_margin":"multirow_fullwidth_margin__3jUOD","normal":"multirow_normal___LjBw"};

/***/ }),

/***/ 2562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"typo_buttons_buttons__Ofy24"};

/***/ }),

/***/ 34823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","accord-box":"accord_accord-box__yp09I","inverted":"accord_inverted__xzx1a","accord-item-content":"accord_accord-item-content__0K8kw","accord-item-image":"accord_accord-item-image__d_AB6","accord-description":"accord_accord-description__Kx9Ml","accord-item-description":"accord_accord-item-description__OS0yg","fullwidth":"accord_fullwidth__yvQba","fullwidth_margin":"accord_fullwidth_margin__wp_F7","normal":"accord_normal__2A_1U"};

/***/ }),

/***/ 23708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","content":"animated_stage_content__Y1Wil","animated-stages-section":"animated_stage_animated-stages-section__YTfzl","small":"animated_stage_small__JQLyG","medium":"animated_stage_medium__not_p","large":"animated_stage_large___EFca","full-height":"animated_stage_full-height__9acx6","decButtonContainer":"animated_stage_decButtonContainer___Wu_o","wrapper":"animated_stage_wrapper__9x_TL","inverted":"animated_stage_inverted__DUjka","slider-inverted":"animated_stage_slider-inverted__mkN2L","withBackground":"animated_stage_withBackground__ccHdu"};

/***/ }),

/***/ 68823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","list":"bullets_list__bCTut","orderedList":"bullets_orderedList__fGWVH","listItem":"bullets_listItem__VXV42","text":"bullets_text__jdPFJ","inverted":"bullets_inverted__8GMt0","body":"bullets_body__XGHgL","fullwidth":"bullets_fullwidth__QKYry","fullwidth_margin":"bullets_fullwidth_margin__JWsw6","normal":"bullets_normal__MEhb3"};

/***/ }),

/***/ 84807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","comment-section":"comment_comment-section__LZRm3","options":"comment_options__K10je","avatar":"comment_avatar__mNCZg","controls":"comment_controls__zbGS_","control-delete":"comment_control-delete__q3pUw","removed":"comment_removed__gT11t"};

/***/ }),

/***/ 92772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","comments-section":"comments_comments-section__qBnEy","fullwidth":"comments_fullwidth__f0VCb","fullwidth_margin":"comments_fullwidth_margin__T_wIS","normal":"comments_normal__6208V","controls":"comments_controls__UtEuE","login-message":"comments_login-message__Mi6qa","text-area":"comments_text-area__FGsLI","button-wrapper":"comments_button-wrapper__RwWs3","inverted":"comments_inverted__GAVfk"};

/***/ }),

/***/ 88546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"monospace":"countdown_monospace__xFXcU","text-center":"countdown_text-center__3tMmH","text-right":"countdown_text-right__LW2Go","text-left":"countdown_text-left__2UKmF"};

/***/ }),

/***/ 55707:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullwidth":"div_fullwidth__i8RqT","fullwidth_margin":"div_fullwidth_margin__mmwUC","normal":"div_normal__bNSUV"};

/***/ }),

/***/ 39409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-section":"header_text-section__In2Zd","headline":"header_headline__86xGF","inverted":"header_inverted__nkFK6","fullwidth":"header_fullwidth__y_PDW","fullwidth_margin":"header_fullwidth_margin__rT4HR","normal":"header_normal__c8Hob","text":"header_text__IozFq"};

/***/ }),

/***/ 10261:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","html":"html_html__gkZSf","inverted":"html_inverted__3SaVg","fullwidth":"html_fullwidth__RAlOL","fullwidth_margin":"html_fullwidth_margin__cNMsb","normal":"html_normal__c6Tkn"};

/***/ }),

/***/ 4242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iframe-box":"iframe_iframe-box__q4HR_","iframe-container":"iframe_iframe-container__jtDE3","fullwidth":"iframe_fullwidth__3wWNH","fullwidth_margin":"iframe_fullwidth_margin__ncNA1","normal":"iframe_normal__lG_Nm"};

/***/ }),

/***/ 99959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","fullwidth":"image_fullwidth__eGY_s","fullwidth_margin":"image_fullwidth_margin__Q8f8F","normal":"image_normal__hRzMG"};

/***/ }),

/***/ 5021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_abstract-section":"menu_abstract_menu_abstract-section__4hDH_","headline":"menu_abstract_headline__sUodS","text":"menu_abstract_text__axZ2z","inverted":"menu_abstract_inverted__J5roW","fullwidth":"menu_abstract_fullwidth__6yFct","fullwidth_margin":"menu_abstract_fullwidth_margin__7CvyE","normal":"menu_abstract_normal__NA92y"};

/***/ }),

/***/ 14779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_categorized_content-section":"menu_categorized_content_menu_categorized_content-section__z09AR","headline":"menu_categorized_content_headline__OPVbE","text":"menu_categorized_content_text__vz5cC","inverted":"menu_categorized_content_inverted__cyEgu","fullwidth":"menu_categorized_content_fullwidth__tA_f_","fullwidth_margin":"menu_categorized_content_fullwidth_margin__MrYP2","normal":"menu_categorized_content_normal__v0uxM"};

/***/ }),

/***/ 96055:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_categorized_pages-section":"menu_categorized_pages_menu_categorized_pages-section__kdYmD","headline":"menu_categorized_pages_headline__LACI6","text":"menu_categorized_pages_text__Wp3L9","inverted":"menu_categorized_pages_inverted__y800M","fullwidth":"menu_categorized_pages_fullwidth__euCMJ","fullwidth_margin":"menu_categorized_pages_fullwidth_margin__0I98H","normal":"menu_categorized_pages_normal__wbNU4"};

/***/ }),

/***/ 44792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_pages-section":"menu_pages_menu_pages-section__woTSN","headline":"menu_pages_headline__U7MR_","text":"menu_pages_text__B1qDo","inverted":"menu_pages_inverted__DOmK_","fullwidth":"menu_pages_fullwidth__u8U2Q","fullwidth_margin":"menu_pages_fullwidth_margin__4qTEJ","normal":"menu_pages_normal__Cp3_B"};

/***/ }),

/***/ 81613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_related_pages-section":"menu_related_pages_menu_related_pages-section__hJUNg","headline":"menu_related_pages_headline__y5UZz","text":"menu_related_pages_text__Be7n6","inverted":"menu_related_pages_inverted__QpQvu","fullwidth":"menu_related_pages_fullwidth__1gWWB","fullwidth_margin":"menu_related_pages_fullwidth_margin__d55NZ","normal":"menu_related_pages_normal__UtQLP"};

/***/ }),

/***/ 67341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_sitemap-section":"menu_sitemap_menu_sitemap-section__wHWQD","headline":"menu_sitemap_headline__9I4al","text":"menu_sitemap_text__V7B30","inverted":"menu_sitemap_inverted__QSUOe","fullwidth":"menu_sitemap_fullwidth__wVfY3","fullwidth_margin":"menu_sitemap_fullwidth_margin__x_Ahk","normal":"menu_sitemap_normal__u1w26"};

/***/ }),

/***/ 29229:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_sitemap_pages-section":"menu_sitemap_pages_menu_sitemap_pages-section__7VdRe","headline":"menu_sitemap_pages_headline__Dl4la","text":"menu_sitemap_pages_text__sQc6y","inverted":"menu_sitemap_pages_inverted__VX1U4","fullwidth":"menu_sitemap_pages_fullwidth__Rhupy","fullwidth_margin":"menu_sitemap_pages_fullwidth_margin__eTdV0","normal":"menu_sitemap_pages_normal__2VXeC"};

/***/ }),

/***/ 48682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","menu_subpages-section":"menu_subpages_menu_subpages-section__4zXen","headline":"menu_subpages_headline__URGv1","text":"menu_subpages_text__KNT_z","inverted":"menu_subpages_inverted__MbQ67","fullwidth":"menu_subpages_fullwidth__Au2ga","fullwidth_margin":"menu_subpages_fullwidth_margin__bT4UV","normal":"menu_subpages_normal__Ti0ys"};

/***/ }),

/***/ 71033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-image-teaser":"mp3_text-image-teaser__8mcPe","text-image-center":"mp3_text-image-center___sfth","right-wrapper":"mp3_right-wrapper__hCVNa","center-wrapper":"mp3_center-wrapper__23ryb","left-wrapper":"mp3_left-wrapper__WTBQL","right-wrapper-img":"mp3_right-wrapper-img___cLIl","left-wrapper-img":"mp3_left-wrapper-img__CCrBM","center-wrapper-img":"mp3_center-wrapper-img__JDOHm","buttons":"mp3_buttons__7NDh3","button-1":"mp3_button-1__uaFu_","button-2":"mp3_button-2__gFlUc","overTheEdge":"mp3_overTheEdge__CpyzN","inverted":"mp3_inverted__Ne7wR","text":"mp3_text__hZEAp","fullwidth":"mp3_fullwidth__GBIs7","fullwidth_margin":"mp3_fullwidth_margin__Mr7dh","normal":"mp3_normal__rrGkT"};

/***/ }),

/***/ 88149:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","audio-player":"big-template_audio-player__zcbGP","artwork":"big-template_artwork__2__PW","track-info":"big-template_track-info__uarE9","title":"big-template_title__8HHHI","description":"big-template_description__ZQXVW","controls":"big-template_controls__U23yY","progress-timer":"big-template_progress-timer__SbPVA"};

/***/ }),

/***/ 45244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","audio-player":"small-template_audio-player__ioaRf","audio-player-information":"small-template_audio-player-information__ccGUK","artwork":"small-template_artwork__5jiPi","track-info":"small-template_track-info__FM5so","title":"small-template_title__sz2gT","description":"small-template_description__XcK7l","controls":"small-template_controls__j77wD","progress-timer":"small-template_progress-timer__qvPgI","progress-timer-symbol":"small-template_progress-timer-symbol__QNlRO"};

/***/ }),

/***/ 5855:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bar":"audio-bar_bar__d5ii0","progress":"audio-bar_progress__2qH4k"};

/***/ }),

/***/ 99404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"audio-controls":"audio-controls_audio-controls__Okktd","play":"audio-controls_play__Dzhb_","pause":"audio-controls_pause__aEME3","prev":"audio-controls_prev__xrs2e","next":"audio-controls_next__pxLuC"};

/***/ }),

/***/ 97955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"volume":"audio-volume_volume__iBZUS","slider":"audio-volume_slider__nkDz2"};

/***/ }),

/***/ 63246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","multi":"multi_multi__qBW_6","multi-item-container":"multi_multi-item-container__7svW5","multi-item-placeholder":"multi_multi-item-placeholder__E_ziW","inverted":"multi_inverted__t4qEW","fullwidth":"multi_fullwidth__KjInp","fullwidth_margin":"multi_fullwidth_margin___YQ5Y","normal":"multi_normal__WXUCq","multi-item-row-1":"multi_multi-item-row-1__xJTEq","multi-item-row-2":"multi_multi-item-row-2__sCjXV","multi-item-row-3":"multi_multi-item-row-3__KY590","multi-item-row-4":"multi_multi-item-row-4__2esj6","multi-item-row-5":"multi_multi-item-row-5__vj1aR","multi-item-row-6":"multi_multi-item-row-6__7czbT","multi-item-row-7":"multi_multi-item-row-7___pH_k","multi-item-row-8":"multi_multi-item-row-8__FbT2g","tablet-multi-item-row-1":"multi_tablet-multi-item-row-1__fPTZp","tablet-multi-item-row-2":"multi_tablet-multi-item-row-2__kpuqH","tablet-multi-item-row-3":"multi_tablet-multi-item-row-3__bNfkk","tablet-multi-item-row-4":"multi_tablet-multi-item-row-4__Z4gHE","mobile-multi-item-row-1":"multi_mobile-multi-item-row-1__zUEZg","mobile-multi-item-row-2":"multi_mobile-multi-item-row-2__hePbz"};

/***/ }),

/***/ 90534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","product-summary":"product-summary_product-summary__HhUdw","media":"product-summary_media__gzfg0","bordered":"product-summary_bordered__SGBUW","topline":"product-summary_topline__IyIRe","subline":"product-summary_subline__CZ6Io","text-left":"product-summary_text-left__U4u1j","text-center":"product-summary_text-center__PGa_b","text-right":"product-summary_text-right__HPdsA","inverted":"product-summary_inverted__erTX5"};

/***/ }),

/***/ 64718:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","news-academy-list":"news-list_news-academy-list__yYqcx","news-academyFilter-list":"news-list_news-academyFilter-list__YSMOe","news-item":"news-list_news-item__4lIww","category-container":"news-list_category-container__QxFJa","select":"news-list_select__6AsLz","inverted":"news-list_inverted__wci6s","fullwidth":"news-list_fullwidth___QsVY","fullwidth_margin":"news-list_fullwidth_margin__zRbFJ","normal":"news-list_normal__GoH7_"};

/***/ }),

/***/ 60848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","card":"academy_template_card__NGcm0","card-image":"academy_template_card-image__vFpx6","card-content":"academy_template_card-content__uv55D","card-title":"academy_template_card-title__0hhwC","card-text":"academy_template_card-text__XzFA5","card-categories":"academy_template_card-categories__rjG2a","category":"academy_template_category__j2_oC","spacing":"academy_template_spacing__2O1DY","card-author":"academy_template_card-author__Plgfx","author":"academy_template_author__QJlfT","author-image":"academy_template_author-image__1NDoI","detail":"academy_template_detail__kPm8o","author-name":"academy_template_author-name__K3gsx","news-related-headline":"academy_template_news-related-headline__oyg99","news-related-news":"academy_template_news-related-news__xsfbD","news-item":"academy_template_news-item__kyurZ","thumbnail-container":"academy_template_thumbnail-container__kDf9e","thumbnail":"academy_template_thumbnail__4qA8P","wrapped":"academy_template_wrapped__bQMfv","academy_template":"academy_template_academy_template__G7lCZ","link":"academy_template_link__ca06n","inverted":"academy_template_inverted__CY2Iq"};

/***/ }),

/***/ 9659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","jobs_template":"jobs_template_jobs_template__Zuj_B","right-wrapper":"jobs_template_right-wrapper__M07a7","left-wrapper":"jobs_template_left-wrapper__A7xMp","right-wrapper-img":"jobs_template_right-wrapper-img__qX_1j","left-wrapper-img":"jobs_template_left-wrapper-img__J9ECt","buttons":"jobs_template_buttons__It7pU","button-1":"jobs_template_button-1__ktWI6","button-2":"jobs_template_button-2__De1n_","overTheEdge":"jobs_template_overTheEdge__t_Yzq","jobs-detail":"jobs_template_jobs-detail__oMSuj","jobs-list":"jobs_template_jobs-list__zB0F7","inverted":"jobs_template_inverted__kyuWG","text":"jobs_template_text__hRffB"};

/***/ }),

/***/ 17544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","podcast_template":"podcast_template_podcast_template__JcnEs","right-wrapper":"podcast_template_right-wrapper__d0Vtc","left-wrapper":"podcast_template_left-wrapper__tunVP","right-wrapper-img":"podcast_template_right-wrapper-img__LhdYx","left-wrapper-img":"podcast_template_left-wrapper-img__KgRov","buttons":"podcast_template_buttons__l0rEO","button-1":"podcast_template_button-1__wBB4M","button-2":"podcast_template_button-2__B9BEC","overTheEdge":"podcast_template_overTheEdge__0CHU9","news-list":"podcast_template_news-list__DwtEz","news-detail":"podcast_template_news-detail__pvzkJ","inverted":"podcast_template_inverted__VfpsJ","text":"podcast_template_text__LYFmk"};

/***/ }),

/***/ 76919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Parallax_small__0k6jf","medium":"Parallax_medium__xfPlY","large":"Parallax_large__dlzjY","full-height":"Parallax_full-height__7qk5f","content":"Parallax_content__ZZH0R"};

/***/ }),

/***/ 10988:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","content":"parallax_content__VW0on","wrapper":"parallax_wrapper__OmwRV","inverted":"parallax_inverted__oixWX","withBackground":"parallax_withBackground__UqfMB"};

/***/ }),

/***/ 945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","pdf":"pdf_pdf___Kome","toolbar-left":"pdf_toolbar-left__nK6Ed","toolbar-center":"pdf_toolbar-center__MfC8m","toolbar-right":"pdf_toolbar-right__KmzhG","toolbar-item":"pdf_toolbar-item__LCVUM","loader":"pdf_loader__pXE7J","error-container":"pdf_error-container__jnEaT","error":"pdf_error__c0mLS","inverted":"pdf_inverted__wO_4z","fullwidth":"pdf_fullwidth__Rafzr","fullwidth_margin":"pdf_fullwidth_margin__KBgwd","normal":"pdf_normal__CU9_J","hide-mobile":"pdf_hide-mobile__J_oqw"};

/***/ }),

/***/ 8632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","quote-section":"quote_quote-section__TpXj_","quote-wrapper":"quote_quote-wrapper__wwp_Y","quote":"quote_quote__4nEs_","inverted":"quote_inverted__NCxIr","headline":"quote_headline__DWeT5"};

/***/ }),

/***/ 80910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-image-button-token":"stage-image-button-token_stage-image-button-token__Pa1ZU","editButton":"stage-image-button-token_editButton__JwaAR","token-button":"stage-image-button-token_token-button___ATOP"};

/***/ }),

/***/ 82242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","stage":"stage_stage__hPaw0","Large":"stage_Large__RqYSY","Normal":"stage_Normal__UHK6_","Small":"stage_Small__abmbq","Left":"stage_Left__qLOK6","Right":"stage_Right__DLZPf","Center":"stage_Center__LMWlb","vert-center":"stage_vert-center__e5MR_","vert-top":"stage_vert-top__71fog","vert-bottom":"stage_vert-bottom__A51YM","inverted":"stage_inverted__nY9fq","LEFT":"stage_LEFT__8vfIo","title":"stage_title__qip5R","CENTER":"stage_CENTER__1Ikgl","RIGHT":"stage_RIGHT__x_GRh","decButtonContainer":"stage_decButtonContainer__huOl9","decButtonCustomContainer":"stage_decButtonCustomContainer__nUoBJ","description":"stage_description__EvLaP","buttons":"stage_buttons__jCkYT","default-background":"stage_default-background__Nf0Pd","stage-background":"stage_stage-background__QGvms","text":"stage_text__4rMkk"};

/***/ }),

/***/ 49402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","table":"table_table__dSZk8","inverted":"table_inverted__4hqsQ","fullwidth":"table_fullwidth__w63IV","fullwidth_margin":"table_fullwidth_margin__Dp_C1","normal":"table_normal__us5XU"};

/***/ }),

/***/ 51163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-section":"text_text-section__HXjhZ","text":"text_text__McUua","inverted":"text_inverted__Oc1oF","fullwidth":"text_fullwidth__7hhcK","fullwidth_margin":"text_fullwidth_margin__i38PZ","normal":"text_normal__NSOnh"};

/***/ }),

/***/ 44014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-image-teaser":"textimg_text-image-teaser__25Bj8","text-image-center":"textimg_text-image-center__iLDoX","right-wrapper":"textimg_right-wrapper___lrng","center-wrapper":"textimg_center-wrapper__a2uLv","left-wrapper":"textimg_left-wrapper__AzoZY","right-wrapper-img":"textimg_right-wrapper-img__CkZLU","left-wrapper-img":"textimg_left-wrapper-img__9_Aai","center-wrapper-img":"textimg_center-wrapper-img__YerzK","buttons":"textimg_buttons___xspA","button-1":"textimg_button-1__C84wv","button-2":"textimg_button-2__qG2n7","overTheEdge":"textimg_overTheEdge__JQzRl","inverted":"textimg_inverted__Ndbsp","text":"textimg_text__kEyVn","fullwidth":"textimg_fullwidth__wfiBu","fullwidth_margin":"textimg_fullwidth_margin__8qmMu","normal":"textimg_normal__3z1ji"};

/***/ }),

/***/ 63367:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px"};

/***/ }),

/***/ 28022:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 93414:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70172:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2001:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 33779:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 82258:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 9682:
/***/ (function(module) {

"use strict";
module.exports = ["de","en","es"];

/***/ })

}]);